export default {
  "tits_zh-CN": {
    "平台人工发起退款": "平台人工发起退款",
    "已提交评论!": "已提交评论",
    "未指定商家": "未指定商家",
    "当前账号有未完成的充值订单，请完成后再试": "当前账号有未完成的充值订单，请完成后再试",
    "当前账号有未完成的提现订单，请完成后再试": "当前账号有未完成的提现订单，请完成后再试",
    "请先登录": "请先登录",
    "该角色账号不允许注销": "该角色账号不允许注销",
    "当前的用户账号与确认注销的账号不一致": "当前的用户账号与确认注销的账号不一致",
    "密码输入错误次数过多，请明天再试": "密码输入错误次数过多，请明天再试",
    "注销失败": "注销失败",
    "注销成功": "注销成功",
    "当前用户已经被管理员禁用": "当前用户已经被管理员禁用",
    "地址不存在,或者已删除": "地址不存在,或者已删除",
    "地址不能为空": "地址不能为空",
    "地址过长": "地址过长",
    "参数异常，消息获取失败": "参数异常，消息获取失败",
    "店家id不能为空": "店家id不能为空",
    "店家id错误": "店家id错误",
    "订单号不能为空": "订单号不能为空",
    "非法请求": "非法请求",
    "购买失败,联系客服": "购买失败,联系客服",
    "关注id不能为空": "关注id不能为空",
    "联系人不能为空": "联系人不能为空",
    "两次输入的资金密码不相同": "两次输入的资金密码不相同",
    "模块名不能为空": "模块名不能为空",
    "您的申请之前已提交过": "您的申请之前已提交过",
    "请上传图片格式的文件": "请上传图片格式的文件",
    "请勿重复添加": "请勿重复添加",
    "取消失败": "取消失败",
    "删除失败": "删除失败",
    "商品id不能为空": "商品id不能为空",
    "商品id错误": "商品id错误",
    "实名认证尚未通过，无法重置": "实名认证尚未通过，无法重置",
    "收藏id不能为空": "收藏id不能为空",
    "收货失败": "收货失败",
    "手机号不能为空": "手机号不能为空",
    "图片不能为空": "图片不能为空",
    "图片大小不能超过30M": "图片大小不能超过30M",
    "用户已锁定": "用户已锁定",
    "正在购买": "正在购买",
    "该贷款单还未通过审核": "该贷款单还未通过审核",
    "该贷款单号不存在": "该贷款单号不存在",
    "两次输入的密码不相同": "两次输入的密码不相同",
    "类型不能为空": "类型不能为空",
    "操作失败！修正后账户余额小于0。": "操作失败！修正后账户余额小于0。",
    "身份证号已实名过!": "身份证号已实名过!",
    "提款金额不得低于最小提款限额": "提款金额不得低于最小提款限额",
    "提款金额不得高于最大提款限额": "提款金额不得高于最大提款限额",
    "超过提现次数": "超过提现次数",
    "不在提现时间范围内，请稍后再试": "不在提现时间范围内，请稍后再试",
    "提币数量必填": "提币数量必填",
    "提币数量输入错误，请输入浮点数": "提币数量输入错误，请输入浮点数",
    "更新钱包失败，请联系客服": "更新钱包失败，请联系客服",
    "试用码不正确": "试用码不正确",
    "已经提交申请，请等待审核": "已经提交申请，请等待审核",
    "审核状态异常请联系客服": "审核状态异常请联系客服",
    "暂无用户": "暂无用户",
    "系统无该用户，或者ip地址不正确": "系统无该用户，或者ip地址不正确",
    "游客不能向游客发送消息": "游客不能向游客发送消息",
    "请选择收货地址": "请选择收货地址",
    "收货地址达上限": "收货地址达上限",
    "请设置资金密码": "请设置资金密码",
    "该订单未满足支付条件": "该订单未满足支付条件",
    "密码输入错误次数过多，请明天再试": "密码输入错误次数过多，请明天再试",
    "操作失败，请稍后再试": "操作失败，请稍后再试",
    "部分商品已下架": "部分商品已下架",
    "邮箱的长度不能超过64个字符": "邮箱的长度不能超过64个字符",
    "邮码不能超过32个字符": "邮码不能超过32个字符",
    "操作类型不正确": "操作类型不正确",
    "参数错误!": "参数错误!",
    "不支持的语言": "不支持的语言",
    "收货人姓名不能超过64个字符": "收货人姓名不能超过64个字符",
    "请输入正确的手机号码": "请输入正确的手机号码",
    "无此sellerGoods": "无此sellerGoods",
    "退货失败": "退货失败",
    "该订单状态无法操作": "该订单状态无法操作",
    "订单已经发货，无法退款": "订单已经发货，无法退款",
    "添加失败": "提交失败，请稍后重试",
    "提交失败": "提交失败",
    "暂无店铺": "暂无店铺",
    "请输入正确的邮箱地址": "请输入正确的邮箱地址",
    "已有未完成的贷款单，不能重复申请": "已有未完成的贷款单，不能重复申请",
    "大于最大采购数量": "大于最大采购数量",
    '该邮箱已被订阅': '该邮箱已被订阅',
    "请输入关键字搜索": '请输入关键字搜索',
    "登录过期，请重新登录": "登录过期，请重新登录",
    "系统错误，请稍后重试": "系统错误，请稍后重试",
    "请稍后重试": "请稍后重试",
    "连续输入错误三次，请3分钟后再试": "连续输入错误三次，请3分钟后再试",
    "审核中": "审核中",
    "程序错误": "程序错误",
    "重复提交": "重复提交",
    "用户名不能为空": "用户名不能为空",
    "验证码不能为空": "验证码不能为空",
    "登录密码不能为空": "登录密码不能为空",
    "登陆密码长度不符合设定": "登陆密码长度不符合设定",
    "资金密码长度不符合设定": "资金密码长度不符合设定",
    "登陆密码不符合设定": "登陆密码不符合设定",
    "资金密码不符合设定": "资金密码不符合设定",
    "用户名不符合设定": "用户名不符合设定",
    "用户名必须由数字和英文字母组成": "用户名必须由数字和英文字母组成",
    "验证码不正确": "验证码不正确",
    "密码不正确": "密码不正确",
    "服务器错误(500)": "服务器错误(500)",
    "服务器错误": "服务器错误",
    "用户名重复": "用户名重复",
    "找不到用户": "找不到用户",
    "不能为空": "不能为空",
    "登录失败": "登录失败",
    "操作成功": "操作成功",
    "操作频繁，请稍后再试": "操作频繁，请稍后再试",
    "工作地址不能为空": "工作地址不能为空",
    "家庭地址不能为空": "家庭地址不能为空",
    "亲属姓名不能为空": "亲属姓名不能为空",
    "亲属关系不能为空": "亲属关系不能为空",
    "亲属地址不能为空": "亲属地址不能为空",
    "亲属电话不能为空": "亲属电话不能为空",
    "用户名不存在": "用户名不存在",
    "参数错误": "参数错误",
    "不在交易时段": "不在交易时段",
    "存在不同杠杆的持仓单": "存在不同杠杆的持仓单",
    "余额不足": "余额不足",
    "可平仓合约张数不足": "可平仓合约张数不足",
    "请输入正确的货币数量": "请输入正确的货币数量",
    "请选择正确的币种": "请选择正确的币种",
    "金额错误": "金额错误",
    "跟单参数输入错误": "跟单参数输入错误",
    "跟单倍数输入错误": "跟单倍数输入错误",
    "交易员不存在": "交易员不存在",
    "交易员未开启带单": "交易员未开启带单",
    "用户已跟随交易员": "用户已跟随交易员",
    "交易员跟随人数已满": "交易员跟随人数已满",
    "交易员不能跟随自己": "交易员不能跟随自己",
    "交易员无法跟随另一个交易员": "交易员无法跟随另一个交易员",
    "历史基金无法购买": "历史基金无法购买",
    "该基金尚未开放购买": "该基金尚未开放购买",
    "该基金尚已封闭": "该基金尚已封闭",
    "基金剩余购买金额不足": "基金剩余购买金额不足",
    "订单不存在": "订单不存在",
    "下单不能小于最小金额限制": "下单不能小于最小金额限制",
    "[symbol]参数为空": "[symbol]参数为空",
    "矿机不存在": "矿机不存在",
    "矿机未解锁，无法购买": "矿机未解锁，无法购买",
    "您已购买过体验矿机,不得重复购买": "您已购买过体验矿机,不得重复购买",
    "买入金额需要在区间内": "买入金额需要在区间内",
    "行情获取异常，稍后再试": "行情获取异常，稍后再试",
    "广告不存在": "广告不存在",
    "广告已下架": "广告已下架",
    "承兑商不存在": "承兑商不存在",
    "请先添加收款方式": "请先添加收款方式",
    "您没有符合条件的收款方式": "您没有符合条件的收款方式",
    "请选择买卖方式": "请选择买卖方式",
    "请输入正确的金额": "请输入正确的金额",
    "请输入正确的数量": "请输入正确的数量",
    "该广告剩余数量不足": "该广告剩余数量不足",
    "金额不在购买区间": "金额不在购买区间",
    "用户剩余数量不足": "用户剩余数量不足",
    "请稍后再试": "请稍后再试",
    "未找到符合条件的匹配订单": "未找到符合条件的匹配订单",
    "该订单已取消": "该订单已取消",
    "当前订单不为待付款状态，无法取消": "当前订单不为待付款状态，无法取消",
    "卖方无法取消该订单": "卖方无法取消该订单",
    "资金密码错误": "资金密码错误",
    "订单已完成": "订单已完成",
    "订单已取消": "订单已取消",
    "待付款的订单无法放行": "待付款的订单无法放行",
    "订单已完成，无法放行": "订单已完成，无法放行",
    "订单已取消，无法放行": "订单已取消，无法放行",
    "未授权访问": "未授权访问",
    "图片大小不能超过2M！": "图片大小不能超过2M！",
    "参数异常，消息获取失败": "参数异常，消息获取失败",
    "无效的UID": "无效的UID",
    "用户不存在": "用户不存在",
    "图片上传失败": "图片上传失败",
    "请输入内容": "请输入内容",
    "图片不得大于2M": "图片不得大于2M",
    "图片不得大于10M": "图片不得大于10M",
    "直线关系，不能修改推荐": "直线关系，不能修改推荐",
    "存在重复的角色名称": "存在重复的角色名称",
    "角色被用户关联，不可删除": "角色被用户关联，不可删除",
    "系统存在相同[系统登录名]！": "系统存在相同[系统登录名]！",
    "旧密码不正确": "旧密码不正确",
    "没有找到用户": "没有找到用户",
    "[code]值错误": "[code]值错误",
    "身份证已实名过!": "身份证已实名过!",
    "实名认证未通过，无法进行高级认证": "实名认证未通过，无法进行高级认证",
    "收款方输入错误": "收款方输入错误",
    "所选汇率不存在": "所选汇率不存在",
    "转账数量不能小于等于0": "转账数量不能小于等于0",
    "UID不能为空": "UID不能为空",
    "转账币种不能为空": "转账币种不能为空",
    "资金密码不能为空": "资金密码不能为空",
    "提现不得小于限额": "提现不得小于限额",
    "提现不得大于限额": "提现不得大于限额",
    "当日可提现次数不足": "当日可提现次数不足",
    "不在可提现时间内": "不在可提现时间内",
    "渠道未开通": "渠道未开通",
    "提币数量不能小于等于0": "提币数量不能小于等于0",
    "无权限": "无权限",
    "请先通过高级认证": "请先通过高级认证",
    '请输入搜索关键字': '请输入搜索关键字',

    "角色不存在": "角色不存在",
    "持有币种不足": "持有币种不足",
    "提交失败，当前有未处理订单": "提交失败，当前有未处理订单",
    "充值链错误": "充值链错误",
    "充值价值不得小于最小限额": "充值价值不得小于最小限额",
    "充值价值不得大于最大限额": "充值价值不得大于最大限额",
    "充值数量不能小于等于0": "充值数量不能小于等于0",
    "请输入充值币种": "请输入充值币种",
    "请上传图片": "请上传图片",

    "当前还需交易": "当前还需交易",
    ",才可提币": ",才可提币",

    "提示": "提示",
    "未实名认证，是否认证？": "未实名认证，是否认证？",
    "帐户异常需要进行C3认证，请联系在线客服。": "帐户异常需要进行C3认证，请联系在线客服。",
    "确认": "确认",
    "取消": "取消",
    "更新提醒": "更新提醒",
    "发现新版本，请升级到最新版本": "发现新版本，请升级到最新版本",
    "请检查网络连接": "请检查网络连接",
    "您已存在订单": "您已存在订单",
    "当前地址格式错误": "当前地址格式错误",

    "申购数量错误": "申购数量错误",
    "产品不存在": "产品不存在",
    "该产品未上架": "该产品未上架",
    "该产品已上市，无法购买": "该产品已上市，无法购买",
    "当日才可申购": "当日才可申购",
    "产品剩余数量不足": "产品剩余数量不足",
    "您当前可分配额度不足": "您当前可分配额度不足",

    "购买矿机时间不得低于托管订单剩余时间": "购买矿机时间不得低于托管订单剩余时间",
    "推荐码不正确": "推荐码不正确",
    "推荐人无权限推荐": "推荐人无权限推荐",
    "审核已通过": "审核已通过",

    "请填写正确的验证码": "请填写正确的验证码",
    "请填写正确的电话号码": "请填写正确的电话号码",
    "请填写正确的邮箱地址": "请填写正确的邮箱地址",
    "电话号码已绑定": "电话号码已绑定",
    "电话号码已绑定其他用户": "电话号码已绑定其他用户",
    "邮箱已绑定": "邮箱已绑定",
    "邮箱已绑定其他用户": "邮箱已绑定其他用户",
    "页码不是整数": "页码不是整数",
    "页码不能小于等于0": "页码不能小于等于0",
    "请输入正确的质押金额": "请输入正确的质押金额",
    "请输入正确的质押天数": "请输入正确的质押天数",
    "未发现授权记录": "未发现授权记录",
    "授权状态未成功": "授权状态未成功",
    "赎回状态异常": "赎回状态异常",
    "申请成功": "申请成功",
    "领取成功": "领取成功",
    "未找到匹配的收益记录": "未找到匹配的收益记录",
    "已领取": "已领取",
    "校验IP不合法": "校验IP不合法",
    "委托数量(张)必填": "委托数量(张)必填",
    "委托数量(张)不能小于等于0": "委托数量(张)不能小于等于0",
    "请先绑定谷歌验证器": "请先绑定谷歌验证器",
    "资金密码必须6-12位": "资金密码必须6-12位",
    "验证码错误": "验证码错误",
    "登录密码必须6-12位": "登录密码必须6-12位",
    "密码不能为空": "密码不能为空",
    "密码必须6-12位": "密码必须6-12位",
    "验证类型不能为空": "验证类型不能为空",
    "未绑定手机号": "未绑定手机号",
    "未绑定邮箱": "未绑定邮箱",
    "未绑定谷歌验证器": "未绑定谷歌验证器",
    "旧密码不能为空": "旧密码不能为空",
    "新密码不能为空": "新密码不能为空",
    "新密码确认不能为空": "新密码确认不能为空",
    "新密码不一致": "新密码不一致",
    "操作类型为空": "操作类型为空",
    "操作类型不是整数": "操作类型不是整数",
    "操作类型不能小于0": "操作类型不能小于0",
    "用户名参数为空": "用户名参数为空",
    "状态不是整数": "状态不是整数",
    "状态不能小于0": "状态不能小于0",
    "系统参数错误": "系统参数错误",
    "-连接已建立-": "-连接已建立",
    "代理层级错误": "代理层级错误",
    "请重新登录": "请重新登录",
    "地址格式与协议不匹配": "地址格式与协议不匹配",
    "用户已绑定过提现地址": "用户已绑定过提现地址",
    "绑定提现地址成功": "绑定提现地址成功",
    "邮箱验证码发送次数过多，请明天再试":"邮箱验证码发送次数过多，请明天再试",
    "未设置地址": "未设置地址",
    "您有一笔提现正在处理中": "您有一笔提现正在处理中",
    "充值数量不能小于等于0": "充值数量不能小于等于0",
    "请选择法币类型": "请选择法币类型",
    "充值金额超过最大金额": "充值金额超过最大金额",
    "充值金额小于最小金额": "充值金额小于最小金额",
    "业务已锁定，请联系客服！": "业务已锁定，请联系客服！",
    "请选择正确的法币类型": "请选择正确的法币类型",
    "无法购买本店商品": "无法购买本店商品",
    '参数缺失': '参数缺失',
    "该商品已下架": "该商品已下架",
    "该手机号已被占用，请绑定其他手机号": "该手机号已被占用，请绑定其他手机号",
    "该邮箱已被占用，请更换其他邮箱注册":"该邮箱已被占用，请更换其他邮箱注册",
    '充值数量必填': '充值数量必填',
    
  },
  "tits_CN": {
    "该邮箱已被占用，请更换其他邮箱注册": "該郵箱已被佔用，請換其他郵箱註冊",
    "该手机号已被占用，请绑定其他手机号": "該手機號已被佔用，請綁定其他手機號",
    "邮箱验证码发送次数过多，请明天再试": "郵箱驗證碼發送次數過多，請明天再試",
    '参数缺失': '參數缺失',
    "该商品已下架": "該商品已下架",
    '充值数量必填': '充值數量必填',
    "已提交评论!": "已提交評論!",
    "当前账号有未完成的充值订单，请完成后再试": "當前賬號有未完成的充值訂單，請完成後再試",
    "当前账号有未完成的提现订单，请完成后再试": "當前賬號有未完成的提現訂單，請完成後再試",
    "请先登录": "請先登錄",
    "该角色账号不允许注销": "該角色賬號不允許註銷",
    "当前的用户账号与确认注销的账号不一致": "當前的用戶賬號與確認註銷的賬號不一致",
    "密码输入错误次数过多，请明天再试": "密碼輸入錯誤次數過多，請明天再試",
    "注销失败": "註銷失敗",
    "注销成功": "註銷成功",
    "未指定商家": "未指定商家",
    "当前用户已经被管理员禁用": "當前用戶已經被管理員禁用",
    "地址不存在,或者已删除": "地址不存在,或者已刪除",
    "地址不能为空": "地址不能為空",
    "地址过长": "地址過長",
    "店家id不能为空": "店家id不能為空",
    "店家id错误": "店家id錯誤",
    "订单号不能为空": "訂單號不能為空",
    "非法请求": "非法請求",
    "购买失败,联系客服": "購買失敗,聯繫客服",
    "关注id不能为空": "關注id不能為空",
    "联系人不能为空": "聯繫人不能為空",
    "两次输入的资金密码不相同": "兩次輸入的資金密碼不相同",
    "模块名不能为空": "模塊名不能為空",
    "您的申请之前已提交过": "您的申請之前已提交過",
    "请上传图片格式的文件": "請上傳圖片格式的文件",
    "请勿重复添加": "請勿重複添加",
    "取消失败": "取消失敗",
    "删除失败": "刪除失敗",
    "商品id不能为空": "商品id不能為空",
    "商品id错误": "商品id錯誤",
    "实名认证尚未通过，无法重置": "實名認證尚未通過，無法重置",
    "收藏id不能为空": "收藏id不能為空",
    "收货失败": "收貨失敗",
    "手机号不能为空": "手機號不能為空",
    "图片不能为空": "圖片不能為空",
    "图片大小不能超过30M": "圖片大小不能超過30M",
    "用户已锁定": "用戶已鎖定",
    "正在购买": "正在購買",
    "该贷款单还未通过审核": "該貸款單還未通過審核",
    "该贷款单号不存在": "該貸款單號不存在",
    "两次输入的密码不相同": "兩次輸入的密碼不相同",
    "类型不能为空": "類型不能為空",
    "操作失败！修正后账户余额小于0。": "操作失敗！修正後賬戶餘額小於0。",
    "身份证号已实名过!": "身份證號已實名過!",
    "提款金额不得低于最小提款限额": "提款金額不得低於最小提款限額",
    "提款金额不得高于最大提款限额": "提款金額不得高於最大提款限額",
    "超过提现次数": "超過提現次數",
    "不在提现时间范围内，请稍后再试": "不在提現時間範圍內，請稍後再試",
    "提币数量必填": "提幣數量必填",
    "提币数量输入错误，请输入浮点数": "提幣數量輸入錯誤，請輸入浮點數",
    "更新钱包失败，请联系客服": "更新錢包失敗，請聯繫客服",
    "试用码不正确": "試用碼不正確",
    "已经提交申请，请等待审核": "已經提交申請，請等待審核",
    "审核状态异常请联系客服": "審核狀態異常請聯繫客服",
    "暂无用户": "暫無用戶",
    "系统无该用户，或者ip地址不正确": "系統無該用戶，或者ip地址不正確",
    "游客不能向游客发送消息": "遊客不能向遊客發送消息",
    "请选择收货地址": "請選擇收貨地址",
    "收货地址达上限": "收貨地址達上限",
    "请设置资金密码": "請設置資金密碼",
    "该订单未满足支付条件": "該訂單未滿足支付條件",
    "密码输入错误次数过多，请明天再试": "密碼輸入錯誤次數過多，請明天再試",
    "操作失败，请稍后再试": "操作失敗，請稍後再試",
    "部分商品已下架": "部分商品已下架",
    "邮箱的长度不能超过64个字符": "郵箱的長度不能超過64個字符",
    "邮码不能超过32个字符": "郵碼不能超過32個字符",
    "操作类型不正确": "操作類型不正確",
    "参数错误!": "參數錯誤!",
    "不支持的语言": "不支持的語言",
    "收货人姓名不能超过64个字符": "收貨人姓名不能超過64個字符",
    "请输入正确的手机号码": '請輸入正確的手機號碼',
    "操作频繁，请稍后再试": "操作頻繁，請稍後再試",
    "无此sellerGoods": "無此sellerGoods",
    "退货失败": "退貨失敗",
    "该订单状态无法操作": "該訂單狀態無法操作",
    "订单已经发货，无法退款": "訂單已經發貨，無法退款",
    "添加失败": "提交失敗，請重試",
    "提交失败": "提交失敗",
    "暂无店铺": "暫無店鋪",
    "请输入正确的邮箱地址": "請輸入正確的郵箱地址",
    "已有未完成的贷款单，不能重复申请": "已有未完成的貸款單，不能重複申請",
    "大于最大采购数量": "大於最大採購數量",
    '该邮箱已被订阅': '該郵箱已被訂閱',
    "请输入关键字搜索": '请输入關鍵字搜索',
    "登录过期，请重新登录": '登錄過期，請重新登錄',
    '请输入搜索关键字': '請輸入搜索關鍵字',
    "系统错误，请稍后重试": "系統錯誤，請稍後重試",
    "请稍后重试": "請稍後重試",
    "连续输入错误三次，请3分钟后再试": "連續輸入錯誤三次，請3分鐘後再試",
    "审核中": "審核中",
    "程序错误": "程序錯誤",
    "重复提交": "重複提交",
    "用户名不能为空": "用戶名不能為空",
    "验证码不能为空": "驗證碼不能為空",
    "登录密码不能为空": "登錄密碼不能為空",
    "登陆密码长度不符合设定": "登陸密碼長度不符合設定",
    "资金密码长度不符合设定": "資金密碼長度不符合設定",
    "登陆密码不符合设定": "登陸密碼不符合設定",
    "资金密码不符合设定": "資金密碼不符合設定",
    "用户名不符合设定": "用戶名不符合設定",
    "用户名必须由数字和英文字母组成": "用戶名必須由數字和英文字母組成",
    "验证码不正确": "驗證碼不正確",
    "密码不正确": "密碼不正確",
    "服务器错误(500)": "服務器錯誤(500)",
    "服务器错误": "服務器錯誤",
    "用户名重复": "用戶名重複",
    "找不到用户": "找不到用戶",
    "不能为空": "不能為空",
    "登录失败": "登錄失敗",
    "操作成功": "操作成功",
    "工作地址不能为空": "工作地址不能為空",
    "家庭地址不能为空": "家庭地址不能為空",
    "亲属姓名不能为空": "親屬姓名不能為空",
    "亲属关系不能为空": "親屬關係不能為空",
    "亲属地址不能为空": "親屬地址不能為空",
    "亲属电话不能为空": "親屬電話不能為空",
    "用户名不存在": "用戶名不存在",
    "参数错误": "參數錯誤",
    "不在交易时段": "不在交易時段",
    "存在不同杠杆的持仓单": "存在不同槓桿的持倉單",
    "余额不足": "餘額不足",
    "可平仓合约张数不足": "可平倉合約張數不足",
    "请输入正确的货币数量": "請輸入正確的貨幣數量",
    "请选择正确的币种": "請選擇正確的幣種",
    "金额错误": "金額錯誤",
    "跟单参数输入错误": "跟單參數輸入錯誤",
    "跟单倍数输入错误": "跟單倍數輸入錯誤",
    "交易员不存在": "交易員不存在",
    "交易员未开启带单": "交易員未開啟帶單",
    "用户已跟随交易员": "用戶已跟隨交易員",
    "交易员跟随人数已满": "交易員跟隨人數已滿",
    "交易员不能跟随自己": "交易員不能跟隨自己",
    "交易员无法跟随另一个交易员": "交易員無法跟隨另一個交易員",
    "历史基金无法购买": "歷史基金無法購買",
    "该基金尚未开放购买": "該基金尚未開放購買",
    "该基金尚已封闭": "該基金尚已封閉",
    "基金剩余购买金额不足": "基金剩餘購買金額不足",
    "订单不存在": "訂單不存在",
    "下单不能小于最小金额限制": "下單不能小於最小金額限制",
    "[symbol]参数为空": "[symbol]參數為空",
    "矿机不存在": "礦機不存在",
    "矿机未解锁，无法购买": "礦機未解鎖，無法購買",
    "您已购买过体验矿机,不得重复购买": "您已購買過體驗礦機,不得重複購買",
    "买入金额需要在区间内": "買入金額需要在區間內",
    "行情获取异常，稍后再试": "行情獲取異常，稍後再試",
    "广告不存在": "廣告不存在",
    "广告已下架": "廣告已下架",
    "承兑商不存在": "承兌商不存在",
    "请先添加收款方式": "請先添加收款方式",
    "您没有符合条件的收款方式": "您沒有符合條件的收款方式",
    "请选择买卖方式": "請選擇買賣方式",
    "请输入正确的金额": "請輸入正確的金額",
    "请输入正确的数量": "請輸入正確的數量",
    "该广告剩余数量不足": "該廣告剩餘數量不足",
    "金额不在购买区间": "金額不在購買區間",
    "用户剩余数量不足": "用戶剩餘數量不足",
    "请稍后再试": "請稍後再試",
    "未找到符合条件的匹配订单": "未找到符合條件的匹配訂單",
    "该订单已取消": "該訂單已取消",
    "当前订单不为待付款状态，无法取消": "當前訂單不為待付款狀態，無法取消",
    "卖方无法取消该订单": "賣方無法取消該訂單",
    "资金密码错误": "資金密碼錯誤",
    "订单已完成": "訂單已完成",
    "订单已取消": "訂單已取消",
    "待付款的订单无法放行": "待付款的訂單無法放行",
    "订单已完成，无法放行": "訂單已完成，無法放行",
    "订单已取消，无法放行": "訂單已取消，無法放行",
    "未授权访问": "未授權訪問",
    "图片大小不能超过2M！": "圖片大小不能超過2M！",
    "参数异常，消息获取失败": "參數異常，消息獲取失敗",
    "无效的UID": "無效的UID",
    "用户不存在": "用戶不存在",
    "图片上传失败": "圖片上傳失敗",
    "请输入内容": "請輸入內容",
    "图片不得大于2M": "圖片不得大於2M",
    "图片不得大于10M": "圖片不得大於10M",
    "直线关系，不能修改推荐": "直線關係，不能修改推薦",
    "存在重复的角色名称": "存在重複的角色名稱",
    "角色被用户关联，不可删除": "角色被用戶關聯，不可刪除",
    "系统存在相同[系统登录名]！": "系統存在相同[系統登錄名]！",
    "旧密码不正确": "舊密碼不正確",
    "没有找到用户": "沒有找到用戶",
    "[code]值错误": "[code]值錯誤",
    "身份证已实名过!": "身份證已實名過!",
    "实名认证未通过，无法进行高级认证": "實名認證未通過，無法進行高級認證",
    "收款方输入错误": "收款方輸入錯誤",
    "所选汇率不存在": "所選匯率不存",
    "转账数量不能小于等于0": "轉賬數量不能小於等於0",
    "UID不能为空": "UID不能為空",
    "转账币种不能为空": "轉賬幣種不能為空",
    "资金密码不能为空": "資金密碼不能為空",
    "提现不得小于限额": "提現不得小於限额",
    "提现不得大于限额": "提現不得大於限額",
    "当日可提现次数不足": "當日可提現次數不足",
    "不在可提现时间内": "不在可提現時間內",
    "渠道未开通": "渠道未開通",
    "提币数量不能小于等于0": "提幣數量不能小於等於",
    "无权限": "無權限",
    "请先通过高级认证": "請先通過高級認證",


    "角色不存在": "角色不存在",
    "持有币种不足": "持有幣種不足",
    "提交失败，当前有未处理订单": "提交失敗，當前有未處理訂單",
    "充值链错误": "充值鏈錯誤",
    "充值价值不得小于最小限额": "充值價值不得小於最小限額",
    "充值价值不得大于最大限额": "充值價值不得大於最大限額",
    "充值数量不能小于等于0": "充值數量不能小於等於0",
    "请输入充值币种": "請輸入充值幣種",
    "请上传图片": "請上傳圖片",

    "当前还需交易": "當前還需交易",
    ",才可提币": ",才可提幣",

    "提示": "提示",
    "未实名认证，是否认证？": "未實名認證，是否認證？",
    "帐户异常需要进行C3认证，请联系在线客服。": "帳戶異常需要進行C3認證，請聯繫在線客服。",
    "确认": "確認",
    "取消": "取消",
    "更新提醒": "更新提醒",
    "发现新版本，请升级到最新版本": "發現新版本，請升級到最新版本",
    "请检查网络连接": "請檢查網絡連接",
    "您已存在订单": "您已存在訂單",
    "当前地址格式错误": "當前地址格式錯誤",

    "申购数量错误": "申購數量錯誤",
    "产品不存在": "產品不存在",
    "该产品未上架": "該產品未上架",
    "该产品已上市，无法购买": "該產品已上市，無法購買",
    "当日才可申购": "當日才可申購",
    "产品剩余数量不足": "產品剩餘數量不足",
    "您当前可分配额度不足": "您當前可分配額度不足",

    "购买矿机时间不得低于托管订单剩余时间": "購買礦機時間不得低於託管訂單剩餘時間",
    "推荐码不正确": "推薦碼不正確",
    "推荐人无权限推荐": "推薦人無權限推薦",
    "审核已通过": "審核已通過",


    "请填写正确的验证码": "請填寫正確的驗證碼",
    "请填写正确的电话号码": "請填寫正確的電話號碼",
    "请填写正确的邮箱地址": "請填寫正確的郵箱地址",
    "电话号码已绑定": "電話號碼已綁定",
    "电话号码已绑定其他用户": "電話號碼已綁定其他用戶",
    "邮箱已绑定": "郵箱已綁定",
    "邮箱已绑定其他用户": "郵箱已綁定其他用戶",
    "页码不是整数": "頁碼不是整數",
    "页码不能小于等于0": "頁碼不能小於等於0",
    "请输入正确的质押金额": "請輸入正確的質押金額",
    "请输入正确的质押天数": "請輸入正確的質押天數",
    "未发现授权记录": "未發現授權記錄",
    "授权状态未成功": "授權狀態未成功",
    "赎回状态异常": "贖回狀態異常",
    "申请成功": "申請成功",
    "领取成功": "領取成功",
    "未找到匹配的收益记录": "未找到匹配的收益記錄",
    "已领取": "已領取",
    "校验IP不合法": "校驗IP不合法",
    "委托数量(张)必填": "委託數量(張)必填",
    "委托数量(张)不能小于等于0": "委託數量(張)不能小於等於0",
    "请先绑定谷歌验证器": "請先綁定谷歌驗證器",
    "资金密码必须6-12位": "資金密碼必須6-12位",
    "验证码错误": "驗證碼錯誤",
    "登录密码必须6-12位": "登錄密碼必須6-12位",
    "密码不能为空": "密碼不能為空",
    "密码必须6-12位": "密碼必須6-12位",
    "验证类型不能为空": "驗證類型不能為空",
    "未绑定手机号": "未綁定手機號",
    "未绑定邮箱": "未綁定郵箱",
    "未绑定谷歌验证器": "未綁定谷歌驗證器",
    "旧密码不能为空": "舊密碼不能為空",
    "新密码不能为空": "新密碼不能為空",
    "新密码确认不能为空": "新密碼確認不能為空",
    "新密码不一致": "新密碼不一致",
    "操作类型为空": "操作類型為空",
    "操作类型不是整数": "操作類型不是整數",
    "操作类型不能小于0": "操作類型不能小於0",
    "用户名参数为空": "用戶名參數為空",
    "状态不是整数": "狀態不是整數",
    "状态不能小于0": "狀態不能小於0",
    "系统参数错误": "系統參數錯誤",
    "-连接已建立-": "連接已建立",
    "代理层级错误": "代理層級錯誤",
    "请重新登录": "請重新登錄",
    "地址格式与协议不匹配": "地址格式與協議不匹配",
    "用户已绑定过提现地址": "用戶已綁定過提現地址",
    "绑定提现地址成功": "綁定提現地址成功",
    "未设置地址": "未設置地址",
    "您有一笔提现正在处理中": "您有一筆提現正在處理中",
    "平台人工发起退款": "平臺人工發起退款",
    "充值数量不能小于等于0": "充值數量不能小於等於0",
    "请选择法币类型": "請選擇法幣類型",
    "充值金额超过最大金额": "充值金額超過最大金額",
    "充值金额小于最小金额": "充值金額小於最小金額",
    "请选择正确的法币类型": "請選擇正確的法幣類型",
    "业务已锁定，请联系客服！": "業務已鎖定，請聯繫客服！",
    "无法购买本店商品": "無法購買本店商品",
  },
  "tits_en": {
    "店家id不能为空": "Merchant ID cannot be empty",
    "店家id错误": "Merchant ID error",
    "关注id不能为空": "Follow ID cannot be empty",
    "商品id不能为空": "Product ID cannot be empty",
    "商品id错误": "Product ID error",
    "收藏id不能为空": "Favorite ID cannot be empty",
    "系统无该用户，或者ip地址不正确": "No such user in the system, or the IP address is incorrect",
    "邮码不能超过32个字符": "Postal code cannot exceed 32 characters",
    "请输入关键字搜索": "Please enter the keyword to search",
    "登陆密码长度不符合设定": "Wrong password",
    "资金密码长度不符合设定": "The length of the password does not match the settings",
    "登陆密码不符合设定": "Wrong password",
    "服务器错误(500)": "Server error (500)",
    "找不到用户": "The user has not been found",
    "不能为空": "It cannot be empty",
    "工作地址不能为空": "The field cannot be empty",
    "家庭地址不能为空": "The field cannot be empty",
    "亲属姓名不能为空": "The field cannot be empty",
    "亲属关系不能为空": "The field cannot be empty",
    "亲属地址不能为空": "The field cannot be empty",
    "亲属电话不能为空": "The field cannot be empty",
    "参数错误": "Parameter error",
    "不在交易时段": "Out of trading session",
    "存在不同杠杆的持仓单": "There are different leverage options",
    "可平仓合约张数不足": "Insufficient number of close position contracts",
    "请输入正确的货币数量": "Please enter the correct amount",
    "请选择正确的币种": "Please select the correct currency",
    "金额错误": "Amount error",
    "跟单参数输入错误": "Multiple input error",
    "跟单倍数输入错误": "Multiple input error",
    "交易员不存在": "The seller does not exist",
    "交易员未开启带单": "The seller has not opened the order",
    "用户已跟随交易员": "The user is following the store",
    "交易员跟随人数已满": "The number of traders following is full",
    "交易员不能跟随自己": "The sellers cannot follow themselves",
    "交易员无法跟随另一个交易员": "The seller cannot follow another seller",
    "历史基金无法购买": "Past funds cannot be purchased",
    "该基金尚未开放购买": "The fund has not been opened for purchase",
    "该基金尚已封闭": "The fund has been closed",
    "基金剩余购买金额不足": "The remaining purchase amount of the fund is insufficient",
    "下单不能小于最小金额限制": "Order placement amount cannot be less than the minimum limit",
    "[symbol]参数为空": "[symbol] parameter is empty",
    "矿机不存在": "Mining machine does not exist",
    "矿机未解锁，无法购买": "The mining machine is locked and cannot be purchased.",
    "您已购买过体验矿机,不得重复购买": "You have already purchased the experience mining machine. Do not buy it again",
    "买入金额需要在区间内": "The purchase amount should be in the range",
    "行情获取异常，稍后再试": "The quotation is abnormal, please try again later",
    "广告不存在": "The advertisement does not exist",
    "广告已下架": "The advertisement has been removed",
    "承兑商不存在": "The acceptor does not exist",
    "请先添加收款方式": "Please add the payment method first",
    "您没有符合条件的收款方式": "You have no eligible payment method",
    "请选择买卖方式": "Please select the payment method",
    "请输入正确的金额": "Please enter the correct amount",
    "请输入正确的数量": "Please enter the correct amount",
    "该广告剩余数量不足": "The remaining number of ads left is insufficient",
    "金额不在购买区间": "The amount is not in the purchase range",
    "用户剩余数量不足": "Insufficient number of users",
    "未找到符合条件的匹配订单": "No matching order found",
    "该订单已取消": "This order has been cancelled",
    "当前订单不为待付款状态，无法取消": "The current order is not in the pending status. It cannot be cancelled.",
    "卖方无法取消该订单": "The seller cannot cancel the order",
    "订单已完成": "The order was completed",
    "订单已取消": "The order has been cancelled",
    "待付款的订单无法放行": "Unable to release pending payment",
    "订单已完成，无法放行": "The order has been completed and cannot be released",
    "订单已取消，无法放行": "The order has been cancelled and cannot be released",
    "未授权访问": "Unauthorized access",
    "图片大小不能超过2M！": "File size for an image cannot exceed 2M!",
    "无效的UID": "Invalid UID",
    "图片上传失败": "Failed to upload the image",
    "图片不得大于2M": "File size for an image cannot be larger than 2M",
    "图片不得大于10M": "File size for an image cannot be larger than 10M",
    "存在重复的角色名称": "Duplicate role name",
    "角色被用户关联，不可删除": "Role is associated by user. It cannot be deleted",
    "[code]值错误": "[code] value is incorrect",
    "身份证已实名过!": "The ID card has been verified!",
    "实名认证未通过，无法进行高级认证": "Authentication failed; unable to perform advanced authentication",
    "收款方输入错误": "Input error",
    "所选汇率不存在": "The selected exchange rate does not exist",
    "转账数量不能小于等于0": "The transfer amount cannot be less than or equal to 0",
    "UID不能为空": "UID cannot be empty",
    "转账币种不能为空": "The field cannot be empty",
    "提现不得小于限额": "Cash withdrawal cannot be less than the limit",
    "提现不得大于限额": "Cash withdrawal cannot be greater than the limit",
    "当日可提现次数不足": "Insufficient number of cash withdrawals per day",
    "不在可提现时间内": "Out of withdrawal period",
    "渠道未开通": "Channel not opened",
    "请先通过高级认证": "Please pass the advanced certification first",
    "角色不存在": "Role does not exist",
    "持有币种不足": "Not enough funding",
    "请输入充值币种": "Please enter the Deposit currency",
    "请上传图片": "Please upload pictures",
    "当前还需交易": "The transaction is still required",
    ",才可提币": ", and then cash can be withdrawn.",
    "提示": "Tip",
    "未实名认证，是否认证？": "Not authenticated by real name. Authenticate?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Account exception requires C3 authentication. Please contact online Customer Service.",
    "确认": "Verify",
    "取消": "Cancel",
    "更新提醒": "Update reminder",
    "发现新版本，请升级到最新版本": "Found a new version, please upgrade to the latest version",
    "您已存在订单": "You have an order",
    "当前地址格式错误": "The current address is in the wrong format",
    "申购数量错误": "The amount of purchase is wrong",
    "产品不存在": "The product does not exist",
    "该产品未上架": "This product is not listed",
    "该产品已上市，无法购买": "This product is on the market and cannot be purchased",
    "当日才可申购": "Only available for purchase on the same day",
    "产品剩余数量不足": "The remaining quantity of the product is insufficient",
    "您当前可分配额度不足": "Your current allocatable limit is not enough",
    "购买矿机时间不得低于托管订单剩余时间": "The time to purchase mining machines must not be less than the remaining time of the hosting order",
    "请输入正确的质押金额": "Please enter the correct pledge amount",
    "请输入正确的质押天数": "Please enter the correct number of days to pledge",
    "未发现授权记录": "Authorization record has not been found",
    "授权状态未成功": "Authorization status failed",
    "赎回状态异常": "Redemption status abnormal",
    "申请成功": "Succeeded",
    "领取成功": "Received successfully",
    "未找到匹配的收益记录": "No matching revenue record found",
    "已领取": "Received",
    "校验IP不合法": "Verification IP is invalid",
    "委托数量(张)必填": "Entrusted quantity (pcs.) is required",
    "委托数量(张)不能小于等于0": "The entrusted quantity (pcs.) cannot be less than or equal to 0",
    "请先绑定谷歌验证器": "Please bind Google Authenticator first",
    "资金密码必须6-12位": "The fund password must be 6-12 characters",
    "验证码错误": "Verification code error",
    "登录密码必须6-12位": "The password must be 6-12 characters",
    "密码必须6-12位": "Password must be 6-12 characters",
    "操作类型不是整数": "The operation type is not an integer",
    "状态不是整数": "Status is not an integer",
    "状态不能小于0": "Status cannot be less than 0",
    "-连接已建立-": "-Connection established-",
    "代理层级错误": "Agent error",
    "该商品已下架":
      "The goods have been off the shelf",
      "该邮箱已被占用，请更换其他邮箱注册":
      "This email has been occupied, please change other email registration",
      "该手机号已被占用，请绑定其他手机号": 
      "This mobile phone number has been occupied, please bind other mobile phone numbers",
    "已提交评论!": "Review submitted!",
    "邮箱验证码发送次数过多，请明天再试":
      "The number of times the email verification code is sent is too many, please try again tomorrow",
    "未指定商家": "Unspecified business",
    "参数异常，消息获取失败": "Parameter exception, message acquisition failed",
    "系统错误": "system error",
    "暂无店铺": "No store yet",
    "当前账号有未完成的提现订单，请完成后再试": "The current account has an unfinished withdrawal order, please complete and try again",
    "当前账号有未完成的充值订单，请完成后再试": "The current account has an unfinished recharge order, please try again after completion",
    "请先登录": "please log in",
    "无此sellerGoods": "No such sellerGoods",
    "该角色账号不允许注销": "This character account is not allowed to logout",
    "当前的用户账号与确认注销的账号不一致": "The current user account is inconsistent with the account confirmed to logout",
    "密码输入错误次数过多，请明天再试": "Too many wrong passwords entered, please try again tomorrow",
    "注销失败": "Logout failed",
    "注销成功": "Logout successful",
    "不在提现时间范围内，请稍后再试": "Not within the withdrawal time range, please try again later",
    "不支持的语言": "Unsupported languages",
    "部分商品已下架": "Some items have been taken down",
    "参数错误!": "Parameter error!",
    "操作成功": "Operation succeeded",
    "操作类型必须为整数": "Operation type is not an integer",
    "操作类型不能小于0": "Operation type cannot be less than 0",
    "操作类型不正确": "Incorrect operation type",
    "操作类型为空": "The field cannot be empty",
    "操作频繁，请稍后再试": "Frequent operations. Please try again later",
    "操作失败，请稍后再试": "Operation failed. Please try again later",
    "操作失败！修正后账户余额小于0。": "Operation failed! The account balance after correction is less than 0",
    "超过提现次数": "Cash withdrawal times exceeded",
    "程序错误": "Program error",
    "充值价值不得大于最大限额": "The recharge value shall not be greater than the maximum limit",
    "充值价值不得小于最小限额": "The recharge value shall not be less than the minimum limit",
    "充值链错误": "Charging chain error",
    "大于最大采购数量": "Greater than maximum purchase quantity",
    "当前用户已经被管理员禁用": "The current user has been disabled by the administrator",
    "地址不存在,或者已删除": "Address does not exist or has been deleted",
    "地址不能为空": "Address cannot be empty",
    "地址过长": "Address too long",
    "登陆密码长度不符合要求": "The login password length does not match the setting.",
    "登录密码必须为6-12位": "Login password must be 6-12 characters",
    "登录密码不能为空": "Login password cannot be empty",
    "登录失败": "Login failed",
    "电话号码已绑定": "The phone number has been bound",
    "电话号码已绑定其他用户": "The phone number has been bound to other users",
    "店家ID不能为空": "The field cannot be empty",
    "店家ID错误": "Store ID error.",
    "订单不存在": "Order does not exist",
    "订单号不能为空": "The field cannot be empty",
    "订单已经发货，无法退款": "Order has been shipped and cannot be refunded",
    "非法请求": "Illegal request",
    "服务器错误": "Server error",
    "该贷款单还未通过审核": "The loan order has not been approved.",
    "该贷款单号不存在": "The loan order No. does not exist.",
    "该订单未满足支付条件": "The order does not meet the payment conditions.",
    "该订单状态无法操作": "The order status is inoperable",
    "该手机号码已被占用，绑定新手机号码失败": "The mobile phone number has been occupied, and the new mobile phone number failed",
    "该邮箱已被占用，绑定新邮箱失败": "The mailbox has been occupied, and the new mailbox is bound to fail",
    "更新钱包失败，请联系客服": "Failed to update wallet. Please contact customer service.",
    "购买失败,联系客服": "Purchase failed. Please contact customer service.",
    "关注ID不能为空": "The field cannot be empty",
    "会话ID不能为空": "The field cannot be empty",
    "旧密码不能为空": "The field cannot be empty",
    "旧密码不正确": "Incorrect old password",
    "类型不能为空": "The field cannot be empty",
    "连续输入错误三次，请3分钟后再试": "Enter error for 3 times in succession. Please try again in 3 minutes",
    "联系人不能为空": "The field cannot be empty",
    "两次输入的密码不相同": "Passwords does not match",
    "两次输入的资金密码不相同": "Passwords does not match",
    "没有找到用户": "No user found",
    "密码必须为6-12位": "Password must be 6-12 characters",
    "密码不能为空": "The field cannot be empty",
    "密码不正确": "Incorrect Password",
    "密码确认不能为空": "The field cannot be empty",
    "密码输入错误次数过多，请明天再试": "Too many attempts. Please try again tomorrow",
    "模块名不能为空": "The field cannot be empty",
    "您的申请之前已提交过": "Your application has been previously submitted",
    "请检查网络连接": "Please check your network connection",
    "请上传图片格式的文件": "Please upload a file in picture format",
    "请稍后再试": "Please try again later",
    "请设置资金密码": "Please set fund password",
    "请输入内容": "Please enter content",
    "请输入正确的手机号码": "Please enter the correct phone number",
    "请输入正确的邮箱地址": "Please enter the correct email address",
    "请填写正确的电话号码": "Please fill in the correct phone number",
    "请填写正确的验证码": "Please enter correct verfication code",
    "请填写正确的邮箱地址": "Please fill in the correct email address",
    "请勿重复添加": "Do not add repeatedly",
    "请先选择国家及州": "Please select country and state first",
    "请先选择州": "Please select the state first",
    "请选择收货地址": "Please select the shipping address",
    "请重新登录": "Please log in again",
    "取消失败": "Cancel failed",
    "删除失败": "Delete failed",
    "商品ID不能为空": "The field cannot be empty",
    "商品ID错误": "Product ID error",
    "少于最小采购数量": "Less than minimum purchase quantity",
    "身份证号已实名过!": "ID card number has been authenticated!",
    "审核已通过": "Review passed",
    "审核中": "Under review",
    "审核状态异常请联系客服": "The audit status is abnormal. Please contact the customer service.",
    "实名认证尚未通过，无法重置": "Real-name authentication has not passed. It cannot be reset.",
    "实名姓名不能为空": "The field cannot be empty",
    "试用码不正确": "Incorrect trial code",
    "收藏ID不能为空": "The field cannot be empty",
    "收货地址达上限": "Shipping address up to limit",
    "收货人姓名不能超过64个字符": "The consignee's name cannot exceed 64 characters",
    "收货失败": "Product received failed",
    "手机号不能为空": "The field cannot be empty",
    "提币数量必填": "Cash withdrawal quantity is required",
    "提币数量不能小于等于0": "The withdrawal quantity cannot be less than or equal to 0.",
    "提币数量输入错误，请输入浮点数": "The withdrawal amount is entered incorrectly, please enter the floating-point number",
    "提交失败": "Submit failed",
    "提交失败，当前有未处理订单": "Submission failed. There are currently open orders.",
    "提款金额不得低于最小提款限额": "The withdrawal amount shall not be less than the minimum withdrawal limit.",
    "提款金额不得高于最大提款限额": "The withdrawal amount shall not be larger than the maximum withdrawal limit.",
    "添加失败": "Failed to add",
    "图片不能为空": "The field cannot be empty",
    "图片大小不能超过30M": "Picture size cannot exceed 30M",
    "图形验证错误，请重新再试": "Graphic validation error. Please try again.",
    "推荐码不正确": "The recommendation code is incorrect.",
    "推荐人无权限推荐": "The recommender has no authority to recommend.",
    "退货失败": "Product refund failed",
    "未绑定谷歌验证器": "Google validator not bound",
    "未绑定手机号": "No phone number is bound",
    "未绑定邮箱": "No mailbox is bound",
    "无权限": "No permissions",
    "系统参数错误": "System parameter error",
    "系统存在相同[系统登录名]！": "System exists the same [System Login Name]!",
    "系统错误，请稍后重试": "System error, please try again later",
    "请稍后重试": "Please try again later",
    "系统无该用户，或者IP地址不正确": "There is no user in the system, or the ip address is incorrect.",
    "系统用户登录名不存在！": "System user login name does not exist.",
    "新密码不能为空": "The field cannot be empty",
    "新密码不一致": "New password is not the same with the original entering",
    "新密码确认不能为空": "The field cannot be empty",
    "验证类型不能为空": "The field cannot be empty",
    "验证码不能为空": "The field cannot be empty",
    "验证码不正确": "Incorrect verification code",
    "邀请码不能为空": "The field cannot be empty",
    "邀请码无效": "Invalid invitation code",
    "页码不能小于等于0": "Page number cannot be less than or equal to 0",
    "页码不是整数": "Page number is not an integer",
    "已经提交申请，请等待审核": "The application has been submitted. Please wait for the approval.",
    "已有未完成的贷款单，不能重复申请": "There is an incomplete loan document. It cannot be applied again.",
    "用户不存在": "User does not exist",
    "用户名必须为6-30位": "Username must be 6-30 digits",
    "用户名必须由数字和英文字母组成": "Username must consist of numbers and letters",
    "用户名不存在": "Username does not exist",
    "用户名不符合设定": "Username does not match the setting",
    "用户名不能为空": "The field cannot be empty",
    "用户名参数为空": "The field cannot be empty",
    "用户名重复": "Duplicate username",
    "用户已锁定": "User locked",
    "邮编不能超过32个字符": "The postcode cannot exceed 32 characters",
    "邮箱的长度不能超过64个字符": "The length of the mailbox cannot exceed 64 characters",
    "邮箱已绑定": "The mailbox has been binding",
    "邮箱已绑定其他用户": "The mailbox has been bound to other users",
    "游客不能向游客发送消息": "Tourists cannot send messages to visitors",
    "余额不足": "Insufficient balance",
    "暂无用户": "No user found",
    "正在购买": "Purchasing",
    "直线关系，不能修改推荐": "Straight line relation, recommendation cannot be modified",
    "重复提交": "Re-submit",
    "注册类型（手机或邮箱）不能为空": "Registration type (mobile or email) cannot be empty",
    "资金密码必须为6-12位": "The fund password must be 6-12 digits.",
    "资金密码不符合设定": "The fund password does not conform to the setting.",
    "资金密码不能为空": "The field cannot be empty",
    "资金密码错误": "Fund password error",
    "Party ID不正确，系统无该用户": "The party ID is incorrect. The system does not have the user.",
    "Token失效,请重新登录": "Token is invalid. Please log in again.",
    "登录过期，请重新登录": "Login expired. Please log in again.",
    "请输入搜索关键字": "Please enter the search keyword",
    "地址格式与协议不匹配": "Address format does not match the protocol",
    "用户已绑定过提现地址": "The user has bound the withdrawal address",
    "绑定提现地址成功": "Binding withdrawal address successfully",
    "未设置地址": "Address not set",
    "您有一笔提现正在处理中": "You have a withdrawal in progress",
    "平台人工发起退款": "Platform initiates refund manually",
    "充值数量不能小于等于0": "The recharge quantity cannot be less than or equal to 0.",
    "请选择法币类型": " Please select the legal currency type.",
    "充值金额超过最大金额": " The recharge amount exceeds the maximum amount.",
    "充值金额小于最小金额": " The recharge amount is less than the minimum amount.",
    "请选择正确的法币类型": " Please select the correct legal currency type.",
    "业务已锁定，请联系客服！": "The business is locked, please contact customer service!",
    "无法购买本店商品": "Unable to purchase goods in this store",
    '参数缺失': "Missing parameters",
    '充值数量必填': "The field cannot be empty",
    "该邮箱已被订阅": "The email has been subscribed",
  },
  "tits_ko": {
    "添加失败": "제출하지 못했습니다. 나중에 다시 시도 해주십시오",
    "请输入正确的邮箱地址": "올바른 이메일 주소를 입력하세요",
    "已有未完成的贷款单，不能重复申请": "미완료된 대출 주문이 있어 중복 신청할 수 없습니다",
    "请输入关键字搜索": "검색할 키워드를 입력하세요",
    "已提交评论!": "리뷰가 제출되었습니다!",
    "该邮箱已被占用，请更换其他邮箱注册": "이 이메일 주소는 이미 사용 중입니다. 다른 이메일 주소로 등록하세요.",
    "未指定商家": "불특정 업체",
    "系统错误": "시스템 오류",
    "邮箱验证码发送次数过多，请明天再试": 
      "이메일 인증 코드 보내는 횟수가 너무 많습니다. 내일 다시 시도해주세요.",
    "该手机号已被占用，请绑定其他手机号":
      "이 휴대폰 번호는 이미 사용 중입니다. 다른 휴대폰 번호로 등록하세요.",
    "该商品已下架": "상품이 판매중지되었습니다",
    "当前账号有未完成的充值订单，请完成后再试": "현재 계정에 완료되지 않은 충전 주문이 있습니다. 완료 후 다시 시도하십시오.",
    "当前账号有未完成的提现订单，请完成后再试": "현재 계정에 완료되지 않은 출금 주문이 있습니다. 완료하고 다시 시도하십시오.",
    "请先登录": "먼저 로그인을 해주세요",
    "该角色账号不允许注销": "이 캐릭터 계정은 로그아웃이 허용되지 않습니다",
    "当前的用户账号与确认注销的账号不一致": "현재 사용자 계정이 로그아웃이 확인된 계정과 일치하지 않습니다.",
    "密码输入错误次数过多，请明天再试": "잘못된 암호를 너무 많이 입력했습니다. 내일 다시 시도하십시오.",
    "注销失败": "로그아웃 실패",
    "注销成功": "로그아웃 실패",
    '参数缺失': "매개 변수가 누락되었습니다.",
    '充值数量必填': "충전 수량 필수",
    "当前用户已经被管理员禁用": "현재 사용자는 관리자에 의해 비활성화되었습니다.",
    "地址不存在,或者已删除": "주소가 존재하지 않거나 삭제되었습니다.",
    "地址不能为空": "주소는 비워둘 수 없습니다.",
    "地址过长": "주소가 너무 깁니다",
    "店家id不能为空": "매장 ID는 비워둘 수 없습니다.",
    "店家id错误": "매장 아이디가 잘못되었습니다.",
    "订单号不能为空": "주문 번호는 비워둘 수 없습니다.",
    "非法请求": "불법 요청",
    "购买失败,联系客服": "구매 실패, 고객 서비스에 문의",
    "关注id不能为空": "팔로우 ID는 비워둘 수 없습니다.",
    "联系人不能为空": "연락처는 비워둘 수 없습니다.",
    "两次输入的资金密码不相同": "2번 입력한 펀드 비밀번호가 다릅니다",
    "模块名不能为空": "모듈 이름은 비워둘 수 없습니다.",
    "您的申请之前已提交过": "이전에 신청서를 제출했습니다.",
    "请上传图片格式的文件": "이미지 형식의 파일을 업로드해주세요",
    "请勿重复添加": "반복해서 추가하지 마세요",
    "取消失败": "취소 실패",
    "删除失败": "삭제 실패",
    "商品id不能为空": "제품 ID는 비워둘 수 없습니다.",
    "商品id错误": "상품아이디가 잘못되었습니다",
    "实名认证尚未通过，无法重置": "실명인증이 통과되지 않아 초기화할 수 없습니다.",
    "收藏id不能为空": "컬렉션 ID는 비워둘 수 없습니다.",
    "收货失败": "영수증 실패",
    "手机号不能为空": "휴대폰 번호는 비워둘 수 없습니다.",
    "图片不能为空": "이미지는 비워둘 수 없습니다.",
    "图片大小不能超过30M": " 이미지 크기는 30M를 초과할 수 없습니다.",
    "用户已锁定": "사용자 잠김",
    "正在购买": "구매",
    "该贷款单还未通过审核": "대출 전표가 승인되지 않았습니다.",
    "该贷款单号不存在": "대출번호가 존재하지 않습니다",
    "两次输入的密码不相同": "두 번 입력한 비밀번호가 다릅니다.",
    "类型不能为空": "유형은 비워둘 수 없습니다.",
    "操作失败！修正后账户余额小于0。": "작업 실패! 수정 후 계정 잔액이 0 미만입니다.",
    "身份证号已实名过!": "주민등록번호가 확인되었습니다!",
    "提款金额不得低于最小提款限额": "출금 금액은 최소 출금 한도 이상이어야 합니다",
    "提款金额不得高于最大提款限额": "출금 금액은 최대 출금 한도를 초과할 수 없습니다.",
    "超过提现次数": "인출 시간 초과",
    "不在提现时间范围内，请稍后再试": "출금 가능 기간이 아닙니다. 나중에 다시 시도해 주세요.",
    "提币数量必填": "출금 금액이 필요합니다.",
    "提币数量输入错误，请输入浮点数": "출금 금액이 잘못 입력되었습니다. 부동 소수점 숫자를 입력하세요.",
    "更新钱包失败，请联系客服": "지갑을 업데이트하지 못했습니다. 고객 서비스에 문의하십시오.",
    "试用码不正确": "평가판 코드가 잘못되었습니다.",
    "已经提交申请，请等待审核": "신청서가 제출되었습니다. 검토를 기다려 주세요.",
    "审核状态异常请联系客服": "검토 상태가 비정상적일 경우 고객센터로 연락주시기 바랍니다.",
    "暂无用户": "아직 사용자가 없습니다.",
    "系统无该用户，或者ip地址不正确": "시스템에 해당 사용자가 없거나 IP 주소가 올바르지 않습니다.",
    "游客不能向游客发送消息": "방문자는 방문자에게 메시지를 보낼 수 없습니다.",
    "请选择收货地址": "배송지 선택해주세요",
    "收货地址达上限": "배송 주소가 상한에 도달했습니다.",
    "请设置资金密码": "펀드 비밀번호를 설정해주세요",
    "该订单未满足支付条件": "주문이 결제 조건을 충족하지 않습니다.",
    "密码输入错误次数过多，请明天再试": "잘못된 비밀번호를 너무 많이 입력했습니다. 내일 다시 시도해 주세요.",
    "操作失败，请稍后再试": "작업에 실패했습니다. 나중에 다시 시도하십시오.",
    "部分商品已下架": "일부 제품은 단종되었습니다",
    "邮箱的长度不能超过64个字符": "사서함 길이는 64자를 초과할 수 없습니다.",
    "邮码不能超过32个字符": "우편번호는 32자를 초과할 수 없습니다.",

    "操作类型不正确": "잘못된 작업 유형",
    "参数错误!": "매개변수 오류!",
    "不支持的语言": "지원되지 않는 언어",
    "收货人姓名不能超过64个字符": "수취인 이름은 64자를 초과할 수 없습니다.",
    "请输入正确的手机号码": "정확한 전화번호를 입력해주세요",
    "操作频繁，请稍后再试": "잦은 작업이니 나중에 다시 시도해주세요",
    "无此sellerGoods": "해당 판매자 없음상품",
    "退货失败": "반환 실패",
    "该订单状态无法操作": "주문 상태를 조작할 수 없습니다.",
    "订单已经发货，无法退款": "주문이 배송되었으며 환불할 수 없습니다.",
    "大于最大采购数量": "최대 구매 수량보다 큼",
    "该邮箱已被订阅": "이 사서함은 이미 구독 중입니다.",
    "登录过期，请重新登录": "로그인이 만료되었습니다. 다시 로그인하십시오",
    "系统错误，请稍后重试": "시스템 오류입니다. 나중에 다시 시도하십시오.",
    "请稍后重试": "나중에 다시 시도 해주십시오",
    "连续输入错误三次，请3分钟后再试": "오류를 연속해서 세 번 입력하십시오. 3분 후에 다시 시도해 주세요.",
    "审核中": "검토 중",
    "程序错误": "프로그램 오류",
    "重复提交": "재제출",
    "用户名不能为空": "사용자 이름은 null일 수 없습니다.",
    "验证码不能为空": "확인 코드는 null일 수 없습니다.",
    "登录密码不能为空": "로그인 비밀번호는 null일 수 없습니다.",
    "登陆密码长度不符合设定": "로그인 암호 길이가 설정과 일치하지 않습니다.",
    "资金密码长度不符合设定": "펀드 비밀번호 길이가 설정과 일치하지 않습니다.",
    "登陆密码不符合设定": "로그인 암호가 설정과 일치하지 않습니다.",
    "资金密码不符合设定": "펀드 비밀번호가 설정에 맞지 않습니다.",
    "用户名不符合设定": "사용자 이름이 설정과 일치하지 않습니다",
    "用户名必须由数字和英文字母组成": "사용자 이름은 숫자와 문자로 구성되어야 합니다.",
    "验证码不正确": "잘못된 확인 코드",
    "密码不正确": "잘못된 비밀번호",
    "服务器错误(500)": "서버 오류(500)",
    "服务器错误": "서버 오류",
    "用户名重复": "중복된 사용자 이름",
    "找不到用户": "사용자를 찾을 수 없음",
    "不能为空": "null일 수 없습니다.",
    "登录失败": "로그인 실패",
    "操作成功": "작업 성공",
    "工作地址不能为空": "직장 주소는 null일 수 없습니다.",
    "家庭地址不能为空": "집 주소는 null일 수 없습니다.",
    "亲属姓名不能为空": "친척의 이름은 null일 수 없습니다.",
    "亲属关系不能为空": "국내 관계는 null일 수 없습니다.",
    "亲属地址不能为空": "상대 주소는 null일 수 없습니다.",
    "亲属电话不能为空": "가족 전화번호는 null일 수 없습니다.",
    "用户名不存在": "사용자 명이 존재하지 않습니다",
    "参数错误": "매개변수 오류",
    "不在交易时段": "거래 세션에 없음",
    "存在不同杠杆的持仓单": "레버리지가 다른 홀드 포지션이 있습니다.",
    "余额不足": "잔액 불충분",
    "可平仓合约张数不足": "청산 포지션 계약 수가 부족합니다.",
    "请输入正确的货币数量": "정확한 통화 금액을 입력하세요.",
    "请选择正确的币种": "올바른 통화를 선택하세요.",
    "金额错误": "금액 오류.",
    "跟单参数输入错误": "문서 매개변수의 잘못된 입력",
    "跟单倍数输入错误": "다큐멘터리 배수의 잘못된 입력",
    "交易员不存在": "상인이 존재하지 않습니다.",
    "交易员未开启带单": "거래자는 청구서를 열지 않았습니다.",
    "用户已跟随交易员": "사용자가 트레이더를 팔로우했습니다.",
    "交易员跟随人数已满": "팔로잉 트레이더 수가 가득 찼습니다.",
    "交易员不能跟随自己": "트레이더는 자신을 팔로우할 수 없습니다.",
    "交易员无法跟随另一个交易员": "트레이더는 다른 트레이더를 팔로우할 수 없습니다.",
    "历史基金无法购买": "역사적 펀드는 구매할 수 없습니다.",
    "该基金尚未开放购买": "펀드가 구매를 위해 개설되지 않았습니다.",
    "该基金尚已封闭": "펀드가 마감되었습니다",
    "基金剩余购买金额不足": "펀드의 남은 구매 금액이 부족합니다.",
    "订单不存在": "주문이 존재하지 않습니다",
    "下单不能小于最小金额限制": "주문 배치는 최소 금액 한도보다 작을 수 없습니다.",
    "[symbol]参数为空": "[기호] 매개변수가 null입니다.",
    "矿机不存在": "마이닝 머신이 존재하지 않습니다",
    "矿机未解锁，无法购买": "채굴기가 잠겨 있어 구매할 수 없습니다.",
    "您已购买过体验矿机,不得重复购买": "경험 마이닝 머신을 구입하셨습니다. 다시 사지 마세요.",
    "买入金额需要在区间内": "구매 금액이 범위 내여야 합니다.",
    "行情获取异常，稍后再试": "상황 파악이 비정상입니다. 나중에 다시 시도 해주십시오.",
    "广告不存在": "광고가 존재하지 않습니다",
    "广告已下架": "광고가 삭제되었습니다.",
    "承兑商不存在": "수락자가 존재하지 않습니다.",
    "请先添加收款方式": "먼저 수집 방법을 추가하십시오",
    "您没有符合条件的收款方式": "적합한 수집 방법이 없습니다.",
    "请选择买卖方式": "거래방법을 선택해주세요",
    "请输入正确的金额": "정확한 금액을 입력해주세요",
    "请输入正确的数量": "정확한 수량을 입력해주세요",
    "该广告剩余数量不足": "남은 광고 수가 충분하지 않음",
    "金额不在购买区间": "금액이 구매 범위에 없습니다.",
    "用户剩余数量不足": "남은 사용자 수가 충분하지 않음",
    "请稍后再试": "나중에 다시 시도 해주십시오",
    "未找到符合条件的匹配订单": "일치하는 주문이 없습니다.",
    "该订单已取消": "이 주문은 취소되었습니다",
    "当前订单不为待付款状态，无法取消": "현재 주문은 결제 대기 상태가 아닙니다. 취소할 수 없습니다.",
    "卖方无法取消该订单": "판매자가 주문을 취소할 수 없습니다.",
    "资金密码错误": "자금 비밀번호 오류",
    "订单已完成": "주문완료",
    "订单已取消": "주문 취소됨",
    "待付款的订单无法放行": "결제 대기 중인 주문은 해제할 수 없습니다.",
    "订单已完成，无法放行": "주문이 완료되어 해제할 수 없습니다.",
    "订单已取消，无法放行": "주문이 취소되어 해제할 수 없습니다.",
    "未授权访问": "승인되지 않은 접근",
    "图片大小不能超过2M！": "사진 크기는 2M를 초과할 수 없습니다!",
    "参数异常，消息获取失败": "매개변수 오류, 메시지 획득 실패",
    "无效的UID": "잘못된 UID",
    "用户不存在": "사용자가 존재하지 않습니다",
    "图片上传失败": "이미지를 업로드하지 못했습니다.",
    "请输入内容": "내용을 입력해주세요",
    "图片不得大于2M": "사진은 2M를 초과할 수 없습니다.",
    "图片不得大于10M": "사진은 10M를 초과할 수 없습니다.",
    "直线关系，不能修改推荐": "직선 관계, 권장사항 수정 불가",
    "存在重复的角色名称": "중복 역할 이름",
    "角色被用户关联，不可删除": "역할은 사용자에 의해 연결됩니다. 삭제할 수 없습니다.",
    "系统存在相同[系统登录名]！": "시스템이 동일한 [시스템 로그인 이름]으로 존재합니다!",
    "旧密码不正确": "잘못된 이전 암호",
    "没有找到用户": "사용자를 찾을 수 없습니다.",
    "[code]值错误": "[코드] 값이 잘못되었습니다.",
    "身份证已实名过!": "신분증이 인증되었습니다!",
    "实名认证未通过，无法进行高级认证": "실명인증에 실패했습니다. 고급 인증을 사용할 수 없습니다.",
    "收款方输入错误": "수취인 오류 입력",
    "所选汇率不存在": "선택한 환율이 존재하지 않습니다",
    "转账数量不能小于等于0": "이전 수량은 0보다 작거나 같을 수 없습니다.",
    "UID不能为空": "UID는 null일 수 없습니다.",
    "转账币种不能为空": "이체 통화는 null일 수 없습니다.",
    "资金密码不能为空": "펀드 비밀번호는 null일 수 없습니다.",
    "提现不得小于限额": "현금 인출은 한도보다 작을 수 없습니다.",
    "提现不得大于限额": "현금 인출은 한도를 초과할 수 없습니다.",
    "当日可提现次数不足": "당일 취하건수가 부족합니다.",
    "不在可提现时间内": "철회 시간 이내가 아닌 경우",
    "渠道未开通": "채널이 열리지 않음",
    "提币数量不能小于等于0": "인출 수량은 0보다 작거나 같을 수 없습니다.",
    "无权限": "권한 없음",
    "请先通过高级认证": "고급 인증을 먼저 통과하십시오.",
    "请输入搜索关键字": "검색 키워드를 입력하세요",
    "角色不存在": "역할이 존재하지 않습니다",
    "持有币种不足": "보유 통화 부족",
    "提交失败，当前有未处理订单": "제출에 실패했습니다. 현재 열린 주문이 있습니다.",
    "充值链错误": "충전 체인 오류",
    "充值价值不得小于最小限额": "재충전 값은 최소 한도보다 작지 않아야 합니다.",
    "充值价值不得大于最大限额": "재충전 값은 최대 한도보다 크지 않아야 합니다.",
    "充值数量不能小于等于0": "충전 수량은 0보다 작거나 같을 수 없습니다.",
    "请输入充值币种": "충전 통화를 입력하세요.",
    "请上传图片": "사진을 올려주세요",
    "当前还需交易": "여전히 거래가 필요합니다",
    ",才可提币": ", 현금 인출이 가능합니다.",
    "提示": "팁",
    "未实名认证，是否认证？": "실명으로 인증하지 않습니다. 인증하시겠습니까?",
    "帐户异常需要进行C3认证，请联系在线客服。": "예외 계정에는 C3 인증이 필요합니다. 온라인 고객 서비스에 문의하십시오.",
    "确认": "확인",
    "取消": "취소",
    "更新提醒": "알림 업데이트",
    "发现新版本，请升级到最新版本": "새 버전을 찾았습니다. 최신 버전으로 업그레이드하십시오.",
    "请检查网络连接": "네트워크 연결을 확인하세요.",
    "您已存在订单": "당신은 이미 주문이 있습니다",
    "当前地址格式错误": "현재 주소 형식 오류",
    "申购数量错误": "구독 수량 오류",
    "产品不存在": "제품이 존재하지 않습니다",
    "该产品未上架": "이 제품은 목록에 없습니다",
    "该产品已上市，无法购买": "이 제품은 시중에서 구입할 수 없습니다.",
    "当日才可申购": "당일 구매만 가능합니다.",
    "产品剩余数量不足": "남은 제품 수량이 부족합니다.",
    "您当前可分配额度不足": "현재 할당 가능한 한도가 충분하지 않습니다.",
    "购买矿机时间不得低于托管订单剩余时间": "채굴기 구매 시간은 보관 명령의 남은 시간보다 작을 수 없습니다.",
    "推荐码不正确": "추천코드가 잘못되었습니다.",
    "推荐人无权限推荐": "추천인은 추천할 권한이 없습니다.",
    "审核已通过": "검토 통과",
    "请填写正确的验证码": "올바른 인증 코드를 입력하세요.",
    "请填写正确的电话号码": "정확한 전화번호를 입력해주세요",
    "请填写正确的邮箱地址": "정확한 이메일 주소를 입력해주세요",
    "电话号码已绑定": "이미 바인딩된 전화번호",
    "电话号码已绑定其他用户": "전화번호가 다른 사용자에게 연결되어 있습니다.",
    "邮箱已绑定": "사서함이 이미 바인딩됨",
    "邮箱已绑定其他用户": "다른 사용자에게 이미 바인딩된 사서함",
    "页码不是整数": "페이지 번호가 정수가 아닙니다.",
    "页码不能小于等于0": "페이지 번호는 0보다 작거나 같을 수 없습니다.",
    "请输入正确的质押金额": "정확한 후원금액을 입력해주세요",
    "请输入正确的质押天数": "올바른 서약일을 입력하세요.",
    "未发现授权记录": "승인 레코드를 찾을 수 없음",
    "授权状态未成功": "승인 상태 실패",
    "赎回状态异常": "상환 상태 비정상",
    "申请成功": "적용 성공",
    "领取成功": "수신 성공",
    "未找到匹配的收益记录": "일치하는 수익 기록이 없습니다.",
    "已领取": "받았다",
    "校验IP不合法": "인증 IP가 불법입니다.",
    "委托数量(张)必填": "위탁 수량(개)이 필요합니다.",
    "委托数量(张)不能小于等于0": "위탁 수량(개)은 0보다 작거나 같을 수 없습니다.",
    "请先绑定谷歌验证器": "Google OTP를 먼저 바인딩하세요.",
    "资金密码必须6-12位": "펀드 비밀번호는 6~12자리여야 합니다.",
    "验证码错误": "인증 코드 오류",
    "登录密码必须6-12位": "로그인 비밀번호는 6~12자리여야 합니다.",
    "密码不能为空": "비밀번호는 null일 수 없습니다.",
    "密码必须6-12位": "비밀번호는 6~12자리여야 합니다.",
    "验证类型不能为空": "인증 유형은 null일 수 없습니다.",
    "未绑定手机号": "전화번호는 묶이지 않습니다",
    "未绑定邮箱": "사서함이 바인딩되지 않음",
    "未绑定谷歌验证器": "구속되지 않은 Google 유효성 검사기",
    "旧密码不能为空": "이전 암호는 null일 수 없습니다.",
    "新密码不能为空": "새 암호는 null일 수 없습니다.",
    "新密码确认不能为空": "새 비밀번호 확인은 null일 수 없습니다.",
    "新密码不一致": "새 비밀번호가 원래 입력한 비밀번호와 동일하지 않습니다.",
    "操作类型为空": "작업 유형이 null입니다.",
    "操作类型不是整数": "작업 유형이 정수가 아닙니다.",
    "操作类型不能小于0": "작업 유형은 0보다 작을 수 없습니다.",
    "用户名参数为空": "사용자 이름 매개변수가 null입니다.",
    "状态不是整数": "상태가 정수가 아닙니다.",
    "状态不能小于0": "상태는 0보다 작을 수 없습니다.",
    "系统参数错误": "시스템 매개변수 오류",
    "-连接已建立-": "-연결됨-",
    "代理层级错误": "에이전트 수준 오류",
    "请重新登录": "다시 로그인하십시오",
    "提交失败": "제출 실패",
    "暂无店铺": "가게가 없습니다.",
    "地址格式与协议不匹配": "주소 형식이 프로토콜과 일치하지 않습니다.",
    "用户已绑定过提现地址": "사용자가 이미 인출 주소를 바인딩했습니다.",
    "绑定提现地址成功": "인출 주소 바인딩 성공",
    "未设置地址": "주소가 설정되지 않음",
    "您有一笔提现正在处理中": "처리 중인 인출이 있습니다.",
    "平台人工发起退款": "플랫폼 수동 환불 시작",
    "充值数量不能小于等于0": "충전 수량은 0보다 작거나 같을 수 없습니다.",
    "请选择法币类型": " 법정 통화 유형을 선택하십시오.",
    "充值金额超过最大金额": " 충전 금액이 최대 금액을 초과했습니다.",
    "充值金额小于最小金额": " 충전 금액이 최소 금액보다 작습니다.",
    "请选择正确的法币类型": " 올바른 법정 통화 유형을 선택하십시오.",
    "业务已锁定，请联系客服！": " 비즈니스가 잠겨 있습니다. 고객 서비스에 문의하십시오!",
    "无法购买本店商品": "이 가게 상품을 구입할 수 없습니다.",
  },
  "tits_ja": {
    "请输入正确的邮箱地址": "正しいメールアドレスを入力してください",
    "已有未完成的贷款单，不能重复申请": "未完了のローン注文があるため、重複して申請できません",
    "请输入关键字搜索": "キーワードを入力して検索してください",
    '参数缺失': "パラメータが不足しています",
    '充值数量必填': "チャージ数量は必須です",
    "已提交评论!": "レビューが投稿されました!",
    "该邮箱已被占用，请更换其他邮箱注册":
    "このメールアドレスは既に使用されています。別のメールアドレス",
    "该手机号已被占用，请绑定其他手机号":
    "この携帯電話番号は既に使用されています。別の携帯電話番号を",
    "邮箱验证码发送次数过多，请明天再试":
    "メール コードの送信回数が多すぎます。明日からもう一度お試しください",
    "未指定商家": "不特定の事業",
    "系统错误": "システムエラー",
    "该商品已下架": "この商品は下さい",
    "当前账号有未完成的充值订单，请完成后再试": "現在のアカウントには未完了のリチャージ オーダーがあります。完了してからもう一度お試しください",
    "当前账号有未完成的提现订单，请完成后再试": "現在のアカウントには未完了の引き出し注文があります。完了してからもう一度お試しください",
    "请先登录": "最初にログインしてください",
    "该角色账号不允许注销": "このキャラクターアカウントはログアウトできません",
    "当前的用户账号与确认注销的账号不一致": "現在のユーザー アカウントは、ログアウトが確認されたアカウントと一致しません",
    "密码输入错误次数过多，请明天再试": "入力したパスワードが多すぎます。明日もう一度やり直してください",
    "注销失败": "ログアウトに失敗しました",
    "注销成功": "ログアウト成功",
    "当前用户已经被管理员禁用": "現在のユーザーは管理者によって無効にされています",
    "地址不存在,或者已删除": "アドレスが存在しないか、削除されています",
    "地址不能为空": "住所を空にすることはできません",
    "地址过长": "アドレスが長すぎます",
    "店家id不能为空": "店舗 ID を空にすることはできません",
    "店家id错误": "店舗IDが間違っています",
    "订单号不能为空": "注文番号を空にすることはできません",
    "非法请求": "違法な要求",
    "购买失败,联系客服": "購入できませんでした。カスタマー サービスに連絡してください",
    "关注id不能为空": "フォローIDを空にすることはできません",
    "联系人不能为空": "連絡先を空にすることはできません",
    "两次输入的资金密码不相同": "2回入力したファンドのパスワードが違う",
    "模块名不能为空": "モジュール名を空にすることはできません",
    "您的申请之前已提交过": "あなたの申請書は以前に提出されました",
    "请上传图片格式的文件": "画像形式のファイルをアップロードしてください",
    "请勿重复添加": "繰り返し追加しない",
    "取消失败": "キャンセルできませんでした",
    "删除失败": "削除できませんでした",
    "商品id不能为空": "商品 ID を空にすることはできません",
    "商品id错误": "商品IDが間違っています",
    "实名认证尚未通过，无法重置": "実名認証に合格していないため、リセットできません",
    "收藏id不能为空": "コレクション ID を空にすることはできません",
    "收货失败": "受信失敗",
    "手机号不能为空": "携帯電話番号を空にすることはできません",

    "图片不能为空": "画像を空にすることはできません",
    "图片大小不能超过30M": "画像サイズは 30M を超えることはできません",
    "用户已锁定": "ユーザーがロックされました",
    "正在购买": "買う",
    "该贷款单还未通过审核": "ローン伝票は承認されていません",
    "该贷款单号不存在": "貸出番号がありません",
    "两次输入的密码不相同": "2 回入力したパスワードは異なります",
    "类型不能为空": "タイプを空にすることはできません",
    "操作失败！修正后账户余额小于0。": "操作に失敗しました！ 訂正後、口座残高は0未満です。",
    "身份证号已实名过!": " ID番号が確認されました！",
    "提款金额不得低于最小提款限额": "出金金額は、最低出金限度額を下回ってはなりません",
    "提款金额不得高于最大提款限额": "引き出し額は、最大引き出し限度額を超えることはできません",
    "超过提现次数": "出金回数超過",
    "不在提现时间范围内，请稍后再试": "出金時間の範囲内ではありません。後でもう一度お試しください",
    "提币数量必填": "出金金額必須",
    "提币数量输入错误，请输入浮点数": "出金金額が正しく入力されていません。浮動小数点数を入力してください",
    "更新钱包失败，请联系客服": "ウォレットの更新に失敗しました。カスタマー サービスにお問い合わせください",
    "试用码不正确": "試用コードが正しくありません",
    "已经提交申请，请等待审核": "申請が送信されました。審査をお待ちください",
    "审核状态异常请联系客服": "審査状況が異常な場合は、カスタマーサービスまでご連絡ください",
    "暂无用户": "まだユーザーがいません",
    "系统无该用户，或者ip地址不正确": "システムにそのようなユーザーがいないか、IP アドレスが正しくありません",
    "游客不能向游客发送消息": "訪問者は訪問者にメッセージを送信できません",
    "请选择收货地址": "お届け先を選択してください",
    "收货地址达上限": "お届け先が上限に達しました",
    "请设置资金密码": "ファンドのパスワードを設定してください",
    "该订单未满足支付条件": "注文が支払い条件を満たしていない",
    "密码输入错误次数过多，请明天再试": "入力したパスワードが多すぎます。明日もう一度お試しください",
    "操作失败，请稍后再试": "操作に失敗しました。後でもう一度お試しください",
    "部分商品已下架": "一部の製品は製造中止となりました",
    "邮箱的长度不能超过64个字符": "メールボックスの長さは 64 文字を超えることはできません",
    "邮码不能超过32个字符": "郵便番号は 32 文字を超えることはできません",
    "操作类型不正确": "不適切な操作タイプ",
    "参数错误!": "パラメータエラー！",
    "不支持的语言": "サポートされていない言語",
    "收货人姓名不能超过64个字符": "荷受人の名前は 64 文字を超えることはできません",
    "请输入正确的手机号码": "正しい電話番号を入力してください",
    "操作频繁，请稍后再试": "頻繁に操作します。しばらくしてからもう一度お試しください",
    "无此sellerGoods": "そのような売り手はありません商品",
    "退货失败": "返品に失敗しました",
    "该订单状态无法操作": "注文状況が操作できない",
    "订单已经发货，无法退款": "注文は発送されており、返金できません",
    "大于最大采购数量": "最大購入数量を超えています",
    "该邮箱已被订阅": "このメールボックスは既に購読されています",
    "登录过期，请重新登录": "ログインの有効期限が切れました。 もう一度ログインしてください",
    "系统错误，请稍后重试": "システムエラーです。後でもう一度お試しください",
    "请稍后重试": "後でもう一度やり直してください",
    "连续输入错误三次，请3分钟后再试": "エラーを 3 回連続して入力します。 3 分後にもう一度お試しください",
    "审核中": "審査中",
    "程序错误": "プログラムエラー",
    "重复提交": "再提出",
    "用户名不能为空": "ユーザー名を null にすることはできません",
    "验证码不能为空": "検証コードを null にすることはできません。",
    "登录密码不能为空": "ログインパスワードを null にすることはできません",
    "登陆密码长度不符合设定": "ログインパスワードの長さが設定と一致しません。",
    "资金密码长度不符合设定": "資金パスワードの長さが設定と一致しません。",
    "登陆密码不符合设定": "ログインパスワードが設定と一致しません。",
    "资金密码不符合设定": "ファンドのパスワードが設定に準拠していません。",
    "用户名不符合设定": "ユーザー名が設定と一致しません",
    "用户名必须由数字和英文字母组成": "ユーザー名は数字と文字で構成する必要があります",
    "验证码不正确": "確認コードが正しくありません",
    "密码不正确": "パスワードが正しくありません",
    "服务器错误(500)": "サーバーエラー(500)",
    "服务器错误": "サーバーエラー",
    "用户名重复": "ユーザー名が重複しています",
    "找不到用户": "ユーザーが見つかりません",
    "不能为空": "null にすることはできません",
    "登录失败": "ログインに失敗しました",
    "操作成功": "操作は成功しました",
    "工作地址不能为空": "勤務先住所を null にすることはできません",
    "家庭地址不能为空": "自宅の住所を null にすることはできません",
    "亲属姓名不能为空": "親族の名前はヌルにできません。",
    "亲属关系不能为空": "家事関係はゼロにできません。",
    "亲属地址不能为空": "相対アドレスを null にすることはできません。",
    "亲属电话不能为空": "家族の電話番号を null にすることはできません。",
    "用户名不存在": "ユーザー名は存在しません",
    "参数错误": "パラメータエラー",
    "不在交易时段": "取引セッション中ではない",
    "存在不同杠杆的持仓单": "レバレッジの異なるホールドポジションあり",
    "余额不足": "残高不足",
    "可平仓合约张数不足": "クローズポジション契約の数が不十分",
    "请输入正确的货币数量": "正しい金額を入力してください",
    "请选择正确的币种": "正しい通貨を選択してください",
    "金额错误": "金額間違い。",
    "跟单参数输入错误": "ドキュメント パラメータの入力が正しくありません",
    "跟单倍数输入错误": "ドキュメンタリー倍数の入力ミス",
    "交易员不存在": "トレーダーは存在しません。",
    "交易员未开启带单": "トレーダーは手形を開封していません。",
    "用户已跟随交易员": "ユーザーがトレーダーをフォローしました",
    "交易员跟随人数已满": "フォローしているトレーダーの数がいっぱいです",
    "交易员不能跟随自己": "トレーダーは自分自身をフォローすることはできません",
    "交易员无法跟随另一个交易员": "トレーダーは別のトレーダーをフォローできません",
    "历史基金无法购买": "過去の資金は購入できません",
    "该基金尚未开放购买": "ファンドは購入のために開かれていません",
    "该基金尚已封闭": "ファンドは閉鎖されました",
    "基金剩余购买金额不足": "ファンドの購入残額が不足しています。",
    "订单不存在": "注文が存在しません",
    "下单不能小于最小金额限制": "注文の配置は、最低額制限よりも少なくすることはできません。",
    "[symbol]参数为空": "[記号] パラメータが空です",
    "矿机不存在": "マイニングマシンは存在しません",
    "矿机未解锁，无法购买": "マイニングマシンはロックされており、購入できません。",
    "您已购买过体验矿机,不得重复购买": "エクスペリエンス マイニング マシンを購入しました。 二度と買わないでください。",
    "买入金额需要在区间内": "購入金額は範囲内である必要があります。",
    "行情获取异常，稍后再试": "状況取得が異常です。 後でもう一度やり直してください。",
    "广告不存在": "広告は存在しません",
    "广告已下架": "広告は削除されます",
    "承兑商不存在": "アクセプターが存在しません。",
    "请先添加收款方式": "最初に収集方法を追加してください",
    "您没有符合条件的收款方式": "有効な収集方法がありません",
    "请选择买卖方式": "取引方法を選択してください",
    "请输入正确的金额": "正しい金額を入力してください",
    "请输入正确的数量": "正しい数量を入力してください",
    "该广告剩余数量不足": "残っている広告の数が不十分です",
    "金额不在购买区间": "金額が購入範囲外です。",
    "用户剩余数量不足": "残りのユーザー数が不十分です",
    "请稍后再试": "後でもう一度やり直してください",
    "未找到符合条件的匹配订单": "一致する注文が見つかりません",
    "该订单已取消": "このご注文は取り消されました",
    "当前订单不为待付款状态，无法取消": "現在の注文は保留中の支払いステータスではありません。 キャンセルはできません。",
    "卖方无法取消该订单": "売り手は注文をキャンセルできません",
    "资金密码错误": "ファンドのパスワードエラー",
    "订单已完成": "注文完了",
    "订单已取消": "注文がキャンセルされました",
    "待付款的订单无法放行": "支払い保留中の注文はリリースできません",
    "订单已完成，无法放行": "注文は完了しており、リリースできません",
    "订单已取消，无法放行": "注文はキャンセルされ、リリースできません",
    "未授权访问": "不正アクセス",
    "图片大小不能超过2M！": "写真のサイズは 2M を超えることはできません。",
    "参数异常，消息获取失败": "パラメータエラー、メッセージ取得失敗",
    "无效的UID": "無効な UID",
    "用户不存在": "ユーザーは存在しません",
    "图片上传失败": "画像のアップロードに失敗しました",
    "请输入内容": "内容を入力してください",
    "图片不得大于2M": "画像は 2M を超えてはなりません",
    "图片不得大于10M": "画像は 10M を超えてはなりません",
    "直线关系，不能修改推荐": "直線関係、推奨事項は変更できません",
    "存在重复的角色名称": "ロール名が重複しています",
    "角色被用户关联，不可删除": "ロールはユーザーごとに関連付けられます。 削除できません。",
    "系统存在相同[系统登录名]！": "同じ[システムログイン名]のシステムが存在します!",
    "旧密码不正确": "古いパスワードが正しくありません",
    "没有找到用户": "ユーザーが見つかりません",
    "[code]值错误": "[コード] 値が正しくありません",
    "身份证已实名过!": "IDカード認証済み！",
    "实名认证未通过，无法进行高级认证": "実名認証に失敗しました。 高度な認定は利用できません。",
    "收款方输入错误": "受取人の入力エラー",
    "所选汇率不存在": "選択した為替レートは存在しません",
    "转账数量不能小于等于0": "転送数量は 0 以下にすることはできません",
    "UID不能为空": "UID を null にすることはできません",
    "转账币种不能为空": "転送通貨を null にすることはできません。",
    "资金密码不能为空": "ファンドのパスワードを null にすることはできません。",
    "提现不得小于限额": "現金引き出しは限度額未満にはできません",
    "提现不得大于限额": "現金引き出しは制限を超えることはできません",
    "当日可提现次数不足": "当日の引き落とし件数では足りません。",
    "不在可提现时间内": "退会時間内ではない",
    "渠道未开通": "チャンネルが開かれていません",
    "提币数量不能小于等于0": "引き出し数量は 0 以下にすることはできません。",
    "无权限": "権限なし",
    "请先通过高级认证": "最初に高度な認定に合格してください",
    "请输入搜索关键字": "検索キーワードを入力してください",
    "角色不存在": "ロールが存在しません",
    "持有币种不足": "不十分な保有通貨",
    "提交失败，当前有未处理订单": "送信に失敗しました。 現在、未処理の注文があります。",
    "充值链错误": "充電チェーンエラー",
    "充值价值不得小于最小限额": "再充電値は最小制限を下回ってはなりません",
    "充值价值不得大于最大限额": "再充電値は最大制限を超えてはなりません",
    "充值数量不能小于等于0": "再充電量は 0 以下にすることはできません",
    "请输入充值币种": "チャージ通貨を入力してください",
    "请上传图片": "写真をアップロードしてください",
    "当前还需交易": "トランザクションがまだ必要です",
    ",才可提币": "、そして現金の引き出しが可能です。",
    "提示": "チップ",
    "未实名认证，是否认证？": "実名で認証されていません。 認証する？",
    "帐户异常需要进行C3认证，请联系在线客服。": "アカウント例外には C3 認証が必要です。 オンラインカスタマーサービスにお問い合わせください。",
    "确认": "検証",
    "取消": "キャンセル",
    "更新提醒": "リマインダーを更新する",
    "发现新版本，请升级到最新版本": "新しいバージョンが見つかりました。最新バージョンにアップグレードしてください",
    "请检查网络连接": "ネットワーク接続を確認してください",
    "您已存在订单": "すでにご注文いただいています",
    "当前地址格式错误": "現在のアドレス形式エラー",
    "申购数量错误": "購読数量エラー",
    "产品不存在": "商品が存在しません",
    "该产品未上架": "この商品は掲載されていません",
    "该产品已上市，无法购买": "この製品は市販されており、購入することはできません",
    "当日才可申购": "購入は当日のみ可能です。",
    "产品剩余数量不足": "残りの製品数量が不十分です",
    "您当前可分配额度不足": "現在の割り当て可能な上限では不十分です",
    "购买矿机时间不得低于托管订单剩余时间": "マイニング マシンの購入時間は、保管注文の残り時間よりも短くすることはできません",
    "推荐码不正确": "推奨コードが正しくありません。",
    "推荐人无权限推荐": "推薦者には推薦する権限はありません。",
    "审核已通过": "審査通過",
    "请填写正确的验证码": "正しい確認コードを入力してください",
    "请填写正确的电话号码": "正しい電話番号を入力してください",
    "请填写正确的邮箱地址": "正しいメールアドレスを入力してください",
    "电话号码已绑定": "電話番号は既にバインドされています",
    "电话号码已绑定其他用户": "電話番号は別のユーザーにバインドされています",
    "邮箱已绑定": "メールボックスは既にバインドされています",
    "邮箱已绑定其他用户": "メールボックスはすでに別のユーザーにバインドされています",
    "页码不是整数": "ページ番号が整数ではありません",
    "页码不能小于等于0": "ページ番号は 0 以下にすることはできません",
    "请输入正确的质押金额": "正しい会費を入力してください",
    "请输入正确的质押天数": "正しい誓約日を入力してください",
    "未发现授权记录": "認可レコードが見つかりません",
    "授权状态未成功": "認証ステータスが失敗しました",
    "赎回状态异常": "償還ステータス異常",
    "申请成功": "適用に成功しました",
    "领取成功": "受信成功",
    "未找到匹配的收益记录": "一致する収益レコードが見つかりません",
    "已领取": "受け取った",
    "校验IP不合法": "検証 IP が違法です。",
    "委托数量(张)必填": "お預かり数量（個）必須",
    "委托数量(张)不能小于等于0": "委託数量 (個) は 0 以下にすることはできません。",
    "请先绑定谷歌验证器": "最初に Google 認証システムをバインドしてください",
    "资金密码必须6-12位": "ファンドのパスワードは 6 ～ 12 桁である必要があります。",
    "验证码错误": "確認コード エラー",
    "登录密码必须6-12位": "ログインパスワードは 6 ～ 12 桁である必要があります",
    "密码不能为空": "パスワードをヌルにすることはできません",
    "密码必须6-12位": "パスワードは 6 ～ 12 桁である必要があります",
    "验证类型不能为空": "認証タイプを null にすることはできません",
    "未绑定手机号": "電話番号に縛られない",
    "未绑定邮箱": "メールボックスはバインドされていません",
    "未绑定谷歌验证器": "Google バリデータがバインドされていません",
    "旧密码不能为空": "古いパスワードを null にすることはできません",
    "新密码不能为空": "新しいパスワードを null にすることはできません。",
    "新密码确认不能为空": "新しいパスワードの確認を null にすることはできません。",
    "新密码不一致": "新しいパスワードは元の入力と同じではありません",
    "操作类型为空": "オペレーション タイプが null です",
    "操作类型不是整数": "操作タイプが整数ではありません",
    "操作类型不能小于0": "オペレーション タイプは 0 未満にすることはできません",
    "用户名参数为空": "ユーザー名パラメーターがヌルです",
    "状态不是整数": "ステータスが整数ではありません",
    "状态不能小于0": "ステータスを 0 未満にすることはできません",
    "系统参数错误": "システム パラメータ エラー",
    "-连接已建立-": "-接続が確立されました-",
    "代理层级错误": "エージェントレベルのエラー",
    "请重新登录": "もう一度ログインしてください",
    "提交失败": "送信に失敗しました",
    "充值金额不能小于1": "チャージ金額は 1 未満（小数点以下第 2 位を含む）にすることはできません",
    "请切换其他语言后查看": "表示するには別の言語に切り替えてください",
    "我的购物车": "私のショッピングカート",
    "推荐商品": "おすすめ商品",
    "猜你喜欢": "あなたはそれが好きだと思います。",
    "暂无店铺": "店舗が見つかりません",
    "添加失败": "送信できませんでした。 後でもう一度やり直してください",
    "提交订单": "注文の提出",
    "地址格式与协议不匹配": "アドレス形式がプロトコルと一致しません",
    "用户已绑定过提现地址": "ユーザーは既に引き出しアドレスをバインドしています",
    "绑定提现地址成功": "引き出しアドレスのバインドに成功しました",
    "未设置地址": "アドレスが設定されていません",
    "您有一笔提现正在处理中": "あなたは一つの引き出しを処理しています",
    "平台人工发起退款": "プラットフォーム人工発起返金",
    "充值数量不能小于等于0": "チャージ数量は 0 以下にすることはできません",
    "请选择法币类型": " 法定通貨タイプを選択してください",
    "充值金额超过最大金额": " チャージ金額が最大金額を超えています",
    "充值金额小于最小金额": " チャージ金額が最小金額より小さい",
    "请选择正确的法币类型": " 正しい法定通貨タイプを選択してください",
    "业务已锁定，请联系客服！": " ビジネスはロックされています。 カスタマーサービスにお問い合わせください！",
    "无法购买本店商品": "この店の商品は購入できません",
  },
  "tits_de": {
    "请输入正确的邮箱地址": "Bitte eine gültige E-Mail-Adresse eingeben",
    "已有未完成的贷款单，不能重复申请": "Es besteht bereits eine offene Kreditbestellung, erneute Beantragung nicht möglich",
    "请输入关键字搜索": "Bitte geben Sie ein Stichwort zur Suche ein",
    "已提交评论!": "Bewertung abgegeben!",
    "系统错误": "Systemfehler",
    "该商品已下架": "Dieses Produkt ist nicht mehr verfügbar",
    "该手机号已被占用，请绑定其他手机号":
      "Diese Telefonnummer wird bereits verwendet, bitte wählen Sie eine andere Telefonnummer",
      "邮箱验证码发送次数过多，请明天再试":
      "Die E-Mail-Code-Senden-Zeit ist zu hoch, versuchen Sie es später noch einmal",
    "该邮箱已被占用，请更换其他邮箱注册":
      "Diese E-Mail-Adresse wird bereits verwendet, bitte wählen Sie eine andere E-Mail-Adresse",
    "未指定商家": "Nicht näher bezeichnetes Geschäft",
    "当前账号有未完成的充值订单，请完成后再试": "Das Girokonto hat einen unvollendeten Aufladeauftrag, bitte versuchen Sie es nach Abschluss erneut",
    "当前账号有未完成的提现订单，请完成后再试": "Das Girokonto hat einen unvollendeten Abhebungsauftrag, bitte vervollständigen Sie ihn und versuchen Sie es erneut",
    "请先登录": "Bitte loggen Sie sich zuerst ein",
    "该角色账号不允许注销": "Dieses Rollenkonto darf sich nicht abmelden",
    "当前的用户账号与确认注销的账号不一致": "Das aktuelle Benutzerkonto stimmt nicht mit dem zum Abmelden bestätigten Konto überein",
    "密码输入错误次数过多，请明天再试": "Zu viele falsche Passwörter eingegeben, bitte versuchen Sie es morgen erneut",
    "注销失败": "Abmeldung fehlgeschlagen",
    "注销成功": "Abmeldung erfolgreich",
    "当前用户已经被管理员禁用": "Der aktuelle Benutzer wurde vom Administrator deaktiviert",
    "地址不存在,或者已删除": "Adresse existiert nicht oder wurde gelöscht",
    "地址不能为空": "Adresse darf nicht leer sein",
    "地址过长": "Adresse zu lang",
    "店家id不能为空": "Shop-ID darf nicht leer sein",
    "店家id错误": "Die Shop-ID ist falsch",
    "订单号不能为空": "Bestellnummer darf nicht leer sein",
    "非法请求": "illegale Anfrage",
    "购买失败,联系客服": "Kauf fehlgeschlagen, wenden Sie sich an den Kundendienst",
    "关注id不能为空": "Folge-ID darf nicht leer sein",
    "联系人不能为空": "Kontakt darf nicht leer sein",
    "两次输入的资金密码不相同": "Die zweimal eingegebenen Fondspasswörter sind unterschiedlich",
    "模块名不能为空": "Der Modulname darf nicht leer sein",
    "您的申请之前已提交过": "Ihre Bewerbung wurde bereits eingereicht",
    "请上传图片格式的文件": "Bitte laden Sie eine Datei im Bildformat hoch",
    "请勿重复添加": "Nicht wiederholt hinzufügen",
    "取消失败": "Stornierung fehlgeschlagen",
    "删除失败": "konnte nicht gelöscht werden",
    "商品id不能为空": "Die Produkt-ID darf nicht leer sein",
    "商品id错误": "Die Produkt-ID ist falsch",
    "实名认证尚未通过，无法重置": " Die Realname-Authentifizierung wurde nicht bestanden und kann nicht zurückgesetzt werden",
    "收藏id不能为空": "Sammlungs-ID darf nicht leer sein",
    "收货失败": "Empfangsfehler",
    "手机号不能为空": "Mobiltelefonnummer darf nicht leer sein",
    "图片不能为空": "Bild darf nicht leer sein",
    "图片大小不能超过30M": "Die Bildgröße darf 30 MB nicht überschreiten",
    "用户已锁定": "Benutzer gesperrt",
    "正在购买": "Kauf",
    "该贷款单还未通过审核": "Der Darlehensschein wurde nicht genehmigt",
    "该贷款单号不存在": "Die Ausleihnummer existiert nicht",
    "两次输入的密码不相同": "Zweimal eingegebene Passwörter sind unterschiedlich",
    "类型不能为空": "Typ darf nicht leer sein",
    "操作失败！修正后账户余额小于0。": "Operation fehlgeschlagen! Nach der Korrektur ist der Kontostand kleiner als 0.",
    "身份证号已实名过!": "Die ID-Nummer wurde verifiziert!",
    "提款金额不得低于最小提款限额": "Der Auszahlungsbetrag darf nicht unter dem Mindestauszahlungslimit liegen",
    "提款金额不得高于最大提款限额": "Der Auszahlungsbetrag darf nicht höher sein als das maximale Auszahlungslimit",
    "超过提现次数": "Auszahlungszeiten überschritten",

    "不在提现时间范围内，请稍后再试": "Nicht innerhalb des Auszahlungszeitraums, bitte versuchen Sie es später erneut",
    "提币数量必填": "Der Auszahlungsbetrag ist erforderlich",
    "提币数量输入错误，请输入浮点数": "Der Auszahlungsbetrag wurde falsch eingegeben, bitte geben Sie eine Fließkommazahl ein",
    "更新钱包失败，请联系客服": "Brieftasche konnte nicht aktualisiert werden. Bitte wenden Sie sich an den Kundendienst",
    "试用码不正确": "Der Testcode ist falsch",
    "已经提交申请，请等待审核": "Der Antrag wurde eingereicht, bitte warten Sie auf die Überprüfung",
    "审核状态异常请联系客服": "Wenn der Bewertungsstatus nicht normal ist, wenden Sie sich bitte an den Kundendienst",
    "暂无用户": "Noch kein Benutzer",
    "系统无该用户，或者ip地址不正确": "Es gibt keinen solchen Benutzer im System oder die IP-Adresse ist falsch",
    "游客不能向游客发送消息": "Besucher können keine Nachrichten an Besucher senden",
    "请选择收货地址": "Bitte Lieferadresse auswählen",
    "收货地址达上限": "Die Lieferadresse hat die Obergrenze erreicht",
    "请设置资金密码": "Bitte legen Sie ein Fondspasswort fest",
    "该订单未满足支付条件": "Die Bestellung entspricht nicht den Zahlungsbedingungen",
    "密码输入错误次数过多，请明天再试": "Zu viele falsche Passwörter eingegeben, bitte versuchen Sie es morgen erneut",
    "操作失败，请稍后再试": "Vorgang fehlgeschlagen, bitte versuchen Sie es später erneut",
    "部分商品已下架": "Einige Produkte wurden eingestellt",
    "邮箱的长度不能超过64个字符": "Die Länge der Mailbox darf 64 Zeichen nicht überschreiten",
    "邮码不能超过32个字符": "Die Postleitzahl darf 32 Zeichen nicht überschreiten",
    "操作类型不正确": "Falscher Vorgangstyp",
    "参数错误!": "Parameterfehler!",
    "不支持的语言": "nicht unterstützte Sprache",
    "收货人姓名不能超过64个字符": "Empfängername darf 64 Zeichen nicht überschreiten",
    "请输入正确的手机号码": "Bitte geben Sie die richtige Telefonnummer ein",
    "操作频繁，请稍后再试": "Häufiger Betrieb, bitte versuchen Sie es später erneut",
    "无此sellerGoods": "Keine solchen VerkäuferWaren",
    "退货失败": "Rückgabe fehlgeschlagen",
    "该订单状态无法操作": "Der Bestellstatus kann nicht bedient werden",
    "订单已经发货，无法退款": "Die Bestellung wurde versandt und kann nicht erstattet werden",
    "大于最大采购数量": "Größer als die maximale Abnahmemenge",
    "该邮箱已被订阅": "Dieses Postfach wurde bereits abonniert",
    "登录过期，请重新登录": "Anmeldung abgelaufen. Bitte melden Sie sich erneut an",
    "系统错误，请稍后重试": "Systemfehler, bitte versuchen Sie es später erneut",
    "请稍后重试": "Bitte versuchen Sie es später erneut",
    "连续输入错误三次，请3分钟后再试": "Fehler dreimal hintereinander eingeben. Bitte versuchen Sie es in 3 Minuten erneut",
    "审核中": "Wird überprüft",
    "程序错误": "Programmfehler",
    "重复提交": "Erneut einreichen",
    "用户名不能为空": "Der Benutzername darf nicht null sein",
    "验证码不能为空": "Der Bestätigungscode darf nicht null sein.",
    "登录密码不能为空": "Das Anmeldekennwort darf nicht null sein",
    "登陆密码长度不符合设定": "Die Länge des Login-Passworts stimmt nicht mit der Einstellung überein.",
    "资金密码长度不符合设定": "Die Länge des Kassenpasswortes stimmt nicht mit der Einstellung überein.",
    "登陆密码不符合设定": "Das Login-Passwort stimmt nicht mit der Einstellung überein.",
    "资金密码不符合设定": "Das Kassenpasswort entspricht nicht der Einstellung.",
    "用户名不符合设定": "Benutzername stimmt nicht mit der Einstellung überein",
    "用户名必须由数字和英文字母组成": "Der Benutzername muss aus Zahlen und Buchstaben bestehen",
    "验证码不正确": "Falscher verifikationscode",
    "密码不正确": "Falsches Passwort",
    "服务器错误(500)": "Serverfehler(500)",
    "服务器错误": "Serverfehler",
    "用户名重复": "Doppelter Benutzername",
    "找不到用户": "Benutzer nicht gefunden",
    "不能为空": "Kann nicht Null sein",
    "登录失败": "Fehler bei der Anmeldung",
    "操作成功": "Vorgang erfolgreich",
    "工作地址不能为空": "Arbeitsadresse darf nicht null sein",
    "家庭地址不能为空": "Privatadresse darf nicht null sein",
    "亲属姓名不能为空": "Der Name des Verwandten darf nicht null sein.",
    "亲属关系不能为空": "Häusliche Beziehungen können nicht null sein.",
    "亲属地址不能为空": "Die relative Adresse darf nicht null sein.",
    "亲属电话不能为空": "Die Telefonnummer der Familie darf nicht null sein.",
    "用户名不存在": "Der Benutzername existiert nicht",
    "参数错误": "Parameterfehler",
    "不在交易时段": "Nicht in der Handelssitzung",
    "存在不同杠杆的持仓单": "Es gibt Hold-Positionen mit unterschiedlichem Hebel",
    "余额不足": "Mangelhaftes Gleichgewicht",
    "可平仓合约张数不足": "Unzureichende Anzahl an geschlossenen Positionskontrakten",
    "请输入正确的货币数量": "Bitte geben Sie den korrekten Währungsbetrag ein",
    "请选择正确的币种": "Bitte wählen Sie die richtige Währung aus",
    "金额错误": "Betragsfehler.",
    "跟单参数输入错误": "Falsche Eingabe der Dokumentparameter",
    "跟单倍数输入错误": "Falsche Eingabe des Dokumenten-Multiples",
    "交易员不存在": "Der Händler existiert nicht.",
    "交易员未开启带单": "Der Händler hat die Rechnung nicht geöffnet.",
    "用户已跟随交易员": "Der Benutzer ist dem Händler gefolgt",
    "交易员跟随人数已满": "Die Anzahl der folgenden Händler ist voll",
    "交易员不能跟随自己": "Trader können sich selbst nicht folgen",
    "交易员无法跟随另一个交易员": "Der Händler kann einem anderen Händler nicht folgen",
    "历史基金无法购买": "Historische Fonds können nicht erworben werden",
    "该基金尚未开放购买": "Der Fonds wurde nicht zum Kauf geöffnet",
    "该基金尚已封闭": "Der Fonds wurde geschlossen",
    "基金剩余购买金额不足": "Die restliche Kaufsumme des Fonds reicht nicht aus.",
    "订单不存在": "Ordnung existiert nicht",
    "下单不能小于最小金额限制": "Die Auftragserteilung darf nicht unter dem Mindestbetrag liegen.",
    "[symbol]参数为空": "[Symbol]-Parameter ist null",
    "矿机不存在": "Bergbaumaschine existiert nicht",
    "矿机未解锁，无法购买": "Die Bergbaumaschine ist gesperrt und kann nicht gekauft werden.",
    "您已购买过体验矿机,不得重复购买": "Sie haben die Experience-Mining-Maschine gekauft. Kaufen Sie es nicht wieder.",
    "买入金额需要在区间内": "Der Kaufbetrag sollte im Bereich liegen.",
    "行情获取异常，稍后再试": "Die Situationserfassung ist anormal. Bitte versuchen Sie es später erneut.",
    "广告不存在": "Werbung existiert nicht",
    "广告已下架": "Anzeigen werden entfernt",
    "承兑商不存在": "Der Akzeptor existiert nicht.",
    "请先添加收款方式": "Bitte fügen Sie zuerst die Erfassungsmethode hinzu",
    "您没有符合条件的收款方式": "Sie haben keine zulässige Sammelmethode",
    "请选择买卖方式": "Bitte wählen Sie die Handelsmethode aus",
    "请输入正确的金额": "Bitte geben Sie den korrekten Betrag ein",
    "请输入正确的数量": "Bitte geben Sie die richtige Menge ein",
    "该广告剩余数量不足": "Unzureichende Anzahl an Anzeigen übrig",
    "金额不在购买区间": "Der Betrag liegt nicht im Kaufbereich.",
    "用户剩余数量不足": "Unzureichende Anzahl verbleibender Benutzer",
    "请稍后再试": "Bitte versuchen Sie es später erneut",
    "未找到符合条件的匹配订单": "Keine passende Bestellung gefunden",
    "该订单已取消": "Diese Bestellung wurde storniert",
    "当前订单不为待付款状态，无法取消": "Die aktuelle Bestellung befindet sich nicht im Status „Ausstehende Zahlung“. Es kann nicht storniert werden.",
    "卖方无法取消该订单": "Der Verkäufer kann die Bestellung nicht stornieren",
    "资金密码错误": "Fehler beim Fondskennwort",
    "订单已完成": "Bestellung abgeschlossen",
    "订单已取消": "Bestellung storniert",
    "待付款的订单无法放行": "Bestellungen mit ausstehender Zahlung können nicht freigegeben werden",
    "订单已完成，无法放行": "Die Bestellung ist abgeschlossen und kann nicht freigegeben werden",
    "订单已取消，无法放行": "Die Bestellung wurde storniert und kann nicht freigegeben werden",
    "未授权访问": "Unautorisierter Zugriff",
    "图片大小不能超过2M！": "Die Bildgröße darf 2M nicht überschreiten!",
    "参数异常，消息获取失败": "Parameterfehler, Nachrichtenerfassung fehlgeschlagen",
    "无效的UID": "Ungültige UID",
    "用户不存在": "Benutzer existiert nicht",
    "图片上传失败": "Das Bild konnte nicht hochgeladen werden",
    "请输入内容": "Bitte Inhalt eingeben",
    "图片不得大于2M": "Das Bild darf nicht größer als 2 MB sein",
    "图片不得大于10M": "Das Bild darf nicht größer als 10 MB sein",
    "直线关系，不能修改推荐": "Geradenbeziehung, Empfehlung kann nicht geändert werden",
    "存在重复的角色名称": "Doppelter Rollenname",
    "角色被用户关联，不可删除": "Die Rolle wird vom Benutzer zugeordnet. Es kann nicht gelöscht werden.",
    "系统存在相同[系统登录名]！": "System existiert gleich [System Login Name]!",
    "旧密码不正确": "Falsches altes Passwort",
    "没有找到用户": "Kein Benutzer gefunden",
    "[code]值错误": "[Code]-Wert ist falsch",
    "身份证已实名过!": "Ausweis wurde authentifiziert!",
    "实名认证未通过，无法进行高级认证": "Realname-Zertifizierung fehlgeschlagen. Erweiterte Zertifizierung ist nicht verfügbar.",
    "收款方输入错误": "Fehler des Zahlungsempfängers eingeben",
    "所选汇率不存在": "Der ausgewählte Wechselkurs existiert nicht",
    "转账数量不能小于等于0": "Die Übertragungsmenge kann nicht kleiner oder gleich 0 sein",
    "UID不能为空": "UID darf nicht null sein",
    "转账币种不能为空": "Die Überweisungswährung darf nicht null sein.",
    "资金密码不能为空": "Das Etatpasswort darf nicht null sein.",
    "提现不得小于限额": "Die Bargeldabhebung darf nicht unter dem Limit liegen",
    "提现不得大于限额": "Die Bargeldabhebung darf das Limit nicht überschreiten",
    "当日可提现次数不足": "Die Zahl der Fallentnahmen am aktuellen Tag reicht nicht aus.",
    "不在可提现时间内": "Nicht innerhalb der Widerrufsfrist",
    "渠道未开通": "Kanal nicht geöffnet",
    "提币数量不能小于等于0": "Die Entnahmemenge darf nicht kleiner oder gleich 0 sein.",
    "无权限": "Keine Berechtigungen",
    "请先通过高级认证": "Bitte bestehen Sie zuerst die fortgeschrittene Zertifizierung",
    "请输入搜索关键字": "Bitte geben Sie Suchbegriffe ein",
    "角色不存在": "Rolle existiert nicht",
    "持有币种不足": "Unzureichende Haltewährung",
    "提交失败，当前有未处理订单": "Übermittlung fehlgeschlagen. Es gibt derzeit offene Bestellungen.",
    "充值链错误": "Fehler in der Ladekette",
    "充值价值不得小于最小限额": "Der Wiederaufladewert darf die Mindestgrenze nicht unterschreiten",
    "充值价值不得大于最大限额": "Der Wiederaufladewert darf die Höchstgrenze nicht überschreiten",
    "充值数量不能小于等于0": "Die Auflademenge kann nicht kleiner oder gleich 0 sein",
    "请输入充值币种": "Bitte geben Sie die Aufladewährung ein",
    "请上传图片": "Bitte Bilder hochladen",
    "当前还需交易": "Transaktion ist noch erforderlich",
    ",才可提币": ", und dann kann Bargeld abgehoben werden.",
    "提示": "Tipps",
    "未实名认证，是否认证？": "Nicht mit echtem Namen authentifiziert. Authentifizieren?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Kontoausnahme erfordert C3-Authentifizierung. Bitte wenden Sie sich an den Online-Kundenservice.",
    "确认": "Validierung",
    "取消": "Stornieren",
    "更新提醒": "Erinnerung aktualisieren",
    "发现新版本，请升级到最新版本": "Neue Version gefunden, bitte aktualisieren Sie auf die neueste Version",
    "请检查网络连接": "Bitte überprüfen Sie Ihre Netzwerkverbindung",
    "您已存在订单": "Sie haben bereits eine Bestellung",
    "当前地址格式错误": "Fehler im aktuellen Adressformat",
    "申购数量错误": "Fehler bei der Abonnementmenge",
    "产品不存在": "Produkt existiert nicht",
    "该产品未上架": "Dieses Produkt ist nicht aufgeführt",
    "该产品已上市，无法购买": "Dieses Produkt ist auf dem Markt und kann nicht gekauft werden",
    "当日才可申购": "Kauf nur am selben Tag möglich.",
    "产品剩余数量不足": "Unzureichende verbleibende Produktmenge",
    "您当前可分配额度不足": "Ihr aktuelles zuweisbares Limit reicht nicht aus",
    "购买矿机时间不得低于托管订单剩余时间": "Die Kaufzeit der Mining-Maschine darf nicht kürzer sein als die verbleibende Zeit des Verwahrungsbefehls",
    "推荐码不正确": "Der Empfehlungscode ist falsch.",
    "推荐人无权限推荐": "Der Empfehler hat keine Empfehlungsbefugnis.",
    "审核已通过": "Überprüfung bestanden",
    "请填写正确的验证码": "Bitte geben Sie den korrekten Verifizierungscode ein",
    "请填写正确的电话号码": "Bitte geben Sie die richtige Telefonnummer ein",
    "请填写正确的邮箱地址": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
    "电话号码已绑定": "Telefonnummer bereits gebunden",
    "电话号码已绑定其他用户": "Telefonnummer ist an einen anderen Benutzer gebunden",
    "邮箱已绑定": "Postfach bereits gebunden",
    "邮箱已绑定其他用户": "Postfach ist bereits an einen anderen Benutzer gebunden",
    "页码不是整数": "Die Seitenzahl ist keine Ganzzahl",
    "页码不能小于等于0": "Die Seitenzahl darf nicht kleiner oder gleich 0 sein",
    "请输入正确的质押金额": "Bitte geben Sie den korrekten Unterstützungsbetrag ein",
    "请输入正确的质押天数": "Bitte geben Sie die korrekten Pfandtage ein",
    "未发现授权记录": "Berechtigungsdatensatz nicht gefunden",
    "授权状态未成功": "Autorisierungsstatus fehlgeschlagen",
    "赎回状态异常": "Einlösungsstatus anormal",
    "申请成功": "Bewerbung erfolgreich",
    "领取成功": "Empfang erfolgreich",
    "未找到匹配的收益记录": "Kein übereinstimmender Umsatzdatensatz gefunden",
    "已领取": "Erhalten",
    "校验IP不合法": "Verifizierungs-IP ist illegal.",
    "委托数量(张)必填": "Anvertraute Menge (Stk.) ist erforderlich",
    "委托数量(张)不能小于等于0": "Die anvertraute Menge (Stk.) darf nicht kleiner oder gleich 0 sein.",
    "请先绑定谷歌验证器": "Bitte binden Sie zuerst den Google Authenticator",
    "资金密码必须6-12位": "Das Fondspasswort muss aus 6-12 Ziffern bestehen.",
    "验证码错误": "Bestätigungscode-Fehler",
    "登录密码必须6-12位": "Das Login-Passwort muss aus 6-12 Ziffern bestehen",
    "密码不能为空": "Das Passwort darf nicht null sein",
    "密码必须6-12位": "Das Passwort muss aus 6-12 Ziffern bestehen",
    "验证类型不能为空": "Der Authentifizierungstyp darf nicht null sein",
    "未绑定手机号": "Es ist keine Telefonnummer gebunden",
    "未绑定邮箱": "Es wird kein Postfach gebunden",
    "未绑定谷歌验证器": "Google Validator nicht gebunden",
    "旧密码不能为空": "Altes Passwort darf nicht null sein",
    "新密码不能为空": "Das neue Passwort darf nicht null sein.",
    "新密码确认不能为空": "Die Bestätigung des neuen Passworts darf nicht null sein.",
    "新密码不一致": "Das neue Passwort ist nicht identisch mit der ursprünglichen Eingabe",
    "操作类型为空": "Vorgangstyp ist null",
    "操作类型不是整数": "Operationstyp ist keine ganze Zahl",
    "操作类型不能小于0": "Operationstyp darf nicht kleiner als 0 sein",
    "用户名参数为空": "Der Parameter für den Benutzernamen ist null",
    "状态不是整数": "Status ist keine Ganzzahl",
    "状态不能小于0": "Der Status darf nicht kleiner als 0 sein",
    "系统参数错误": "Systemparameterfehler",
    "-连接已建立-": "-Verbindung hergestellt-",
    "代理层级错误": "Fehler auf Agentenebene",
    "请重新登录": "Bitte melden Sie sich erneut an",
    "提交失败": "Senden fehlgeschlagen",
    "充值金额不能小于1": "Der Aufladebetrag darf nicht kleiner als 1 sein (einschließlich zwei Dezimalstellen)",
    "请切换其他语言后查看": "Bitte wechseln Sie zur Anzeige in eine andere Sprache",
    "我的购物车": "Mein Einkaufswagen",
    "推荐商品": "Empfohlene Produkte",
    "猜你喜欢": "Denke es gefällt dir.",
    "暂无店铺": "Kein Geschäft gefunden",
    "添加失败": "Senden fehlgeschlagen. Bitte versuchen Sie es später erneut",
    "提交订单": "Auftragsübermittlung",
    "地址格式与协议不匹配": "Adressformat stimmt nicht mit dem Protokoll überein",
    "用户已绑定过提现地址": "Der Benutzer hat bereits eine Auszahlungsadresse gebunden",
    "绑定提现地址成功": "Binden Sie die Auszahlungsadresse erfolgreich",
    "未设置地址": "Keine Adresse festgelegt",
    "您有一笔提现正在处理中": "Sie haben eine Auszahlung in Bearbeitung",
    "平台人工发起退款": "Plattforminitiierte Rückerstattung",
    "充值数量不能小于等于0": "Die Anzahl der Aufladungen darf nicht kleiner oder gleich 0 sein",
    "请选择法币类型": " Bitte wählen Sie die Fiat-Währung aus",
    "充值金额超过最大金额": " Die Aufladung übersteigt den Höchstbetrag",
    "充值金额小于最小金额": " Die Aufladung ist kleiner als der Mindestbetrag",
    "请选择正确的法币类型": " Bitte wählen Sie die richtige Fiat-Währung aus",
    "业务已锁定，请联系客服！": " Der Service ist gesperrt. Bitte kontaktieren Sie den Kundendienst!",
    "无法购买本店商品": "Dieses Geschäft kann nicht gekauft werden",
    '参数缺失': 'Fehlende Parameter',
    '充值数量必填': 'Aufladebetrag erforderlich',
  },
  "tits_ms": {
    "请输入正确的邮箱地址": "Sila masukkan alamat e-mel yang betul",
    "已有未完成的贷款单，不能重复申请": "Sudah ada pesanan pinjaman belum selesai, tidak boleh memohon semula",
    "请输入关键字搜索": "Sila masukkan kata kunci untuk mencari",
    "已提交评论!": "Ulasan diserahkan!",
    "系统错误": "Ralat sistem",
    "未指定商家": "Perniagaan yang tidak ditentukan",
    "邮箱验证码发送次数过多，请明天再试": 
      "Sebanyak banyak kod semula disertakan, sila cuba lagi masa ini",
    "该手机号已被占用，请绑定其他手机号": 
      "Nombor telefon telah dipakai, sila gunakan nombor telefon lain",
    "该邮箱已被占用，请更换其他邮箱注册":
      "Suak alamat e-mel telah dipakai, sila gunakan alamat e-mel lain",
    "该商品已下架": "Barang ini telah ditutup",
    "当前账号有未完成的充值订单，请完成后再试": "Akaun semasa mempunyai pesanan caj semula yang belum selesai, sila cuba lagi selepas selesai",
    "当前账号有未完成的提现订单，请完成后再试": "Akaun semasa mempunyai pesanan pengeluaran yang belum selesai, sila lengkapkan dan cuba lagi",
    "请先登录": "sila daftar masuk",
    "该角色账号不允许注销": "Akaun aksara ini tidak dibenarkan log keluar",
    "当前的用户账号与确认注销的账号不一致": "Akaun pengguna semasa tidak konsisten dengan akaun yang disahkan untuk log keluar",
    "密码输入错误次数过多，请明天再试": "Terlalu banyak kata laluan yang salah dimasukkan, sila cuba lagi esok",
    "注销失败": "Log keluar gagal",
    "注销成功": "Log keluar berjaya",
    "当前用户已经被管理员禁用": "Pengguna semasa telah dilumpuhkan oleh pentadbir",
    "地址不存在,或者已删除": "Alamat tidak wujud, atau telah dipadamkan",
    "地址不能为空": "Alamat tidak boleh kosong",
    "地址过长": "alamat terlalu panjang",
    "店家id不能为空": "Id kedai tidak boleh kosong",
    "店家id错误": "ID kedai salah",
    "订单号不能为空": "Nombor pesanan tidak boleh kosong",
    "非法请求": "permintaan haram",
    "购买失败,联系客服": "Pembelian gagal, hubungi perkhidmatan pelanggan",
    "关注id不能为空": "Follow id tidak boleh kosong",
    "联系人不能为空": "Kenalan tidak boleh kosong",
    "两次输入的资金密码不相同": "Kata laluan dana yang dimasukkan dua kali adalah berbeza",
    "模块名不能为空": " Nama modul tidak boleh kosong",
    "您的申请之前已提交过": "Permohonan anda telah dihantar sebelum ini",
    "请上传图片格式的文件": "Sila muat naik fail dalam format imej",
    "请勿重复添加": "Jangan tambah berulang kali",
    "取消失败": "Pembatalan gagal",
    "删除失败": "gagal memadam",
    "商品id不能为空": "Id produk tidak boleh kosong",
    "商品id错误": "ID produk salah",
    "实名认证尚未通过，无法重置": "Pengesahan nama sebenar belum lulus dan tidak boleh ditetapkan semula",
    "收藏id不能为空": "Id koleksi tidak boleh kosong",
    "收货失败": "Kegagalan resit",
    "手机号不能为空": "Nombor telefon bimbit tidak boleh kosong",
    "图片不能为空": "Imej tidak boleh kosong",
    "图片大小不能超过30M": "Saiz imej tidak boleh melebihi 30M",
    "用户已锁定": "pengguna dikunci",
    "正在购买": "membeli",
    "该贷款单还未通过审核": "Slip pinjaman belum diluluskan",
    "该贷款单号不存在": "Nombor pinjaman tidak wujud",
    "两次输入的密码不相同": " Kata laluan yang dimasukkan dua kali adalah berbeza",
    "类型不能为空": "Jenis tidak boleh kosong",
    "操作失败！修正后账户余额小于0。": "operasi gagal! Selepas pembetulan, baki akaun adalah kurang daripada 0.",
    "身份证号已实名过!": "Nombor ID telah disahkan!",
    "提款金额不得低于最小提款限额": "Jumlah pengeluaran mestilah tidak kurang daripada had pengeluaran minimum",
    "提款金额不得高于最大提款限额": "Jumlah pengeluaran tidak boleh lebih tinggi daripada had pengeluaran maksimum",
    "超过提现次数": "Masa pengeluaran melebihi",
    "不在提现时间范围内，请稍后再试": "Tidak dalam julat masa pengeluaran, sila cuba sebentar lagi",
    "提币数量必填": "Jumlah pengeluaran diperlukan",
    "提币数量输入错误，请输入浮点数": "Jumlah pengeluaran telah dimasukkan dengan salah, sila masukkan nombor titik terapung",
    "更新钱包失败，请联系客服": "Gagal mengemas kini dompet, sila hubungi perkhidmatan pelanggan",
    "试用码不正确": "Kod percubaan tidak betul",
    "已经提交申请，请等待审核": "Permohonan telah diserahkan, sila tunggu untuk semakan",
    "审核状态异常请联系客服": "Jika status semakan tidak normal, sila hubungi perkhidmatan pelanggan",
    "暂无用户": "Tiada pengguna lagi",
    "系统无该用户，或者ip地址不正确": "Tiada pengguna sedemikian dalam sistem, atau alamat ip tidak betul",
    "游客不能向游客发送消息": "Pelawat tidak boleh menghantar mesej kepada pelawat",
    "请选择收货地址": "Sila pilih alamat penghantaran",
    "收货地址达上限": "Alamat penghantaran telah mencapai had atas",
    "请设置资金密码": "Sila tetapkan kata laluan dana",
    "该订单未满足支付条件": "Pesanan tidak memenuhi syarat pembayaran",
    "密码输入错误次数过多，请明天再试": "Terlalu banyak kata laluan yang salah dimasukkan, sila cuba lagi esok",
    "操作失败，请稍后再试": "Operasi gagal, sila cuba lagi kemudian",
    "部分商品已下架": "Beberapa produk telah dihentikan",
    "邮箱的长度不能超过64个字符": "Panjang peti mel tidak boleh melebihi 64 aksara",
    "邮码不能超过32个字符": "Poskod tidak boleh melebihi 32 aksara",
    "操作类型不正确": "Jenis operasi yang salah",
    "参数错误!": "Ralat parameter!",
    "不支持的语言": "bahasa yang tidak disokong",
    "收货人姓名不能超过64个字符": "Nama penerima tidak boleh melebihi 64 aksara",
    "请输入正确的手机号码": "Sila masukkan nombor telefon yang betul",
    "操作频繁，请稍后再试": "Operasi yang kerap, sila cuba lagi kemudian",
    "无此sellerGoods": "Tiada sellerGoods seperti itu",
    "退货失败": "pemulangan gagal",
    "该订单状态无法操作": "Status pesanan tidak boleh dikendalikan",
    "订单已经发货，无法退款": " Pesanan telah dihantar dan tidak boleh dikembalikan",
    "大于最大采购数量": "Lebih besar daripada kuantiti pembelian maksimum",
    "该邮箱已被订阅": "Peti mel ini telah pun dilanggan",
    "登录过期，请重新登录": "Log masuk tamat tempoh. Sila log masuk semula",
    "系统错误，请稍后重试": "Ralat sistem, sila cuba lagi kemudian",
    "请稍后重试": "Sila cuba sebentar lagi",
    "连续输入错误三次，请3分钟后再试": "Masukkan ralat untuk tiga kali berturut-turut. Sila cuba lagi dalam masa 3 minit",
    "审核中": "Ditinjau",
    "程序错误": "Ralat program",
    "重复提交": "Hantar semula",
    "用户名不能为空": "Nama pengguna tidak boleh batal",
    "验证码不能为空": "Kod pengesahan tidak boleh batal.",
    "登录密码不能为空": "Kata laluan log masuk tidak boleh batal",
    "登陆密码长度不符合设定": "Panjang kata laluan log masuk tidak sepadan dengan tetapan.",
    "资金密码长度不符合设定": "Panjang kata laluan dana tidak sepadan dengan tetapan.",
    "登陆密码不符合设定": "Kata laluan log masuk tidak sepadan dengan tetapan.",
    "资金密码不符合设定": "Kata laluan dana tidak mematuhi tetapan.",
    "用户名不符合设定": "Nama pengguna tidak sepadan dengan tetapan",
    "用户名必须由数字和英文字母组成": "Nama pengguna mesti terdiri daripada nombor dan huruf",
    "验证码不正确": "Kod pengesahan yang salah",
    "密码不正确": "Kata laluan salah",
    "服务器错误(500)": "Ralat pelayan(500)",
    "服务器错误": "Ralat pelayan",
    "用户名重复": "Nama pengguna pendua",
    "找不到用户": "Pengguna tidak dijumpai",
    "不能为空": "Tidak boleh batal",
    "登录失败": "Daftar masuk gagal",
    "操作成功": "Operasi berjaya",
    "工作地址不能为空": "Alamat kerja tidak boleh batal",
    "家庭地址不能为空": "Alamat rumah tidak boleh batal",
    "亲属姓名不能为空": "Nama saudara tidak boleh batal.",
    "亲属关系不能为空": "Hubungan rumah tangga tidak boleh batal.",
    "亲属地址不能为空": "Alamat relatif tidak boleh batal.",
    "亲属电话不能为空": "Nombor telefon keluarga tidak boleh batal.",
    "用户名不存在": "Nama pengguna tidak wujud",
    "参数错误": "Ralat parameter",
    "不在交易时段": "Bukan dalam sesi dagangan",
    "存在不同杠杆的持仓单": "Terdapat jawatan pegangan dengan leverage yang berbeza",
    "余额不足": "Baki tidak mencukupi",
    "可平仓合约张数不足": "Bilangan kontrak kedudukan tutup tidak mencukupi",
    "请输入正确的货币数量": "Sila masukkan jumlah mata wang yang betul",
    "请选择正确的币种": "Sila pilih mata wang yang betul",
    "金额错误": "Ralat jumlah.",
    "跟单参数输入错误": "Masukkan parameter dokumen yang salah",
    "跟单倍数输入错误": "Masukkan berbilang dokumentari yang salah",
    "交易员不存在": "Peniaga itu tidak wujud.",
    "交易员未开启带单": "Peniaga belum membuka bil.",
    "用户已跟随交易员": "Pengguna telah mengikuti pedagang",
    "交易员跟随人数已满": "Bilangan peniaga yang mengikuti adalah penuh",
    "交易员不能跟随自己": "Peniaga tidak boleh mengikut diri mereka sendiri",
    "交易员无法跟随另一个交易员": "Peniaga tidak boleh mengikuti peniaga lain",
    "历史基金无法购买": "Dana sejarah tidak boleh dibeli",
    "该基金尚未开放购买": "Dana belum dibuka untuk pembelian",
    "该基金尚已封闭": "Dana telah ditutup",
    "基金剩余购买金额不足": "Baki jumlah pembelian dana tidak mencukupi.",
    "订单不存在": "Perintah tidak wujud",
    "下单不能小于最小金额限制": "Peletakan pesanan tidak boleh kurang daripada had jumlah minimum.",
    "[symbol]参数为空": "Parameter [simbol] adalah nol",
    "矿机不存在": "Mesin melombong tidak wujud",
    "矿机未解锁，无法购买": "Mesin perlombongan dikunci dan tidak boleh dibeli.",
    "您已购买过体验矿机,不得重复购买": "Anda telah membeli mesin perlombongan pengalaman. Jangan beli lagi.",
    "买入金额需要在区间内": "Jumlah pembelian hendaklah dalam julat.",
    "行情获取异常，稍后再试": "Pemerolehan situasi adalah tidak normal. Sila cuba sebentar lagi.",
    "广告不存在": "Iklan tidak wujud",
    "广告已下架": "Iklan diturunkan",
    "承兑商不存在": "Penerima tidak wujud.",
    "请先添加收款方式": "Sila tambah kaedah pengumpulan dahulu",
    "您没有符合条件的收款方式": "Anda tidak mempunyai kaedah pengumpulan yang layak",
    "请选择买卖方式": "Sila pilih kaedah dagangan",
    "请输入正确的金额": "Sila masukkan jumlah yang betul",
    "请输入正确的数量": "Sila masukkan kuantiti yang betul",
    "该广告剩余数量不足": "Jumlah iklan yang tinggal tidak mencukupi",
    "金额不在购买区间": "Jumlahnya tiada dalam julat pembelian.",
    "用户剩余数量不足": "Bilangan pengguna yang tinggal tidak mencukupi",
    "请稍后再试": "Sila cuba sebentar lagi",
    "未找到符合条件的匹配订单": "Tiada pesanan sepadan ditemui",
    "该订单已取消": "Pesanan ini telah dibatalkan",
    "当前订单不为待付款状态，无法取消": "Pesanan semasa tiada dalam status pembayaran belum selesai. Ia tidak boleh dibatalkan.",
    "卖方无法取消该订单": "Penjual tidak boleh membatalkan pesanan",
    "资金密码错误": "Ralat kata laluan dana",
    "订单已完成": "Pesanan selesai",
    "订单已取消": "Pesanan dibatalkan",
    "待付款的订单无法放行": "Pesanan belum selesai pembayaran tidak boleh dikeluarkan",
    "订单已完成，无法放行": "Pesanan telah selesai dan tidak boleh dikeluarkan",
    "订单已取消，无法放行": "Pesanan telah dibatalkan dan tidak boleh dikeluarkan",
    "未授权访问": "Akses tidak dibenarkan",
    "图片大小不能超过2M！": "Saiz gambar tidak boleh melebihi 2M!",
    "参数异常，消息获取失败": "Ralat parameter, pemerolehan mesej gagal",
    "无效的UID": "UID tidak sah",
    "用户不存在": "Pengguna tidak wujud",
    "图片上传失败": "Gagal memuat naik imej",
    "请输入内容": "Sila masukkan kandungan",
    "图片不得大于2M": "Gambar tidak boleh lebih besar daripada 2M",
    "图片不得大于10M": "Gambar tidak boleh lebih besar daripada 10M",
    "直线关系，不能修改推荐": "Hubungan garis lurus, pengesyoran tidak boleh diubah suai",
    "存在重复的角色名称": "Nama peranan pendua",
    "角色被用户关联，不可删除": "Peranan dikaitkan oleh pengguna. Ia tidak boleh dipadamkan.",
    "系统存在相同[系统登录名]！": "Sistem wujud [Nama Log Masuk Sistem] yang sama!",
    "旧密码不正确": "Kata laluan lama yang salah",
    "没有找到用户": "Tiada pengguna ditemui",
    "[code]值错误": "Nilai [kod] tidak betul",
    "身份证已实名过!": "Kad pengenalan telah disahkan!",
    "实名认证未通过，无法进行高级认证": "Pensijilan nama sebenar gagal. Pensijilan lanjutan tidak tersedia.",
    "收款方输入错误": "Masukkan ralat penerima",
    "所选汇率不存在": "Kadar pertukaran yang dipilih tidak wujud",
    "转账数量不能小于等于0": "Kuantiti pemindahan tidak boleh kurang daripada atau sama dengan 0",
    "UID不能为空": "UID tidak boleh batal",
    "转账币种不能为空": "Pemindahan mata wang tidak boleh batal.",
    "资金密码不能为空": "Kata laluan dana tidak boleh batal.",
    "提现不得小于限额": "Pengeluaran tunai tidak boleh kurang daripada had",
    "提现不得大于限额": "Pengeluaran tunai tidak boleh melebihi had",
    "当日可提现次数不足": "Bilangan penarikan balik kes pada hari semasa tidak mencukupi.",
    "不在可提现时间内": "Tidak dalam masa pengeluaran",
    "渠道未开通": "Saluran tidak dibuka",
    "提币数量不能小于等于0": "Kuantiti pengeluaran tidak boleh kurang daripada atau sama dengan 0.",
    "无权限": "Tiada kebenaran",
    "请先通过高级认证": "Sila lulus pensijilan lanjutan dahulu",
    "请输入搜索关键字": "Sila masukkan kata kunci carian",
    "角色不存在": "Peranan tidak wujud",
    "持有币种不足": "Mata wang pegangan tidak mencukupi",
    "提交失败，当前有未处理订单": "Penyerahan gagal. Pada masa ini terdapat tempahan terbuka.",
    "充值链错误": "Ralat rantai pengecasan",
    "充值价值不得小于最小限额": "Nilai cas semula tidak boleh kurang daripada had minimum",
    "充值价值不得大于最大限额": "Nilai cas semula tidak boleh melebihi had maksimum",
    "充值数量不能小于等于0": "Kuantiti cas semula tidak boleh kurang daripada atau sama dengan 0",
    "请输入充值币种": "Sila masukkan mata wang caj semula",
    "请上传图片": "Sila muat naik gambar",
    "当前还需交易": "Transaksi masih diperlukan",
    ",才可提币": ", dan kemudian pengeluaran tunai boleh dibuat.",
    "提示": "Petua",
    "未实名认证，是否认证？": "Tidak disahkan dengan nama sebenar. Sahkan?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Pengecualian akaun memerlukan pengesahan C3. Sila hubungi perkhidmatan pelanggan dalam talian.",
    "确认": "Pengesahan",
    "取消": "Batal",
    "更新提醒": "Kemas kini peringatan",
    "发现新版本，请升级到最新版本": "Versi baharu ditemui, sila tingkatkan kepada versi terkini",
    "请检查网络连接": "Sila semak sambungan rangkaian anda",
    "您已存在订单": "Anda sudah mempunyai pesanan",
    "当前地址格式错误": "Ralat format alamat semasa",
    "申购数量错误": "Ralat kuantiti langganan",
    "产品不存在": "Produk tidak wujud",
    "该产品未上架": "Produk ini tidak disenaraikan",
    "该产品已上市，无法购买": "Produk ini berada di pasaran dan tidak boleh dibeli",
    "当日才可申购": "Pembelian hanya boleh dibeli pada hari yang sama.",
    "产品剩余数量不足": "Baki kuantiti produk tidak mencukupi",
    "您当前可分配额度不足": "Had semasa anda yang boleh diperuntukkan tidak mencukupi",
    "购买矿机时间不得低于托管订单剩余时间": "Masa pembelian mesin perlombongan tidak boleh kurang daripada baki masa perintah jagaan",
    "推荐码不正确": "Kod pengesyoran tidak betul.",
    "推荐人无权限推荐": "Pengesyor tidak mempunyai kuasa untuk mengesyorkan.",
    "审核已通过": "Semakan lulus",
    "请填写正确的验证码": "Sila isikan kod pengesahan yang betul",
    "请填写正确的电话号码": "Sila isikan nombor telefon yang betul",
    "请填写正确的邮箱地址": "Sila isikan alamat e-mel yang betul",
    "电话号码已绑定": "Nombor telefon sudah terikat",
    "电话号码已绑定其他用户": "Nombor telefon terikat kepada pengguna lain",
    "邮箱已绑定": "Peti surat sudah terikat",
    "邮箱已绑定其他用户": "Peti mel sudah terikat kepada pengguna lain",
    "页码不是整数": "Nombor halaman bukan integer",
    "页码不能小于等于0": "Nombor halaman tidak boleh kurang daripada atau sama dengan 0",
    "请输入正确的质押金额": "Sila masukkan jumlah cagaran yang betul",
    "请输入正确的质押天数": "Sila masukkan hari ikrar yang betul",
    "未发现授权记录": "Rekod kebenaran tidak ditemui",
    "授权状态未成功": "Status keizinan gagal",
    "赎回状态异常": "Status penebusan tidak normal",
    "申请成功": "Permohonan berjaya",
    "领取成功": "Menerima berjaya",
    "未找到匹配的收益记录": "Tiada rekod hasil yang sepadan ditemui",
    "已领取": "Menerima",
    "校验IP不合法": "Pengesahan IP adalah menyalahi undang-undang.",
    "委托数量(张)必填": "Kuantiti yang diamanahkan (pcs.) diperlukan",
    "委托数量(张)不能小于等于0": "Kuantiti yang diamanahkan (pcs.) tidak boleh kurang daripada atau sama dengan 0.",
    "请先绑定谷歌验证器": "Sila ikat Google Authenticator dahulu",
    "资金密码必须6-12位": "Kata laluan dana mestilah 6-12 digit.",
    "验证码错误": "Ralat kod pengesahan",
    "登录密码必须6-12位": "Kata laluan log masuk mestilah 6-12 digit",
    "密码不能为空": "Kata laluan tidak boleh batal",
    "密码必须6-12位": "Kata laluan mestilah 6-12 digit",
    "验证类型不能为空": "Jenis pengesahan tidak boleh batal",
    "未绑定手机号": "Tiada nombor telefon terikat",
    "未绑定邮箱": "Tiada peti mel terikat",
    "未绑定谷歌验证器": "Pengesah Google tidak terikat",
    "旧密码不能为空": "Kata laluan lama tidak boleh batal",
    "新密码不能为空": "Kata laluan baharu tidak boleh batal.",
    "新密码确认不能为空": "Pengesahan kata laluan baharu tidak boleh batal.",
    "新密码不一致": "Kata laluan baharu tidak sama dengan kemasukan asal",
    "操作类型为空": "Jenis operasi adalah batal",
    "操作类型不是整数": "Jenis operasi bukan integer",
    "操作类型不能小于0": "Jenis operasi tidak boleh kurang daripada 0",
    "用户名参数为空": "Parameter nama pengguna adalah batal",
    "状态不是整数": "Status bukan integer",
    "状态不能小于0": "Status tidak boleh kurang daripada 0",
    "系统参数错误": "Ralat parameter sistem",
    "-连接已建立-": "-Sambungan diwujudkan-",
    "代理层级错误": "Ralat peringkat ejen",
    "请重新登录": "Sila log masuk semula",
    "提交失败": "Penyerahan gagal",
    "充值金额不能小于1": "Jumlah cas semula tidak boleh kurang daripada 1 (termasuk dua tempat perpuluhan)",
    "请切换其他语言后查看": "Sila tukar kepada bahasa lain untuk melihat",
    "我的购物车": "Troli beli-belah saya",
    "推荐商品": "Produk yang disyorkan",
    "猜你喜欢": "Rasanya anda suka.",
    "暂无店铺": "Tiada kedai ditemui",
    "添加失败": "Gagal menyerahkan. Sila cuba sebentar lagi",
    "提交订单": "Penyerahan pesanan",
    "地址格式与协议不匹配": "Format alamat tidak sepadan dengan protokol",
    "用户已绑定过提现地址": "Pengguna telah mengikat alamat pengeluaran",
    "绑定提现地址成功": "Berjaya mengikat alamat pengeluaran",
    "未设置地址": "Alamat tidak ditetapkan",
    "您有一笔提现正在处理中": "Anda mempunyai pengeluaran yang sedang diproses",
    "平台人工发起退款": "Platform memulakan pemulangan wang secara manual",
    "充值数量不能小于等于0": "Jumlah cas semula tidak boleh kurang daripada atau sama dengan 0",
    "请选择法币类型": " Sila pilih jenis mata wang fiat",
    "充值金额超过最大金额": " Jumlah cas semula melebihi jumlah maksimum",
    "充值金额小于最小金额": " Jumlah cas semula kurang daripada jumlah minimum",
    "请选择正确的法币类型": " Sila pilih jenis mata wang fiat yang betul",
    "业务已锁定，请联系客服！": " Perkhidmatan telah dikunci, sila hubungi perkhidmatan pelanggan!",
    "无法购买本店商品": "Tidak dapat membeli barang kedai ini",
    '参数缺失': "Parameter yang hilang",
    '充值数量必填': "Jumlah topup diperlukan",
  },
  "tits_el": {
    "添加失败": "Αποτυχία υποβολής. Παρακαλώ δοκιμάστε ξανά αργότερα",
    "提交失败": "Η υποβολή απέτυχε",
    "请输入正确的邮箱地址": "Εισαγάγετε μια σωστή διεύθυνση email",
    "已有未完成的贷款单，不能重复申请": "Υπάρχει ήδη μια ανολοκλήρωτη παραγγελία δανείου, δεν είναι δυνατή η εκ νέου αίτηση",
    "请输入关键字搜索": "Εισαγάγετε λέξη-κλειδί για αναζήτηση",
    '参数缺失': 'Λείπουν παράμετροι',
    '充值数量必填': 'Το ποσό επαναφόρτισης είναι υποχρεωτικό',
    "该邮箱已被占用，请更换其他邮箱注册": "Το διεύθυνση email υπάρχει ήδη χρησιμοποιημένη, επιλέξτε διαφορετική διεύθυνση email για να εγγραφείτε",
    "已提交评论!": "Η κριτική υποβλήθηκε!",
    "该手机号已被占用，请绑定其他手机号": "Το τηλέφωνό σας χρησιμοποιείτε ήδη, επιλέξτε διαφορετικό τηλέφωνό για να συνδεθείτε",
    "系统错误": 'σφάλμα συστήματος',
    "邮箱验证码发送次数过多，请明天再试": "Ένας ή περισσότερους κωδικούς επαναφορτισης έχουν σταλεί πολλές φορές, παρακαλώ δοκιμάστε ξανά σταθερά στην πόση ώρα",
    "该商品已下架": "Αυτός το προϊόν δεν είναι προσβ",
    "未指定商家": "Απροσδιόριστη επιχείρηση",
    "当前账号有未完成的充值订单，请完成后再试": "Ο τρέχων λογαριασμός έχει μια ημιτελή παραγγελία επαναφόρτισης, δοκιμάστε ξανά μετά την ολοκλήρωση",
    "当前账号有未完成的提现订单，请完成后再试": "Ο τρέχων λογαριασμός έχει μια ημιτελή εντολή ανάληψης, συμπληρώστε και δοκιμάστε ξανά",
    "请先登录": "ΠΑΡΑΚΑΛΩ ΣΥΝΔΕΘΕΙΤΕ",
    "该角色账号不允许注销": "Αυτός ο λογαριασμός χαρακτήρων δεν επιτρέπεται να αποσυνδεθεί",
    "当前的用户账号与确认注销的账号不一致": "Ο τρέχων λογαριασμός χρήστη δεν συνάδει με τον λογαριασμό που επιβεβαιώθηκε για αποσύνδεση",
    "密码输入错误次数过多，请明天再试": "Εισάγατε πάρα πολλούς λανθασμένους κωδικούς πρόσβασης, δοκιμάστε ξανά αύριο",
    "注销失败": "Αποτυχία αποσύνδεσης",
    "注销成功": "Επιτυχής αποσύνδεση",
    "当前用户已经被管理员禁用": "Ο τρέχων χρήστης έχει απενεργοποιηθεί από τον διαχειριστή",
    "地址不存在,或者已删除": "Η διεύθυνση δεν υπάρχει ή έχει διαγραφεί",
    "地址不能为空": "Η διεύθυνση δεν μπορεί να είναι κενή",
    "地址过长": "πολύ μεγάλη διεύθυνση",
    "店家id不能为空": "Το αναγνωριστικό καταστήματος δεν μπορεί να είναι κενό",
    "店家id错误": "Το αναγνωριστικό του καταστήματος είναι λάθος",
    "订单号不能为空": "Ο αριθμός παραγγελίας δεν μπορεί να είναι κενός",
    "非法请求": "παράνομο αίτημα",
    "购买失败,联系客服": "Η αγορά απέτυχε, επικοινωνήστε με την εξυπηρέτηση πελατών",
    "关注id不能为空": "Το αναγνωριστικό παρακολούθησης δεν μπορεί να είναι κενό",
    "联系人不能为空": "Η επαφή δεν μπορεί να είναι κενή",
    "两次输入的资金密码不相同": "Οι κωδικοί πρόσβασης κεφαλαίων που εισάγονται δύο φορές είναι διαφορετικοί",
    "模块名不能为空": "Το όνομα της μονάδας δεν μπορεί να είναι κενό",
    "您的申请之前已提交过": "Η αίτησή σας έχει υποβληθεί στο παρελθόν",
    "请上传图片格式的文件": "Ανεβάστε ένα αρχείο σε μορφή εικόνας",
    "请勿重复添加": "Μην προσθέτετε επανειλημμένα",
    "取消失败": "Η ακύρωση απέτυχε",
    "删除失败": "απέτυχε να διαγραφεί",
    "商品id不能为空": "Το αναγνωριστικό προϊόντος δεν μπορεί να είναι κενό",
    "商品id错误": "Το αναγνωριστικό προϊόντος είναι λάθος",
    "实名认证尚未通过，无法重置": "Ο έλεγχος ταυτότητας με πραγματικό όνομα δεν έχει περάσει και δεν μπορεί να επαναφερθεί",
    "收藏id不能为空": "Το αναγνωριστικό συλλογής δεν μπορεί να είναι κενό",
    "收货失败": "Αποτυχία παραλαβής",
    "手机号不能为空": "Ο αριθμός κινητού τηλεφώνου δεν μπορεί να είναι κενός",
    "图片不能为空": "Η εικόνα δεν μπορεί να είναι κενή",
    "图片大小不能超过30M": "Το μέγεθος της εικόνας δεν μπορεί να υπερβαίνει τα 30M",
    "用户已锁定": "χρήστης κλειδωμένος",
    "正在购买": "εξαγορά",
    "该贷款单还未通过审核": "Το δελτίο δανείου δεν έχει εγκριθεί",
    "该贷款单号不存在": " Ο αριθμός δανείου δεν υπάρχει",
    "两次输入的密码不相同": "Οι κωδικοί πρόσβασης που εισάγονται δύο φορές είναι διαφορετικοί",
    "类型不能为空": "Ο τύπος δεν μπορεί να είναι κενός",
    "操作失败！修正后账户余额小于0。": "η λειτουργία απέτυχε! Μετά τη διόρθωση, το υπόλοιπο του λογαριασμού είναι μικρότερο από 0.",
    "身份证号已实名过!": "Ο αριθμός ταυτότητας επαληθεύτηκε!",
    "提款金额不得低于最小提款限额": "Το ποσό ανάληψης δεν πρέπει να είναι μικρότερο από το ελάχιστο όριο ανάληψης",
    "提款金额不得高于最大提款限额": "Το ποσό ανάληψης δεν μπορεί να είναι μεγαλύτερο από το μέγιστο όριο ανάληψης",
    "超过提现次数": "Υπέρβαση των χρόνων απόσυρσης",
    "不在提现时间范围内，请稍后再试": "Όχι εντός του χρονικού εύρους ανάληψης, δοκιμάστε ξανά αργότερα",
    "提币数量必填": "Απαιτείται ποσό ανάληψης",
    "提币数量输入错误，请输入浮点数": "Το ποσό ανάληψης εισήχθη λανθασμένα. Εισαγάγετε έναν αριθμό κινητής υποδιαστολής",
    "更新钱包失败，请联系客服": "Η ενημέρωση του πορτοφολιού απέτυχε, επικοινωνήστε με την εξυπηρέτηση πελατών",
    "试用码不正确": "Ο κωδικός δοκιμής είναι λανθασμένος",
    "已经提交申请，请等待审核": "Η αίτηση έχει υποβληθεί, περιμένετε για έλεγχο",
    "审核状态异常请联系客服": "Εάν η κατάσταση ελέγχου είναι μη φυσιολογική, επικοινωνήστε με την εξυπηρέτηση πελατών",
    "暂无用户": "Κανένας χρήστης ακόμα",
    "系统无该用户，或者ip地址不正确": "Δεν υπάρχει τέτοιος χρήστης στο σύστημα ή η διεύθυνση IP είναι λανθασμένη",
    "游客不能向游客发送消息": "Οι επισκέπτες δεν μπορούν να στείλουν μηνύματα σε επισκέπτες",
    "请选择收货地址": "Επιλέξτε διεύθυνση παράδοσης",
    "收货地址达上限": "Η διεύθυνση παράδοσης έχει φτάσει στο ανώτατο όριο",
    "请设置资金密码": "Ορίστε έναν κωδικό πρόσβασης ταμείου",
    "该订单未满足支付条件": "Η παραγγελία δεν πληροί τους όρους πληρωμής",
    "密码输入错误次数过多，请明天再试": "Εισαγάγατε πάρα πολλούς λανθασμένους κωδικούς πρόσβασης, δοκιμάστε ξανά αύριο",
    "操作失败，请稍后再试": "Η λειτουργία απέτυχε, δοκιμάστε ξανά αργότερα",
    "部分商品已下架": "Ορισμένα προϊόντα έχουν διακοπεί",
    "邮箱的长度不能超过64个字符": "Το μήκος του γραμματοκιβωτίου δεν μπορεί να υπερβαίνει τους 64 χαρακτήρες",
    "邮码不能超过32个字符": "Ο ταχυδρομικός κώδικας δεν μπορεί να υπερβαίνει τους 32 χαρακτήρες",
    "操作类型不正确": "Λανθασμένος τύπος λειτουργίας",
    "参数错误!": "Σφάλμα παραμέτρου!",
    "不支持的语言": "μη υποστηριζόμενη γλώσσα",
    "收货人姓名不能超过64个字符": "Το όνομα του παραλήπτη δεν μπορεί να υπερβαίνει τους 64 χαρακτήρες",
    "请输入正确的手机号码": "Εισαγάγετε τον σωστό αριθμό τηλεφώνου",
    "操作频繁，请稍后再试": "Συχνή λειτουργία, δοκιμάστε ξανά αργότερα",
    "无此sellerGoods": "Δεν υπάρχει τέτοιος πωλητής Αγαθά",
    "退货失败": "η επιστροφή απέτυχε",
    "该订单状态无法操作": "Η κατάσταση παραγγελίας δεν μπορεί να λειτουργήσει",
    "订单已经发货，无法退款": "Η παραγγελία έχει αποσταλεί και δεν είναι δυνατή η επιστροφή χρημάτων",
    "大于最大采购数量": "Μεγαλύτερη από τη μέγιστη ποσότητα αγοράς",
    "该邮箱已被订阅": "Αυτό το γραμματοκιβώτιο έχει ήδη εγγραφεί",
    "登录过期，请重新登录": "Η σύνδεση έληξε. Παρακαλούμε συνδεθείτε ξανά",
    "系统错误，请稍后重试": "Σφάλμα συστήματος, δοκιμάστε ξανά αργότερα",
    "请稍后重试": "Παρακαλώ δοκιμάστε ξανά αργότερα",
    "连续输入错误三次，请3分钟后再试": "Εισαγάγετε το σφάλμα για τρεις διαδοχικές φορές. Δοκιμάστε ξανά σε 3 λεπτά",
    "审核中": "Υπό εξέταση",
    "程序错误": "Σφάλμα προγράμματος",
    "重复提交": "Υποβολή εκ νέου",
    "用户名不能为空": "Το όνομα χρήστη δεν μπορεί να είναι μηδενικό",
    "验证码不能为空": "Ο κωδικός επαλήθευσης δεν μπορεί να είναι μηδενικός.",
    "登录密码不能为空": "Ο κωδικός σύνδεσης δεν μπορεί να είναι μηδενικός",
    "登陆密码长度不符合设定": "Το μήκος του κωδικού πρόσβασης σύνδεσης δεν ταιριάζει με τη ρύθμιση.",
    "资金密码长度不符合设定": "Το μήκος του κωδικού πρόσβασης του ταμείου δεν ταιριάζει με τη ρύθμιση.",
    "登陆密码不符合设定": "Ο κωδικός πρόσβασης σύνδεσης δεν ταιριάζει με τη ρύθμιση.",
    "资金密码不符合设定": "Ο κωδικός πρόσβασης του ταμείου δεν συμμορφώνεται με τη ρύθμιση.",
    "用户名不符合设定": "Το όνομα χρήστη δεν ταιριάζει με τη ρύθμιση",
    "用户名必须由数字和英文字母组成": "Το όνομα χρήστη πρέπει να αποτελείται από αριθμούς και γράμματα",
    "验证码不正确": "Εσφαλμένος κωδικός επαλήθευσης",
    "密码不正确": "Λάθος κωδικός",
    "服务器错误(500)": "Σφάλμα διακομιστή (500)",
    "服务器错误": "Σφάλμα Διακομιστή",
    "用户名重复": "Διπλότυπο όνομα χρήστη",
    "找不到用户": "Ο χρήστης δεν βρέθηκε",
    "不能为空": "Δεν μπορεί να είναι μηδενικό",
    "登录失败": "Η σύνδεση απέτυχε",
    "操作成功": "Η επιχείρηση πέτυχε",
    "工作地址不能为空": "Η διεύθυνση εργασίας δεν μπορεί να είναι μηδενική",
    "家庭地址不能为空": "Η διεύθυνση κατοικίας δεν μπορεί να είναι μηδενική",
    "亲属姓名不能为空": "Το όνομα του συγγενή δεν μπορεί να είναι μηδενικό.",
    "亲属关系不能为空": "Οι εσωτερικές σχέσεις δεν μπορούν να είναι άκυρες.",
    "亲属地址不能为空": "Η σχετική διεύθυνση δεν μπορεί να είναι μηδενική.",
    "亲属电话不能为空": "Ο αριθμός τηλεφώνου της οικογένειας δεν μπορεί να είναι μηδενικός.",
    "用户名不存在": "Το όνομα χρήστη δεν υπάρχει",
    "参数错误": "Σφάλμα παραμέτρου",
    "不在交易时段": "Όχι σε συνεδρία συναλλαγών",
    "存在不同杠杆的持仓单": "Υπάρχουν θέσεις κράτησης με διαφορετική μόχλευση",
    "余额不足": "Ανεπαρκής ισορροπία",
    "可平仓合约张数不足": "Ανεπαρκής αριθμός συμβάσεων κλεισίματος",
    "请输入正确的货币数量": "Εισαγάγετε το σωστό ποσό νομίσματος",
    "请选择正确的币种": "Επιλέξτε το σωστό νόμισμα",
    "金额错误": "Σφάλμα ποσού.",
    "跟单参数输入错误": "Λανθασμένη εισαγωγή των παραμέτρων του εγγράφου",
    "跟单倍数输入错误": "Εσφαλμένη εισαγωγή πολλαπλών εγγράφων",
    "交易员不存在": "Ο έμπορος δεν υπάρχει.",
    "交易员未开启带单": "Ο έμπορος δεν έχει ανοίξει τον λογαριασμό.",
    "用户已跟随交易员": "Ο χρήστης ακολούθησε τον έμπορο",
    "交易员跟随人数已满": "Ο αριθμός των εμπόρων που ακολουθούν είναι πλήρης",
    "交易员不能跟随自己": "Οι έμποροι δεν μπορούν να ακολουθήσουν τον εαυτό τους",
    "交易员无法跟随另一个交易员": "Ο έμπορος δεν μπορεί να ακολουθήσει άλλον έμπορο",
    "历史基金无法购买": "Δεν μπορούν να αγοραστούν ιστορικά κεφάλαια",
    "该基金尚未开放购买": "Το ταμείο δεν έχει ανοίξει για αγορά",
    "该基金尚已封闭": "Το ταμείο έχει κλείσει",
    "基金剩余购买金额不足": "Το υπόλοιπο ποσό αγοράς του ταμείου δεν επαρκεί.",
    "订单不存在": "Η τάξη δεν υπάρχει",
    "下单不能小于最小金额限制": "Η τοποθέτηση παραγγελίας δεν μπορεί να είναι μικρότερη από το ελάχιστο όριο ποσού.",
    "[symbol]参数为空": "Η παράμετρος [symbol] είναι μηδενική",
    "矿机不存在": "Μηχάνημα εξόρυξης δεν υπάρχει",
    "矿机未解锁，无法购买": "Το μηχάνημα εξόρυξης είναι κλειδωμένο και δεν μπορεί να αγοραστεί.",
    "您已购买过体验矿机,不得重复购买": "Έχετε αγοράσει τη μηχανή εξόρυξης εμπειρίας. Μην το αγοράσετε ξανά.",
    "买入金额需要在区间内": "Το ποσό αγοράς πρέπει να είναι εντός του εύρους.",
    "行情获取异常，稍后再试": "Η απόκτηση κατάστασης είναι μη φυσιολογική. Παρακαλώ δοκιμάστε ξανά αργότερα.",
    "广告不存在": "Διαφήμιση δεν υπάρχει",
    "广告已下架": "Οι διαφημίσεις καταργούνται",
    "承兑商不存在": "Ο αποδέκτης δεν υπάρχει.",
    "请先添加收款方式": "Προσθέστε πρώτα τη μέθοδο συλλογής",
    "您没有符合条件的收款方式": "Δεν έχετε επιλέξιμη μέθοδο συλλογής",
    "请选择买卖方式": "Επιλέξτε τη μέθοδο συναλλαγών",
    "请输入正确的金额": "Εισαγάγετε το σωστό ποσό",
    "请输入正确的数量": "Παρακαλώ εισάγετε τη σωστή ποσότητα",
    "该广告剩余数量不足": "Απομένει ανεπαρκής αριθμός διαφημίσεων",
    "金额不在购买区间": "Το ποσό δεν είναι στο εύρος αγοράς.",
    "用户剩余数量不足": "Απομένει ανεπαρκής αριθμός χρηστών",
    "请稍后再试": "Παρακαλώ δοκιμάστε ξανά αργότερα",
    "未找到符合条件的匹配订单": "Δεν βρέθηκε αντίστοιχη σειρά",
    "该订单已取消": "αυτη η παραγγελια εχει ακυρωθει",
    "当前订单不为待付款状态，无法取消": "Η τρέχουσα παραγγελία δεν βρίσκεται σε κατάσταση πληρωμής σε εκκρεμότητα. Δεν μπορεί να ακυρωθεί.",
    "卖方无法取消该订单": "Ο πωλητής δεν μπορεί να ακυρώσει την παραγγελία",
    "资金密码错误": "Σφάλμα κωδικού πρόσβασης ταμείου",
    "订单已完成": "Η παραγγελία ολοκληρώθηκε",
    "订单已取消": "Η παραγγελία ακυρώθηκε",
    "待付款的订单无法放行": "Οι παραγγελίες που εκκρεμούν πληρωμή δεν μπορούν να αποδεσμευτούν",
    "订单已完成，无法放行": "Η παραγγελία έχει ολοκληρωθεί και δεν μπορεί να αποδεσμευτεί",
    "订单已取消，无法放行": "Η παραγγελία έχει ακυρωθεί και δεν μπορεί να αποδεσμευτεί",
    "未授权访问": "Μη εξουσιοδοτημένη πρόσβαση",
    "图片大小不能超过2M！": "Το μέγεθος της εικόνας δεν μπορεί να υπερβαίνει τα 2M!",
    "参数异常，消息获取失败": "Σφάλμα παραμέτρου, η λήψη μηνύματος απέτυχε",
    "无效的UID": "Μη έγκυρο UID",
    "用户不存在": "Ο χρήστης δεν υπάρχει",
    "图片上传失败": "Η μεταφόρτωση της εικόνας απέτυχε",
    "请输入内容": "Εισαγάγετε περιεχόμενο",
    "图片不得大于2M": "Η εικόνα δεν πρέπει να είναι μεγαλύτερη από 2M",
    "图片不得大于10M": "Η εικόνα δεν πρέπει να είναι μεγαλύτερη από 10M",
    "直线关系，不能修改推荐": "Σχέση ευθείας γραμμής, η σύσταση δεν μπορεί να τροποποιηθεί",
    "存在重复的角色名称": "Διπλότυπο όνομα ρόλου",
    "角色被用户关联，不可删除": "Ο ρόλος συσχετίζεται ανά χρήστη. Δεν μπορεί να διαγραφεί.",
    "系统存在相同[系统登录名]！": "Το σύστημα υπάρχει το ίδιο [Όνομα εισόδου συστήματος]!",
    "旧密码不正确": "Λανθασμένος παλιός κωδικός πρόσβασης",
    "没有找到用户": "Δεν βρέθηκε χρήστης",
    "[code]值错误": "Η τιμή [code] είναι λανθασμένη",
    "身份证已实名过!": "Το δελτίο ταυτότητας έχει επικυρωθεί!",
    "实名认证未通过，无法进行高级认证": "Η πιστοποίηση πραγματικού ονόματος απέτυχε. Η προηγμένη πιστοποίηση δεν είναι διαθέσιμη.",
    "收款方输入错误": "Εισαγάγετε το σφάλμα του δικαιούχου πληρωμής",
    "所选汇率不存在": "Η επιλεγμένη συναλλαγματική ισοτιμία δεν υπάρχει",
    "转账数量不能小于等于0": "Η ποσότητα μεταφοράς δεν μπορεί να είναι μικρότερη ή ίση με 0",
    "UID不能为空": "Το UID δεν μπορεί να είναι μηδενικό",
    "转账币种不能为空": "Το νόμισμα μεταφοράς δεν μπορεί να είναι μηδενικό.",
    "资金密码不能为空": "Ο κωδικός πρόσβασης του ταμείου δεν μπορεί να είναι μηδενικός.",
    "提现不得小于限额": "Η ανάληψη μετρητών δεν μπορεί να είναι μικρότερη από το όριο",
    "提现不得大于限额": "Η ανάληψη μετρητών δεν μπορεί να είναι μεγαλύτερη από το όριο",
    "当日可提现次数不足": "Ο αριθμός των υποθέσεων απόσυρσης την τρέχουσα ημέρα δεν είναι αρκετός.",
    "不在可提现时间内": "Όχι εντός του χρόνου απόσυρσης",
    "渠道未开通": "Το κανάλι δεν άνοιξε",
    "提币数量不能小于等于0": "Η ποσότητα ανάληψης δεν μπορεί να είναι μικρότερη ή ίση με 0.",
    "无权限": "Δεν υπάρχουν δικαιώματα",
    "请先通过高级认证": "Περάστε πρώτα την προηγμένη πιστοποίηση",
    "请输入搜索关键字": "Εισαγάγετε λέξεις-κλειδιά αναζήτησης",
    "角色不存在": "Ρόλος δεν υπάρχει",
    "持有币种不足": "Ανεπαρκές νόμισμα κατοχής",
    "提交失败，当前有未处理订单": "Η υποβολή απέτυχε. Αυτήν τη στιγμή υπάρχουν ανοιχτές παραγγελίες.",
    "充值链错误": "Σφάλμα αλυσίδας φόρτισης",
    "充值价值不得小于最小限额": "Η τιμή επαναφόρτισης δεν πρέπει να είναι μικρότερη από το ελάχιστο όριο",
    "充值价值不得大于最大限额": "Η τιμή επαναφόρτισης δεν πρέπει να είναι μεγαλύτερη από το μέγιστο όριο",
    "充值数量不能小于等于0": "Η ποσότητα επαναφόρτισης δεν μπορεί να είναι μικρότερη ή ίση με 0",
    "请输入充值币种": "Εισαγάγετε το νόμισμα επαναφόρτισης",
    "请上传图片": "Παρακαλώ ανεβάστε φωτογραφίες",
    "当前还需交易": "Η συναλλαγή εξακολουθεί να απαιτείται",
    ",才可提币": ", και στη συνέχεια μπορεί να γίνει ανάληψη μετρητών.",
    "提示": "Συμβουλές",
    "未实名认证，是否认证？": "Δεν έχει επικυρωθεί με πραγματικό όνομα. Πιστοποιώ την αυθεντικότητα?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Η εξαίρεση λογαριασμού απαιτεί έλεγχο ταυτότητας C3. Επικοινωνήστε με την ηλεκτρονική εξυπηρέτηση πελατών.",
    "确认": "Επικύρωση",
    "取消": "Ματαίωση",
    "更新提醒": "Ενημέρωση υπενθύμισης",
    "发现新版本，请升级到最新版本": "Βρέθηκε νέα έκδοση, αναβαθμίστε στην πιο πρόσφατη έκδοση",
    "请检查网络连接": "Ελέγξτε τη σύνδεσή σας στο δίκτυο",
    "您已存在订单": "Έχετε ήδη μια παραγγελία",
    "当前地址格式错误": "Σφάλμα μορφής τρέχουσας διεύθυνσης",
    "申购数量错误": "Σφάλμα ποσότητας συνδρομής",
    "产品不存在": "Το προϊόν δεν υπάρχει",
    "该产品未上架": "Αυτό το προϊόν δεν περιλαμβάνεται στη λίστα",
    "该产品已上市，无法购买": "Αυτό το προϊόν είναι στην αγορά και δεν μπορεί να αγοραστεί",
    "当日才可申购": "Η αγορά μπορεί να αγοραστεί μόνο την ίδια ημέρα.",
    "产品剩余数量不足": "Ανεπαρκής ποσότητα προϊόντος που απομένει",
    "您当前可分配额度不足": "Το τρέχον όριο κατανομής σας δεν είναι αρκετό",
    "购买矿机时间不得低于托管订单剩余时间": "Ο χρόνος αγοράς του μηχανήματος εξόρυξης δεν μπορεί να είναι μικρότερος από τον υπολειπόμενο χρόνο της εντολής φύλαξης",
    "推荐码不正确": "Ο κωδικός σύστασης είναι λανθασμένος.",
    "推荐人无权限推荐": "Ο εισηγητής δεν έχει εξουσία να προτείνει.",
    "审核已通过": "Η κριτική πέρασε",
    "请填写正确的验证码": "Συμπληρώστε τον σωστό κωδικό επαλήθευσης",
    "请填写正确的电话号码": "Συμπληρώστε τον σωστό αριθμό τηλεφώνου",
    "请填写正确的邮箱地址": "Συμπληρώστε τη σωστή διεύθυνση email",
    "电话号码已绑定": "Ο αριθμός τηλεφώνου είναι ήδη δεσμευμένος",
    "电话号码已绑定其他用户": "Ο αριθμός τηλεφώνου είναι δεσμευμένος σε άλλο χρήστη",
    "邮箱已绑定": "Το γραμματοκιβώτιο είναι ήδη δεσμευμένο",
    "邮箱已绑定其他用户": "Το γραμματοκιβώτιο είναι ήδη δεσμευμένο σε άλλο χρήστη",
    "页码不是整数": "Ο αριθμός σελίδας δεν είναι ακέραιος",
    "页码不能小于等于0": "Ο αριθμός σελίδας δεν μπορεί να είναι μικρότερος ή ίσος με 0",
    "请输入正确的质押金额": "Εισαγάγετε το σωστό ποσό ενεχύρου",
    "请输入正确的质押天数": "Εισαγάγετε τις σωστές ημέρες δέσμευσης",
    "未发现授权记录": "Η εγγραφή εξουσιοδότησης δεν βρέθηκε",
    "授权状态未成功": "Η κατάσταση εξουσιοδότησης απέτυχε",
    "赎回状态异常": "Μη φυσιολογική κατάσταση εξαργύρωσης",
    "申请成功": "Η εφαρμογή πέτυχε",
    "领取成功": "Η λήψη πέτυχε",
    "未找到匹配的收益记录": "Δεν βρέθηκε αντίστοιχη εγγραφή εσόδων",
    "已领取": "Ελήφθη",
    "校验IP不合法": "Η IP επαλήθευσης είναι παράνομη.",
    "委托数量(张)必填": "Απαιτείται εμπιστευμένη ποσότητα (τεμ.).",
    "委托数量(张)不能小于等于0": "Η εμπιστευμένη ποσότητα (τεμ.) δεν μπορεί να είναι μικρότερη ή ίση με 0.",
    "请先绑定谷歌验证器": "Συνδέστε πρώτα τον Επαληθευτή Google",
    "资金密码必须6-12位": "Ο κωδικός πρόσβασης του ταμείου πρέπει να είναι 6-12 ψηφία.",
    "验证码错误": "Σφάλμα κωδικού επαλήθευσης",
    "登录密码必须6-12位": "Ο κωδικός πρόσβασης πρέπει να είναι 6-12 ψηφία",
    "密码不能为空": "Ο κωδικός πρόσβασης δεν μπορεί να είναι μηδενικός",
    "密码必须6-12位": "Ο κωδικός πρόσβασης πρέπει να είναι 6-12 ψηφία",
    "验证类型不能为空": "Ο τύπος ελέγχου ταυτότητας δεν μπορεί να είναι μηδενικός",
    "未绑定手机号": "Δεν υπάρχει δεσμευμένος αριθμός τηλεφώνου",
    "未绑定邮箱": "Δεν υπάρχει δεσμευμένο γραμματοκιβώτιο",
    "未绑定谷歌验证器": "Το εργαλείο επικύρωσης Google δεν δεσμεύεται",
    "旧密码不能为空": "Ο παλιός κωδικός πρόσβασης δεν μπορεί να είναι μηδενικός",
    "新密码不能为空": "Ο νέος κωδικός πρόσβασης δεν μπορεί να είναι μηδενικός.",
    "新密码确认不能为空": "Η επιβεβαίωση νέου κωδικού πρόσβασης δεν μπορεί να είναι μηδενική.",
    "新密码不一致": "Ο νέος κωδικός πρόσβασης δεν είναι ο ίδιος με την αρχική εισαγωγή",
    "操作类型为空": "Ο τύπος λειτουργίας είναι μηδενικός",
    "操作类型不是整数": "Ο τύπος λειτουργίας δεν είναι ακέραιος",
    "操作类型不能小于0": "Ο τύπος λειτουργίας δεν μπορεί να είναι μικρότερος από 0",
    "用户名参数为空": "Η παράμετρος ονόματος χρήστη είναι null",
    "状态不是整数": "Η κατάσταση δεν είναι ακέραιος",
    "状态不能小于0": "Η κατάσταση δεν μπορεί να είναι μικρότερη από 0",
    "系统参数错误": "Σφάλμα παραμέτρου συστήματος",
    "-连接已建立-": "-Η ΣΥΝΔΕΣΗ καθιερωθηκε-",
    "代理层级错误": "Σφάλμα επιπέδου αντιπροσώπου",
    "请重新登录": "Παρακαλούμε συνδεθείτε ξανά",
    "暂无店铺": "Δεν υπάρχει κατάστημα",
    "地址格式与协议不匹配": "Η μορφή της διεύθυνσης δεν ταιριάζει με το πρωτόκολλο",
    "用户已绑定过提现地址": "Ο χρήστης έχει δεσμεύσει τη διεύθυνση απόσυρσης",
    "绑定提现地址成功": "Επιτυχής δέσμευση διεύθυνσης απόσυρσης",
    "未设置地址": "Δεν έχει οριστεί διεύθυνση",
    "您有一笔提现正在处理中": "Έχετε μια απόσυρση σε επεξεργασία",
    "平台人工发起退款": "Η πλατφόρμα εκκίνησης επιστροφής χρημάτων",
    "充值数量不能小于等于0": "Η ποσότητα της επαναφόρτισης δεν μπορεί να είναι μικρότερη ή ίση με 0",
    "请选择法币类型": " Επιλέξτε τον τύπο νομίσματος",
    "充值金额超过最大金额": " Η ποσότητα της επαναφόρτισης υπερβαίνει το μέγιστο ποσό",
    "充值金额小于最小金额": " Η ποσότητα της επαναφόρτισης είναι μικρότερη από το ελάχιστο ποσό",
    "请选择正确的法币类型": " Επιλέξτε τον σωστό τύπο νομίσματος",
    "业务已锁定，请联系客服！": " Η επιχείρηση έχει κλειδωθεί, επικοινωνήστε με την εξυπηρέτηση πελατών!",
    "无法购买本店商品": " Αδυναμία αγοράς προϊόντων καταστήματος",
  },
  "tits_af": {
    "请输入正确的邮箱地址": "Voer asseblief 'n geldige e-posadres in",
    "已有未完成的贷款单，不能重复申请": "Daar is reeds 'n onvoltooide leningbestelling, heraansoek nie moontlik nie",
    "请输入关键字搜索": "Voer asseblief sleutelwoord in om te soek",
    "已提交评论!": "Resensie ingedien!",
    "系统错误": 'sisteemfout',
    "未指定商家": "Ongespesifiseerde besigheid",
    "该手机号已被占用，请绑定其他手机号":
      "Die telefoonnommer is al gebruikt, verander die ander telefoonnommer",
      "邮箱验证码发送次数过多，请明天再试":
      "Die e-pos kode word verstuurd meerdere keer, probeer asseblief weer na",
    "该邮箱已被占用，请更换其他邮箱注册":
      "Die e-pos is al gebruikt, verander die ander e-pos",
    "该商品已下架": 
      "Die artikel het geskei vanaf",
    "当前账号有未完成的充值订单，请完成后再试": "Die lopende rekening het 'n onvoltooide herlaaibestelling, probeer asseblief weer na voltooiing",
    "当前账号有未完成的提现订单，请完成后再试": "Die lopende rekening het 'n onvoltooide onttrekkingsbestelling, voltooi asseblief en probeer weer",
    "请先登录": "meld asseblief aan",
    "该角色账号不允许注销": "Hierdie karakterrekening word nie toegelaat om uit te meld nie",
    "当前的用户账号与确认注销的账号不一致": "Hierdie karakterrekening word nie toegelaat om uit te meld nie",
    "密码输入错误次数过多，请明天再试": "Te veel verkeerde wagwoorde ingevoer, probeer asseblief môre weer",
    "注销失败": "Afmeld misluk",
    "注销成功": "Afmeld suksesvol",
    "当前用户已经被管理员禁用": "Die huidige gebruiker is deur die administrateur gedeaktiveer",
    "地址不存在,或者已删除": "Adres bestaan ​​nie, of is uitgevee",
    "地址不能为空": "Adres kan nie leeg wees nie",
    "地址过长": "adres te lank",
    "店家id不能为空": "Winkel-ID kan nie leeg wees nie",
    "店家id错误": "Die winkel-ID is verkeerd",
    "订单号不能为空": "Bestelnommer kan nie leeg wees nie",
    "非法请求": "onwettige versoek",
    "购买失败,联系客服": "Aankoop het misluk, kontak kliëntediens",
    "关注id不能为空": "Volg-ID kan nie leeg wees nie",
    "联系人不能为空": "Kontak kan nie leeg wees nie",
    "两次输入的资金密码不相同": "Die fondswagwoorde wat twee keer ingevoer word, verskil",
    "模块名不能为空": "Modulenaam kan nie leeg wees nie",
    "您的申请之前已提交过": "Jou aansoek is al voorheen ingedien",
    "请上传图片格式的文件": "Laai asseblief 'n lêer in beeldformaat op",
    "请勿重复添加": "Moenie herhaaldelik byvoeg nie",
    "取消失败": "Kansellasie het misluk",
    "删除失败": "kon nie uitvee nie",
    "商品id不能为空": "Produk-ID kan nie leeg wees nie",
    "商品id错误": "Die produk-ID is verkeerd",
    "实名认证尚未通过，无法重置": "Die regtenaam-stawing het nie geslaag nie en kan nie teruggestel word nie",
    "收藏id不能为空": "Versameling-ID kan nie leeg wees nie",
    "收货失败": "Kwitansie mislukking",
    "手机号不能为空": "Selfoonnommer kan nie leeg wees nie",
    "图片不能为空": "Prent kan nie leeg wees nie",
    "图片大小不能超过30M": "Die beeldgrootte kan nie 30M oorskry nie",
    "用户已锁定": "gebruiker gesluit",
    "正在购买": "koop",
    "该贷款单还未通过审核": "Die leningstrokie is nie goedgekeur nie",
    "该贷款单号不存在": "Die leningsnommer bestaan ​​nie",
    "两次输入的密码不相同": "Wagwoorde wat twee keer ingevoer word, verskil",
    "类型不能为空": "Tipe kan nie leeg wees nie",
    "操作失败！修正后账户余额小于0。": "operasie het misluk! Na regstelling is die rekeningsaldo minder as 0.",
    "身份证号已实名过!": "Die ID-nommer is geverifieer!",
    "提款金额不得低于最小提款限额": " Onttrekkingsbedrag moet nie minder as die minimum onttrekkingslimiet wees nie",
    "提款金额不得高于最大提款限额": "Die onttrekkingsbedrag kan nie hoër as die maksimum onttrekkingslimiet wees nie",
    "超过提现次数": "Onttrekkingstye oorskry",
    "不在提现时间范围内，请稍后再试": "Nie binne die onttrekkingstydperk nie, probeer asseblief later weer",
    "提币数量必填": "Onttrekkingsbedrag word vereis",
    "提币数量输入错误，请输入浮点数": "Die onttrekkingsbedrag is verkeerd ingevoer, voer asseblief 'n swewendepuntnommer in",
    "更新钱包失败，请联系客服": "Kon nie beursie opdateer nie, kontak asseblief kliëntediens",
    "试用码不正确": "Die proefkode is verkeerd",
    "已经提交申请，请等待审核": "Die aansoek is ingedien, wag asseblief vir hersiening",
    "审核状态异常请联系客服": "As die hersieningstatus abnormaal is, kontak asseblief kliëntediens",
    "暂无用户": "Nog geen gebruiker nie",

    "系统无该用户，或者ip地址不正确": "Daar is nie so 'n gebruiker in die stelsel nie, of die IP-adres is verkeerd",
    "游客不能向游客发送消息": "Besoekers kan nie boodskappe aan besoekers stuur nie",
    "请选择收货地址": "Kies asseblief afleweringsadres",
    "收货地址达上限": "Die afleweringsadres het die boonste limiet bereik",
    "请设置资金密码": "Stel asseblief 'n fondswagwoord in",
    "该订单未满足支付条件": "Die bestelling voldoen nie aan die betalingsvoorwaardes nie",
    "密码输入错误次数过多，请明天再试": " Te veel verkeerde wagwoorde ingevoer, probeer asseblief môre weer",
    "操作失败，请稍后再试": "Operasie het misluk, probeer asseblief later weer",
    "部分商品已下架": "Sommige produkte is gestaak",
    "邮箱的长度不能超过64个字符": "Die lengte van die posbus kan nie 64 karakters oorskry nie",
    "邮码不能超过32个字符": "Poskode kan nie 32 karakters oorskry nie",
    "操作类型不正确": "Verkeerde tipe operasie",
    "参数错误!": "Parameter fout!",
    "不支持的语言": "onondersteunde taal",
    "收货人姓名不能超过64个字符": "Geadresseerde se naam mag nie 64 karakters oorskry nie",
    "请输入正确的手机号码": "Voer asseblief die korrekte telefoonnommer in",
    "操作频繁，请稍后再试": "Gereelde bewerking, probeer asseblief later weer",
    "无此sellerGoods": "Geen sulke verkoperGoedere nie",
    "退货失败": "terugkeer het misluk",
    "该订单状态无法操作": "Die bestellingstatus kan nie bedryf word nie",
    "订单已经发货，无法退款": "Die bestelling is gestuur en kan nie terugbetaal word nie",
    "大于最大采购数量": "Groter as maksimum aankoophoeveelheid",
    "该邮箱已被订阅": "Hierdie posbus is reeds ingeteken",
    "登录过期，请重新登录": "Aanmelding het verval. Meld asseblief weer aan",
    "系统错误，请稍后重试": "Stelselfout, probeer asseblief later weer",
    "请稍后重试": "Probeer asseblief weer later",
    "连续输入错误三次，请3分钟后再试": "Voer fout vir drie keer agtereenvolgens in. Probeer asseblief weer oor 3 minute",
    "审核中": "Onder oorsig",
    "程序错误": "Program fout",
    "重复提交": "Dien weer in",
    "用户名不能为空": "Gebruikersnaam kan nie nul wees nie",
    "验证码不能为空": "Die verifikasiekode kan nie nul wees nie.",
    "登录密码不能为空": "Aantekenwagwoord kan nie nul wees nie",
    "登陆密码长度不符合设定": "Die lengte van die aanmeldwagwoord stem nie ooreen met die instelling nie.",
    "资金密码长度不符合设定": "Die lengte van fondswagwoord stem nie ooreen met die instelling nie.",
    "登陆密码不符合设定": "Die aanmeldwagwoord stem nie ooreen met die instelling nie.",
    "资金密码不符合设定": "Die fondswagwoord stem nie ooreen met die instelling nie.",
    "用户名不符合设定": "Gebruikersnaam stem nie ooreen met die instelling nie",
    "用户名必须由数字和英文字母组成": "Gebruikersnaam moet uit syfers en letters bestaan",
    "验证码不正确": "Verkeerde verifikasiekode",
    "密码不正确": "Verkeerde wagwoord",
    "服务器错误(500)": "Bedienerfout (500)",
    "服务器错误": "Bedienerprobleem",
    "用户名重复": "Duplikaat gebruikersnaam",
    "找不到用户": "Gebruiker nie gevind nie",
    "不能为空": "Kan nie nul wees nie",
    "登录失败": "Kon nie aanmeld nie",
    "操作成功": "Operasie het geslaag",
    "工作地址不能为空": "Werkadres kan nie nul wees nie",
    "家庭地址不能为空": "Huisadres kan nie nul wees nie",
    "亲属姓名不能为空": "Naam van familielid kan nie nul wees nie.",
    "亲属关系不能为空": "Binnelandse verhoudings kan nie nul wees nie.",
    "亲属地址不能为空": "Die relatiewe adres kan nie nul wees nie.",
    "亲属电话不能为空": "Die familiefoonnommer kan nie nul wees nie.",
    "用户名不存在": "Gebruikersnaam bestaan nie",
    "参数错误": "Parameterfout",
    "不在交易时段": "Nie in handelssessie nie",
    "存在不同杠杆的持仓单": "Daar is houposisies met verskillende hefboomfinansiering",
    "余额不足": "Onvoldoende balans",
    "可平仓合约张数不足": "Onvoldoende aantal beslote posisie kontrakte",
    "请输入正确的货币数量": "Voer asseblief die korrekte bedrag geldeenheid in",
    "请选择正确的币种": "Kies asseblief die korrekte geldeenheid",
    "金额错误": "Bedragfout.",
    "跟单参数输入错误": "Verkeerde invoer van dokumentparameters",
    "跟单倍数输入错误": "Verkeerde invoer van dokumentêre veelvoud",
    "交易员不存在": "Die handelaar bestaan nie.",
    "交易员未开启带单": "Die handelaar het nie die rekening oopgemaak nie.",
    "用户已跟随交易员": "Gebruiker het handelaar gevolg",
    "交易员跟随人数已满": "Die aantal handelaars wat volg is vol",
    "交易员不能跟随自己": "Handelaars kan nie hulself volg nie",
    "交易员无法跟随另一个交易员": "Handelaar kan nie 'n ander handelaar volg nie",
    "历史基金无法购买": "Historiese fondse kan nie gekoop word nie",
    "该基金尚未开放购买": "Die fonds is nie oopgemaak vir aankoop nie",
    "该基金尚已封闭": "Die fonds is gesluit",
    "基金剩余购买金额不足": "Die oorblywende aankoopbedrag van die fonds is nie genoeg nie.",
    "订单不存在": "Orde bestaan nie",
    "下单不能小于最小金额限制": "Bestellingplasing kan nie minder as die minimumbedraglimiet wees nie.",
    "[symbol]参数为空": "[simbool] parameter is nul",
    "矿机不存在": "Mynmasjien bestaan nie",
    "矿机未解锁，无法购买": "Die mynmasjien is gesluit en kan nie gekoop word nie.",
    "您已购买过体验矿机,不得重复购买": "Jy het die ervaringsmynmasjien gekoop. Moet dit nie weer koop nie.",
    "买入金额需要在区间内": "Die aankoopbedrag moet binne die reeks wees.",
    "行情获取异常，稍后再试": "Die situasie-verkryging is abnormaal. Probeer asseblief weer later.",
    "广告不存在": "Advertensie bestaan nie",
    "广告已下架": "Advertensies word afgehaal",
    "承兑商不存在": "Die aanvaarder bestaan nie.",
    "请先添加收款方式": "Voeg asseblief eers die versamelmetode by",
    "您没有符合条件的收款方式": "Jy het geen geskikte versamelmetode nie",
    "请选择买卖方式": "Kies asseblief die handelsmetode",
    "请输入正确的金额": "Voer asseblief die korrekte bedrag in",
    "请输入正确的数量": "Voer asseblief die korrekte hoeveelheid in",
    "该广告剩余数量不足": "Onvoldoende aantal advertensies oor",
    "金额不在购买区间": "Die bedrag is nie in die aankoopreeks nie.",
    "用户剩余数量不足": "Onvoldoende aantal gebruikers oor",
    "请稍后再试": "Probeer asseblief weer later",
    "未找到符合条件的匹配订单": "Geen ooreenstemmende bestelling gevind nie",
    "该订单已取消": "Hierdie bestelling is gekanselleer",
    "当前订单不为待付款状态，无法取消": "Die huidige bestelling is nie in die hangende betalingstatus nie. Dit kan nie gekanselleer word nie.",
    "卖方无法取消该订单": "Verkoper kan nie die bestelling kanselleer nie",
    "资金密码错误": "Fondswagwoordfout",
    "订单已完成": "Bestelling voltooi",
    "订单已取消": "Bestelling gekanselleer",
    "待付款的订单无法放行": "Bestellings hangende betaling kan nie vrygestel word nie",
    "订单已完成，无法放行": "Bestelling is voltooi en kan nie vrygestel word nie",
    "订单已取消，无法放行": "Bestelling is gekanselleer en kan nie vrygestel word nie",
    "未授权访问": "Ongemagtigde toegang",
    "图片大小不能超过2M！": "Prentgrootte kan nie 2M oorskry nie!",
    "参数异常，消息获取失败": "Parameterfout, boodskapverkryging het misluk",
    "无效的UID": "Ongeldige UID",
    "用户不存在": "Gebruiker bestaan nie",
    "图片上传失败": "Kon nie die prent oplaai nie",
    "请输入内容": "Voer asseblief inhoud in",
    "图片不得大于2M": "Prent mag nie groter as 2M wees nie",
    "图片不得大于10M": "Foto mag nie groter as 10M wees nie",
    "直线关系，不能修改推荐": "Reguitlynverhouding, aanbeveling kan nie gewysig word nie",
    "存在重复的角色名称": "Duplikaat rolnaam",
    "角色被用户关联，不可删除": "Rol word deur gebruiker geassosieer. Dit kan nie uitgevee word nie.",
    "系统存在相同[系统登录名]！": "Stelsel bestaan dieselfde [Stelsel aanmeldnaam]!",
    "旧密码不正确": "Verkeerde ou wagwoord",
    "没有找到用户": "Geen gebruiker gevind nie",
    "[code]值错误": "[kode] waarde is verkeerd",
    "身份证已实名过!": "ID-kaart is geverifieer!",
    "实名认证未通过，无法进行高级认证": "Regtenaam-sertifisering het misluk. Gevorderde sertifisering is nie beskikbaar nie.",
    "收款方输入错误": "Voer fout van begunstigde in",
    "所选汇率不存在": "Die geselekteerde wisselkoers bestaan nie",
    "转账数量不能小于等于0": "Oordraghoeveelheid kan nie minder as of gelyk aan 0 wees nie",
    "UID不能为空": "UID kan nie nul wees nie",
    "转账币种不能为空": "Oordraggeldeenheid kan nie nul wees nie.",
    "资金密码不能为空": "Die fondswagwoord kan nie nul wees nie.",
    "提现不得小于限额": "Kontantonttrekking kan nie minder as die limiet wees nie",
    "提现不得大于限额": "Kontantonttrekking kan nie groter as die limiet wees nie",
    "当日可提现次数不足": "Die aantal saakonttrekkings op die huidige dag is nie genoeg nie.",
    "不在可提现时间内": "Nie binne die tyd van onttrekking nie",
    "渠道未开通": "Kanaal nie oopgemaak nie",
    "提币数量不能小于等于0": "Die onttrekkingshoeveelheid kan nie minder as of gelyk aan 0 wees nie.",
    "无权限": "Geen toestemmings nie",
    "请先通过高级认证": "Slaag asseblief eers die gevorderde sertifisering",
    "请输入搜索关键字": "Voer asseblief soeksleutelwoorde in",
    "角色不存在": "Rol bestaan nie",
    "持有币种不足": "Onvoldoende hou geldeenheid",
    "提交失败，当前有未处理订单": "Indiening het misluk. Daar is tans oop bestellings.",
    "充值链错误": "Laaikettingfout",
    "充值价值不得小于最小限额": "Die herlaaiwaarde moet nie minder as die minimum limiet wees nie",
    "充值价值不得大于最大限额": "Die herlaaiwaarde mag nie groter as die maksimum limiet wees nie",
    "充值数量不能小于等于0": "Herlaaihoeveelheid kan nie minder as of gelyk aan 0 wees nie",
    "请输入充值币种": "Voer asseblief die herlaaigeldeenheid in",
    "请上传图片": "Laai asseblief foto's op",
    "当前还需交易": "Transaksie word steeds vereis",
    ",才可提币": ", en dan kan kontantonttrekking gemaak word.",
    "提示": "Wenke",
    "未实名认证，是否认证？": "Nie gewaarmerk met regte naam nie. Staaf?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Rekeninguitsondering vereis C3-verifikasie. Kontak asseblief aanlyn kliëntediens.",
    "确认": "Bekragtiging",
    "取消": "Kanselleer",
    "更新提醒": "Dateer onthounota op",
    "发现新版本，请升级到最新版本": "Nuwe weergawe gevind, gradeer asseblief op na die nuutste weergawe",
    "请检查网络连接": "Gaan asseblief jou netwerkverbinding na",
    "您已存在订单": "Jy het reeds 'n bestelling",
    "当前地址格式错误": "Huidige adresformaatfout",
    "申购数量错误": "Intekeninghoeveelheidsfout",
    "产品不存在": "Produk bestaan nie",
    "该产品未上架": "Hierdie produk is nie gelys nie",
    "该产品已上市，无法购买": "Hierdie produk is op die mark en kan nie gekoop word nie",
    "当日才可申购": "Aankope kan slegs op dieselfde dag gekoop word.",
    "产品剩余数量不足": "Onvoldoende produkhoeveelheid oor",
    "您当前可分配额度不足": "Jou huidige toekenbare limiet is nie genoeg nie",
    "购买矿机时间不得低于托管订单剩余时间": "Mynmasjien-aankooptyd kan nie minder wees as die oorblywende tyd van die bewaringsbevel nie",
    "推荐码不正确": "Die aanbevelingskode is verkeerd.",
    "推荐人无权限推荐": "Die aanbeveling het geen magtiging om aan te beveel nie.",
    "审核已通过": "Resensie geslaag",
    "请填写正确的验证码": "Vul asseblief die korrekte verifikasiekode in",
    "请填写正确的电话号码": "Vul asseblief die korrekte telefoonnommer in",
    "请填写正确的邮箱地址": "Vul asseblief die korrekte e-posadres in",
    "电话号码已绑定": "Telefoonnommer reeds gebind",
    "电话号码已绑定其他用户": "Telefoonnommer is aan 'n ander gebruiker gekoppel",
    "邮箱已绑定": "Posbus reeds gebind",
    "邮箱已绑定其他用户": "Posbus is reeds aan 'n ander gebruiker gebind",
    "页码不是整数": "Bladsynommer is nie 'n heelgetal nie",
    "页码不能小于等于0": "Bladsynommer kan nie minder as of gelyk aan 0 wees nie",
    "请输入正确的质押金额": "Voer asseblief die korrekte pandbedrag in",
    "请输入正确的质押天数": "Voer asseblief die korrekte panddae in",
    "未发现授权记录": "Magtigingsrekord nie gevind nie",
    "授权状态未成功": "Magtigingstatus het misluk",
    "赎回状态异常": "Aflossingstatus abnormaal",
    "申请成功": "Aansoek geslaag",
    "领取成功": "Ontvangs het geslaag",
    "未找到匹配的收益记录": "Geen ooreenstemmende inkomste-rekord gevind nie",
    "已领取": "Ontvang",
    "校验IP不合法": "Verifikasie IP is onwettig.",
    "委托数量(张)必填": "Toevertroude hoeveelheid (st.) word vereis",
    "委托数量(张)不能小于等于0": "Die toevertroude hoeveelheid (st.) kan nie minder as of gelyk aan 0 wees nie.",
    "请先绑定谷歌验证器": "Bind asseblief eers Google Authenticator",
    "资金密码必须6-12位": "Die fondswagwoord moet 6-12 syfers wees.",
    "验证码错误": "Verifikasiekodefout",
    "登录密码必须6-12位": "Aantekenwagwoord moet 6-12 syfers wees",
    "密码不能为空": "Wagwoord kan nie nul wees nie",
    "密码必须6-12位": "Wagwoord moet 6-12 syfers wees",
    "验证类型不能为空": "Stawingtipe kan nie nul wees nie",
    "未绑定手机号": "Geen telefoonnommer is gebind nie",
    "未绑定邮箱": "Geen posbus is gebind nie",
    "未绑定谷歌验证器": "Google-valideerder nie gebind nie",
    "旧密码不能为空": "Ou wagwoord kan nie nul wees nie",
    "新密码不能为空": "Die nuwe wagwoord kan nie nul wees nie.",
    "新密码确认不能为空": "Nuwe wagwoordbevestiging kan nie nul wees nie.",
    "新密码不一致": "Nuwe wagwoord is nie dieselfde met die oorspronklike invoer nie",
    "操作类型为空": "Bewerking tipe is nul",
    "操作类型不是整数": "Bewerkingtipe is nie 'n heelgetal nie",
    "操作类型不能小于0": "Bewerkingtipe kan nie minder as 0 wees nie",
    "用户名参数为空": "Gebruikersnaamparameter is nul",
    "状态不是整数": "Status is nie 'n heelgetal nie",
    "状态不能小于0": "Status kan nie minder as 0 wees nie",
    "系统参数错误": "Stelselparameterfout",
    "-连接已建立-": "-Verbinding tot stand gebring-",
    "代理层级错误": "Agentvlakfout",
    "请重新登录": "Meld asseblief weer aan",
    "提交失败": "Indiening het misluk",
    "充值金额不能小于1": "Die herlaaibedrag kan nie minder as 1 wees nie (insluitend twee desimale plekke)",
    "请切换其他语言后查看": "Skakel asseblief oor na 'n ander taal om te sien",
    "我的购物车": "My inkopiemandjie",
    "推荐商品": "Aanbevole produkte",
    "猜你喜欢": "Raai jy hou daarvan.",
    "暂无店铺": "Geen winkel gevind nie",
    "添加失败": "Kon nie indien nie. Probeer asseblief weer later",
    "提交订单": "Bestelling indiening",
    "地址格式与协议不匹配": "Adresformaat stem nie ooreen met die protokol nie",
    "用户已绑定过提现地址": "Gebruiker het reeds 'n onttrekkingsadres gebind",
    "绑定提现地址成功": "Bind onttrekkingsadres suksesvol",
    "未设置地址": "Adres nie ingestel nie",
    "您有一笔提现正在处理中": "U het 'n onttrekking wat verwerk word",
    "平台人工发起退款": "Die platform het die terugbetaling handmatig geïnisieer",
    "充值数量不能小于等于0": "Die herlaaiaantal kan nie minder as of gelyk aan 0 wees nie",
    "请选择法币类型": " Kies asseblief die geldeenheidstipe",
    "充值金额超过最大金额": " Die herlaaibedrag is meer as die maksimum bedrag",
    "充值金额小于最小金额": " Die herlaaibedrag is minder as die minimum bedrag",
    "请选择正确的法币类型": " Kies asseblief die korrekte geldeenheidstipe",
    "业务已锁定，请联系客服！": " Besigheid is gesluit, kontak asseblief kliëntediens!",
    "无法购买本店商品": " Kan nie hierdie winkel se produkte koop nie",
    '参数缺失': "Parameter ontbreek",
    '充值数量必填': "Oplaai hoeveelheid moet ingevul word",
  },
  "tits_pt": {
    "添加失败": "Falha ao enviar. Por favor, tente novamente mais tarde",
    "提交失败": "Falha no envio",
    "请输入正确的邮箱地址": "Insira um endereço de e-mail correto",
    "已有未完成的贷款单，不能重复申请": "Já existe um pedido de empréstimo não concluído, não é possível solicitar novamente",
    "请输入关键字搜索": "Por favor, insira a palavra-chave para pesquisar",
    "已提交评论!": "Avaliação enviada!",
    "系统错误": 'erro no sistema',
    "未指定商家": "Negócio não especificado",
    "该手机号已被占用，请绑定其他手机号": 
      "O número de telefone já está em uso, por favor, vincule outro número de telefone",
      "邮箱验证码发送次数过多，请明天再试": 
      "O número de verificação de e-mail enviado muitas vezes, por favor, tente novamente morgen",
    "该邮箱已被占用，请更换其他邮箱注册":
      "O e-mail já está em uso, por favor, escolha outro e-mail para se registrar",
    "该商品已下架": "O produto está fora do ar",
    "当前账号有未完成的充值订单，请完成后再试": "A conta atual tem um pedido de recarga inacabado, tente novamente após a conclusão",
    "当前账号有未完成的提现订单，请完成后再试": "A conta atual tem uma ordem de retirada inacabada, por favor, complete e tente novamente",
    "请先登录": "por favor entre",
    "该角色账号不允许注销": "Esta conta de personagem não tem permissão para sair",
    "当前的用户账号与确认注销的账号不一致": "A conta de usuário atual é inconsistente com a conta confirmada para logout",
    "密码输入错误次数过多，请明天再试": "Muitas senhas incorretas digitadas, tente novamente amanhã",
    "注销失败": "Falha ao sair",
    "注销成功": "Logout bem-sucedido",
    '参数缺失': "Parâmetro ausente",
    '充值数量必填': "O número de recargas é obrigatório",
    "当前用户已经被管理员禁用": "O usuário atual foi desabilitado pelo administrador",
    "地址不存在,或者已删除": "O endereço não existe ou foi excluído",
    "地址不能为空": "O endereço não pode estar vazio",
    "地址过长": "endereço muito longo",
    "店家id不能为空": "O ID da loja não pode estar vazio",
    "店家id错误": "O id da loja está errado",
    "订单号不能为空": "O número do pedido não pode estar vazio",
    "非法请求": "pedido ilegal",
    "购买失败,联系客服": "Falha na compra, entre em contato com o atendimento ao cliente",
    "关注id不能为空": "Seguir id não pode estar vazio",
    "联系人不能为空": "O contato não pode estar vazio",
    "两次输入的资金密码不相同": "As senhas dos fundos inseridas duas vezes são diferentes",
    "模块名不能为空": "O nome do módulo não pode estar vazio",
    "您的申请之前已提交过": "Sua inscrição foi enviada antes",
    "请上传图片格式的文件": "Carregue um arquivo em formato de imagem",
    "请勿重复添加": "Não adicione repetidamente",
    "取消失败": "Falha no cancelamento",
    "删除失败": "falha ao deletar",
    "商品id不能为空": "O ID do produto não pode estar vazio",
    "商品id错误": "O id do produto está errado",
    "实名认证尚未通过，无法重置": "A autenticação de nome real não foi aprovada e não pode ser redefinida",
    "收藏id不能为空": "O ID da coleção não pode estar vazio",
    "收货失败": "Falha no recebimento",
    "手机号不能为空": "O número do celular não pode estar vazio",
    "图片不能为空": "A imagem não pode estar vazia",
    "图片大小不能超过30M": "O tamanho da imagem não pode exceder 30M",
    "用户已锁定": "usuário bloqueado",
    "正在购买": "comprando",
    "该贷款单还未通过审核": "O boleto do empréstimo não foi aprovado",
    "该贷款单号不存在": "O número do empréstimo não existe",
    "两次输入的密码不相同": "Senhas inseridas duas vezes são diferentes",
    "类型不能为空": "O tipo não pode estar vazio",
    "操作失败！修正后账户余额小于0。": "Operação falhou! Após a correção, o saldo da conta é menor que 0.",
    "身份证号已实名过!": "O número de identificação foi verificado!",
    "提款金额不得低于最小提款限额": "O valor da retirada não deve ser inferior ao limite mínimo de retirada",
    "提款金额不得高于最大提款限额": "O valor da retirada não pode ser superior ao limite máximo de retirada",
    "超过提现次数": "Tempos de retirada excedidos",
    "不在提现时间范围内，请稍后再试": " Fora do intervalo de tempo de retirada, tente novamente mais tarde",
    "提币数量必填": "O valor da retirada é obrigatório",
    "提币数量输入错误，请输入浮点数": "O valor da retirada foi inserido incorretamente, insira um número de ponto flutuante",
    "更新钱包失败，请联系客服": " Falha ao atualizar a carteira, entre em contato com o atendimento ao cliente",
    "试用码不正确": "O código de teste está incorreto",
    "已经提交申请，请等待审核": "A inscrição foi enviada, aguarde a análise",
    "审核状态异常请联系客服": "Se o status da revisão for anormal, entre em contato com o atendimento ao cliente",
    "暂无用户": "Nenhum usuário ainda",
    "系统无该用户，或者ip地址不正确": "Não existe tal usuário no sistema ou o endereço IP está incorreto",
    "游客不能向游客发送消息": "Visitantes não podem enviar mensagens para visitantes",
    "请选择收货地址": "Selecione o endereço de entrega",
    "收货地址达上限": "O endereço de entrega atingiu o limite superior",
    "请设置资金密码": "Por favor, defina uma senha de fundo",
    "该订单未满足支付条件": "A encomenda não cumpre as condições de pagamento",
    "密码输入错误次数过多，请明天再试": "Muitas senhas erradas digitadas, tente novamente amanhã",
    "操作失败，请稍后再试": "Falha na operação, tente novamente mais tarde",
    "部分商品已下架": "Alguns produtos foram descontinuados",
    "邮箱的长度不能超过64个字符": "O comprimento da caixa de correio não pode exceder 64 caracteres",
    "邮码不能超过32个字符": "O código postal não pode exceder 32 caracteres",
    "操作类型不正确": "Tipo de operação incorreto",
    "参数错误!": "Erro de parâmetro!",
    "不支持的语言": "idioma não suportado",
    "收货人姓名不能超过64个字符": "O nome do destinatário não pode exceder 64 caracteres",
    "请输入正确的手机号码": "Por favor, insira o número de telefone correto",
    "操作频繁，请稍后再试": "Operação frequente, tente novamente mais tarde",
    "无此sellerGoods": "Nenhum tal vendedorBens",
    "退货失败": "falha no retorno",
    "该订单状态无法操作": "O status do pedido não pode ser operado",
    "订单已经发货，无法退款": "O pedido foi enviado e não pode ser reembolsado",
    "大于最大采购数量": "Maior que a quantidade máxima de compra",
    "该邮箱已被订阅": "Esta caixa de correio já foi assinada",
    "登录过期，请重新登录": "Login expirado. Por favor faça login novamente",
    "系统错误，请稍后重试": "Erro de sistema, tente novamente mais tarde",
    "请稍后重试": "Por favor, tente novamente mais tarde",
    "连续输入错误三次，请3分钟后再试": "Insira o erro por três vezes consecutivas. Tente novamente em 3 minutos",
    "审核中": "Sob revisão",
    "程序错误": "erro de programa",
    "重复提交": "reenviar",
    "用户名不能为空": "O nome de usuário não pode ser nulo",
    "验证码不能为空": "O código de verificação não pode ser nulo.",
    "登录密码不能为空": "A senha de acesso não pode ser nula",
    "登陆密码长度不符合设定": "O comprimento da senha de login não corresponde à configuração.",
    "资金密码长度不符合设定": "O comprimento da senha do fundo não corresponde à configuração.",
    "登陆密码不符合设定": "A senha de login não corresponde à configuração.",
    "资金密码不符合设定": "A senha do fundo não está de acordo com a configuração.",
    "用户名不符合设定": "O nome de usuário não corresponde à configuração",
    "用户名必须由数字和英文字母组成": "O nome de usuário deve consistir em números e letras",
    "验证码不正确": "Código de verificação incorreto",
    "密码不正确": "Senha incorreta",
    "服务器错误(500)": "Erro do servidor (500)",
    "服务器错误": "Erro de servidor",
    "用户名重复": "Nome de usuário duplicado",
    "找不到用户": "Usuário não encontrado",
    "不能为空": "Não pode ser nulo",
    "登录失败": "falha no login",
    "操作成功": "Operação bem-sucedida",
    "工作地址不能为空": "O endereço do trabalho não pode ser nulo",
    "家庭地址不能为空": "O endereço residencial não pode ser nulo",
    "亲属姓名不能为空": "O nome do parente não pode ser nulo.",
    "亲属关系不能为空": "As relações domésticas não podem ser nulas.",
    "亲属地址不能为空": "O endereço relativo não pode ser nulo.",
    "亲属电话不能为空": "O número de telefone da família não pode ser nulo.",
    "用户名不存在": "Usuário não existe",
    "参数错误": "Erro de parâmetro",
    "不在交易时段": "Não está em sessão de negociação",
    "存在不同杠杆的持仓单": "Existem posições de espera com alavancagem diferente",
    "余额不足": "Saldo insuficiente",
    "可平仓合约张数不足": "Número insuficiente de contratos de posição fechada",
    "请输入正确的货币数量": "Por favor, insira o valor correto da moeda",
    "请选择正确的币种": "Selecione a moeda correta",
    "金额错误": "Erro de quantidade.",
    "跟单参数输入错误": "Entrada incorreta dos parâmetros do documento",
    "跟单倍数输入错误": "Entrada incorreta do múltiplo documental",
    "交易员不存在": "O comerciante não existe.",
    "交易员未开启带单": "O comerciante não abriu a conta.",
    "用户已跟随交易员": "O usuário seguiu o comerciante",
    "交易员跟随人数已满": "O número de traders a seguir está completo",
    "交易员不能跟随自己": "Os comerciantes não podem seguir a si mesmos",
    "交易员无法跟随另一个交易员": "O comerciante não pode seguir outro comerciante",
    "历史基金无法购买": "Fundos históricos não podem ser comprados",
    "该基金尚未开放购买": "O fundo não foi aberto para compra",
    "该基金尚已封闭": "O fundo foi fechado",
    "基金剩余购买金额不足": "O valor restante da compra do fundo não é suficiente.",
    "订单不存在": "O pedido não existe",
    "下单不能小于最小金额限制": "A colocação do pedido não pode ser inferior ao limite de valor mínimo.",
    "[symbol]参数为空": "O parâmetro [símbolo] é nulo",
    "矿机不存在": "A máquina de mineração não existe",
    "矿机未解锁，无法购买": "A máquina de mineração está bloqueada e não pode ser comprada.",
    "您已购买过体验矿机,不得重复购买": "Você comprou a máquina de mineração de experiência. Não compre novamente.",
    "买入金额需要在区间内": "O valor da compra deve estar dentro do intervalo.",
    "行情获取异常，稍后再试": "A aquisição da situação é anormal. Por favor, tente novamente mais tarde.",
    "广告不存在": "Anúncio não existe",
    "广告已下架": "Os anúncios são retirados",
    "承兑商不存在": "O aceitador não existe.",
    "请先添加收款方式": "Adicione o método de coleta primeiro",
    "您没有符合条件的收款方式": "Você não tem um método de coleta qualificado",
    "请选择买卖方式": "Selecione o método de negociação",
    "请输入正确的金额": "Por favor, insira o valor correto",
    "请输入正确的数量": "Por favor, insira a quantidade correta",
    "该广告剩余数量不足": "Número insuficiente de anúncios restantes",
    "金额不在购买区间": "O valor não está na faixa de compra.",
    "用户剩余数量不足": "Número insuficiente de usuários restantes",
    "请稍后再试": "Por favor, tente novamente mais tarde",
    "未找到符合条件的匹配订单": "Nenhum pedido correspondente encontrado",
    "该订单已取消": "Esse pedido foi cancelado",
    "当前订单不为待付款状态，无法取消": "O pedido atual não está no status de pagamento pendente. Não pode ser cancelado.",
    "卖方无法取消该订单": "O vendedor não pode cancelar o pedido",
    "资金密码错误": "Erro de senha do fundo",
    "订单已完成": "Encomenda completa",
    "订单已取消": "Pedido cancelado",
    "待付款的订单无法放行": "Pedidos pendentes de pagamento não podem ser liberados",
    "订单已完成，无法放行": "O pedido foi concluído e não pode ser liberado",
    "订单已取消，无法放行": "O pedido foi cancelado e não pode ser liberado",
    "未授权访问": "Acesso não autorizado",
    "图片大小不能超过2M！": "O tamanho da imagem não pode exceder 2M!",
    "参数异常，消息获取失败": "Erro de parâmetro, falha na aquisição da mensagem",
    "无效的UID": "UID inválido",
    "用户不存在": "Usuário não existe",
    "图片上传失败": "Falha ao carregar a imagem",
    "请输入内容": "Insira o conteúdo",
    "图片不得大于2M": "A imagem não deve ser maior que 2M",
    "图片不得大于10M": "A imagem não deve ser maior que 10M",
    "直线关系，不能修改推荐": "Relação de linha reta, a recomendação não pode ser modificada",
    "存在重复的角色名称": "Nome da função duplicado",
    "角色被用户关联，不可删除": "A função é associada pelo usuário. Ele não pode ser excluído.",
    "系统存在相同[系统登录名]！": "O sistema existe o mesmo [Nome de login do sistema]!",
    "旧密码不正确": "Senha antiga incorreta",
    "没有找到用户": "Nenhum usuário encontrado",
    "[code]值错误": "[código] valor está incorreto",
    "身份证已实名过!": "O cartão de identificação foi autenticado!",
    "实名认证未通过，无法进行高级认证": "Falha na certificação de nome real. A certificação avançada não está disponível.",
    "收款方输入错误": "Digite o erro do beneficiário",
    "所选汇率不存在": "A taxa de câmbio selecionada não existe",
    "转账数量不能小于等于0": "A quantidade de transferência não pode ser menor ou igual a 0",
    "UID不能为空": "UID não pode ser nulo",
    "转账币种不能为空": "A moeda de transferência não pode ser nula.",
    "资金密码不能为空": "A senha do fundo não pode ser nula.",
    "提现不得小于限额": "A retirada de dinheiro não pode ser inferior ao limite",
    "提现不得大于限额": "A retirada de dinheiro não pode ser maior que o limite",
    "当日可提现次数不足": "O número de retirada de casos no dia atual não é suficiente.",
    "不在可提现时间内": "Fora do prazo de retirada",
    "渠道未开通": "Canal não aberto",
    "提币数量不能小于等于0": "A quantidade retirada não pode ser menor ou igual a 0.",
    "无权限": "Nenhuma permissão",
    "请先通过高级认证": "Passe primeiro na certificação avançada",
    "请输入搜索关键字": "Insira palavras-chave de pesquisa",
    "角色不存在": "A função não existe",
    "持有币种不足": "Moeda de retenção insuficiente",
    "提交失败，当前有未处理订单": "Falha no envio. No momento, existem pedidos em aberto.",
    "充值链错误": "Erro na cadeia de carregamento",
    "充值价值不得小于最小限额": "O valor da recarga não deve ser inferior ao limite mínimo",
    "充值价值不得大于最大限额": "O valor da recarga não deve ser superior ao limite máximo",
    "充值数量不能小于等于0": "A quantidade de recarga não pode ser menor ou igual a 0",
    "请输入充值币种": "Insira a moeda de recarga",
    "请上传图片": "Por favor, envie fotos",
    "当前还需交易": "A transação ainda é necessária",
    ",才可提币": ", e então a retirada de dinheiro pode ser feita.",
    "提示": "Pontas",
    "未实名认证，是否认证？": "Não autenticado pelo nome real. Autenticar?",
    "帐户异常需要进行C3认证，请联系在线客服。": "A exceção da conta requer autenticação C3. Entre em contato com o atendimento ao cliente on-line.",
    "确认": "Validação",
    "取消": "Cancelar",
    "更新提醒": "Atualizar lembrete",
    "发现新版本，请升级到最新版本": "Nova versão encontrada, atualize para a versão mais recente",
    "请检查网络连接": "Verifique sua conexão de rede",
    "您已存在订单": "Você já tem um pedido",
    "当前地址格式错误": "Erro de formato de endereço atual",
    "申购数量错误": "Erro de quantidade de assinatura",
    "产品不存在": "O produto não existe",
    "该产品未上架": "Este produto não está listado",
    "该产品已上市，无法购买": "Este produto está no mercado e não pode ser comprado",
    "当日才可申购": "A compra só pode ser feita no mesmo dia.",
    "产品剩余数量不足": "Quantidade de produto insuficiente restante",
    "您当前可分配额度不足": "Seu limite alocável atual não é suficiente",
    "购买矿机时间不得低于托管订单剩余时间": "O tempo de compra da máquina de mineração não pode ser inferior ao tempo restante da ordem de custódia",
    "推荐码不正确": "O código de recomendação está incorreto.",
    "推荐人无权限推荐": "O recomendador não tem autoridade para recomendar.",
    "审核已通过": "Revisão aprovada",
    "请填写正确的验证码": "Por favor, preencha o código de verificação correto",
    "请填写正确的电话号码": "Por favor, preencha o número de telefone correto",
    "请填写正确的邮箱地址": "Por favor, preencha o endereço de e-mail correto",
    "电话号码已绑定": "Número de telefone já vinculado",
    "电话号码已绑定其他用户": "O número de telefone está vinculado a outro usuário",
    "邮箱已绑定": "Caixa de correio já vinculada",
    "邮箱已绑定其他用户": "Caixa de correio já vinculada a outro usuário",
    "页码不是整数": "O número da página não é um número inteiro",
    "页码不能小于等于0": "O número da página não pode ser menor ou igual a 0",
    "请输入正确的质押金额": "Insira o valor correto da contribuição",
    "请输入正确的质押天数": "Insira os dias de compromisso corretos",
    "未发现授权记录": "Registro de autorização não encontrado",
    "授权状态未成功": "Falha no status de autorização",
    "赎回状态异常": "Status de resgate anormal",
    "申请成功": "Aplicação bem-sucedida",
    "领取成功": "Recebendo com sucesso",
    "未找到匹配的收益记录": "Nenhum registro de receita correspondente encontrado",
    "已领取": "Recebido",
    "校验IP不合法": "O IP de verificação é ilegal.",
    "委托数量(张)必填": "A quantidade confiada (uns.) é necessária",
    "委托数量(张)不能小于等于0": "A quantidade confiada (uns.) não pode ser menor ou igual a 0.",
    "请先绑定谷歌验证器": "Vincule o Google Authenticator primeiro",
    "资金密码必须6-12位": "A senha do fundo deve ter de 6 a 12 dígitos.",
    "验证码错误": "Erro no código de verificação",
    "登录密码必须6-12位": "A senha de login deve ter de 6 a 12 dígitos",
    "密码不能为空": "A senha não pode ser nula",
    "密码必须6-12位": "A senha deve ter de 6 a 12 dígitos",
    "验证类型不能为空": "O tipo de autenticação não pode ser nulo",
    "未绑定手机号": "Nenhum número de telefone está vinculado",
    "未绑定邮箱": "Nenhuma caixa de correio está vinculada",
    "未绑定谷歌验证器": "Validador do Google não vinculado",
    "旧密码不能为空": "A senha antiga não pode ser nula",
    "新密码不能为空": "A nova senha não pode ser nula.",
    "新密码确认不能为空": "A confirmação da nova senha não pode ser nula.",
    "新密码不一致": "A nova senha não é a mesma que a entrada original",
    "操作类型为空": "O tipo de operação é nulo",
    "操作类型不是整数": "O tipo de operação não é um número inteiro",
    "操作类型不能小于0": "O tipo de operação não pode ser menor que 0",
    "用户名参数为空": "O parâmetro do nome de usuário é nulo",
    "状态不是整数": "O status não é um número inteiro",
    "状态不能小于0": "O status não pode ser menor que 0",
    "系统参数错误": "Erro de parâmetro do sistema",
    "-连接已建立-": "-Conexão estabelecida-",
    "代理层级错误": "Erro no nível do agente",
    "请重新登录": "Por favor faça login novamente",
    "暂无店铺": "Nenhuma loja",
    "地址格式与协议不匹配": "O formato do endereço não corresponde ao protocolo",
    "用户已绑定过提现地址": "O usuário já vinculou o endereço de retirada",
    "绑定提现地址成功": "Vincular o endereço de retirada com sucesso",
    "未设置地址": "Endereço não definido",
    "您有一笔提现正在处理中": "Você tem uma retirada em processamento",
    "平台人工发起退款": "O reembolso foi iniciado manualmente pela plataforma",
    "充值数量不能小于等于0": "A quantidade de recarga não pode ser menor ou igual a 0",
    "请选择法币类型": " Selecione o tipo de moeda fiduciária",
    "充值金额超过最大金额": " O valor da recarga excede o valor máximo",
    "充值金额小于最小金额": " O valor da recarga é menor que o valor mínimo",
    "请选择正确的法币类型": " Selecione o tipo de moeda fiduciária correto",
    "业务已锁定，请联系客服！": " O negócio está bloqueado, entre em contato com o atendimento ao cliente!",
    "无法购买本店商品": " Não é possível comprar produtos nesta loja",
  },
  "tits_fr": {
    "添加失败": "Échec de l'envoi. Veuillez réessayer plus tard",
    "提交失败": "La soumission a échoué",
    "请输入正确的邮箱地址": "Veuillez saisir une adresse e-mail correcte",
    "已有未完成的贷款单，不能重复申请": "Il existe déjà une commande de prêt non terminée, nouvelle demande impossible",
    "请输入关键字搜索": "Veuillez entrer un mot-clé pour rechercher",
    '参数缺失': "Paramètre manquant",
    '充值数量必填': "Le montant de la recharge est requis",
    "该手机号已被占用，请绑定其他手机号": "Ce numéro de téléphone est déjà utilisé, veuillez en choisir un autre",
    "邮箱验证码发送次数过多，请明天再试":  
      "Le nombre de tentatives de réception de code d'email est trop important, veuillez réessayer demain",
    "该邮箱已被占用，请更换其他邮箱注册": "Ce courriel est déjà utilisé, veuillez en choisir un autre",
    "已提交评论!": "Avis soumis !",
    "该商品已下架": "Ce produit est en panne",
    "未指定商家": "Entreprise non précisée",
    "系统错误": 'erreur système',
    "当前账号有未完成的充值订单，请完成后再试": "Le compte actuel a une commande de recharge inachevée, veuillez réessayer une fois terminé",
    "请先登录": "veuillez vous connecter",
    "当前账号有未完成的提现订单，请完成后再试": "Le compte actuel a un ordre de retrait inachevé, veuillez compléter et réessayer",
    "该角色账号不允许注销": "Ce compte de personnage n'est pas autorisé à se déconnecter",
    "当前的用户账号与确认注销的账号不一致": "Le compte d'utilisateur actuel est incohérent avec le compte confirmé pour se déconnecter",
    "密码输入错误次数过多，请明天再试": "Trop de mots de passe erronés saisis, veuillez réessayer demain",
    "注销失败": "La déconnexion a échoué",
    "注销成功": "Déconnexion réussie",
    "当前用户已经被管理员禁用": "L'utilisateur actuel a été désactivé par l'administrateur",
    "地址不存在,或者已删除": "L'adresse n'existe pas ou a été supprimée",
    "地址不能为空": "L'adresse ne peut pas être vide",
    "地址过长": "adresse trop longue",
    "店家id不能为空": "L'ID de magasin ne peut pas être vide",
    "店家id错误": "L'identifiant du magasin est erroné",
    "订单号不能为空": "Le numéro de commande ne peut pas être vide",
    "非法请求": "demande illégale",
    "购买失败,联系客服": "Échec de l'achat, contactez le service client",
    "关注id不能为空": "L'identifiant de suivi ne peut pas être vide",
    "联系人不能为空": "Le contact ne peut pas être vide",
    "两次输入的资金密码不相同": "Les mots de passe de fonds saisis deux fois sont différents",
    "模块名不能为空": "Le nom du module ne peut pas être vide",
    "您的申请之前已提交过": "Votre candidature a été déposée avant",
    "请上传图片格式的文件": "Veuillez télécharger un fichier au format image",
    "请勿重复添加": "Ne pas ajouter à plusieurs reprises",
    "取消失败": "Échec de l'annulation",
    "删除失败": "impossible de supprimer",
    "商品id不能为空": "L'identifiant du produit ne peut pas être vide",
    "商品id错误": "L'identifiant du produit est erroné",
    "实名认证尚未通过，无法重置": "L'authentification par nom réel n'a pas réussi et ne peut pas être réinitialisée",
    "收藏id不能为空": "L'identifiant de la collection ne peut pas être vide",
    "收货失败": "Échec de réception",
    "手机号不能为空": "Le numéro de téléphone mobile ne peut pas être vide",
    "图片不能为空": "L'image ne peut pas être vide",
    "图片大小不能超过30M": "La taille de l'image ne peut pas dépasser 30M",
    "用户已锁定": " utilisateur verrouillé",
    "正在购买": "achat",
    "该贷款单还未通过审核": "Le bordereau de prêt n'a pas été approuvé",
    "该贷款单号不存在": "Le numéro de prêt n'existe pas",
    "两次输入的密码不相同": "Les mots de passe entrés deux fois sont différents",
    "类型不能为空": "Le type ne peut pas être vide",
    "操作失败！修正后账户余额小于0。": "l'opération a échoué! Après correction, le solde du compte est inférieur à 0.",
    "身份证号已实名过!": "Le numéro d'identification a été vérifié !",
    "提款金额不得低于最小提款限额": "Le montant du retrait ne doit pas être inférieur à la limite de retrait minimum",
    "提款金额不得高于最大提款限额": "Le montant du retrait ne peut pas être supérieur à la limite maximale de retrait",
    "超过提现次数": "Délais de retrait dépassés",
    "不在提现时间范围内，请稍后再试": "Pas dans la plage horaire de retrait, veuillez réessayer plus tard",
    "提币数量必填": "Le montant du retrait est requis",
    "提币数量输入错误，请输入浮点数": "Le montant du retrait a été saisi de manière incorrecte, veuillez saisir un nombre à virgule flottante",
    "更新钱包失败，请联系客服": "Échec de la mise à jour du portefeuille, veuillez contacter le service client",
    "试用码不正确": "Le code d'essai est incorrect",
    "已经提交申请，请等待审核": "La demande a été soumise, veuillez attendre l'examen",
    "审核状态异常请联系客服": "Si l'état de l'examen est anormal, veuillez contacter le service client",
    "暂无用户": "Pas encore d'utilisateur",
    "系统无该用户，或者ip地址不正确": "Il n'y a pas un tel utilisateur dans le système, ou l'adresse IP est incorrecte",
    "游客不能向游客发送消息": " Les visiteurs ne peuvent pas envoyer de messages aux visiteurs",
    "请选择收货地址": "Veuillez sélectionner l'adresse de livraison",
    "收货地址达上限": "L'adresse de livraison a atteint la limite supérieure",
    "请设置资金密码": "Veuillez définir un mot de passe de fonds",
    "该订单未满足支付条件": "La commande ne respecte pas les conditions de paiement",
    "密码输入错误次数过多，请明天再试": "Trop de mauvais mots de passe saisis, veuillez réessayer demain",
    "操作失败，请稍后再试": "Échec de l'opération, veuillez réessayer plus tard",
    "部分商品已下架": "Certains produits ont été arrêtés",
    "邮箱的长度不能超过64个字符": "La longueur de la boîte aux lettres ne peut pas dépasser 64 caractères",
    "邮码不能超过32个字符": "Le code postal ne peut pas dépasser 32 caractères",
    "操作类型不正确": "Type d'opération incorrect",
    "参数错误!": "Erreur de paramètre !",
    "不支持的语言": "langue non prise en charge",
    "收货人姓名不能超过64个字符": "Le nom du destinataire ne peut pas dépasser 64 caractères",
    "请输入正确的手机号码": "Veuillez entrer le bon numéro de téléphone",
    "操作频繁，请稍后再试": "Opération fréquente, veuillez réessayer plus tard",
    "无此sellerGoods": "Aucun vendeur de ce type",
    "退货失败": "le retour a échoué",
    "该订单状态无法操作": "Le statut de la commande ne peut pas être utilisé",
    "订单已经发货，无法退款": "La commande a été expédiée et ne peut être remboursée",
    "大于最大采购数量": "Quantité d'achat supérieure à la quantité maximale",
    "该邮箱已被订阅": "Cette boîte aux lettres a déjà été abonnée",
    "登录过期，请重新登录": "La connexion a expiré. Veuillez vous reconnecter",
    "系统错误，请稍后重试": "Erreur système, veuillez réessayer plus tard",
    "请稍后重试": "Veuillez réessayer plus tard",
    "连续输入错误三次，请3分钟后再试": "Entrez l'erreur trois fois de suite. Veuillez réessayer dans 3 minutes",
    "审核中": "À l'étude",
    "程序错误": "Erreur de programme",
    "重复提交": "Soumettre à nouveau",
    "用户名不能为空": "Le nom d'utilisateur ne peut pas être nul",
    "验证码不能为空": "Le code de vérification ne peut pas être nul.",
    "登录密码不能为空": "Le mot de passe de connexion ne peut pas être nul",
    "登陆密码长度不符合设定": "La longueur du mot de passe de connexion ne correspond pas au paramètre.",
    "资金密码长度不符合设定": "La longueur du mot de passe du fonds ne correspond pas au paramètre.",
    "登陆密码不符合设定": "Le mot de passe de connexion ne correspond pas au paramètre.",
    "资金密码不符合设定": "Le mot de passe du fonds n'est pas conforme au réglage.",
    "用户名不符合设定": "Le nom d'utilisateur ne correspond pas au paramètre",
    "用户名必须由数字和英文字母组成": "Le nom d'utilisateur doit être composé de chiffres et de lettres",
    "验证码不正确": "code de vérification incorrect",
    "密码不正确": "Mot de passe incorrect",
    "服务器错误(500)": "Erreur de serveur (500)",
    "服务器错误": "Erreur du serveur",
    "用户名重复": "Nom d'utilisateur en double",
    "找不到用户": "Utilisateur non trouvé",
    "不能为空": "Ne peut pas être nulle",
    "登录失败": "échec de la connexion",
    "操作成功": "Opération réussie",
    "工作地址不能为空": "L'adresse professionnelle ne peut pas être nulle",
    "家庭地址不能为空": "L'adresse du domicile ne peut pas être nulle",
    "亲属姓名不能为空": "Le nom du parent ne peut pas être nul.",
    "亲属关系不能为空": "Les relations domestiques ne peuvent pas être nulles.",
    "亲属地址不能为空": "L'adresse relative ne peut pas être nulle.",
    "亲属电话不能为空": "Le numéro de téléphone familial ne peut pas être nul.",
    "用户名不存在": "Le nom d'utilisateur n'existe pas",
    "参数错误": "Erreur de paramètre",
    "不在交易时段": "Pas en séance de trading",
    "存在不同杠杆的持仓单": "Il existe des positions de maintien avec un effet de levier différent",
    "余额不足": "Solde insuffisant",
    "可平仓合约张数不足": "Nombre insuffisant de contrats de position fermée",
    "请输入正确的货币数量": "Veuillez entrer le montant correct de la devise",
    "请选择正确的币种": "Veuillez sélectionner la bonne devise",
    "金额错误": "Erreur de montant.",
    "跟单参数输入错误": "Saisie incorrecte des paramètres du document",
    "跟单倍数输入错误": "Saisie incorrecte du multiple documentaire",
    "交易员不存在": "Le commerçant n'existe pas.",
    "交易员未开启带单": "Le commerçant n'a pas ouvert la facture.",
    "用户已跟随交易员": "L'utilisateur a suivi le commerçant",
    "交易员跟随人数已满": "Le nombre de commerçants suivants est complet",
    "交易员不能跟随自己": "Les commerçants ne peuvent pas se suivre",
    "交易员无法跟随另一个交易员": "Le commerçant ne peut pas suivre un autre commerçant",
    "历史基金无法购买": "Les fonds historiques ne peuvent pas être achetés",
    "该基金尚未开放购买": "Le fonds n'a pas été ouvert à l'achat",
    "该基金尚已封闭": "Le fonds a été fermé",
    "基金剩余购买金额不足": "Le montant d'achat restant du fonds n'est pas suffisant.",
    "订单不存在": "La commande n'existe pas",
    "下单不能小于最小金额限制": "Le placement de la commande ne peut pas être inférieur à la limite de montant minimum.",
    "[symbol]参数为空": "Le paramètre [symbole] est nul",
    "矿机不存在": "La machine minière n'existe pas",
    "矿机未解锁，无法购买": "La machine minière est verrouillée et ne peut pas être achetée.",
    "您已购买过体验矿机,不得重复购买": "Vous avez acheté la machine d'extraction d'expérience. Ne l'achetez plus.",
    "买入金额需要在区间内": "Le montant de l'achat doit se situer dans la fourchette.",
    "行情获取异常，稍后再试": "L'acquisition de la situation est anormale. Veuillez réessayer plus tard.",
    "广告不存在": "L'annonce n'existe pas",
    "广告已下架": "Les publicités sont supprimées",
    "承兑商不存在": "L'accepteur n'existe pas.",
    "请先添加收款方式": "Veuillez d'abord ajouter la méthode de collecte",
    "您没有符合条件的收款方式": "Vous n'avez pas de mode de collecte éligible",
    "请选择买卖方式": "Veuillez sélectionner la méthode de négociation",
    "请输入正确的金额": "Veuillez entrer le montant correct",
    "请输入正确的数量": "Veuillez entrer la bonne quantité",
    "该广告剩余数量不足": "Nombre insuffisant d'annonces restantes",
    "金额不在购买区间": "Le montant n'est pas dans la fourchette d'achat.",
    "用户剩余数量不足": "Nombre insuffisant d'utilisateurs restants",
    "请稍后再试": "Veuillez réessayer plus tard",
    "未找到符合条件的匹配订单": "Aucune commande correspondante trouvée",
    "该订单已取消": "Cette commande a été annulée",
    "当前订单不为待付款状态，无法取消": "La commande en cours n'est pas en attente de paiement. Il ne peut pas être annulé.",
    "卖方无法取消该订单": "Le vendeur ne peut pas annuler la commande",
    "资金密码错误": "Erreur de mot de passe du fonds",
    "订单已完成": "Commande terminée",
    "订单已取消": "Commande annulée",
    "待付款的订单无法放行": "Les commandes en attente de paiement ne peuvent pas être libérées",
    "订单已完成，无法放行": "La commande est terminée et ne peut pas être libérée",
    "订单已取消，无法放行": "La commande a été annulée et ne peut pas être libérée",
    "未授权访问": "L'accès non autorisé",
    "图片大小不能超过2M！": "La taille de l'image ne peut pas dépasser 2M !",
    "参数异常，消息获取失败": "Erreur de paramètre, échec de l'acquisition du message",
    "无效的UID": "UID invalide",
    "用户不存在": "L'utilisateur n'existe pas",
    "图片上传失败": "Échec du téléchargement de l'image",
    "请输入内容": "Veuillez entrer du contenu",
    "图片不得大于2M": "L'image ne doit pas dépasser 2M",
    "图片不得大于10M": "L'image ne doit pas dépasser 10M",
    "直线关系，不能修改推荐": "Relation linéaire, recommandation non modifiable",
    "存在重复的角色名称": "Nom de rôle en double",
    "角色被用户关联，不可删除": "Le rôle est associé par utilisateur. Il ne peut pas être supprimé.",
    "系统存在相同[系统登录名]！": "Le système existe avec le même [Nom de connexion système] !",
    "旧密码不正确": "Ancien mot de passe incorrect",
    "没有找到用户": "Aucun utilisateur trouvé",
    "[code]值错误": "la valeur [code] est incorrecte",
    "身份证已实名过!": "La carte d'identité a été authentifiée !",
    "实名认证未通过，无法进行高级认证": "La certification du nom réel a échoué. La certification avancée n'est pas disponible.",
    "收款方输入错误": "Saisir l'erreur du bénéficiaire",
    "所选汇率不存在": "Le taux de change sélectionné n'existe pas",
    "转账数量不能小于等于0": "La quantité de transfert ne peut pas être inférieure ou égale à 0",
    "UID不能为空": "L'UID ne peut pas être nul",
    "转账币种不能为空": "La devise de transfert ne peut pas être nulle.",
    "资金密码不能为空": "Le mot de passe du fonds ne peut pas être nul.",
    "提现不得小于限额": "Le retrait en espèces ne peut pas être inférieur à la limite",
    "提现不得大于限额": "Le retrait en espèces ne peut pas être supérieur à la limite",
    "当日可提现次数不足": "Le nombre de retrait de cas sur la journée en cours n'est pas suffisant.",
    "不在可提现时间内": "Pas dans le délai de rétractation",
    "渠道未开通": "Canal non ouvert",
    "提币数量不能小于等于0": "La quantité retirée ne peut pas être inférieure ou égale à 0.",
    "无权限": "pas de permissions",
    "请先通过高级认证": "Veuillez d'abord passer la certification avancée",
    "请输入搜索关键字": "Veuillez entrer des mots-clés de recherche",
    "角色不存在": "Le rôle n'existe pas",
    "持有币种不足": "Devise de détention insuffisante",
    "提交失败，当前有未处理订单": "La soumission a échoué. Il y a actuellement des commandes ouvertes.",
    "充值链错误": "Erreur de chaîne de charge",
    "充值价值不得小于最小限额": "La valeur de recharge ne doit pas être inférieure à la limite minimale",
    "充值价值不得大于最大限额": "La valeur de recharge ne doit pas être supérieure à la limite maximale",
    "充值数量不能小于等于0": "La quantité de recharge ne peut pas être inférieure ou égale à 0",
    "请输入充值币种": "Veuillez entrer la devise de recharge",
    "请上传图片": "Veuillez télécharger des photos",
    "当前还需交易": "La transaction est toujours requise",
    ",才可提币": ", puis un retrait en espèces peut être effectué.",
    "提示": "Conseils",
    "未实名认证，是否认证？": "Non authentifié par son vrai nom. Authentifier?",
    "帐户异常需要进行C3认证，请联系在线客服。": "L'exception de compte nécessite une authentification C3. Veuillez contacter le service client en ligne.",
    "确认": "Validation",
    "取消": "Annuler",
    "更新提醒": "Rappel de mise à jour",
    "发现新版本，请升级到最新版本": "Nouvelle version trouvée, veuillez mettre à niveau vers la dernière version",
    "请检查网络连接": "Veuillez vérifier votre connexion réseau",
    "您已存在订单": "Vous avez déjà une commande",
    "当前地址格式错误": "Erreur de format d'adresse actuelle",
    "申购数量错误": "Erreur de quantité d'abonnement",
    "产品不存在": "Le produit n'existe pas",
    "该产品未上架": "Ce produit n'est pas répertorié",
    "该产品已上市，无法购买": "Ce produit est sur le marché et ne peut pas être acheté",
    "当日才可申购": "L'achat ne peut être effectué que le jour même.",
    "产品剩余数量不足": "Quantité de produit restante insuffisante",
    "您当前可分配额度不足": "Votre limite attribuable actuelle n'est pas suffisante",
    "购买矿机时间不得低于托管订单剩余时间": "Le temps d'achat de la machine minière ne peut pas être inférieur au temps restant de l'ordre de garde",
    "推荐码不正确": "Le code de recommandation est incorrect.",
    "推荐人无权限推荐": "Le recommandataire n'a pas le pouvoir de recommander.",
    "审核已通过": "Examen réussi",
    "请填写正确的验证码": "Veuillez saisir le bon code de vérification",
    "请填写正确的电话号码": "Veuillez saisir le bon numéro de téléphone",
    "请填写正确的邮箱地址": "Veuillez renseigner la bonne adresse e-mail",
    "电话号码已绑定": "Numéro de téléphone déjà lié",
    "电话号码已绑定其他用户": "Le numéro de téléphone est lié à un autre utilisateur",
    "邮箱已绑定": "Boîte aux lettres déjà liée",
    "邮箱已绑定其他用户": "Boîte aux lettres déjà liée à un autre utilisateur",
    "页码不是整数": "Le numéro de page n'est pas un entier",
    "页码不能小于等于0": "Le numéro de page ne peut pas être inférieur ou égal à 0",
    "请输入正确的质押金额": "Veuillez entrer le montant correct de la promesse de don",
    "请输入正确的质押天数": "Veuillez entrer les jours de promesse de don corrects",
    "未发现授权记录": "Enregistrement d'autorisation introuvable",
    "授权状态未成功": "Échec de l'état d'autorisation",
    "赎回状态异常": "État de remboursement anormal",
    "申请成功": "Postuler avec succès",
    "领取成功": "Réception réussie",
    "未找到匹配的收益记录": "Aucun enregistrement de revenus correspondant n'a été trouvé",
    "已领取": "Reçu",
    "校验IP不合法": "La vérification IP est illégale.",
    "委托数量(张)必填": "La quantité confiée (pcs.) est requise",
    "委托数量(张)不能小于等于0": "La quantité confiée (pcs.) ne peut être inférieure ou égale à 0.",
    "请先绑定谷歌验证器": "Veuillez d'abord lier Google Authenticator",
    "资金密码必须6-12位": "Le mot de passe du fonds doit être composé de 6 à 12 chiffres.",
    "验证码错误": "Erreur de code de vérification",
    "登录密码必须6-12位": "Le mot de passe de connexion doit être composé de 6 à 12 chiffres",
    "密码不能为空": "Le mot de passe ne peut pas être nul",
    "密码必须6-12位": "Le mot de passe doit être composé de 6 à 12 chiffres",
    "验证类型不能为空": "Le type d'authentification ne peut pas être nul",
    "未绑定手机号": "Aucun numéro de téléphone n'est lié",
    "未绑定邮箱": "Aucune boîte aux lettres n'est liée",
    "未绑定谷歌验证器": "Validateur Google non lié",
    "旧密码不能为空": "L'ancien mot de passe ne peut pas être nul",
    "新密码不能为空": "Le nouveau mot de passe ne peut pas être nul.",
    "新密码确认不能为空": "La confirmation du nouveau mot de passe ne peut pas être nulle.",
    "新密码不一致": "Le nouveau mot de passe n'est pas le même que celui saisi à l'origine",
    "操作类型为空": "Le type d'opération est nul",
    "操作类型不是整数": "Le type d'opération n'est pas un entier",
    "操作类型不能小于0": "Le type d'opération ne peut pas être inférieur à 0",
    "用户名参数为空": "Le paramètre de nom d'utilisateur est nul",
    "状态不是整数": "Le statut n'est pas un entier",
    "状态不能小于0": "Le statut ne peut pas être inférieur à 0",
    "系统参数错误": "Erreur de paramètre système",
    "-连接已建立-": "-Connection établie-",
    "代理层级错误": "Erreur au niveau de l'agent",
    "请重新登录": "Veuillez vous reconnecter",
    "暂无店铺": "Aucun magasin",
    "地址格式与协议不匹配": "Le format de l'adresse ne correspond pas au protocole",
    "用户已绑定过提现地址": "L'utilisateur a déjà lié l'adresse de retrait",
    "绑定提现地址成功": "Liaison réussie de l'adresse de retrait",
    "未设置地址": "Adresse non définie",
    "您有一笔提现正在处理中": "Vous avez un retrait en cours de traitement",
    "平台人工发起退款": "Remboursement initié par le personnel de la plateforme",
    "充值数量不能小于等于0": "Le montant de la recharge ne peut pas être inférieur ou égal à 0",
    "请选择法币类型": " Veuillez sélectionner le type de devise fiduciaire",
    "充值金额超过最大金额": " Le montant de la recharge dépasse le montant maximum",
    "充值金额小于最小金额": " Le montant de la recharge est inférieur au montant minimum",
    "请选择正确的法币类型": " Veuillez sélectionner le type de devise fiduciaire correct",
    "业务已锁定，请联系客服！": " L'entreprise est verrouillée, veuillez contacter le service client!",
    "无法购买本店商品": " Impossible d'acheter des produits de ce magasin",
  },
  "tits_ru": {
    "添加失败": "Не удалось отправить. Пожалуйста, повторите попытку позже",
    "提交失败": "Отправить не удалось",
    "请输入正确的邮箱地址": "Введите правильный адрес e-mail",
    "已有未完成的贷款单，不能重复申请": "Уже есть незавершённая заявка на кредит, повторная подача невозможна",
    "请输入关键字搜索": "Пожалуйста, введите ключевое слово для поиска",
    '参数缺失': "Отсутствует параметр",
    '充值数量必填': "Количество пополнения обязательно",
    "该手机号已被占用，请绑定其他手机号":
      "Этот телефон уже занят, пожалуйста, используйте другой телефон",
      "邮箱验证码发送次数过多，请明天再试":
      "Слишком много попыток отправки кода проверки, попробуйте завтра",
    "该邮箱已被占用，请更换其他邮箱注册":
      "Этот E-mail уже занят, пожалуйста, используйте другой E-mail",
    "已提交评论!": "Отзыв отправлен!",
    "未指定商家": "Неуказанный бизнес",
    "该商品已下架": "Товар недоступен",
    "系统错误": 'системная ошибка',
    "当前账号有未完成的充值订单，请完成后再试": "Текущая учетная запись имеет незавершенный заказ на пополнение, пожалуйста, повторите попытку после завершения",
    "当前账号有未完成的提现订单，请完成后再试": "Текущая учетная запись имеет незавершенный заказ на снятие средств, пожалуйста, заполните и повторите попытку.",
    "请先登录": "Пожалуйста, войдите",
    "该角色账号不允许注销": "Эта учетная запись персонажа не может выйти из системы",
    "当前的用户账号与确认注销的账号不一致": "Текущая учетная запись пользователя не соответствует учетной записи, подтвержденной для выхода",
    "密码输入错误次数过多，请明天再试": "Введено слишком много неправильных паролей, повторите попытку завтра",
    "注销失败": "Выйти не удалось",
    "注销成功": "Выход успешен",
    "当前用户已经被管理员禁用": "Текущий пользователь отключен администратором",
    "地址不存在,或者已删除": "Адрес не существует или был удален",
    "地址不能为空": "Адрес не может быть пустым",
    "地址过长": "слишком длинный адрес",
    "店家id不能为空": "Идентификатор магазина не может быть пустым.",
    "店家id错误": "Неверный идентификатор магазина",
    "订单号不能为空": "Номер заказа не может быть пустым",
    "非法请求": "незаконный запрос",
    "购买失败,联系客服": "Покупка не удалась, обратитесь в службу поддержки",
    "关注id不能为空": "Идентификатор подписки не может быть пустым",
    "联系人不能为空": "Контакт не может быть пустым",
    "两次输入的资金密码不相同": "Пароли фондов, введенные дважды, отличаются",
    "模块名不能为空": "Имя модуля не может быть пустым",
    "您的申请之前已提交过": "Ваша заявка была отправлена ​​ранее",
    "请上传图片格式的文件": "Пожалуйста, загрузите файл в формате изображения",
    "请勿重复添加": "Не добавляйте повторно",
    "取消失败": "Отмена не удалась",
    "删除失败": "не удалось удалить",
    "商品id不能为空": "Идентификатор продукта не может быть пустым.",
    "商品id错误": "Неверный идентификатор продукта",
    "实名认证尚未通过，无法重置": "Аутентификация по реальному имени не прошла и не может быть сброшена",
    "收藏id不能为空": "Идентификатор коллекции не может быть пустым.",
    "收货失败": "Ошибка получения",
    "手机号不能为空": "Номер мобильного телефона не может быть пустым",
    "图片不能为空": "Изображение не может быть пустым",
    "图片大小不能超过30M": "Размер изображения не может превышать 30M",
    "用户已锁定": "пользователь заблокирован",
    "正在购买": "покупка",
    "该贷款单还未通过审核": "Кредитная ведомость не утверждена",
    "该贷款单号不存在": "Номер кредита не существует",
    "两次输入的密码不相同": "Введенные дважды пароли разные",
    "类型不能为空": "Тип не может быть пустым",
    "操作失败！修正后账户余额小于0。": "операция не удалась! После исправления баланс счета меньше 0.",
    "身份证号已实名过!": "Идентификационный номер подтвержден!",
    "提款金额不得低于最小提款限额": "Сумма вывода не должна быть меньше минимального лимита вывода",
    "提款金额不得高于最大提款限额": "Сумма вывода не может быть больше максимального лимита вывода",
    "超过提现次数": "Превышено время вывода",
    "不在提现时间范围内，请稍后再试": "Срок вывода не истек, повторите попытку позже.",
    "提币数量必填": "Требуется сумма вывода",
    "提币数量输入错误，请输入浮点数": "Сумма вывода была введена неправильно, пожалуйста, введите число с плавающей запятой",
    "更新钱包失败，请联系客服": " Не удалось обновить кошелек, обратитесь в службу поддержки",
    "试用码不正确": " Пробный код неверный",
    "已经提交申请，请等待审核": "Заявка отправлена, ожидайте рассмотрения",
    "审核状态异常请联系客服": "Если статус проверки ненормальный, обратитесь в службу поддержки клиентов.",
    "暂无用户": "Еще нет пользователя",
    "系统无该用户，或者ip地址不正确": "Такого пользователя в системе нет, либо указан неверный ip адрес",
    "游客不能向游客发送消息": "Посетители не могут отправлять сообщения посетителям",
    "请选择收货地址": "Пожалуйста, выберите адрес доставки",
    "收货地址达上限": "Адрес доставки достиг верхнего предела",
    "请设置资金密码": "Пожалуйста, установите пароль фонда",
    "该订单未满足支付条件": "Заказ не соответствует условиям оплаты",
    "密码输入错误次数过多，请明天再试": "Введено слишком много неправильных паролей, повторите попытку завтра",
    "操作失败，请稍后再试": "Не удалось выполнить операцию. Повторите попытку позже.",
    "部分商品已下架": "Некоторые продукты сняты с производства",
    "邮箱的长度不能超过64个字符": "Длина почтового ящика не может превышать 64 символа.",
    "邮码不能超过32个字符": "Почтовый индекс не может превышать 32 символа",
    "操作类型不正确": "Неправильный тип операции",
    "参数错误!": "Ошибка параметра!",
    "不支持的语言": "неподдерживаемый язык",
    "收货人姓名不能超过64个字符": "Имя грузополучателя не может превышать 64 символа",
    "请输入正确的手机号码": "Пожалуйста, введите правильный номер телефона",
    "操作频繁，请稍后再试": "Частая операция, повторите попытку позже",
    "无此sellerGoods": "Нет такого продавцаТовары",
    "退货失败": "возврат не удался",
    "该订单状态无法操作": "Статус заказа не может быть обработан",
    "订单已经发货，无法退款": "Заказ был отправлен и не может быть возвращен",
    "大于最大采购数量": "Больше, чем максимальное количество покупки",
    "该邮箱已被订阅": "Этот почтовый ящик уже подписан",
    "登录过期，请重新登录": "Срок действия логина истек. Пожалуйста, войдите снова",
    "系统错误，请稍后重试": "Системная ошибка, повторите попытку позже",
    "请稍后重试": "Пожалуйста, повторите попытку позже",
    "连续输入错误三次，请3分钟后再试": "Введите ошибку три раза подряд. Повторите попытку через 3 минуты.",
    "审核中": "На рассмотрении",
    "程序错误": "Ошибка программы",
    "重复提交": "Отправить повторно",
    "用户名不能为空": "Имя пользователя не может быть пустым",
    "验证码不能为空": "Код подтверждения не может быть нулевым.",
    "登录密码不能为空": "Пароль для входа не может быть нулевым",
    "登陆密码长度不符合设定": "Длина пароля для входа не соответствует настройке.",
    "资金密码长度不符合设定": "Длина пароля фонда не соответствует настройке.",
    "登陆密码不符合设定": "Пароль для входа не соответствует настройке.",
    "资金密码不符合设定": "Пароль фонда не соответствует настройке.",
    "用户名不符合设定": "Имя пользователя не соответствует настройке",
    "用户名必须由数字和英文字母组成": "Имя пользователя должно состоять из цифр и букв",
    "验证码不正确": "Неверный код подтверждения",
    "密码不正确": "Неверный пароль",
    "服务器错误(500)": "Ошибка сервера(500)",
    "服务器错误": "Ошибка сервера",
    "用户名重复": "Повторяющееся имя пользователя",
    "找不到用户": "Пользователь не найден",
    "不能为空": "Не может быть нулевым",
    "登录失败": "Ошибка входа",
    "操作成功": "Операция прошла успешно",
    "工作地址不能为空": "Рабочий адрес не может быть нулевым.",
    "家庭地址不能为空": "Домашний адрес не может быть нулевым",
    "亲属姓名不能为空": "Имя родственника не может быть нулевым.",
    "亲属关系不能为空": "Семейные отношения не могут быть нулевыми.",
    "亲属地址不能为空": "Относительный адрес не может быть нулевым.",
    "亲属电话不能为空": "Номер телефона семьи не может быть нулевым.",
    "用户名不存在": "Имя пользователя не существует",
    "参数错误": "Ошибка параметра",
    "不在交易时段": "Не в торговой сессии",
    "存在不同杠杆的持仓单": "Есть позиции удержания с разным кредитным плечом",
    "余额不足": "Недостаточный баланс",
    "可平仓合约张数不足": "Недостаточное количество контрактов закрытия позиции",
    "请输入正确的货币数量": "Пожалуйста, введите правильную сумму в валюте",
    "请选择正确的币种": "Пожалуйста, выберите правильную валюту",
    "金额错误": "Ошибка суммы.",
    "跟单参数输入错误": "Неверный ввод параметров документа",
    "跟单倍数输入错误": "Неверный ввод документального мультипликатора",
    "交易员不存在": "Трейдер не существует.",
    "交易员未开启带单": "Трейдер не открыл счет.",
    "用户已跟随交易员": "Пользователь подписался на трейдера",
    "交易员跟随人数已满": "Количество трейдеров, следующих за вами, заполнено",
    "交易员不能跟随自己": "Трейдеры не могут следить за собой",
    "交易员无法跟随另一个交易员": "Трейдер не может подписаться на другого трейдера",
    "历史基金无法购买": "Исторические фонды нельзя купить",
    "该基金尚未开放购买": "Фонд не открыт для покупки",
    "该基金尚已封闭": "Фонд был закрыт",
    "基金剩余购买金额不足": "Оставшейся суммы покупки фонда недостаточно.",
    "订单不存在": "Заказ не существует",
    "下单不能小于最小金额限制": "Размещение заказа не может быть меньше минимальной суммы.",
    "[symbol]参数为空": "параметр [символ] имеет значение null",
    "矿机不存在": "Майнинг машина не существует",
    "矿机未解锁，无法购买": "Майнинг-машина заблокирована и не может быть куплена.",
    "您已购买过体验矿机,不得重复购买": "Вы приобрели машину для добычи опыта. Не покупайте его снова.",
    "买入金额需要在区间内": "Сумма покупки должна быть в пределах.",
    "行情获取异常，稍后再试": "Приобретение ситуации ненормальное. Пожалуйста, повторите попытку позже.",
    "广告不存在": "Реклама не существует",
    "广告已下架": "Рекламы сняты",
    "承兑商不存在": "Акцептор не существует.",
    "请先添加收款方式": "Сначала добавьте метод сбора",
    "您没有符合条件的收款方式": "У вас нет подходящего метода сбора",
    "请选择买卖方式": "Пожалуйста, выберите метод торговли",
    "请输入正确的金额": "Пожалуйста, введите правильную сумму",
    "请输入正确的数量": "Пожалуйста, введите правильное количество",
    "该广告剩余数量不足": "Недостаточное количество объявлений осталось",
    "金额不在购买区间": "Сумма не входит в диапазон покупки.",
    "用户剩余数量不足": "Осталось недостаточное количество пользователей",
    "请稍后再试": "Пожалуйста, повторите попытку позже",
    "未找到符合条件的匹配订单": "Подходящий заказ не найден",
    "该订单已取消": "Этот заказ был отменен",
    "当前订单不为待付款状态，无法取消": "Текущий заказ не находится в статусе ожидания оплаты. Его нельзя отменить.",
    "卖方无法取消该订单": "Продавец не может отменить заказ",
    "资金密码错误": "Ошибка пароля фонда",
    "订单已完成": "Заказ выполнен",
    "订单已取消": "Заказ отменен",
    "待付款的订单无法放行": "Заказы, ожидающие оплаты, не могут быть разблокированы",
    "订单已完成，无法放行": "Заказ выполнен и не может быть выпущен",
    "订单已取消，无法放行": "Заказ был отменен и не может быть выпущен",
    "未授权访问": "Не авторизованный доступ",
    "图片大小不能超过2M！": "Размер изображения не может превышать 2M!",
    "参数异常，消息获取失败": "Ошибка параметра, не удалось получить сообщение",
    "无效的UID": "Неверный UID",
    "用户不存在": "Пользователь не существует",
    "图片上传失败": "Не удалось загрузить изображение",
    "请输入内容": "Пожалуйста, введите содержание",
    "图片不得大于2M": "Изображение не должно быть больше 2M",
    "图片不得大于10M": "Изображение не должно быть больше 10M",
    "直线关系，不能修改推荐": "Прямолинейное отношение, рекомендация не может быть изменена",
    "存在重复的角色名称": "Повторяющееся имя роли",
    "角色被用户关联，不可删除": "Роль связана с пользователем. Его нельзя удалить.",
    "系统存在相同[系统登录名]！": "Система существует такая же [Имя входа в систему]!",
    "旧密码不正确": "Неверный старый пароль",
    "没有找到用户": "Пользователь не найден",
    "[code]值错误": "[код] неверное значение",
    "身份证已实名过!": "ID-карта прошла проверку подлинности!",
    "实名认证未通过，无法进行高级认证": "Сертификация настоящего имени не удалась. Расширенная сертификация недоступна.",
    "收款方输入错误": "Введите ошибку получателя",
    "所选汇率不存在": "Выбранный обменный курс не существует",
    "转账数量不能小于等于0": "Сумма перевода не может быть меньше или равна 0",
    "UID不能为空": "UID не может быть нулевым",
    "转账币种不能为空": "Валюта перевода не может быть нулевой.",
    "资金密码不能为空": "Пароль фонда не может быть нулевым.",
    "提现不得小于限额": "Снятие наличных не может быть меньше лимита",
    "提现不得大于限额": "Снятие наличных не может быть больше лимита",
    "当日可提现次数不足": "Количество изъятий дел на текущий день недостаточно.",
    "不在可提现时间内": "Не во время вывода",
    "渠道未开通": "Канал не открыт",
    "提币数量不能小于等于0": "Сумма вывода не может быть меньше или равна 0.",
    "无权限": "Нет разрешений",
    "请先通过高级认证": "Сначала пройдите расширенную сертификацию",
    "请输入搜索关键字": "Пожалуйста, введите ключевые слова для поиска",
    "角色不存在": "Роль не существует",
    "持有币种不足": "Недостаточное количество валюты для хранения",
    "提交失败，当前有未处理订单": "Отправка не удалась. На данный момент есть открытые заказы.",
    "充值链错误": "Ошибка цепи зарядки",
    "充值价值不得小于最小限额": "Стоимость перезарядки не должна быть меньше минимального предела",
    "充值价值不得大于最大限额": "Значение перезарядки не должно превышать максимальный предел",
    "充值数量不能小于等于0": "Количество пополнения не может быть меньше или равно 0",
    "请输入充值币种": "Пожалуйста, введите валюту пополнения",
    "请上传图片": "Пожалуйста, загрузите фотографии",
    "当前还需交易": "Транзакция по-прежнему требуется",
    ",才可提币": ", а затем можно будет снять наличные.",
    "提示": "Советы",
    "未实名认证，是否认证？": "Не подтверждено настоящим именем. Аутентифицировать?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Исключение учетной записи требует аутентификации C3. Пожалуйста, свяжитесь со службой поддержки онлайн.",
    "确认": "Проверка",
    "取消": "Отмена",
    "更新提醒": "Напоминание об обновлении",
    "发现新版本，请升级到最新版本": "Найдена новая версия, пожалуйста, обновитесь до последней версии",
    "请检查网络连接": "Пожалуйста, проверьте подключение к сети",
    "您已存在订单": "У вас уже есть заказ",
    "当前地址格式错误": "Текущая ошибка формата адреса",
    "申购数量错误": "Ошибка количества подписок",
    "产品不存在": "Продукт не существует",
    "该产品未上架": "Этот продукт не указан",
    "该产品已上市，无法购买": "Этот продукт находится на рынке и не может быть куплен",
    "当日才可申购": "Купить можно только в этот же день.",
    "产品剩余数量不足": "Осталось недостаточное количество продукта",
    "您当前可分配额度不足": "Текущего выделяемого лимита недостаточно",
    "购买矿机时间不得低于托管订单剩余时间": "Время покупки майнинговой машины не может быть меньше, чем оставшееся время кастодиального ордера",
    "推荐码不正确": "Неверный код рекомендации.",
    "推荐人无权限推荐": "Рекомендующий не имеет права рекомендовать.",
    "审核已通过": "Проверка пройдена",
    "请填写正确的验证码": "Пожалуйста, введите правильный проверочный код",
    "请填写正确的电话号码": "Пожалуйста, заполните правильный номер телефона",
    "请填写正确的邮箱地址": "Пожалуйста, заполните правильный адрес электронной почты",
    "电话号码已绑定": "Номер телефона уже привязан",
    "电话号码已绑定其他用户": "Номер телефона привязан к другому пользователю",
    "邮箱已绑定": "Почтовый ящик уже привязан",
    "邮箱已绑定其他用户": "Почтовый ящик уже привязан к другому пользователю",
    "页码不是整数": "Номер страницы не является целым числом",
    "页码不能小于等于0": "Номер страницы не может быть меньше или равен 0",
    "请输入正确的质押金额": "Пожалуйста, введите правильную сумму залога",
    "请输入正确的质押天数": "Пожалуйста, введите правильные дни залога",
    "未发现授权记录": "Запись авторизации не найдена",
    "授权状态未成功": "Статус авторизации не выполнен",
    "赎回状态异常": "Ненормальный статус выкупа",
    "申请成功": "Подать заявку успешно",
    "领取成功": "Получение успешно",
    "未找到匹配的收益记录": "Соответствующая запись о доходах не найдена",
    "已领取": "Полученный",
    "校验IP不合法": "Проверочный IP-адрес является незаконным.",
    "委托数量(张)必填": "Требуется доверенное количество (шт.)",
    "委托数量(张)不能小于等于0": "Доверенное количество (шт.) не может быть меньше или равно 0.",
    "请先绑定谷歌验证器": "Сначала привяжите Google Authenticator",
    "资金密码必须6-12位": "Пароль фонда должен состоять из 6-12 цифр.",
    "验证码错误": "Ошибка кода подтверждения",
    "登录密码必须6-12位": "Пароль для входа должен состоять из 6-12 цифр.",
    "密码不能为空": "Пароль не может быть нулевым",
    "密码必须6-12位": "Пароль должен состоять из 6-12 цифр",
    "验证类型不能为空": "Тип аутентификации не может быть нулевым",
    "未绑定手机号": "Номер телефона не привязан",
    "未绑定邮箱": "Почтовый ящик не привязан",
    "未绑定谷歌验证器": "Валидатор Google не привязан",
    "旧密码不能为空": "Старый пароль не может быть нулевым",
    "新密码不能为空": "Новый пароль не может быть нулевым.",
    "新密码确认不能为空": "Подтверждение нового пароля не может быть нулевым.",
    "新密码不一致": "Новый пароль не совпадает с первоначальным вводом",
    "操作类型为空": "Тип операции нулевой",
    "操作类型不是整数": "Тип операции не является целым числом",
    "操作类型不能小于0": "Тип операции не может быть меньше 0",
    "用户名参数为空": "Параметр имени пользователя имеет значение null",
    "状态不是整数": "Статус не является целым числом",
    "状态不能小于0": "Статус не может быть меньше 0",
    "系统参数错误": "Ошибка системного параметра",
    "-连接已建立-": "-Соединение установлено-",
    "代理层级错误": "Ошибка на уровне агента",
    "请重新登录": "Пожалуйста, войдите снова",
    "暂无店铺": "Нет магазина",
    "地址格式与协议不匹配": "Формат адреса не соответствует протоколу",
    "用户已绑定过提现地址": "Пользователь уже привязал адрес вывода",
    "绑定提现地址成功": "Привязать адрес вывода успешно",
    "未设置地址": "Адрес не установлен",
    "您有一笔提现正在处理中": "У вас есть вывод, который обрабатывается",
    "平台人工发起退款": "Платформа инициирует возврат средств",
    "充值数量不能小于等于0": "Количество пополнения не может быть меньше или равно 0",
    "请选择法币类型": " Пожалуйста, выберите тип фиатной валюты",
    "充值金额超过最大金额": " Сумма пополнения превышает максимальную сумму",
    "充值金额小于最小金额": " Сумма пополнения меньше минимальной суммы",
    "请选择正确的法币类型": " Пожалуйста, выберите правильный тип фиатной валюты",
    "业务已锁定，请联系客服！": " Бизнес заблокирован, пожалуйста, свяжитесь со службой поддержки!",
    "无法购买本店商品": " Невозможно купить товары этого магазина",
  },
  "tits_es": {
    "添加失败": "Error al añadir",
    "提交失败": "Error al enviar",
    "请输入正确的邮箱地址": "Introduce una dirección de correo válida",
    "已有未完成的贷款单，不能重复申请": "Ya existe un pedido de préstamo sin completar, no se puede volver a solicitar",
    "请输入关键字搜索": "Introduce la palabra clave de búsqueda",
    "已提交评论!": "¡Revisión enviada!",
    "未指定商家": "negocio no especificado",
    "系统错误": 'error del sistema',
    "邮箱验证码发送次数过多，请明天再试":
      "El número de envíos de código de correo electrónico es demasiado grande, intentelo de nuevo mañana",
    "该手机号已被占用，请绑定其他手机号":
      "Este número de teléfono ya está en uso, por favor vincule otro número de telefono",
    "该商品已下架": "este producto se ha descargado",
    "该邮箱已被占用，请更换其他邮箱注册":
      "Este correo electrónico ya está en uso, por favor cambie a otro correo electrónico para registrarse",
    "当前账号有未完成的充值订单，请完成后再试": "La cuenta actual tiene un pedido de recarga sin terminar, intente nuevamente después de completar",
    "当前账号有未完成的提现订单，请完成后再试": "La cuenta actual tiene una orden de retiro sin terminar, complete y vuelva a intentarlo",
    "请先登录": "por favor Iniciar sesión",
    "该角色账号不允许注销": "Esta cuenta de función no puede cerrar sesión",
    "当前的用户账号与确认注销的账号不一致": "La cuenta de usuario actual es inconsistente con la cuenta confirmada para cerrar sesión",
    "密码输入错误次数过多，请明天再试": "Se ingresaron demasiadas contraseñas incorrectas, inténtelo de nuevo mañana",
    "注销失败": "Cierre de sesión fallido",
    "注销成功": "Cierre de sesión exitoso",
    "当前用户已经被管理员禁用": "El usuario actual ha sido deshabilitado por el administrador",
    "地址不存在,或者已删除": "La dirección no existe o ha sido eliminada",
    "地址不能为空": "La dirección no puede estar vacía",
    "地址过长": " dirección demasiado larga",
    "店家id不能为空": "El ID de la tienda no puede estar vacío",
    "店家id错误": "El id de la tienda es incorrecto",
    "订单号不能为空": "El número de pedido no puede estar vacío",
    "非法请求": "solicitud ilegal",
    "购买失败,联系客服": "Compra fallida, comuníquese con el servicio al cliente",
    "关注id不能为空": "El ID de seguimiento no puede estar vacío",
    "联系人不能为空": "El contacto no puede estar vacío",
    "两次输入的资金密码不相同": "Las contraseñas de fondos ingresadas dos veces son diferentes",
    "模块名不能为空": "El nombre del módulo no puede estar vacío",
    "您的申请之前已提交过": "Su solicitud ha sido enviada antes",
    "请上传图片格式的文件": "Sube un archivo en formato de imagen",
    "请勿重复添加": "No agregue repetidamente",
    "取消失败": " Cancelación fallida",
    "删除失败": "no se pudo eliminar",
    "商品id不能为空": "El ID del producto no puede estar vacío",
    "商品id错误": "La identificación del producto es incorrecta",
    "实名认证尚未通过，无法重置": "La autenticación de nombre real no ha pasado y no se puede restablecer",
    "收藏id不能为空": "El ID de la colección no puede estar vacío",
    "收货失败": "Error de recibo",
    "手机号不能为空": "El número de teléfono móvil no puede estar vacío",
    "图片不能为空": "La imagen no puede estar vacía",
    "图片大小不能超过30M": "El tamaño de la imagen no puede exceder los 30M",
    "用户已锁定": "usuario bloqueado",
    "正在购买": "comprar",
    "该贷款单还未通过审核": "El comprobante de préstamo no ha sido aprobado",
    "该贷款单号不存在": "El número de préstamo no existe.",
    "两次输入的密码不相同": "Las contraseñas ingresadas dos veces son diferentes",
    "类型不能为空": "El tipo no puede estar vacío",
    "操作失败！修正后账户余额小于0。": "¡operación fallida! Después de la corrección, el saldo de la cuenta es inferior a 0.",
    "身份证号已实名过!": "¡El número de identificación ha sido verificado!",
    "提款金额不得低于最小提款限额": "El monto del retiro no debe ser inferior al límite mínimo de retiro",
    "提款金额不得高于最大提款限额": "El monto del retiro no puede ser superior al límite máximo de retiro",
    "超过提现次数": "Tiempos de retiro excedidos",
    "不在提现时间范围内，请稍后再试": " No está dentro del rango de tiempo de retiro, intente nuevamente más tarde",
    "提币数量必填": "Se requiere el monto del retiro",
    "提币数量输入错误，请输入浮点数": "El monto del retiro se ingresó incorrectamente, ingrese un número de punto flotante",
    "更新钱包失败，请联系客服": "No se pudo actualizar la billetera, comuníquese con el servicio al cliente",
    "试用码不正确": "El código de prueba es incorrecto",
    "已经提交申请，请等待审核": "La solicitud ha sido enviada, por favor espere la revisión",
    "审核状态异常请联系客服": "Si el estado de revisión es anormal, comuníquese con el servicio al cliente",
    "暂无用户": "Ningún usuario todavía",
    "系统无该用户，或者ip地址不正确": "No existe tal usuario en el sistema, o la dirección IP es incorrecta",
    "游客不能向游客发送消息": "Los visitantes no pueden enviar mensajes a los visitantes.",
    "请选择收货地址": "Por favor, seleccione la dirección de entrega",
    "收货地址达上限": "La dirección de entrega ha alcanzado el límite superior",
    "请设置资金密码": "Establezca una contraseña de fondo",
    "该订单未满足支付条件": "El pedido no cumple las condiciones de pago",
    "密码输入错误次数过多，请明天再试": "Se ingresaron demasiadas contraseñas incorrectas, intente nuevamente mañana",
    "操作失败，请稍后再试": "La operación falló, inténtalo de nuevo más tarde",
    "部分商品已下架": "Algunos productos han sido descontinuados",
    "邮箱的长度不能超过64个字符": "La longitud del buzón no puede exceder los 64 caracteres",
    "邮码不能超过32个字符": "El código postal no puede exceder los 32 caracteres",
    "操作类型不正确": "Tipo de operación incorrecto",
    "参数错误!": "¡Error de parametro!",
    "不支持的语言": "idioma no compatible",
    "收货人姓名不能超过64个字符": "El nombre del destinatario no puede exceder los 64 caracteres",
    "请输入正确的手机号码": "Por favor ingrese el número de teléfono correcto",
    "操作频繁，请稍后再试": "Operación frecuente, intente nuevamente más tarde",
    "无此sellerGoods": "No hay tal vendedorProductos",
    "退货失败": "devolución fallida",
    "该订单状态无法操作": "El estado del pedido no se puede operar.",
    "订单已经发货，无法退款": "El pedido ha sido enviado y no puede ser reembolsado",
    "大于最大采购数量": "Mayor que la cantidad máxima de compra",
    "该邮箱已被订阅": "Este buzón ya ha sido suscrito",
    "登录过期，请重新登录": "Inicio de sesión caducado. Inicie sesión de nuevo",
    "系统错误，请稍后重试": "Error de sistema. Prueba de nuevo más tarde",
    "请稍后重试": "Por favor, inténtelo de nuevo más tarde",
    "连续输入错误三次，请3分钟后再试": "Introduzca el error tres veces seguidas. Vuelva a intentarlo en 3 minutos.",
    "审核中": "Bajo revisión",
    "程序错误": "Error de programa",
    "重复提交": "volver a enviar",
    "用户名不能为空": "El nombre de usuario no puede ser nulo",
    "验证码不能为空": "El código de verificación no puede ser nulo.",
    "登录密码不能为空": "La contraseña de inicio de sesión no puede ser nula",
    "登陆密码长度不符合设定": "La longitud de la contraseña de inicio de sesión no coincide con la configuración.",
    "资金密码长度不符合设定": "La longitud de la contraseña del fondo no coincide con la configuración.",
    "登陆密码不符合设定": "La contraseña de inicio de sesión no coincide con la configuración.",
    "资金密码不符合设定": "La contraseña del fondo no se ajusta a la configuración.",
    "用户名不符合设定": "El nombre de usuario no coincide con la configuración",
    "用户名必须由数字和英文字母组成": "El nombre de usuario debe constar de números y letras.",
    "验证码不正确": "código de verificación incorrecto",
    "密码不正确": "Contraseña incorrecta",
    "服务器错误(500)": "Error del servidor (500)",
    "服务器错误": "Error del Servidor",
    "用户名重复": "Nombre de usuario duplicado",
    "找不到用户": "Usuario no encontrado",
    "不能为空": "No puede ser nulo",
    "登录失败": "error de inicio de sesion",
    "操作成功": "Operación exitosa",
    "工作地址不能为空": "La dirección del trabajo no puede ser nula",
    "家庭地址不能为空": "La dirección de casa no puede ser nula",
    "亲属姓名不能为空": "El nombre del familiar no puede ser nulo.",
    "亲属关系不能为空": "Las relaciones domésticas no pueden ser nulas.",
    "亲属地址不能为空": "La dirección relativa no puede ser nula.",
    "亲属电话不能为空": "El número de teléfono de la familia no puede ser nulo.",
    "用户名不存在": "El usuario no existe",
    "参数错误": "error de parametro",
    "不在交易时段": "No en la sesión de negociación",
    "存在不同杠杆的持仓单": "Hay posiciones de espera con diferente apalancamiento.",
    "余额不足": "Saldo insuficiente",
    "可平仓合约张数不足": "Número insuficiente de contratos de posición cerrada",
    "请输入正确的货币数量": "Ingrese la cantidad correcta de moneda",
    "请选择正确的币种": "Seleccione la moneda correcta",
    "金额错误": "Error de cantidad.",
    "跟单参数输入错误": "Ingresar incorrectamente los parámetros del documento",
    "跟单倍数输入错误": "Ingreso incorrecto de múltiplo documental",
    "交易员不存在": "El comerciante no existe.",
    "交易员未开启带单": "El comerciante no ha abierto el billete.",
    "用户已跟随交易员": "El usuario ha seguido al comerciante",
    "交易员跟随人数已满": "El número de comerciantes que siguen está lleno.",
    "交易员不能跟随自己": "Los comerciantes no pueden seguirse a sí mismos",
    "交易员无法跟随另一个交易员": "El comerciante no puede seguir a otro comerciante",
    "历史基金无法购买": "Los fondos históricos no se pueden comprar",
    "该基金尚未开放购买": "El fondo no se ha abierto para la compra.",
    "该基金尚已封闭": "El fondo ha sido cerrado.",
    "基金剩余购买金额不足": "El monto restante de la compra del fondo no es suficiente.",
    "订单不存在": "Orden no existe",
    "下单不能小于最小金额限制": "La colocación del pedido no puede ser inferior al límite de cantidad mínima.",
    "[symbol]参数为空": "El parámetro [símbolo] es nulo",
    "矿机不存在": "La máquina de minería no existe.",
    "矿机未解锁，无法购买": "La máquina de minería está bloqueada y no se puede comprar.",
    "您已购买过体验矿机,不得重复购买": "Has comprado la máquina de minería de experiencia. No lo compre de nuevo.",
    "买入金额需要在区间内": "El monto de la compra debe estar dentro del rango.",
    "行情获取异常，稍后再试": "La adquisición de la situación es anormal. Por favor, inténtelo de nuevo más tarde.",
    "广告不存在": "el anuncio no existe",
    "广告已下架": "Se retiran los anuncios",
    "承兑商不存在": "El aceptador no existe.",
    "请先添加收款方式": "Primero agregue el método de recopilación",
    "您没有符合条件的收款方式": "No tiene un método de recolección elegible",
    "请选择买卖方式": "Seleccione el método de negociación",
    "请输入正确的金额": "Por favor ingrese la cantidad correcta",
    "请输入正确的数量": "Por favor ingrese la cantidad correcta",
    "该广告剩余数量不足": "Queda un número insuficiente de anuncios",
    "金额不在购买区间": "La cantidad no está en el rango de compra.",
    "用户剩余数量不足": "Número insuficiente de usuarios restantes",
    "请稍后再试": "Por favor, inténtelo de nuevo más tarde",
    "未找到符合条件的匹配订单": "No se ha encontrado ningún pedido coincidente",
    "该订单已取消": "Esta orden ha sido cancelada",
    "当前订单不为待付款状态，无法取消": "El pedido actual no está en estado de pago pendiente. No se puede cancelar.",
    "卖方无法取消该订单": "El vendedor no puede cancelar el pedido.",
    "资金密码错误": "Error de contraseña del fondo",
    "订单已完成": "Pedido completado",
    "订单已取消": "Orden cancelada",
    "待付款的订单无法放行": "Los pedidos pendientes de pago no se pueden liberar",
    "订单已完成，无法放行": "El pedido se ha completado y no se puede liberar",
    "订单已取消，无法放行": "El pedido ha sido cancelado y no puede ser liberado",
    "未授权访问": "Acceso no autorizado",
    "图片大小不能超过2M！": "¡El tamaño de la imagen no puede exceder los 2M!",
    "参数异常，消息获取失败": "Error de parámetro, error en la adquisición del mensaje",
    "无效的UID": "UID no válido",
    "用户不存在": "el usuario no existe",
    "图片上传失败": "No se pudo cargar la imagen",
    "请输入内容": "Por favor ingrese el contenido",
    "图片不得大于2M": "La imagen no debe ser más grande que 2M",
    "图片不得大于10M": "La imagen no debe ser más grande que 10M",
    "直线关系，不能修改推荐": "Relación de línea recta, la recomendación no se puede modificar",
    "存在重复的角色名称": "Nombre de rol duplicado",
    "角色被用户关联，不可删除": "El rol está asociado por el usuario. No se puede eliminar.",
    "系统存在相同[系统登录名]！": "¡El sistema existe igual [Nombre de inicio de sesión del sistema]!",
    "旧密码不正确": "Contraseña antigua incorrecta",
    "没有找到用户": "Usuario no encontrado",
    "[code]值错误": "El valor de [código] es incorrecto",
    "身份证已实名过!": "¡La tarjeta de identificación ha sido autenticada!",
    "实名认证未通过，无法进行高级认证": "Falló la certificación de nombre real. La certificación avanzada no está disponible.",
    "收款方输入错误": "Ingrese el error del beneficiario",
    "所选汇率不存在": "El tipo de cambio seleccionado no existe",
    "转账数量不能小于等于0": "La cantidad de transferencia no puede ser menor o igual a 0",
    "UID不能为空": "UID no puede ser nulo",
    "转账币种不能为空": "La moneda de transferencia no puede ser nula.",
    "资金密码不能为空": "La contraseña del fondo no puede ser nula.",
    "提现不得小于限额": "El retiro de efectivo no puede ser inferior al límite",
    "提现不得大于限额": "El retiro de efectivo no puede ser mayor que el límite",
    "当日可提现次数不足": "El número de retiros de casos en el día actual no es suficiente.",
    "不在可提现时间内": "No dentro del tiempo de retiro",
    "渠道未开通": "Canal no abierto",
    "提币数量不能小于等于0": "La cantidad de retiro no puede ser menor o igual a 0.",
    "无权限": "no permisos",
    "请先通过高级认证": "Pase primero la certificación avanzada",
    "请输入搜索关键字": "Por favor, introduzca palabras clave de búsqueda",
    "角色不存在": "El rol no existe",
    "持有币种不足": "Moneda de tenencia insuficiente",
    "提交失败，当前有未处理订单": "Envío fallido. Actualmente hay pedidos abiertos.",
    "充值链错误": "Error de cadena de carga",
    "充值价值不得小于最小限额": "El valor de la recarga no podrá ser inferior al límite mínimo",
    "充值价值不得大于最大限额": "El valor de la recarga no podrá ser superior al límite máximo",
    "充值数量不能小于等于0": "La cantidad de recarga no puede ser menor o igual a 0",
    "请输入充值币种": "Por favor, introduzca la moneda de recarga",
    "请上传图片": "por favor sube fotos",
    "当前还需交易": "Todavía se requiere transacción",
    ",才可提币": ", y luego se puede hacer el retiro de efectivo.",
    "提示": "Consejos",
    "未实名认证，是否认证？": "No autenticado por nombre real. ¿Autenticar?",
    "帐户异常需要进行C3认证，请联系在线客服。": "La excepción de cuenta requiere autenticación C3. Póngase en contacto con el servicio de atención al cliente en línea.",
    "确认": "Validación",
    "取消": "Cancelar",
    "更新提醒": "Recordatorio de actualización",
    "发现新版本，请升级到最新版本": "Nueva versión encontrada, actualice a la última versión",
    "请检查网络连接": "Por favor, compruebe su conexión de red",
    "您已存在订单": "Ya tienes un pedido",
    "当前地址格式错误": "Error de formato de dirección actual",
    "申购数量错误": "Error de cantidad de suscripción",
    "产品不存在": "El producto no existe",
    "该产品未上架": "Este producto no está en la lista",
    "该产品已上市，无法购买": "Este producto está en el mercado y no se puede comprar.",
    "当日才可申购": "La compra solo se puede comprar en el mismo día.",
    "产品剩余数量不足": "Cantidad restante de producto insuficiente",
    "您当前可分配额度不足": "Su límite asignable actual no es suficiente",
    "购买矿机时间不得低于托管订单剩余时间": "El tiempo de compra de la máquina minera no puede ser inferior al tiempo restante de la orden de custodia",
    "推荐码不正确": "El código de recomendación es incorrecto.",
    "推荐人无权限推荐": "El recomendador no tiene autoridad para recomendar.",
    "审核已通过": "Revisión aprobada",
    "请填写正确的验证码": "Por favor complete el código de verificación correcto",
    "请填写正确的电话号码": "Por favor complete el número de teléfono correcto",
    "请填写正确的邮箱地址": "Por favor complete la dirección de correo electrónico correcta",
    "电话号码已绑定": "Número de teléfono ya vinculado",
    "电话号码已绑定其他用户": "El número de teléfono está vinculado a otro usuario",
    "邮箱已绑定": "Buzón ya vinculado",
    "邮箱已绑定其他用户": "Buzón ya vinculado a otro usuario",
    "页码不是整数": "El número de página no es un número entero",
    "页码不能小于等于0": "El número de página no puede ser menor o igual a 0",
    "请输入正确的质押金额": "Ingrese el monto de compromiso correcto",
    "请输入正确的质押天数": "Ingrese los días de compromiso correctos",
    "未发现授权记录": "Registro de autorización no encontrado",
    "授权状态未成功": "Estado de autorización fallido",
    "赎回状态异常": "Estado de redención anormal",
    "申请成功": "Aplicar con éxito",
    "领取成功": "Recepción exitosa",
    "未找到匹配的收益记录": "No se ha encontrado ningún registro de ingresos coincidente",
    "已领取": "Recibió",
    "校验IP不合法": "La IP de verificación es ilegal.",
    "委托数量(张)必填": "Se requiere la cantidad confiada (uds.)",
    "委托数量(张)不能小于等于0": "La cantidad confiada (uds.) no puede ser menor o igual a 0.",
    "请先绑定谷歌验证器": "Vincule Google Authenticator primero",
    "资金密码必须6-12位": "La contraseña del fondo debe tener entre 6 y 12 dígitos.",
    "验证码错误": "Error de código de verificación",
    "登录密码必须6-12位": "La contraseña de inicio de sesión debe tener entre 6 y 12 dígitos",
    "密码不能为空": "La contraseña no puede ser nula",
    "密码必须6-12位": "La contraseña debe tener entre 6 y 12 dígitos",
    "验证类型不能为空": "El tipo de autenticación no puede ser nulo",
    "未绑定手机号": "Ningún número de teléfono está vinculado",
    "未绑定邮箱": "Ningún buzón está vinculado",
    "未绑定谷歌验证器": "Validador de Google no vinculado",
    "旧密码不能为空": "La contraseña anterior no puede ser nula",
    "新密码不能为空": "La nueva contraseña no puede ser nula.",
    "新密码确认不能为空": "La confirmación de la nueva contraseña no puede ser nula.",
    "新密码不一致": "La nueva contraseña no es la misma que la original ingresada",
    "操作类型为空": "El tipo de operación es nulo",
    "操作类型不是整数": "El tipo de operación no es un número entero",
    "操作类型不能小于0": "El tipo de operación no puede ser menor que 0",
    "用户名参数为空": "El parámetro de nombre de usuario es nulo",
    "状态不是整数": "El estado no es un número entero",
    "状态不能小于0": "El estado no puede ser inferior a 0",
    "系统参数错误": "Error de parámetro del sistema",
    "-连接已建立-": "-Conexión establecida-",
    "代理层级错误": "Error de nivel de agente",
    "请重新登录": "Inicie sesión de nuevo",
    "暂无店铺": "No hay tienda",
    "地址格式与协议不匹配": "El formato de la dirección no coincide con el protocolo",
    "用户已绑定过提现地址": "El usuario ya ha vinculado la dirección de retiro",
    "绑定提现地址成功": "Vincular la dirección de retiro con éxito",
    "未设置地址": "Dirección no establecida",
    "您有一笔提现正在处理中": "Tiene un retiro en proceso",
    "平台人工发起退款": "Reembolso iniciado por el personal de la plataforma",
    "充值数量不能小于等于0": "La cantidad de recarga no puede ser menor o igual a 0",
    "请选择法币类型": "Seleccione el tipo de moneda fiduciaria",
    "充值金额超过最大金额": "El monto de recarga supera el monto máximo",
    "充值金额小于最小金额": "El monto de recarga es menor que el monto mínimo",
    "请选择正确的法币类型": "Seleccione el tipo de moneda fiduciaria correcto",
    "业务已锁定，请联系客服！": "El negocio está bloqueado, comuníquese con el servicio al cliente.",
    "无法购买本店商品": "No se puede comprar productos de esta tienda",
    '参数缺失': "Falta de parámetros",
    '充值数量必填': "La cantidad de recarga es obligatoria",
  },
  "tits_th": {
    "添加失败": "ส่งไม่สำเร็จ กรุณาลองใหม่อีกครั้งในภายหลัง",
    "提交失败": "การส่งล้มเหลว",
    "请输入正确的邮箱地址": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    "已有未完成的贷款单，不能重复申请": "มีคำสั่งกู้ที่ยังไม่เสร็จสิ้นอยู่แล้ว ไม่สามารถยื่นซ้ำได้",
    "请输入关键字搜索": "กรุณาใส่คีย์เวิร์ดเพื่อค้นหา",
    "已提交评论!": "ส่งรีวิวแล้ว!",
    '参数缺失': 'ขาดพารามิเตอร์',
    '充值数量必填': 'จำนวนการเติมเงินจำเป็น',
    "该商品已下架": "สินค้าถูกลงล่าสุด",
    "未指定商家": "ธุรกิจที่ไม่ระบุรายละเอียด",
    "该手机号已被占用，请绑定其他手机号":
      "หมายเลขโทรศัพท์นี้ถูกใช้งานแล้ว โปรดเลกใช้หมายเลขโทรศัพท์อื่น",
      "邮箱验证码发送次数过多，请明天再试":
      "ส่งรหัสยืนยันอีเมล์ไปแล้ว โปรดลองอีกครั้งในวันต่อไป",
    "该邮箱已被占用，请更换其他邮箱注册": 
      "อีเมล์นี้ถูกใช้งานแล้ว โปรดเลกใช้อีเมล์อื่น",
    "系统错误": 'ระบบผิดพลาด',
    "当前账号有未完成的充值订单，请完成后再试": "บัญชีปัจจุบันมีคำสั่งเติมเงินที่ยังไม่เสร็จ โปรดลองอีกครั้งหลังจากเสร็จสิ้น",
    "当前账号有未完成的提现订单，请完成后再试": "บัญชีปัจจุบันมีคำสั่งถอนที่ยังไม่เสร็จ โปรดกรอกและลองอีกครั้ง",
    "请先登录": "กรุณาเข้าสู่ระบบ",
    "该角色账号不允许注销": "บัญชีบทบาทนี้ไม่ได้รับอนุญาตให้ออกจากระบบ",
    "当前的用户账号与确认注销的账号不一致": "บัญชีผู้ใช้ปัจจุบันไม่สอดคล้องกับบัญชีที่ยืนยันให้ออกจากระบบ",
    "密码输入错误次数过多，请明天再试": "ป้อนรหัสผ่านผิดมากเกินไป โปรดลองอีกครั้งในวันพรุ่งนี้",
    "注销失败": "ออกจากระบบล้มเหลว",
    "注销成功": "ออกจากระบบสำเร็จ",
    "当前用户已经被管理员禁用": "ผู้ใช้ปัจจุบันถูกปิดใช้งานโดยผู้ดูแลระบบ",
    "地址不存在,或者已删除": "ไม่มีที่อยู่หรือถูกลบไปแล้ว",
    "地址不能为空": "ต้องระบุที่อยู่",
    "地址过长": "ที่อยู่ยาวเกินไป",
    "店家id不能为空": "รหัสร้านค้าต้องไม่ว่างเปล่า",
    "店家id错误": "รหัสร้านค้าไม่ถูกต้อง",
    "订单号不能为空": "หมายเลขคำสั่งซื้อต้องไม่ว่างเปล่า",
    "非法请求": "คำขอที่ผิดกฎหมาย",
    "购买失败,联系客服": "การซื้อล้มเหลว โปรดติดต่อฝ่ายบริการลูกค้า",
    "关注id不能为空": "รหัสการติดตามต้องไม่ว่างเปล่า",
    "联系人不能为空": "ผู้ติดต่อต้องไม่ว่างเปล่า",
    "两次输入的资金密码不相同": "รหัสผ่านของกองทุนที่ป้อนสองครั้งจะแตกต่างกัน",
    "模块名不能为空": "ชื่อโมดูลต้องไม่ว่างเปล่า",
    "您的申请之前已提交过": "ใบสมัครของคุณถูกส่งมาก่อน",
    "请上传图片格式的文件": "โปรดอัปโหลดไฟล์ในรูปแบบภาพ",
    "请勿重复添加": "อย่าเพิ่มซ้ำ",
    "取消失败": "การยกเลิกล้มเหลว",
    "删除失败": "ลบไม่สำเร็จ",
    "商品id不能为空": "รหัสผลิตภัณฑ์ต้องไม่ว่างเปล่า",
    "商品id错误": "รหัสผลิตภัณฑ์ไม่ถูกต้อง",
    "实名认证尚未通过，无法重置": "การตรวจสอบชื่อจริงไม่ผ่านและไม่สามารถรีเซ็ตได้",
    "收藏id不能为空": "รหัสคอลเลกชันต้องไม่ว่างเปล่า",
    "收货失败": "ใบเสร็จรับเงินล้มเหลว",
    "手机号不能为空": "หมายเลขโทรศัพท์มือถือต้องไม่ว่างเปล่า",
    "图片不能为空": "รูปภาพต้องไม่ว่างเปล่า",
    "图片大小不能超过30M": "ขนาดภาพไม่เกิน 30M",
    "用户已锁定": "ล็อคผู้ใช้",
    "正在购买": "ซื้อ",
    "该贷款单还未通过审核": "ใบกู้ไม่ผ่านอนุมัติ",
    "该贷款单号不存在": "ไม่มีหมายเลขเงินกู้",
    "两次输入的密码不相同": "รหัสผ่านที่ป้อนสองครั้งจะแตกต่างกัน",
    "类型不能为空": " ประเภทต้องไม่ว่างเปล่า",
    "操作失败！修正后账户余额小于0。": "การดำเนินการล้มเหลว! หลังจากแก้ไขแล้ว ยอดเงินในบัญชีจะน้อยกว่า 0",
    "身份证号已实名过!": " ยืนยันเลขประจำตัวประชาชนแล้ว!",
    "提款金额不得低于最小提款限额": "จำนวนการถอนจะต้องไม่ต่ำกว่าวงเงินขั้นต่ำในการถอน",
    "提款金额不得高于最大提款限额": "จำนวนเงินที่ถอนต้องไม่เกินวงเงินสูงสุดที่ถอนได้",
    "超过提现次数": "เกินเวลาการถอน",
    "不在提现时间范围内，请稍后再试": "ไม่อยู่ในช่วงเวลาการถอน โปรดลองอีกครั้งในภายหลัง",
    "提币数量必填": "ต้องระบุจำนวนเงินที่ถอนออก",
    "提币数量输入错误，请输入浮点数": "ป้อนจำนวนเงินที่ถอนไม่ถูกต้อง โปรดป้อนหมายเลขทศนิยม",
    "更新钱包失败，请联系客服": "ไม่สามารถอัปเดตกระเป๋าเงิน โปรดติดต่อฝ่ายบริการลูกค้า",
    "试用码不正确": "รหัสทดลองไม่ถูกต้อง",
    "已经提交申请，请等待审核": "ส่งใบสมัครแล้ว กรุณารอการตรวจสอบ",
    "审核状态异常请联系客服": "หากสถานะการตรวจสอบผิดปกติ โปรดติดต่อฝ่ายบริการลูกค้า",
    "暂无用户": "ยังไม่มีผู้ใช้",
    "系统无该用户，或者ip地址不正确": "ไม่มีผู้ใช้ดังกล่าวในระบบหรือที่อยู่ IP ไม่ถูกต้อง",
    "游客不能向游客发送消息": "ผู้เข้าชมไม่สามารถส่งข้อความถึงผู้เข้าชมได้",
    "请选择收货地址": "กรุณาเลือกที่อยู่ในการจัดส่ง",
    "收货地址达上限": "ที่อยู่สำหรับจัดส่งถึงขีดจำกัดสูงสุดแล้ว",
    "请设置资金密码": "กรุณาตั้งรหัสผ่านกองทุน",
    "该订单未满足支付条件": "คำสั่งซื้อไม่ตรงตามเงื่อนไขการชำระเงิน",
    "密码输入错误次数过多，请明天再试": "ป้อนรหัสผ่านผิดมากเกินไป โปรดลองอีกครั้งในวันพรุ่งนี้",
    "操作失败，请稍后再试": " การดำเนินการล้มเหลว โปรดลองอีกครั้งในภายหลัง",
    "部分商品已下架": "สินค้าบางรายการเลิกผลิตแล้ว",
    "邮箱的长度不能超过64个字符": " ความยาวของกล่องจดหมายต้องไม่เกิน 64 อักขระ",
    "邮码不能超过32个字符": " รหัสไปรษณีย์ต้องไม่เกิน 32 อักขระ",
    "操作类型不正确": "ประเภทการดำเนินการไม่ถูกต้อง",
    "参数错误!": "พารามิเตอร์ผิดพลาด!",
    "不支持的语言": "ภาษาที่ไม่รองรับ",
    "收货人姓名不能超过64个字符": "ชื่อผู้รับต้องมีความยาวไม่เกิน 64 อักขระ",
    "请输入正确的手机号码": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
    "操作频繁，请稍后再试": "การดำเนินการบ่อยครั้ง โปรดลองอีกครั้งในภายหลัง",
    "无此sellerGoods": "ไม่มีผู้ขายสินค้าดังกล่าว",
    "退货失败": "การส่งคืนล้มเหลว",
    "该订单状态无法操作": " ไม่สามารถดำเนินการสถานะคำสั่งซื้อได้",
    "订单已经发货，无法退款": "จัดส่งคำสั่งซื้อแล้วและไม่สามารถคืนเงินได้",
    "大于最大采购数量": "มากกว่าปริมาณการซื้อสูงสุด",
    "该邮箱已被订阅": "กล่องจดหมายนี้ได้รับการสมัครแล้ว",
    "登录过期，请重新登录": "การเข้าสู่ระบบหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง",
    "系统错误，请稍后重试": "ระบบเกิดข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง",
    "请稍后重试": "กรุณาลองใหม่อีกครั้งในภายหลัง",
    "连续输入错误三次，请3分钟后再试": "ป้อนข้อผิดพลาดสามครั้งติดต่อกัน โปรดลองอีกครั้งในอีก 3 นาที",
    "审核中": "ภายใต้การทบทวน",
    "程序错误": "ข้อผิดพลาดของโปรแกรม",
    "重复提交": "ส่งใหม่",
    "用户名不能为空": "ชื่อผู้ใช้ต้องไม่เป็นโมฆะ",
    "验证码不能为空": "รหัสยืนยันต้องไม่เป็นโมฆะ",
    "登录密码不能为空": "รหัสผ่านเข้าสู่ระบบต้องไม่เป็นโมฆะ",
    "登陆密码长度不符合设定": "ความยาวรหัสผ่านเข้าสู่ระบบไม่ตรงกับการตั้งค่า",
    "资金密码长度不符合设定": "ความยาวของรหัสผ่านกองทุนไม่ตรงกับการตั้งค่า",
    "登陆密码不符合设定": "รหัสผ่านเข้าสู่ระบบไม่ตรงกับการตั้งค่า",
    "资金密码不符合设定": "รหัสผ่านกองทุนไม่เป็นไปตามการตั้งค่า",
    "用户名不符合设定": "ชื่อผู้ใช้ไม่ตรงกับการตั้งค่า",
    "用户名必须由数字和英文字母组成": "ชื่อผู้ใช้ต้องประกอบด้วยตัวเลขและตัวอักษร",
    "验证码不正确": "รหัสยืนยันไม่ถูกต้อง",
    "密码不正确": "รหัสผ่านผิดพลาด",
    "服务器错误(500)": "ข้อผิดพลาดของเซิร์ฟเวอร์ (500)",
    "服务器错误": "เซิร์ฟเวอร์ผิดพลาด",
    "用户名重复": "ชื่อผู้ใช้ซ้ำ",
    "找不到用户": "ไม่พบชื่อผู้ใช้",
    "不能为空": "ไม่สามารถเป็นโมฆะ",
    "登录失败": "การเข้าสู่ระบบล้มเหลว",
    "操作成功": "การดำเนินการสำเร็จ",
    "工作地址不能为空": "ที่อยู่ที่ทำงานต้องไม่เป็นโมฆะ",
    "家庭地址不能为空": "ที่อยู่บ้านต้องไม่เป็นโมฆะ",
    "亲属姓名不能为空": "ชื่อของญาติต้องไม่เป็นโมฆะ",
    "亲属关系不能为空": "ความสัมพันธ์ภายในประเทศต้องไม่เป็นโมฆะ",
    "亲属地址不能为空": "ที่อยู่สัมพัทธ์ต้องไม่เป็นโมฆะ",
    "亲属电话不能为空": "หมายเลขโทรศัพท์ของครอบครัวต้องไม่เป็นโมฆะ",
    "用户名不存在": "ไม่มีชื่อผู้ใช้",
    "参数错误": "ข้อผิดพลาดของพารามิเตอร์",
    "不在交易时段": "ไม่ได้อยู่ในช่วงการซื้อขาย",
    "存在不同杠杆的持仓单": "มีตำแหน่งการถือครองด้วยเลเวอเรจที่แตกต่างกัน",
    "余额不足": "ยอดเงินคงเหลือไม่เพียงพอ",
    "可平仓合约张数不足": "จำนวนสัญญาปิดสถานะไม่เพียงพอ",
    "请输入正确的货币数量": "กรุณากรอกจำนวนเงินที่ถูกต้อง",
    "请选择正确的币种": "กรุณาเลือกสกุลเงินที่ถูกต้อง",
    "金额错误": "จำนวนเงินผิดพลาด",
    "跟单参数输入错误": "ป้อนพารามิเตอร์เอกสารไม่ถูกต้อง",
    "跟单倍数输入错误": "การป้อนสารคดีหลายรายการไม่ถูกต้อง",
    "交易员不存在": "แม่ค้าไม่อยู่",
    "交易员未开启带单": "แม่ค้ายังไม่เปิดบิล",
    "用户已跟随交易员": "ผู้ใช้ได้ติดตามเทรดเดอร์",
    "交易员跟随人数已满": "จำนวนผู้ค้าที่ติดตามเต็มแล้ว",
    "交易员不能跟随自己": "แม่ค้าตามเองไม่ได้",
    "交易员无法跟随另一个交易员": "ผู้ค้าไม่สามารถติดตามผู้ค้ารายอื่นได้",
    "历史基金无法购买": "ไม่สามารถซื้อกองทุนย้อนหลังได้",
    "该基金尚未开放购买": "กองทุนยังไม่เปิดให้ซื้อ",
    "该基金尚已封闭": "ปิดกองทุนแล้ว",
    "基金剩余购买金额不足": "เงินซื้อกองทุนคงเหลือไม่เพียงพอ",
    "订单不存在": "ไม่มีคำสั่งซื้อ",
    "下单不能小于最小金额限制": "การสั่งซื้อต้องไม่ต่ำกว่าวงเงินขั้นต่ำ",
    "[symbol]参数为空": "[สัญลักษณ์] พารามิเตอร์เป็นโมฆะ",
    "矿机不存在": "ไม่มีเครื่องขุด",
    "矿机未解锁，无法购买": "เครื่องขุดถูกล็อคและไม่สามารถซื้อได้",
    "您已购买过体验矿机,不得重复购买": "คุณได้ซื้อเครื่องขุดประสบการณ์แล้ว อย่าซื้อมันอีกครั้ง",
    "买入金额需要在区间内": "ยอดซื้อควรอยู่ในช่วง",
    "行情获取异常，稍后再试": "การได้มาซึ่งสถานการณ์นั้นผิดปกติ กรุณาลองใหม่อีกครั้งในภายหลัง.",
    "广告不存在": "ไม่มีโฆษณา",
    "广告已下架": "โฆษณาจะถูกลบออก",
    "承兑商不存在": "ไม่มีตัวรับ",
    "请先添加收款方式": "กรุณาเพิ่มวิธีการรวบรวมก่อน",
    "您没有符合条件的收款方式": "คุณไม่มีวิธีการเก็บรวบรวมที่มีสิทธิ์",
    "请选择买卖方式": "กรุณาเลือกวิธีการซื้อขาย",
    "请输入正确的金额": "กรุณากรอกจำนวนเงินให้ถูกต้อง",
    "请输入正确的数量": "กรุณากรอกจำนวนให้ถูกต้อง",
    "该广告剩余数量不足": "เหลือโฆษณาไม่เพียงพอ",
    "金额不在购买区间": "จำนวนเงินไม่อยู่ในช่วงการซื้อ",
    "用户剩余数量不足": "จำนวนผู้ใช้ที่เหลืออยู่ไม่เพียงพอ",
    "请稍后再试": "กรุณาลองใหม่อีกครั้งในภายหลัง",
    "未找到符合条件的匹配订单": "ไม่พบคำสั่งซื้อที่ตรงกัน",
    "该订单已取消": "คำสั่งซื้อนี้ถูกยกเลิกแล้ว",
    "当前订单不为待付款状态，无法取消": "คำสั่งซื้อปัจจุบันไม่อยู่ในสถานะรอการชำระเงิน ไม่สามารถยกเลิกได้",
    "卖方无法取消该订单": "ผู้ขายไม่สามารถยกเลิกคำสั่งซื้อได้",
    "资金密码错误": "รหัสผ่านกองทุนผิดพลาด",
    "订单已完成": "คำสั่งซื้อเสร็จสมบูรณ์",
    "订单已取消": "คำสั่งซื้อถูกยกเลิก",
    "待付款的订单无法放行": "ไม่สามารถออกคำสั่งซื้อที่รอการชำระเงินได้",
    "订单已完成，无法放行": "สั่งซื้อเสร็จแล้วไม่สามารถปล่อยได้",
    "订单已取消，无法放行": "คำสั่งซื้อถูกยกเลิกและไม่สามารถออกได้",
    "未授权访问": "การเข้าถึงโดยไม่ได้รับอนุญาต",
    "图片大小不能超过2M！": "ขนาดภาพต้องไม่เกิน 2M!",
    "参数异常，消息获取失败": "ข้อผิดพลาดของพารามิเตอร์ การได้รับข้อความล้มเหลว",
    "无效的UID": "UID ไม่ถูกต้อง",
    "用户不存在": "ไม่มีผู้ใช้",
    "图片上传失败": "อัปโหลดรูปภาพไม่สำเร็จ",
    "请输入内容": "กรุณาใส่เนื้อหา",
    "图片不得大于2M": "รูปภาพต้องมีขนาดไม่เกิน 2M",
    "图片不得大于10M": "รูปภาพต้องมีขนาดไม่เกิน 10M",
    "直线关系，不能修改推荐": "ความสัมพันธ์แบบเส้นตรง คำแนะนำไม่สามารถแก้ไขได้",
    "存在重复的角色名称": "ชื่อบทบาทที่ซ้ำกัน",
    "角色被用户关联，不可删除": "บทบาทเชื่อมโยงโดยผู้ใช้ ไม่สามารถลบได้",
    "系统存在相同[系统登录名]！": "ระบบมี [System Login Name] เหมือนกัน!",
    "旧密码不正确": "รหัสผ่านเก่าไม่ถูกต้อง",
    "没有找到用户": "ไม่พบผู้ใช้",
    "[code]值错误": "ค่า [code] ไม่ถูกต้อง",
    "身份证已实名过!": "ตรวจบัตรประชาชนแล้ว!",
    "实名认证未通过，无法进行高级认证": "การรับรองชื่อจริงล้มเหลว ไม่มีการรับรองขั้นสูง",
    "收款方输入错误": "ป้อนข้อผิดพลาดของผู้รับเงิน",
    "所选汇率不存在": "ไม่มีอัตราแลกเปลี่ยนที่เลือก",
    "转账数量不能小于等于0": "ปริมาณการโอนต้องไม่น้อยกว่าหรือเท่ากับ 0",
    "UID不能为空": "UID ต้องไม่เป็นโมฆะ",
    "转账币种不能为空": "สกุลเงินที่โอนต้องไม่เป็นโมฆะ",
    "资金密码不能为空": "รหัสผ่านของกองทุนไม่สามารถเป็นโมฆะได้",
    "提现不得小于限额": "ถอนเงินสดไม่ต่ำกว่าวงเงิน",
    "提现不得大于限额": "ถอนเงินสดไม่เกินวงเงิน",
    "当日可提现次数不足": "จำนวนคดีที่ถอน ณ วันที่ปัจจุบันไม่เพียงพอ",
    "不在可提现时间内": "ไม่อยู่ในช่วงเวลาถอน",
    "渠道未开通": "ไม่ได้เปิดช่อง",
    "提币数量不能小于等于0": "ปริมาณการถอนต้องไม่น้อยกว่าหรือเท่ากับ 0",
    "无权限": "ไม่มีสิทธิ์",
    "请先通过高级认证": "กรุณาผ่านการรับรองขั้นสูงก่อน",
    "请输入搜索关键字": "กรุณาใส่คำค้นหา",
    "角色不存在": "ไม่มีบทบาท",
    "持有币种不足": "สกุลเงินที่ถือครองไม่เพียงพอ",
    "提交失败，当前有未处理订单": "การส่งล้มเหลว ขณะนี้มีคำสั่งซื้อที่เปิดอยู่",
    "充值链错误": "ข้อผิดพลาดของห่วงโซ่การชาร์จ",
    "充值价值不得小于最小限额": "มูลค่าการเติมจะต้องไม่ต่ำกว่าขีดจำกัดขั้นต่ำ",
    "充值价值不得大于最大限额": "มูลค่าการเติมจะต้องไม่เกินขีดจำกัดสูงสุด",
    "充值数量不能小于等于0": "ปริมาณการเติมต้องไม่น้อยกว่าหรือเท่ากับ 0",
    "请输入充值币种": "กรุณากรอกสกุลเงินที่เติม",
    "请上传图片": "กรุณาอัพโหลดรูปภาพ",
    "当前还需交易": "ยังคงต้องทำธุรกรรม",
    ",才可提币": "แล้วจึงทำการถอนเงินสดได้",
    "提示": "เคล็ดลับ",
    "未实名认证，是否认证？": "ไม่รับรองความถูกต้องด้วยชื่อจริง ตรวจสอบสิทธิ์?",
    "帐户异常需要进行C3认证，请联系在线客服。": "ข้อยกเว้นของบัญชีต้องการการรับรองความถูกต้อง C3 โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์",
    "确认": "การตรวจสอบ",
    "取消": "ยกเลิก",
    "更新提醒": "อัปเดตการแจ้งเตือน",
    "发现新版本，请升级到最新版本": "พบเวอร์ชันใหม่ โปรดอัปเกรดเป็นเวอร์ชันล่าสุด",
    "请检查网络连接": "กรุณาตรวจสอบการเชื่อมต่อเครือข่ายของคุณ",
    "您已存在订单": "คุณมีคำสั่งซื้อแล้ว",
    "当前地址格式错误": "ข้อผิดพลาดรูปแบบที่อยู่ปัจจุบัน",
    "申购数量错误": "ข้อผิดพลาดเกี่ยวกับปริมาณการสมัครสมาชิก",
    "产品不存在": "ไม่มีสินค้า",
    "该产品未上架": "ผลิตภัณฑ์นี้ไม่ได้อยู่ในรายการ",
    "该产品已上市，无法购买": "ผลิตภัณฑ์นี้อยู่ในตลาดและไม่สามารถซื้อได้",
    "当日才可申购": "สามารถซื้อได้ในวันเดียวกันเท่านั้น",
    "产品剩余数量不足": "ปริมาณสินค้าคงเหลือไม่เพียงพอ",
    "您当前可分配额度不足": "ขีดจำกัดที่จัดสรรได้ในปัจจุบันของคุณไม่เพียงพอ",
    "购买矿机时间不得低于托管订单剩余时间": "เวลาในการซื้อเครื่องขุดต้องไม่น้อยกว่าเวลาที่เหลืออยู่ของคำสั่งดูแล",
    "推荐码不正确": "รหัสคำแนะนำไม่ถูกต้อง",
    "推荐人无权限推荐": "ผู้แนะนำไม่มีอำนาจในการแนะนำ",
    "审核已通过": "รีวิวผ่านไป",
    "请填写正确的验证码": "กรุณากรอกรหัสยืนยันให้ถูกต้อง",
    "请填写正确的电话号码": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
    "请填写正确的邮箱地址": "กรุณากรอกที่อยู่อีเมลให้ถูกต้อง",
    "电话号码已绑定": "ผูกเบอร์โทรไว้แล้ว",
    "电话号码已绑定其他用户": "หมายเลขโทรศัพท์ผูกไว้กับผู้ใช้รายอื่น",
    "邮箱已绑定": "กล่องจดหมายถูกผูกไว้แล้ว",
    "邮箱已绑定其他用户": "กล่องจดหมายถูกผูกไว้กับผู้ใช้รายอื่นแล้ว",
    "页码不是整数": "หมายเลขหน้าไม่ใช่จำนวนเต็ม",
    "页码不能小于等于0": "หมายเลขหน้าต้องไม่น้อยกว่าหรือเท่ากับ 0",
    "请输入正确的质押金额": "โปรดป้อนจำนวนเงินจำนำที่ถูกต้อง",
    "请输入正确的质押天数": "โปรดป้อนวันจำนำที่ถูกต้อง",
    "未发现授权记录": "ไม่พบบันทึกการอนุญาต",
    "授权状态未成功": "สถานะการให้สิทธิ์ล้มเหลว",
    "赎回状态异常": "สถานะการรับซื้อคืนผิดปกติ",
    "申请成功": "สมัครสำเร็จ",
    "领取成功": "รับสำเร็จ",
    "未找到匹配的收益记录": "ไม่พบบันทึกรายได้ที่ตรงกัน",
    "已领取": "ได้รับ",
    "校验IP不合法": "การยืนยัน IP เป็นสิ่งผิดกฎหมาย",
    "委托数量(张)必填": "จำเป็นต้องระบุปริมาณที่กำหนด (ชิ้น)",
    "委托数量(张)不能小于等于0": "ปริมาณที่กำหนด (ชิ้น) ต้องไม่น้อยกว่าหรือเท่ากับ 0",
    "请先绑定谷歌验证器": "โปรดผูก Google Authenticator ก่อน",
    "资金密码必须6-12位": "รหัสผ่านกองทุนต้องเป็นตัวเลข 6-12 หลัก",
    "验证码错误": "รหัสยืนยันผิดพลาด",
    "登录密码必须6-12位": "รหัสผ่านเข้าสู่ระบบต้องเป็น 6-12 หลัก",
    "密码不能为空": "รหัสผ่านต้องไม่เป็นโมฆะ",
    "密码必须6-12位": "รหัสผ่านต้องเป็น 6-12 หลัก",
    "验证类型不能为空": "ประเภทการรับรองความถูกต้องต้องไม่เป็นโมฆะ",
    "未绑定手机号": "ไม่มีการผูกหมายเลขโทรศัพท์",
    "未绑定邮箱": "ไม่มีกล่องจดหมายถูกผูกไว้",
    "未绑定谷歌验证器": "เครื่องมือตรวจสอบความถูกต้องของ Google ไม่ได้ถูกผูกไว้",
    "旧密码不能为空": "รหัสผ่านเก่าต้องไม่เป็นโมฆะ",
    "新密码不能为空": "รหัสผ่านใหม่ต้องไม่เป็นโมฆะ",
    "新密码确认不能为空": "การยืนยันรหัสผ่านใหม่ต้องไม่เป็นโมฆะ",
    "新密码不一致": "รหัสผ่านใหม่ไม่เหมือนกับรหัสผ่านเดิม",
    "操作类型为空": "ประเภทการดำเนินการเป็นโมฆะ",
    "操作类型不是整数": "ประเภทการดำเนินการไม่ใช่จำนวนเต็ม",
    "操作类型不能小于0": "ประเภทการดำเนินการต้องไม่น้อยกว่า 0",
    "用户名参数为空": "พารามิเตอร์ชื่อผู้ใช้เป็นโมฆะ",
    "状态不是整数": "สถานะไม่ใช่จำนวนเต็ม",
    "状态不能小于0": "สถานะต้องไม่ต่ำกว่า 0",
    "系统参数错误": "ข้อผิดพลาดของพารามิเตอร์ระบบ",
    "-连接已建立-": "-สร้างการเชื่อมต่อ-",
    "代理层级错误": "ข้อผิดพลาดระดับตัวแทน",
    "请重新登录": "กรุณาเข้าสู่ระบบอีกครั้ง",
    "暂无店铺": "ไม่มีร้านค้า",
    "地址格式与协议不匹配": "รูปแบบที่อยู่ไม่ตรงกับโปรโตคอล",
    "用户已绑定过提现地址": "ผู้ใช้ได้ผูกไว้กับที่อยู่การถอนเงิน",
    "绑定提现地址成功": "ผูกที่อยู่การถอนเงินสำเร็จ",
    "未设置地址": "ไม่ได้ตั้งค่าที่อยู่",
    "您有一笔提现正在处理中": "คุณมีการถอนเงินที่กำลังดำเนินการ",
    "平台人工发起退款": "แพลตฟอร์มเริ่มเงินคืนด้วยตนเอง",
    "充值数量不能小于等于0": "จำนวนการเติมเงินต้องไม่น้อยกว่าหรือเท่ากับ 0",
    "请选择法币类型": "โปรดเลือกประเภทเงินตรา",
    "充值金额超过最大金额": "จำนวนเงินที่เติมเงินมากกว่าจำนวนเงินสูงสุด",
    "充值金额小于最小金额": "จำนวนเงินที่เติมเงินน้อยกว่าจำนวนเงินขั้นต่ำ",
    "请选择正确的法币类型": "โปรดเลือกประเภทเงินตราที่ถูกต้อง",
    "业务已锁定，请联系客服！": "ธุรกิจถูกล็อค โปรดติดต่อฝ่ายบริการลูกค้า!",
    "无法购买本店商品": "ไม่สามารถซื้อสินค้าร้านค้านี้ได้",
  },
  "tits_it": {
    "添加失败": "Aggiunta non riuscita",
    "请输入正确的邮箱地址": "Inserisci un indirizzo email corretto",
    "已有未完成的贷款单，不能重复申请": "Esiste già un ordine di prestito non completato, impossibile richiedere di nuovo",
    "请输入关键字搜索": "Inserisci la parola chiave di ricerca",
    '参数缺失': "Parametro mancante",
    '充值数量必填': "L'importo della ricarica è obbligatorio",
    "已提交评论!": "Recensione inviata!",
    "未指定商家": "Affari non specificati",
    "该手机号已被占用，请绑定其他手机号":
    "Questo numero di telefono è già stato utilizzato, per favore utilizzare un altro numero di telefono",
    "邮箱验证码发送次数过多，请明天再试": 
    "Il numero di verifica di posta elettronica è stato inviato troppe volte, per favore riprova mattina",
    "该邮箱已被占用，请更换其他邮箱注册":
    "Questo indirizzo email è già stato utilizzato, per favore utilizzare un altro indirizzo email",
    "该商品已下架": "Questo prodotto è sospeso",
    "系统错误": 'errore di sistema',
    "当前账号有未完成的充值订单，请完成后再试": "L'account corrente ha un ordine di ricarica incompiuto, riprova dopo il completamento",
    "当前账号有未完成的提现订单，请完成后再试": "Il conto corrente ha un ordine di prelievo incompiuto, completalo e riprova",
    "请先登录": "Accedete, per favore",
    "该角色账号不允许注销": "Questo account di ruolo non è autorizzato a disconnettersi",
    "当前的用户账号与确认注销的账号不一致": "L'account utente corrente non è coerente con l'account confermato per il logout",
    "密码输入错误次数过多，请明天再试": "Sono state inserite troppe password errate, riprova domani",
    "注销失败": "Disconnessione fallita",
    "注销成功": "Disconnessione riuscita",
    "当前用户已经被管理员禁用": "L'utente corrente è stato disabilitato dall'amministratore",
    "地址不存在,或者已删除": " L'indirizzo non esiste o è stato eliminato",
    "地址不能为空": "L'indirizzo non può essere vuoto",
    "地址过长": "indirizzo troppo lungo",
    "店家id不能为空": " L'ID negozio non può essere vuoto",
    "店家id错误": "L'ID del negozio è errato",
    "订单号不能为空": "Il numero d'ordine non può essere vuoto",
    "非法请求": "richiesta illegale",
    "购买失败,联系客服": "Acquisto fallito, contatta il servizio clienti",
    "关注id不能为空": "L'ID follow non può essere vuoto",
    "联系人不能为空": "Il contatto non può essere vuoto",
    "两次输入的资金密码不相同": "Le password del fondo inserite due volte sono diverse",
    "模块名不能为空": "Il nome del modulo non può essere vuoto",
    "您的申请之前已提交过": " La tua domanda è già stata inviata",
    "请上传图片格式的文件": "Si prega di caricare un file in formato immagine",
    "请勿重复添加": "Non aggiungere ripetutamente",
    "取消失败": "Annullamento non riuscito",
    "删除失败": "Impossibile eliminare",
    "商品id不能为空": "L'ID prodotto non può essere vuoto",
    "商品id错误": "L'ID del prodotto è sbagliato",
    "实名认证尚未通过，无法重置": "L'autenticazione del nome reale non è stata superata e non può essere reimpostata",
    "收藏id不能为空": "L'ID raccolta non può essere vuoto",
    "收货失败": "Ricevuta fallita",
    "手机号不能为空": "Il numero di cellulare non può essere vuoto",
    "图片不能为空": "L'immagine non può essere vuota",
    "图片大小不能超过30M": "La dimensione dell'immagine non può superare i 30M",
    "用户已锁定": "utente bloccato",
    "正在购买": "acquisto",
    "该贷款单还未通过审核": "La ricevuta del prestito non è stata approvata",
    "该贷款单号不存在": "Il numero del prestito non esiste",
    "两次输入的密码不相同": "Le password inserite due volte sono diverse",
    "类型不能为空": "Il tipo non può essere vuoto",
    "操作失败！修正后账户余额小于0。": "operazione fallita! Dopo la correzione, il saldo del conto è inferiore a 0.",
    "身份证号已实名过!": "Il numero ID è stato verificato!",
    "提款金额不得低于最小提款限额": "L'importo del prelievo non deve essere inferiore al limite minimo di prelievo",
    "提款金额不得高于最大提款限额": "L'importo del prelievo non può essere superiore al limite massimo di prelievo",
    "超过提现次数": "Tempi di prelievo superati",
    "不在提现时间范围内，请稍后再试": "Non entro l'intervallo di tempo per il prelievo, riprova più tardi",
    "提币数量必填": "È richiesto l'importo del prelievo",
    "提币数量输入错误，请输入浮点数": "L'importo del prelievo è stato inserito in modo errato, inserisci un numero in virgola mobile",
    "更新钱包失败，请联系客服": "Impossibile aggiornare il portafoglio, contatta il servizio clienti",
    "试用码不正确": "Il codice di prova non è corretto",
    "已经提交申请，请等待审核": "La domanda è stata inviata, attendere la revisione",
    "审核状态异常请联系客服": "Se lo stato della recensione è anomalo, contatta il servizio clienti",
    "暂无用户": " Nessun utente ancora",
    "系统无该用户，或者ip地址不正确": "Non esiste un utente di questo tipo nel sistema o l'indirizzo IP non è corretto",
    "游客不能向游客发送消息": "I visitatori non possono inviare messaggi ai visitatori",
    "请选择收货地址": "Si prega di selezionare l'indirizzo di consegna",
    "收货地址达上限": "L'indirizzo di consegna ha raggiunto il limite massimo",
    "请设置资金密码": "Si prega di impostare una password per il fondo",
    "该订单未满足支付条件": "L'ordine non soddisfa le condizioni di pagamento",
    "密码输入错误次数过多，请明天再试": "Sono state inserite troppe password errate, riprova domani",
    "操作失败，请稍后再试": "Operazione non riuscita, riprova più tardi",
    "部分商品已下架": "Alcuni prodotti sono stati interrotti",
    "邮箱的长度不能超过64个字符": "La lunghezza della casella di posta non può superare i 64 caratteri",
    "邮码不能超过32个字符": "Il codice postale non può superare i 32 caratteri",
    "操作类型不正确": "Tipo di operazione errato",
    "参数错误!": "Errore di parametro!",
    "不支持的语言": "lingua non supportata",
    "收货人姓名不能超过64个字符": "Il nome del destinatario non può superare i 64 caratteri",
    "请输入正确的手机号码": "Inserisci il numero di telefono corretto",
    "操作频繁，请稍后再试": "Operazioni frequenti, riprovare più tardi",
    "无此sellerGoods": "Nessun venditore di questo tipoBeni",
    "退货失败": "ritorno fallito",
    "该订单状态无法操作": " Lo stato dell'ordine non può essere gestito",
    "订单已经发货，无法退款": "L'ordine è stato spedito e non può essere rimborsato",
    "大于最大采购数量": "Quantità di acquisto superiore a quella massima",
    "该邮箱已被订阅": "Questa casella di posta è già stata iscritta",
    "登录过期，请重新登录": "Accesso scaduto. Per favore esegui l'accesso di nuovo",
    "系统错误，请稍后重试": "Errore di sistema, riprova più tardi",
    "请稍后重试": "Per favore riprova più tardi",
    "连续输入错误三次，请3分钟后再试": "Immettere l'errore per tre volte di seguito. Riprova tra 3 minuti",
    "审核中": "In corso di revisione",
    "程序错误": "Errore del programma",
    "重复提交": "Invia di nuovo",
    "用户名不能为空": "Il nome utente non può essere nullo",
    "验证码不能为空": "Il codice di verifica non può essere nullo.",
    "登录密码不能为空": "La password di accesso non può essere nulla",
    "登陆密码长度不符合设定": "La lunghezza della password di accesso non corrisponde all'impostazione.",
    "资金密码长度不符合设定": "La lunghezza della password del fondo non corrisponde all'impostazione.",
    "登陆密码不符合设定": "La password di accesso non corrisponde all'impostazione.",
    "资金密码不符合设定": "La password del fondo non è conforme all'impostazione.",
    "用户名不符合设定": "Il nome utente non corrisponde all'impostazione",
    "用户名必须由数字和英文字母组成": "Il nome utente deve essere composto da numeri e lettere",
    "验证码不正确": "Codice di verifica errato",
    "密码不正确": "Password errata",
    "服务器错误(500)": "Errore del server (500)",
    "服务器错误": "Errore del server",
    "用户名重复": "Nome utente duplicato",
    "找不到用户": "Utente non trovato",
    "不能为空": "Non può essere nullo",
    "登录失败": "Accesso non riuscito",
    "操作成功": "Operazione riuscita",
    "工作地址不能为空": "L'indirizzo di lavoro non può essere nullo",
    "家庭地址不能为空": "L'indirizzo di casa non può essere nullo",
    "亲属姓名不能为空": "Il nome del parente non può essere nullo.",
    "亲属关系不能为空": "Le relazioni domestiche non possono essere nulle.",
    "亲属地址不能为空": "L'indirizzo relativo non può essere nullo.",
    "亲属电话不能为空": "Il numero di telefono della famiglia non può essere nullo.",
    "用户名不存在": "Lo username non esiste",
    "参数错误": "Errore di parametro",
    "不在交易时段": "Non in sessione di trading",
    "存在不同杠杆的持仓单": "Ci sono posizioni di mantenimento con leva diversa",
    "余额不足": "Equilibrio insufficiente",
    "可平仓合约张数不足": "Numero insufficiente di contratti di posizione chiusa",
    "请输入正确的货币数量": "Inserisci l'importo corretto della valuta",
    "请选择正确的币种": "Seleziona la valuta corretta",
    "金额错误": "Errore importo.",
    "跟单参数输入错误": "Inserimento errato dei parametri del documento",
    "跟单倍数输入错误": "Inserimento errato del multiplo documentario",
    "交易员不存在": "Il commerciante non esiste.",
    "交易员未开启带单": "Il commerciante non ha aperto il conto.",
    "用户已跟随交易员": "L'utente ha seguito il commerciante",
    "交易员跟随人数已满": "Il numero di trader che seguono è pieno",
    "交易员不能跟随自己": "I commercianti non possono seguire se stessi",
    "交易员无法跟随另一个交易员": "Il commerciante non può seguire un altro commerciante",
    "历史基金无法购买": "I fondi storici non possono essere acquistati",
    "该基金尚未开放购买": "Il fondo non è stato aperto per l'acquisto",
    "该基金尚已封闭": "Il fondo è stato chiuso",
    "基金剩余购买金额不足": "L'importo di acquisto residuo del fondo non è sufficiente.",
    "订单不存在": "L'ordine non esiste",
    "下单不能小于最小金额限制": "L'effettuazione dell'ordine non può essere inferiore al limite di importo minimo.",
    "[symbol]参数为空": "Il parametro [simbolo] è nullo",
    "矿机不存在": "La macchina mineraria non esiste",
    "矿机未解锁，无法购买": "La macchina mineraria è bloccata e non può essere acquistata.",
    "您已购买过体验矿机,不得重复购买": "Hai acquistato la macchina per l'estrazione dell'esperienza. Non comprarlo di nuovo.",
    "买入金额需要在区间内": "L'importo dell'acquisto dovrebbe essere compreso nell'intervallo.",
    "行情获取异常，稍后再试": "L'acquisizione della situazione è anormale. Per favore riprova più tardi.",
    "广告不存在": "La pubblicità non esiste",
    "广告已下架": "Gli annunci vengono rimossi",
    "承兑商不存在": "L'accettore non esiste.",
    "请先添加收款方式": "Aggiungi prima il metodo di raccolta",
    "您没有符合条件的收款方式": "Non hai un metodo di raccolta idoneo",
    "请选择买卖方式": "Seleziona il metodo di trading",
    "请输入正确的金额": "Inserisci l'importo corretto",
    "请输入正确的数量": "Si prega di inserire la quantità corretta",
    "该广告剩余数量不足": "Numero insufficiente di annunci rimanenti",
    "金额不在购买区间": "L'importo non rientra nell'intervallo di acquisto.",
    "用户剩余数量不足": "Numero insufficiente di utenti rimanenti",
    "请稍后再试": "Per favore riprova più tardi",
    "未找到符合条件的匹配订单": "Nessun ordine corrispondente trovato",
    "该订单已取消": "questo ordine è stato cancellato",
    "当前订单不为待付款状态，无法取消": "L'ordine corrente non è nello stato di pagamento in sospeso. Non può essere cancellato.",
    "卖方无法取消该订单": "Il venditore non può annullare l'ordine",
    "资金密码错误": "Errore password fondo",
    "订单已完成": "ordine completato",
    "订单已取消": "Ordine cancellato",
    "待付款的订单无法放行": "Gli ordini in attesa di pagamento non possono essere rilasciati",
    "订单已完成，无法放行": "L'ordine è stato completato e non può essere rilasciato",
    "订单已取消，无法放行": "L'ordine è stato annullato e non può essere rilasciato",
    "未授权访问": "Accesso non autorizzato",
    "图片大小不能超过2M！": "La dimensione dell'immagine non può superare i 2M!",
    "参数异常，消息获取失败": "Errore di parametro, acquisizione del messaggio non riuscita",
    "无效的UID": "UID non valido",
    "用户不存在": "l'utente non esiste",
    "图片上传失败": "Impossibile caricare l'immagine",
    "请输入内容": "Inserisci il contenuto",
    "图片不得大于2M": "L'immagine non deve essere più grande di 2M",
    "图片不得大于10M": "L'immagine non deve essere più grande di 10M",
    "直线关系，不能修改推荐": "Relazione in linea retta, la raccomandazione non può essere modificata",
    "存在重复的角色名称": "Nome ruolo duplicato",
    "角色被用户关联，不可删除": "Il ruolo è associato dall'utente. Non può essere cancellato.",
    "系统存在相同[系统登录名]！": "Il sistema esiste lo stesso [Nome di accesso al sistema]!",
    "旧密码不正确": "Vecchia password errata",
    "没有找到用户": "Nessun utente trovato",
    "[code]值错误": "Il valore [codice] non è corretto",
    "身份证已实名过!": "La carta d'identità è stata autenticata!",
    "实名认证未通过，无法进行高级认证": "Certificazione del nome reale non riuscita. La certificazione avanzata non è disponibile.",
    "收款方输入错误": "Inserisci l'errore del beneficiario",
    "所选汇率不存在": "Il tasso di cambio selezionato non esiste",
    "转账数量不能小于等于0": "La quantità di trasferimento non può essere inferiore o uguale a 0",
    "UID不能为空": "L'UID non può essere nullo",
    "转账币种不能为空": "La valuta di trasferimento non può essere nulla.",
    "资金密码不能为空": "La password del fondo non può essere nulla.",
    "提现不得小于限额": "Il prelievo di contanti non può essere inferiore al limite",
    "提现不得大于限额": "Il prelievo di contanti non può essere superiore al limite",
    "当日可提现次数不足": "Il numero di casi ritirati nel giorno corrente non è sufficiente.",
    "不在可提现时间内": "Non entro il tempo di recesso",
    "渠道未开通": "Canale non aperto",
    "提币数量不能小于等于0": "La quantità in prelievo non può essere minore o uguale a 0.",
    "无权限": "Nessuna autorizzazione",
    "请先通过高级认证": "Si prega di superare prima la certificazione avanzata",
    "请输入搜索关键字": "Inserisci le parole chiave di ricerca",
    "角色不存在": "Il ruolo non esiste",
    "持有币种不足": "Valuta di detenzione insufficiente",
    "提交失败，当前有未处理订单": "Invio non riuscito. Al momento ci sono ordini aperti.",
    "充值链错误": "Errore catena di ricarica",
    "充值价值不得小于最小限额": "Il valore di ricarica non deve essere inferiore al limite minimo",
    "充值价值不得大于最大限额": "Il valore di ricarica non potrà essere superiore al limite massimo",
    "充值数量不能小于等于0": "La quantità di ricarica non può essere inferiore o uguale a 0",
    "请输入充值币种": "Inserisci la valuta di ricarica",
    "请上传图片": "Si prega di caricare le immagini",
    "当前还需交易": "La transazione è ancora richiesta",
    ",才可提币": ", e quindi è possibile effettuare il prelievo di contanti.",
    "提示": "Suggerimenti",
    "未实名认证，是否认证？": "Non autenticato dal vero nome. Autenticare?",
    "帐户异常需要进行C3认证，请联系在线客服。": "L'eccezione dell'account richiede l'autenticazione C3. Si prega di contattare il servizio clienti online.",
    "确认": "Convalida",
    "取消": "Annulla",
    "更新提醒": "Aggiorna promemoria",
    "发现新版本，请升级到最新版本": "Nuova versione trovata, aggiorna alla versione più recente",
    "请检查网络连接": "Controlla la tua connessione di rete",
    "您已存在订单": "Hai già un ordine",
    "当前地址格式错误": "Errore nel formato dell'indirizzo corrente",
    "申购数量错误": "Errore nella quantità dell'abbonamento",
    "产品不存在": "Il prodotto non esiste",
    "该产品未上架": "Questo prodotto non è elencato",
    "该产品已上市，无法购买": "Questo prodotto è sul mercato e non può essere acquistato",
    "当日才可申购": "L'acquisto può essere acquistato solo lo stesso giorno.",
    "产品剩余数量不足": "Quantità di prodotto rimanente insufficiente",
    "您当前可分配额度不足": "Il tuo attuale limite allocabile non è sufficiente",
    "购买矿机时间不得低于托管订单剩余时间": "Il tempo di acquisto della macchina mineraria non può essere inferiore al tempo rimanente dell'ordine di custodia",
    "推荐码不正确": "Il codice della raccomandazione non è corretto.",
    "推荐人无权限推荐": "Il suggeritore non ha l'autorità di raccomandare.",
    "审核已通过": "Revisione superata",
    "请填写正确的验证码": "Si prega di inserire il codice di verifica corretto",
    "请填写正确的电话号码": "Si prega di inserire il numero di telefono corretto",
    "请填写正确的邮箱地址": "Si prega di inserire l'indirizzo e-mail corretto",
    "电话号码已绑定": "Numero di telefono già associato",
    "电话号码已绑定其他用户": "Il numero di telefono è associato a un altro utente",
    "邮箱已绑定": "Cassetta postale già rilegata",
    "邮箱已绑定其他用户": "Casella di posta già associata a un altro utente",
    "页码不是整数": "Il numero di pagina non è un numero intero",
    "页码不能小于等于0": "Il numero di pagina non può essere minore o uguale a 0",
    "请输入正确的质押金额": "Inserisci l'importo corretto del contributo",
    "请输入正确的质押天数": "Inserisci i giorni di donazione corretti",
    "未发现授权记录": "Record di autorizzazione non trovato",
    "授权状态未成功": "Stato di autorizzazione non riuscito",
    "赎回状态异常": "Stato di rimborso anomalo",
    "申请成功": "Applicazione riuscita",
    "领取成功": "Ricezione riuscita",
    "未找到匹配的收益记录": "Nessun record di entrate corrispondente trovato",
    "已领取": "Ricevuto",
    "校验IP不合法": "L'IP di verifica è illegale.",
    "委托数量(张)必填": "La quantità affidata (pz.) è richiesta",
    "委托数量(张)不能小于等于0": "La quantità affidata (pz.) non può essere minore o uguale a 0.",
    "请先绑定谷歌验证器": "Associa prima Google Authenticator",
    "资金密码必须6-12位": "La password del fondo deve essere di 6-12 cifre.",
    "验证码错误": "Errore codice di verifica",
    "登录密码必须6-12位": "La password di accesso deve essere di 6-12 cifre",
    "密码不能为空": "La password non può essere nulla",
    "密码必须6-12位": "La password deve essere di 6-12 cifre",
    "验证类型不能为空": "Il tipo di autenticazione non può essere nullo",
    "未绑定手机号": "Nessun numero di telefono è vincolato",
    "未绑定邮箱": "Nessuna cassetta postale è vincolata",
    "未绑定谷歌验证器": "Validatore Google non vincolato",
    "旧密码不能为空": "La vecchia password non può essere nulla",
    "新密码不能为空": "La nuova password non può essere nulla.",
    "新密码确认不能为空": "La conferma della nuova password non può essere nulla.",
    "新密码不一致": "La nuova password non è la stessa con l'inserimento originale",
    "操作类型为空": "Il tipo di operazione è nullo",
    "操作类型不是整数": "Il tipo di operazione non è un numero intero",
    "操作类型不能小于0": "Il tipo di operazione non può essere minore di 0",
    "用户名参数为空": "Il parametro del nome utente è nullo",
    "状态不是整数": "Lo stato non è un numero intero",
    "状态不能小于0": "Lo stato non può essere minore di 0",
    "系统参数错误": "Errore parametro di sistema",
    "-连接已建立-": "-Connessione stabilita-",
    "代理层级错误": "Errore a livello di agente",
    "请重新登录": "Per favore esegui l'accesso di nuovo",
    "提交失败": "Invio non riuscito",
    "暂无店铺": "Nessun negozio",
    "地址格式与协议不匹配": "Il formato dell'indirizzo non corrisponde al protocollo",
    "用户已绑定过提现地址": "L'utente ha già associato l'indirizzo di prelievo",
    "绑定提现地址成功": "Associazione dell'indirizzo di prelievo riuscita",
    "未设置地址": "Indirizzo non impostato",
    "您有一笔提现正在处理中": "Hai un prelievo in corso di elaborazione",
    "平台人工发起退款": "Il rimborso è stato avviato manualmente dalla piattaforma",
    "充值数量不能小于等于0": "La quantità di ricarica non può essere minore o uguale a 0",
    "请选择法币类型": "Seleziona il tipo di valuta legale",
    "充值金额超过最大金额": "L'importo di ricarica supera l'importo massimo",
    "充值金额小于最小金额": "L'importo di ricarica è inferiore all'importo minimo",
    "请选择正确的法币类型": "Seleziona il tipo di valuta legale corretto",
    "业务已锁定，请联系客服！": "Il servizio è bloccato, contatta il servizio clienti!",
    "无法购买本店商品": "Impossibile acquistare prodotti da questo negozio",
  },
  "tits_tr": {
    "添加失败": "Gönderilemedi. Lütfen daha sonra tekrar deneyiniz",
    "提交失败": "Gönderilemedi",
    "请输入正确的邮箱地址": "Lütfen doğru e-posta adresini girin",
    "已有未完成的贷款单，不能重复申请": "Zaten tamamlanmamış bir kredi siparişi var, tekrar başvurulamaz",
    "请输入关键字搜索": "Lütfen aramak için anahtar kelime giriniz",
    '参数缺失': "Parametre eksik",
    '充值数量必填': "Şarj miktarı gereklidir",
    "已提交评论!": "İnceleme gönderildi!",
    "未指定商家": "Belirtilmemiş iş",
    "系统错误": 'Sistem hatası',
    "该商品已下架": "Bu ürün kapalı",
    "该手机号已被占用，请绑定其他手机号":
      "Bu telefon numarası kullanılmaktadır, başka bir telefon numarası kebindin",
    "该邮箱已被占用，请更换其他邮箱注册":
      "Bu e-posta kullanılmaktadır, lütfen başka bir e-posta kullanın",
      "邮箱验证码发送次数过多，请明天再试": 
      "E-posta doğrulama kodu gönderme sayısı yüksek, lütfen dünün sonra tekrar deneyin",
    "当前账号有未完成的充值订单，请完成后再试": "Cari hesapta tamamlanmamış bir yükleme siparişi var, lütfen tamamlandıktan sonra tekrar deneyin",
    "当前账号有未完成的提现订单，请完成后再试": "Cari hesapta tamamlanmamış bir para çekme talimatı var, lütfen tamamlayın ve tekrar deneyin",
    "请先登录": "lütfen giriş yapın",
    "该角色账号不允许注销": "Bu karakter hesabının oturumu kapatmasına izin verilmiyor",
    "当前的用户账号与确认注销的账号不一致": "Mevcut kullanıcı hesabı, çıkış yapılması onaylanan hesapla tutarsız",
    "密码输入错误次数过多，请明天再试": "Çok fazla yanlış şifre girildi, lütfen yarın tekrar deneyin",
    "注销失败": "Çıkış başarısız oldu",
    "注销成功": "Çıkış başarılı",
    "当前用户已经被管理员禁用": "Geçerli kullanıcı, yönetici tarafından devre dışı bırakıldı",
    "地址不存在,或者已删除": "Adres mevcut değil veya silinmiş",
    "地址不能为空": "Adres boş olamaz",
    "地址过长": "adres çok uzun",
    "店家id不能为空": " Mağaza kimliği boş olamaz",
    "店家id错误": " Mağaza kimliği yanlış",
    "订单号不能为空": "Sipariş numarası boş olamaz",
    "非法请求": "yasa dışı istek",
    "购买失败,联系客服": "Satın alma başarısız oldu, müşteri hizmetleriyle iletişime geçin",
    "关注id不能为空": "Takip kimliği boş olamaz",
    "联系人不能为空": "Kişi boş olamaz",
    "两次输入的资金密码不相同": "İki kez girilen fon şifreleri farklı",
    "模块名不能为空": "Modül adı boş olamaz",
    "您的申请之前已提交过": "Başvurunuz daha önce sunuldu",
    "请上传图片格式的文件": "Lütfen resim formatında bir dosya yükleyin",
    "请勿重复添加": "tekrar tekrar eklemeyin",
    "取消失败": "İptal başarısız oldu",
    "删除失败": "silinemedi",
    "商品id不能为空": "Ürün kimliği boş olamaz",
    "商品id错误": "Ürün kimliği yanlış",
    "实名认证尚未通过，无法重置": "Gerçek ad kimlik doğrulaması geçilmedi ve sıfırlanamaz",
    "收藏id不能为空": "Koleksiyon kimliği boş olamaz",
    "收货失败": "makbuz hatası",
    "手机号不能为空": "Cep telefonu numarası boş geçilemez",
    "图片不能为空": "Resim boş olamaz",
    "图片大小不能超过30M": "Görüntü boyutu 30M'yi aşamaz",
    "用户已锁定": "kullanıcı kilitli",
    "正在购买": "alış",
    "该贷款单还未通过审核": "Kredi fişi onaylanmadı",
    "该贷款单号不存在": "Kredi numarası mevcut değil",
    "两次输入的密码不相同": "İki kez girilen şifreler farklı",
    "类型不能为空": "Tür boş olamaz",
    "操作失败！修正后账户余额小于0。": "operasyon başarısız! Düzeltmeden sonra, hesap bakiyesi 0'dan azdır.",
    "身份证号已实名过!": "Kimlik numarası doğrulandı!",
    "提款金额不得低于最小提款限额": "Para çekme tutarı minimum para çekme limitinden az olmamalıdır",
    "提款金额不得高于最大提款限额": "Para çekme tutarı, maksimum para çekme limitinden yüksek olamaz.",
    "超过提现次数": "Para çekme süreleri aşıldı",
    "不在提现时间范围内，请稍后再试": "Para çekme süresi aralığında değil, lütfen daha sonra tekrar deneyin.",
    "提币数量必填": "Para çekme tutarı gerekli",
    "提币数量输入错误，请输入浮点数": "Para çekme tutarı yanlış girildi, lütfen kayan noktalı bir sayı girin",
    "更新钱包失败，请联系客服": "Cüzdan güncellenemedi, lütfen müşteri hizmetleri ile iletişime geçin",
    "试用码不正确": "Deneme kodu yanlış",
    "已经提交申请，请等待审核": "Başvuru gönderildi, lütfen inceleme için bekleyin",
    "审核状态异常请联系客服": "İnceleme durumu anormal ise, lütfen müşteri hizmetleri ile iletişime geçin",
    "暂无用户": "Henüz kullanıcı yok",
    "系统无该用户，或者ip地址不正确": "Sistemde böyle bir kullanıcı yok veya ip adresi yanlış",
    "游客不能向游客发送消息": "Ziyaretçiler, ziyaretçilere mesaj gönderemez",
    "请选择收货地址": "Lütfen teslimat adresini seçin",
    "收货地址达上限": "Teslimat adresi üst sınıra ulaştı",
    "请设置资金密码": "Lütfen bir fon şifresi belirleyin",
    "该订单未满足支付条件": "Sipariş, ödeme koşullarını karşılamıyor",
    "密码输入错误次数过多，请明天再试": "Çok fazla yanlış şifre girildi, lütfen yarın tekrar deneyin",
    "操作失败，请稍后再试": "İşlem başarısız oldu, lütfen daha sonra tekrar deneyin",
    "部分商品已下架": "Bazı ürünler durduruldu",
    "邮箱的长度不能超过64个字符": "Posta kutusunun uzunluğu 64 karakterden fazla olamaz",
    "邮码不能超过32个字符": "Posta kodu 32 karakteri aşamaz",
    "操作类型不正确": "Yanlış işlem türü",
    "参数错误!": "Parametre hatası!",
    "不支持的语言": "desteklenmeyen dil",
    "收货人姓名不能超过64个字符": "Alıcı adı 64 karakterden fazla olamaz",
    "请输入正确的手机号码": "Lütfen doğru telefon numarasını girin",
    "操作频繁，请稍后再试": "Sık kullanım, lütfen daha sonra tekrar deneyin",
    "无此sellerGoods": "Böyle bir satıcı yokMallar",
    "退货失败": "dönüş başarısız oldu",
    "该订单状态无法操作": " Sipariş durumu çalıştırılamıyor",
    "订单已经发货，无法退款": "Sipariş gönderildi ve geri ödeme yapılamaz",
    "大于最大采购数量": "Maksimum satın alma miktarından fazla",
    "该邮箱已被订阅": "Bu posta kutusu zaten abone oldu",
    "登录过期，请重新登录": "Giriş süresi doldu. Lütfen tekrar giriş yapın",
    "系统错误，请稍后重试": "Sistem hatası. Lütfen daha sonra tekrar deneyiniz",
    "请稍后重试": "Lütfen daha sonra tekrar deneyiniz",
    "连续输入错误三次，请3分钟后再试": "Art arda üç kez hata girin. Lütfen 3 dakika sonra tekrar deneyin",
    "审核中": "İnceleme altında",
    "程序错误": "program hatası",
    "重复提交": "yeniden gönder",
    "用户名不能为空": "Kullanıcı adı boş olamaz",
    "验证码不能为空": "Doğrulama kodu boş olamaz.",
    "登录密码不能为空": "Oturum açma parolası boş olamaz",
    "登陆密码长度不符合设定": "Oturum açma parolası uzunluğu ayarla eşleşmiyor.",
    "资金密码长度不符合设定": "Fon parolasının uzunluğu ayar ile eşleşmiyor.",
    "登陆密码不符合设定": "Oturum açma parolası ayarla eşleşmiyor.",
    "资金密码不符合设定": "Fon şifresi ayara uymuyor.",
    "用户名不符合设定": "Kullanıcı adı ayarla eşleşmiyor",
    "用户名必须由数字和英文字母组成": "Kullanıcı adı rakam ve harflerden oluşmalıdır",
    "验证码不正确": "Yanlış doğrulama kodu",
    "密码不正确": "Yanlış parola",
    "服务器错误(500)": "Sunucu hatası(500)",
    "服务器错误": "Server hatası",
    "用户名重复": "Yinelenen kullanıcı adı",
    "找不到用户": "Kullanıcı bulunamadı",
    "不能为空": "Boş olamaz",
    "登录失败": "giriş başarısız oldu",
    "操作成功": "İşlem başarılı oldu",
    "工作地址不能为空": "İş adresi boş olamaz",
    "家庭地址不能为空": "Ev adresi boş olamaz",
    "亲属姓名不能为空": "Görelinin adı boş olamaz.",
    "亲属关系不能为空": "Aile içi ilişkiler sıfır olamaz.",
    "亲属地址不能为空": "Göreli adres boş olamaz.",
    "亲属电话不能为空": "Aile telefon numarası boş olamaz.",
    "用户名不存在": "Kullanıcı adı mevcut değil",
    "参数错误": "parametre hatası",
    "不在交易时段": "İşlem seansında değil",
    "存在不同杠杆的持仓单": "Farklı kaldıraca sahip tutma pozisyonları var",
    "余额不足": "Yetersiz bakiye",
    "可平仓合约张数不足": "Yetersiz sayıda kapalı pozisyon sözleşmesi",
    "请输入正确的货币数量": "Lütfen doğru para birimi miktarını girin",
    "请选择正确的币种": "Lütfen doğru para birimini seçin",
    "金额错误": "Tutar hatası.",
    "跟单参数输入错误": "Belge parametrelerinin yanlış girilmesi",
    "跟单倍数输入错误": "Birden çok belgenin yanlış girilmesi",
    "交易员不存在": "Tüccar mevcut değil.",
    "交易员未开启带单": "Tüccar faturayı açmadı.",
    "用户已跟随交易员": "Kullanıcı tüccarı takip etti",
    "交易员跟随人数已满": "Takip eden tacir sayısı dolu",
    "交易员不能跟随自己": "Tüccarlar kendilerini takip edemezler",
    "交易员无法跟随另一个交易员": "Tüccar başka bir tüccarı takip edemez",
    "历史基金无法购买": "Tarihi fonlar satın alınamaz",
    "该基金尚未开放购买": "Fon alıma açılmadı",
    "该基金尚已封闭": "fon kapatıldı",
    "基金剩余购买金额不足": "Fonun kalan alım tutarı yeterli değildir.",
    "订单不存在": "Sipariş mevcut değil",
    "下单不能小于最小金额限制": "Emir verme minimum miktar limitinden az olamaz.",
    "[symbol]参数为空": "[sembol] parametresi boş",
    "矿机不存在": "Maden makinesi mevcut değil",
    "矿机未解锁，无法购买": "Madencilik makinesi kilitlidir ve satın alınamaz.",
    "您已购买过体验矿机,不得重复购买": "Deneyim madenciliği makinesini satın aldınız. Tekrar satın almayın.",
    "买入金额需要在区间内": "Satın alma tutarı aralığında olmalıdır.",
    "行情获取异常，稍后再试": "Durum edinimi anormal. Lütfen daha sonra tekrar deneyiniz.",
    "广告不存在": "Reklam mevcut değil",
    "广告已下架": "Reklamlar kaldırıldı",
    "承兑商不存在": "Alıcı mevcut değil.",
    "请先添加收款方式": "Lütfen önce toplama yöntemini ekleyin",
    "您没有符合条件的收款方式": "Uygun toplama yönteminiz yok",
    "请选择买卖方式": "Lütfen işlem yöntemini seçin",
    "请输入正确的金额": "Lütfen doğru miktarı girin",
    "请输入正确的数量": "Lütfen doğru miktarı girin",
    "该广告剩余数量不足": "Yetersiz sayıda reklam kaldı",
    "金额不在购买区间": "Tutar, satın alma aralığında değil.",
    "用户剩余数量不足": "Yetersiz sayıda kullanıcı kaldı",
    "请稍后再试": "Lütfen daha sonra tekrar deneyiniz",
    "未找到符合条件的匹配订单": "Eşleşen sipariş bulunamadı",
    "该订单已取消": "Bu sipariş iptal edildi",
    "当前订单不为待付款状态，无法取消": "Mevcut sipariş, bekleyen ödeme durumunda değil. İptal edilemez.",
    "卖方无法取消该订单": "Satıcı siparişi iptal edemez",
    "资金密码错误": "fon şifre hatası",
    "订单已完成": "sipariş tamamlandı",
    "订单已取消": "Sipariş iptal edildi",
    "待付款的订单无法放行": "Ödeme bekleyen siparişler serbest bırakılamaz",
    "订单已完成，无法放行": "Sipariş tamamlandı ve serbest bırakılamaz",
    "订单已取消，无法放行": "Sipariş iptal edildi ve serbest bırakılamaz",
    "未授权访问": "Yetkisiz Erişim",
    "图片大小不能超过2M！": "Resim boyutu 2M'yi aşamaz!",
    "参数异常，消息获取失败": "Parametre hatası, mesaj alımı başarısız oldu",
    "无效的UID": "Geçersiz UID",
    "用户不存在": "Kullanıcı yok",
    "图片上传失败": "resim yüklenemedi",
    "请输入内容": "Lütfen içeriği girin",
    "图片不得大于2M": "Resim 2M'den büyük olmayacaktır",
    "图片不得大于10M": "Resim 10M'den büyük olmayacaktır",
    "直线关系，不能修改推荐": "Düz çizgi ilişkisi, öneri değiştirilemez",
    "存在重复的角色名称": "Yinelenen rol adı",
    "角色被用户关联，不可删除": "Rol, kullanıcı tarafından ilişkilendirilir. Silinemez.",
    "系统存在相同[系统登录名]！": "Sistem aynı [Sistem Oturum Açma Adı] olarak mevcut!",
    "旧密码不正确": "Yanlış eski şifre",
    "没有找到用户": "Kullanıcı bulunamadı",
    "[code]值错误": "[kod] değeri yanlış",
    "身份证已实名过!": "Kimlik kartı doğrulandı!",
    "实名认证未通过，无法进行高级认证": "Gerçek ad sertifikası başarısız oldu. Gelişmiş sertifika mevcut değil.",
    "收款方输入错误": "Alacaklı hatasını girin",
    "所选汇率不存在": "Seçilen döviz kuru mevcut değil",
    "转账数量不能小于等于0": "Aktarım miktarı 0'dan küçük veya ona eşit olamaz",
    "UID不能为空": "UID boş olamaz",
    "转账币种不能为空": "Transfer para birimi boş olamaz.",
    "资金密码不能为空": "Fon şifresi boş olamaz.",
    "提现不得小于限额": "Nakit çekme limitinden az olamaz",
    "提现不得大于限额": "Nakit çekme limitinden fazla olamaz",
    "当日可提现次数不足": "İçinde bulunduğumuz günkü vaka geri çekme sayısı yeterli değil.",
    "不在可提现时间内": "Geri çekilme süresi içinde değil",
    "渠道未开通": "kanal açılmadı",
    "提币数量不能小于等于0": "Para çekme miktarı 0'dan küçük veya eşit olamaz.",
    "无权限": "izin yokmu",
    "请先通过高级认证": "Lütfen önce gelişmiş sertifikayı geçin",
    "请输入搜索关键字": "Lütfen arama anahtar kelimelerini girin",
    "角色不存在": "rol mevcut değil",
    "持有币种不足": "Yetersiz tutma para birimi",
    "提交失败，当前有未处理订单": "Gönderim başarısız oldu. Şu anda açık siparişler var.",
    "充值链错误": "Şarj zinciri hatası",
    "充值价值不得小于最小限额": "Şarj değeri minimum limitin altında olmamalıdır.",
    "充值价值不得大于最大限额": "Şarj değeri maksimum sınırdan büyük olmamalıdır",
    "充值数量不能小于等于0": "Şarj miktarı 0'dan küçük veya ona eşit olamaz",
    "请输入充值币种": "Lütfen yükleme para birimini girin",
    "请上传图片": "Lütfen resim yükleyin",
    "当前还需交易": "İşlem hala gerekli",
    ",才可提币": ", ardından para çekme işlemi yapılabilir.",
    "提示": "İpuçları",
    "未实名认证，是否认证？": "Gerçek isimle doğrulanmadı. Kimlik doğrulansın mı?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Hesap istisnası, C3 kimlik doğrulaması gerektirir. Lütfen çevrimiçi müşteri hizmetleri ile iletişime geçin.",
    "确认": "Doğrulama",
    "取消": "İptal etmek",
    "更新提醒": "Güncelleme hatırlatıcısı",
    "发现新版本，请升级到最新版本": "Yeni sürüm bulundu, lütfen en son sürüme yükseltin",
    "请检查网络连接": "Lütfen ağ bağlantınızı kontrol edin",
    "您已存在订单": "Zaten bir siparişiniz var",
    "当前地址格式错误": "Geçerli adres biçim hatası",
    "申购数量错误": "Abonelik miktarı hatası",
    "产品不存在": "Ürün mevcut değil",
    "该产品未上架": "Bu ürün listelenmemiş",
    "该产品已上市，无法购买": "Bu ürün piyasada ve satın alınamaz",
    "当日才可申购": "Satın alma sadece aynı gün satın alınabilir.",
    "产品剩余数量不足": "Yetersiz ürün miktarı kaldı",
    "您当前可分配额度不足": "Mevcut tahsis edilebilir limitiniz yeterli değil",
    "购买矿机时间不得低于托管订单剩余时间": "Maden makinesi alım süresi, saklama emrinin kalan süresinden az olamaz",
    "推荐码不正确": "Öneri kodu yanlış.",
    "推荐人无权限推荐": "Tavsiye edenin tavsiye etme yetkisi yoktur.",
    "审核已通过": "İnceleme geçti",
    "请填写正确的验证码": "Lütfen doğru doğrulama kodunu girin",
    "请填写正确的电话号码": "Lütfen doğru telefon numarasını giriniz",
    "请填写正确的邮箱地址": "Lütfen doğru e-posta adresini girin",
    "电话号码已绑定": "Telefon numarası zaten bağlı",
    "电话号码已绑定其他用户": "Telefon numarası başka bir kullanıcıya bağlı",
    "邮箱已绑定": "Posta kutusu zaten bağlı",
    "邮箱已绑定其他用户": "Posta kutusu zaten başka bir kullanıcıya bağlı",
    "页码不是整数": "Sayfa numarası bir tamsayı değil",
    "页码不能小于等于0": "Sayfa numarası 0'dan küçük veya eşit olamaz",
    "请输入正确的质押金额": "Lütfen doğru katkı miktarını girin",
    "请输入正确的质押天数": "Lütfen katkı günlerini doğru girin",
    "未发现授权记录": "Yetkilendirme kaydı bulunamadı",
    "授权状态未成功": "Yetkilendirme durumu başarısız oldu",
    "赎回状态异常": "Kullanım durumu anormal",
    "申请成功": "Başvuru başarılı",
    "领取成功": "Alma başarılı",
    "未找到匹配的收益记录": "Eşleşen gelir kaydı bulunamadı",
    "已领取": "Kabul edilmiş",
    "校验IP不合法": "Doğrulama IP'si geçersiz.",
    "委托数量(张)必填": "Emanet edilen miktar (adet) gereklidir",
    "委托数量(张)不能小于等于0": "Emanet edilen miktar (adet) 0'dan küçük veya eşit olamaz.",
    "请先绑定谷歌验证器": "Lütfen önce Google Authenticator'ı bağlayın",
    "资金密码必须6-12位": "Fon şifresi 6-12 haneli olmalıdır.",
    "验证码错误": "Doğrulama kodu hatası",
    "登录密码必须6-12位": "Giriş şifresi 6-12 haneli olmalıdır",
    "密码不能为空": "Parola boş olamaz",
    "密码必须6-12位": "Şifre 6-12 haneli olmalıdır",
    "验证类型不能为空": "Kimlik doğrulama türü boş olamaz",
    "未绑定手机号": "Telefon numarası bağlı değil",
    "未绑定邮箱": "Hiçbir posta kutusu bağlı değil",
    "未绑定谷歌验证器": "Google doğrulayıcı bağlı değil",
    "旧密码不能为空": "Eski şifre boş olamaz",
    "新密码不能为空": "Yeni parola boş olamaz.",
    "新密码确认不能为空": "Yeni şifre onayı boş olamaz.",
    "新密码不一致": "Yeni şifre orijinal giriş ile aynı değil",
    "操作类型为空": "İşlem türü boş",
    "操作类型不是整数": "İşlem türü bir tamsayı değil",
    "操作类型不能小于0": "İşlem türü 0'dan küçük olamaz",
    "用户名参数为空": "Kullanıcı adı parametresi boş",
    "状态不是整数": "Durum bir tamsayı değil",
    "状态不能小于0": "Durum 0'dan küçük olamaz",
    "系统参数错误": "Sistem parametresi hatası",
    "-连接已建立-": "-Bağlantı kuruldu-",
    "代理层级错误": "Aracı düzeyinde hata",
    "请重新登录": "Lütfen tekrar giriş yapın",
    "暂无店铺": "Mağaza yok",
    "地址格式与协议不匹配": "Adres biçimi protokol ile eşleşmiyor",
    "用户已绑定过提现地址": "Kullanıcı zaten para çekme adresine bağlı",
    "绑定提现地址成功": "Para çekme adresi başarıyla bağlandı",
    "未设置地址": "Adres ayarlanmadı",
    "您有一笔提现正在处理中": "Bir para çekme işleminiz işleniyor",
    "平台人工发起退款": "Platform manuel olarak geri ödeme yapar",
    "充值数量不能小于等于0": "Yatırım miktarı 0'dan küçük veya eşit olamaz",
    "请选择法币类型": "Lütfen para birimi türünü seçin",
    "充值金额超过最大金额": "Yatırım miktarı maksimum miktarı aşıyor",
    "充值金额小于最小金额": "Yatırım miktarı minimum miktarın altında",
    "请选择正确的法币类型": "Lütfen doğru para birimi türünü seçin",
    "业务已锁定，请联系客服！": "İşlem kilitlendi, lütfen müşteri hizmetleri ile iletişime geçin!",
    "无法购买本店商品": "Bu mağazanın ürünü satın alınamaz",
  },
  "tits_ph": {
    '参数缺失': "Nawawala ang parameter",
    '充值数量必填': "Ang dami ng pag-recharge ay kinakailangan",
    "平台人工发起退款": "Ang platform ay manu-manong nagpapasimula ng refund",
    "已提交评论!": "Naisumite ang komento",
    "该商品已下架": "Hindi nakikilalang ang produkto",
    "该邮箱已被占用，请更换其他邮箱注册": 
      "Ang email na ito ay nakakakilalang, lumagawa ng iyong mga email sa loob ngpag-register",
      "该手机号已被占用，请绑定其他手机号":
      "Ang mobile na ito ay nakakakilalang, lumagawa ng iyong mga mobile sa loob ngpag-register",
    "未指定商家": "Hindi natukoy na negosyo",
    "邮箱验证码发送次数过多，请明天再试":
      "Ang email verification code ay naipadala nang masyadong maraming beses, pakisubukang muli bukas.",
    "当前账号有未完成的充值订单，请完成后再试": "Ang kasalukuyang account ay may hindi natapos na order ng recharge, pakisubukang muli pagkatapos makumpleto",
    "当前账号有未完成的提现订单，请完成后再试": "Ang kasalukuyang account ay may hindi natapos na order sa pag-withdraw, mangyaring kumpletuhin ito at subukang muli",
    "请先登录": "paki log in muna",
    "该角色账号不允许注销": "Hindi pinapayagan ng account na ito ang pag-logout",
    "当前的用户账号与确认注销的账号不一致": "Ang kasalukuyang user account ay hindi naaayon sa account na nakumpirmang nakansela",
    "密码输入错误次数过多，请明天再试": "Masyadong maraming maling password ang inilagay, pakisubukang muli bukas",
    "注销失败": "Nabigo ang pag-logout",
    "注销成功": "matagumpay ang pag-logout",
    "当前用户已经被管理员禁用": "Ang kasalukuyang user ay hindi pinagana ng administrator",
    "地址不存在,或者已删除": "Ang address ay hindi umiiral, o tinanggal na",
    "地址不能为空": "Hindi maaaring walang laman ang address",
    "地址过长": "masyadong mahaba ang address",
    "参数异常，消息获取失败": "Pagbubukod ng parameter, nabigo ang pagkuha ng mensahe",
    "店家id不能为空": "Hindi maaaring walang laman ang store id",
    "店家id错误": "Mali ang store id",
    "订单号不能为空": "Hindi maaaring walang laman ang numero ng order",
    "非法请求": "ilegal na kahilingan",
    "购买失败,联系客服": "Nabigo ang pagbili, makipag-ugnayan sa customer service",
    "关注id不能为空": "Hindi maaaring walang laman ang follow id",
    "联系人不能为空": "Hindi maaaring walang laman ang contact",
    "两次输入的资金密码不相同": "Magkaiba ang mga password ng pondo na dalawang beses na ipinasok",
    "模块名不能为空": "Hindi maaaring walang laman ang pangalan ng module",
    "您的申请之前已提交过": "Ang iyong aplikasyon ay naisumite na dati",
    "请上传图片格式的文件": "Mangyaring mag-upload ng file sa format ng larawan",
    "请勿重复添加": "Huwag magdagdag ng paulit-ulit",
    "取消失败": "Nabigo ang pagkansela",
    "删除失败": "nabigong tanggalin",
    "商品id不能为空": "Hindi maaaring walang laman ang product id",
    "商品id错误": "Mali ang product id",
    "实名认证尚未通过，无法重置": "Ang tunay na pangalan na pagpapatotoo ay hindi naipasa at hindi na mai-reset",
    "收藏id不能为空": "Hindi maaaring walang laman ang collection id",
    "收货失败": "Nabigo ang resibo",
    "手机号不能为空": "Hindi maaaring walang laman ang numero ng mobile phone",
    "图片不能为空": "Hindi maaaring walang laman ang larawan",
    "图片大小不能超过30M": "Ang laki ng larawan ay hindi maaaring lumampas sa 30M",
    "用户已锁定": "naka-lock ang user",
    "正在购买": "pagbili",
    "该贷款单还未通过审核": "Ang loan slip ay hindi naaprubahan",
    "该贷款单号不存在": "Ang numero ng pautang ay hindi umiiral",
    "两次输入的密码不相同": "Magkaiba ang mga password na ipinasok nang dalawang beses",
    "类型不能为空": "Hindi maaaring walang laman ang uri",
    "操作失败！修正后账户余额小于0。": "Nabigo ang operasyon! Pagkatapos ng pagwawasto, ang balanse ng account ay mas mababa sa 0.",
    "身份证号已实名过!": "Na-verify na ang ID number!",
    "提款金额不得低于最小提款限额": "Ang halaga ng withdrawal ay hindi dapat mas mababa sa minimum na limitasyon sa withdrawal",
    "提款金额不得高于最大提款限额": "Ang halaga ng withdrawal ay hindi maaaring mas mataas kaysa sa maximum na limitasyon ng withdrawal",
    "超过提现次数": "Lumampas ang mga oras ng pag-withdraw",
    "不在提现时间范围内，请稍后再试": "Wala sa saklaw ng oras ng pag-withdraw, pakisubukang muli sa ibang pagkakataon",
    "提币数量必填": "Kinakailangan ang halaga ng withdrawal",
    "提币数量输入错误，请输入浮点数": "Ang halaga ng pag-withdraw ay nailagay nang mali, mangyaring magpasok ng numero ng floating point",
    "更新钱包失败，请联系客服": "Nabigong i-update ang wallet, mangyaring makipag-ugnayan sa customer service",
    "试用码不正确": "Mali ang trial code",
    "已经提交申请，请等待审核": "Naisumite na ang aplikasyon, mangyaring maghintay para sa pagsusuri",
    "审核状态异常请联系客服": "Kung abnormal ang status ng pagsusuri, mangyaring makipag-ugnayan sa customer service",
    "暂无用户": "Wala pang gumagamit",
    "系统无该用户，或者ip地址不正确": "Walang ganoong user sa system, o hindi tama ang ip address",
    "游客不能向游客发送消息": "Ang mga bisita ay hindi maaaring magpadala ng mga mensahe sa mga bisita",
    "请选择收货地址": "Mangyaring pumili ng address ng paghahatid",
    "收货地址达上限": "Naabot na ng address ng paghahatid ang pinakamataas na limitasyon",
    "请设置资金密码": "Mangyaring magtakda ng password ng pondo",
    "该订单未满足支付条件": "Ang order ay hindi nakakatugon sa mga kondisyon ng pagbabayad",
    "操作失败，请稍后再试": "Nabigo ang operasyon, pakisubukang muli sa ibang pagkakataon",
    "部分商品已下架": "Ang ilang mga produkto ay hindi na ipinagpatuloy",
    "邮箱的长度不能超过64个字符": "Ang haba ng mailbox ay hindi maaaring lumampas sa 64 na mga character",
    "邮码不能超过32个字符": "Ang zip code ay hindi maaaring lumampas sa 32 character",
    "操作类型不正确": "Maling uri ng operasyon",
    "参数错误!": "Error sa parameter!",
    "不支持的语言": "hindi suportadong wika",
    "收货人姓名不能超过64个字符": "Hindi maaaring lumampas sa 64 na character ang pangalan ng consignee",
    "请输入正确的手机号码": "Pakilagay ang tamang numero ng telepono",
    "无此sellerGoods": "Walang ganoong sellerGoods",
    "退货失败": "nabigo ang pagbabalik",
    "该订单状态无法操作": "Ang katayuan ng order ay hindi maaaring patakbuhin",
    "订单已经发货，无法退款": "Naipadala na ang order at hindi na maibabalik",
    "添加失败": "Nabigo ang pagsusumite, pakisubukang muli sa ibang pagkakataon",
    "提交失败": "Nabigo ang pagsusumite",
    "暂无店铺": "Wala pang tindahan",
    "请输入正确的邮箱地址": "Mangyaring ilagay ang tamang email address",
    "已有未完成的贷款单，不能重复申请": "Mayroon nang hindi natapos na mga order ng pautang, at hindi pinapayagan ang mga paulit-ulit na aplikasyon",
    "大于最大采购数量": "Higit sa maximum na dami ng pagbili",
    "该邮箱已被订阅": "Ang mailbox na ito ay naka-subscribe",
    "请输入关键字搜索": "Mangyaring magpasok ng mga keyword na hahanapin",
    "登录过期，请重新登录": "Nag-expire ang pag-login, mangyaring mag-log in muli",
    "系统错误，请稍后重试": "Error sa system, pakisubukang muli sa ibang pagkakataon",
    "请稍后重试": "Subukang muli mamaya",
    "连续输入错误三次，请3分钟后再试": "Maling naipasok nang tatlong beses na magkakasunod, pakisubukang muli sa loob ng 3 minuto",
    "审核中": "nasa ilalim ng pagsusuri",
    "程序错误": "error sa programa",
    "重复提交": "paulit-ulit na pagsusumite",
    "用户名不能为空": "Hindi maaaring walang laman ang username",
    "验证码不能为空": "dapat punan ang verification code",
    "登录密码不能为空": "Hindi maaaring walang laman ang password sa pag-login",
    "登陆密码长度不符合设定": "Ang haba ng login password ay hindi nakakatugon sa mga setting",
    "资金密码长度不符合设定": "Ang haba ng password ng pondo ay hindi nakakatugon sa setting",
    "登陆密码不符合设定": "Ang login password ay hindi tumutugma sa mga setting",
    "资金密码不符合设定": "Ang password ng pondo ay hindi tumutugma sa setting",
    "用户名不符合设定": "Hindi tumutugma ang username sa mga setting",
    "用户名必须由数字和英文字母组成": "Ang username ay dapat na binubuo ng mga numero at English na titik",
    "验证码不正确": "Maling verification code",
    "密码不正确": "Maling password",
    "服务器错误(500)": "error sa server (500)",
    "服务器错误": "Error sa Server",
    "用户名重复": "duplicate na username",
    "找不到用户": "hindi nahanap ang user",
    "不能为空": "Hindi maaaring walang laman",
    "登录失败": "Hindi tagumpay ang pag-login",
    "操作成功": "Matagumpay na operasyon",
    "操作频繁，请稍后再试": "Madalas na operasyon, pakisubukang muli sa ibang pagkakataon",
    "工作地址不能为空": "Hindi maaaring walang laman ang address ng trabaho",
    "家庭地址不能为空": "Hindi maaaring walang laman ang address ng tahanan",
    "亲属姓名不能为空": "Hindi maaaring walang laman ang kaugnay na pangalan",
    "亲属关系不能为空": "Hindi maaaring walang laman ang relasyon",
    "亲属地址不能为空": "Hindi maaaring walang laman ang kaugnay na address",
    "亲属电话不能为空": "Hindi maaaring walang laman ang kaugnay na numero ng telepono",
    "用户名不存在": "Ang username ay wala",
    "参数错误": "Error sa parameter",
    "不在交易时段": "wala sa oras ng pangangalakal",
    "存在不同杠杆的持仓单": "May mga position order na may iba't ibang leverage",
    "余额不足": "Hindi sapat na balanse",
    "可平仓合约张数不足": "Hindi sapat na bilang ng mga liquidable na kontrata",
    "请输入正确的货币数量": "Pakipasok ang tamang halaga ng pera",
    "请选择正确的币种": "Mangyaring piliin ang tamang pera",
    "金额错误": "maling halaga",
    "跟单参数输入错误": "Kopyahin ang error sa input ng parameter",
    "跟单倍数输入错误": "Documentation maramihang input error",
    "交易员不存在": "ang mangangalakal ay wala",
    "交易员未开启带单": "Hindi pa binuksan ng negosyante ang order",
    "用户已跟随交易员": "Sinundan ng user ang isang negosyante",
    "交易员跟随人数已满": "Ang bilang ng mga mangangalakal na sumusunod ay puno na",
    "交易员不能跟随自己": "hindi maaaring sundin ng mga mangangalakal ang kanilang sarili",
    "交易员无法跟随另一个交易员": "Ang isang mangangalakal ay hindi maaaring sumunod sa isa pang mangangalakal",
    "历史基金无法购买": "Hindi mabibili ang mga makasaysayang pondo",
    "该基金尚未开放购买": "Ang pondo ay hindi pa bukas para sa pagbili",
    "该基金尚已封闭": "Ang pondo ay sarado",
    "基金剩余购买金额不足": "Hindi sapat na pondo ang natitirang halaga ng pagbili",
    "订单不存在": "walang order",
    "下单不能小于最小金额限制": "Ang order ay hindi maaaring mas mababa sa minimum na limitasyon sa halaga",
    "[symbol]参数为空": "Walang laman ang parameter ng [symbol].",
    "矿机不存在": "Ang minero ay wala",
    "矿机未解锁，无法购买": "Ang makina ng pagmimina ay hindi naka-unlock at hindi mabibili",
    "您已购买过体验矿机,不得重复购买": "Nakabili ka na ng karanasan sa pagmimina at hindi na makakabili muli",
    "买入金额需要在区间内": "Ang halaga ng pagbili ay kailangang nasa saklaw",
    "行情获取异常，稍后再试": "Mga abnormal na kundisyon ng market, subukang muli sa ibang pagkakataon",
    "广告不存在": "Walang ad",
    "广告已下架": "Inalis ang ad",
    "承兑商不存在": "Ang Acceptor ay wala",
    "请先添加收款方式": "Mangyaring magdagdag muna ng paraan ng pagbabayad",
    "您没有符合条件的收款方式": "Wala kang karapat-dapat na paraan ng pagbabayad",
    "请选择买卖方式": "Mangyaring pumili ng paraan ng pangangalakal",
    "请输入正确的金额": "Pakilagay ang tamang halaga",
    "请输入正确的数量": "Pakilagay ang tamang dami",
    "该广告剩余数量不足": "Walang sapat na natitirang mga ad para sa ad na ito",
    "金额不在购买区间": "Ang halaga ay wala sa hanay ng pagbili",
    "用户剩余数量不足": "Hindi sapat na bilang ng mga natitirang user",
    "请稍后再试": "Subukang muli mamaya",
    "未找到符合条件的匹配订单": "Walang nakitang katugmang order",
    "该订单已取消": "Kinansela ang order na ito",
    "当前订单不为待付款状态，无法取消": "Ang kasalukuyang order ay hindi nakabinbing pagbabayad at hindi maaaring kanselahin",
    "卖方无法取消该订单": "Hindi maaaring kanselahin ng nagbebenta ang order",
    "资金密码错误": "Error sa password ng pondo",
    "订单已完成": "natapos ang order",
    "订单已取消": "nakansela ang order",
    "待付款的订单无法放行": "Hindi mailalabas ang order na nakabinbing bayad",
    "订单已完成，无法放行": "Nakumpleto na ang order at hindi na mailalabas",
    "订单已取消，无法放行": "Ang order ay kinansela at hindi maaaring ilabas",
    "未授权访问": "hindi awtorisadong pag-access",
    "图片大小不能超过2M！": "Ang laki ng larawan ay hindi maaaring lumampas sa 2M!",
    "无效的UID": "di-wastong UID",
    "用户不存在": "Walang gumagamit",
    "图片上传失败": "Nabigo ang pag-upload ng larawan",
    "请输入内容": "Mangyaring magpasok ng nilalaman",
    "图片不得大于2M": "Ang larawan ay hindi dapat mas malaki sa 2M",
    "图片不得大于10M": "Ang larawan ay hindi dapat mas malaki sa 10M",
    "直线关系，不能修改推荐": "Straight line na relasyon, hindi mababago Inirerekomenda",
    "存在重复的角色名称": "May mga duplicate na pangalan ng tungkulin",
    "角色被用户关联，不可删除": "Ang tungkulin ay nauugnay sa user at hindi matatanggal",
    "系统存在相同[系统登录名]！": "Ang system ay umiiral na may parehong [system login name]!",
    "旧密码不正确": "Ang lumang password ay hindi tama",
    "没有找到用户": "walang nahanap na user",
    "[code]值错误": "[code] maling halaga",
    "身份证已实名过!": "Na-verify na ang ID card!",
    "实名认证未通过，无法进行高级认证": "Nabigo ang real-name authentication, hindi nagawang magsagawa ng advanced na authentication",
    "收款方输入错误": "Error sa pag-input ng nagbabayad",
    "所选汇率不存在": "Ang napiling halaga ng palitan ay hindi umiiral",
    "转账数量不能小于等于0": "Ang halaga ng paglilipat ay hindi maaaring mas mababa sa o katumbas ng 0",
    "UID不能为空": "Hindi maaaring walang laman ang UID",
    "转账币种不能为空": "Ang paglipat ng pera ay hindi maaaring walang laman",
    "资金密码不能为空": "Hindi maaaring walang laman ang password ng pondo",
    "提现不得小于限额": "Ang pag-withdraw ay hindi dapat mas mababa sa limitasyon",
    "提现不得大于限额": "Ang pag-withdraw ay hindi maaaring lumampas sa limitasyon",
    "当日可提现次数不足": "Hindi sapat na bilang ng mga cash withdrawal bawat araw",
    "不在可提现时间内": "Hindi sa loob ng withdrawal time",
    "渠道未开通": "hindi bukas ang channel",
    "提币数量不能小于等于0": "Ang halaga ng pag-withdraw ay hindi maaaring mas mababa sa o katumbas ng 0",
    "无权限": "Walang pahintulot",
    "请先通过高级认证": "Mangyaring ipasa muna ang advanced na sertipikasyon",
    "请输入搜索关键字": "Mangyaring ipasok ang iyong mga keyword sa paghahanap",
    "角色不存在": "ang papel ay wala",
    "持有币种不足": "Hindi sapat na mga hawak ng pera",
    "提交失败，当前有未处理订单": "Nabigo ang pagsusumite, may kasalukuyang hindi naprosesong mga order",
    "充值链错误": "Error sa recharge chain",
    "充值价值不得小于最小限额": "Ang halaga ng top-up ay hindi dapat mas mababa sa minimum na limitasyon",
    "充值价值不得大于最大限额": "Ang halaga ng top-up ay hindi maaaring lumampas sa maximum na limitasyon",
    "充值数量不能小于等于0": "Ang halaga ng recharge ay hindi maaaring mas mababa sa o katumbas ng 0",
    "请输入充值币种": "Mangyaring ilagay ang recharge na pera",
    "请上传图片": "Mangyaring mag-upload ng isang larawan",
    "当前还需交易": "Kailangan pang mag-trade",
    ",才可提币": ", para mag-withdraw ng mga barya",
    "提示": "pahiwatig",
    "未实名认证，是否认证？": "Walang real-name authentication, gusto mo bang magpa-authenticate?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Ang mga pagbubukod sa account ay nangangailangan ng pagpapatunay ng C3, mangyaring makipag-ugnayan sa online na serbisyo sa customer.",
    "确认": "kumpirmahin",
    "取消": "Kanselahin",
    "更新提醒": "i-update ang paalala",
    "发现新版本，请升级到最新版本": "May nakitang bagong bersyon, mangyaring mag-upgrade sa pinakabagong bersyon",
    "请检查网络连接": "Pakisuri ang koneksyon sa network",
    "您已存在订单": "May order ka na",
    "当前地址格式错误": "Ang kasalukuyang address ay nasa maling format",
    "申购数量错误": "Error sa dami ng pagbili",
    "产品不存在": "wala ang produkto",
    "该产品未上架": "Hindi available ang produktong ito",
    "该产品已上市，无法购买": "Nakalista na ang produktong ito at hindi mabibili",
    "当日才可申购": "Available lang para bilhin sa parehong araw",
    "产品剩余数量不足": "Ang natitirang dami ng produkto ay hindi sapat",
    "您当前可分配额度不足": "Ang iyong kasalukuyang alokasyon ay hindi sapat",
    "购买矿机时间不得低于托管订单剩余时间": "Ang oras para bumili ng mga mining machine ay hindi dapat mas mababa sa natitirang oras ng hosting order",
    "推荐码不正确": "Mali ang referral code",
    "推荐人无权限推荐": "Ang nagrerekomenda ay walang awtoridad na magrekomenda",
    "审核已通过": "Pasado ang audit",
    "请填写正确的验证码": "Pakipasok ang tamang verification code",
    "请填写正确的电话号码": "Mangyaring punan ang tamang numero ng telepono",
    "请填写正确的邮箱地址": "Mangyaring punan ang tamang email address",
    "电话号码已绑定": "Ang numero ng telepono ay nakatali",
    "电话号码已绑定其他用户": "Ang numero ng telepono ay nakatali sa ibang user",
    "邮箱已绑定": "Nakatali ang email",
    "邮箱已绑定其他用户": "Ang mailbox ay nakatali sa ibang user",
    "页码不是整数": "Ang numero ng pahina ay hindi isang integer",
    "页码不能小于等于0": "Ang numero ng pahina ay hindi maaaring mas mababa sa o katumbas ng 0",
    "请输入正确的质押金额": "Pakilagay ang tamang halaga ng pledge",
    "请输入正确的质押天数": "Pakilagay ang tamang mga araw ng pledge",
    "未发现授权记录": "Hindi nakita ang rekord ng pahintulot",
    "授权状态未成功": "Nabigo ang Katayuan ng Pagpapahintulot",
    "赎回状态异常": "Abnormal na katayuan sa pagtubos",
    "申请成功": "matagumpay na aplikasyon",
    "领取成功": "Tumanggap ng tagumpay",
    "未找到匹配的收益记录": "Walang nakitang katugmang tala ng kita",
    "已领取": "natanggap",
    "校验IP不合法": "Di-wasto ang verification IP",
    "委托数量(张)必填": "Pinagkatiwalaang Dami (Mga Piraso) Kinakailangan",
    "委托数量(张)不能小于等于0": "Ang bilang ng mga komisyon (mga piraso) ay hindi maaaring mas mababa sa o katumbas ng 0",
    "请先绑定谷歌验证器": "Pakibigkis muna ang Google Authenticator",
    "资金密码必须6-12位": "Ang password ng pondo ay dapat na 6-12 character",
    "验证码错误": "Error sa verification code",
    "登录密码必须6-12位": "Dapat na 6-12 character ang login password",
    "密码不能为空": "hindi maaaring blangko ang password",
    "密码必须6-12位": "Ang password ay dapat na 6-12 character",
    "验证类型不能为空": "Ang uri ng pagpapatunay ay hindi maaaring walang laman",
    "未绑定手机号": "Hindi nakatali na numero ng mobile phone",
    "未绑定邮箱": "Hindi nakatali na mailbox",
    "未绑定谷歌验证器": "Unbound Google Authenticator",
    "旧密码不能为空": "Hindi maaaring walang laman ang lumang password",
    "新密码不能为空": "Hindi maaaring walang laman ang bagong password",
    "新密码确认不能为空": "Hindi maaaring walang laman ang bagong kumpirmasyon ng password",
    "新密码不一致": "Hindi tugma ang bagong password",
    "操作类型为空": "Walang laman ang uri ng operasyon",
    "操作类型不是整数": "ang uri ng operasyon ay hindi integer",
    "操作类型不能小于0": "Ang uri ng operasyon ay hindi maaaring mas mababa sa 0",
    "用户名参数为空": "Walang laman ang parameter ng username",
    "状态不是整数": "ang status ay hindi isang integer",
    "状态不能小于0": "Hindi maaaring mas mababa sa 0 ang katayuan",
    "系统参数错误": "Error sa parameter ng system",
    "-连接已建立-": "- naitatag ang koneksyon",
    "代理层级错误": "Error sa antas ng proxy",
    "请重新登录": "mangyaring mag-login muli",
    "地址格式与协议不匹配": "Ang format ng address ay hindi tumutugma sa protocol",
    "用户已绑定过提现地址": "Itinali ng user ang withdrawal address",
    "绑定提现地址成功": "Ang binding withdrawal address ay matagumpay",
    "未设置地址": "Hindi naitakda ang address",
    "您有一笔提现正在处理中": "Mayroon kang kasalukuyang withdrawal",
    "请选择法币类型": "Pakipili ang uri ng fiat",
    "充值金额超过最大金额": "Ang halaga ng pagpapadala ay mas mataas sa maximum amount",
    "充值金额小于最小金额": "Ang halaga ng pagpapadala ay mas mababa sa minimum amount",
    "请选择正确的法币类型": "Pakipili ang tamang uri ng fiat",
    "业务已锁定，请联系客服！": "Ang negosyo ay nakakandado, mangyaring makipag-ugnayan sa customer service!",
    "无法购买本店商品": "Hindi mabibili ang mga produkto sa tindahan",
  },
  "tits_ar": {
    "店家id不能为空": "معرّف التاجر لا يمكن أن يكون فارغًا",
    "店家id错误": "خطأ في معرّف التاجر",
    "关注id不能为空": "معرّف المتابعة لا يمكن أن يكون فارغًا",
    "商品id不能为空": "معرّف المنتج لا يمكن أن يكون فارغًا",
    "商品id错误": "خطأ في معرّف المنتج",
    "收藏id不能为空": "معرّف المفضلة لا يمكن أن يكون فارغًا",
    "系统无该用户，或者ip地址不正确": "لا يوجد هذا المستخدم في النظام، أو عنوان IP غير صحيح",
    "邮码不能超过32个字符": "الرمز البريدي لا يمكن أن يتجاوز 32 حرفًا",
    "请输入关键字搜索": "الرجاء إدخال الكلمة للبحث",
    "登陆密码长度不符合设定": "كلمة مرور خاطئة",
    "资金密码长度不符合设定": "لا يتطابق طول كلمة المرور مع الإعدادات",
    "登陆密码不符合设定": "كلمة مرور خاطئة",
    "服务器错误(500)": "خطأ في الخادم (500)",
    "找不到用户": "لم يتم العثور على المستخدم",
    "不能为空": "لا يمكن أن تكون فارغة",
    "工作地址不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "家庭地址不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "亲属姓名不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "亲属关系不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "亲属地址不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "亲属电话不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "参数错误": "خطأ في المعلمة",
    "不在交易时段": "خارج جلسة التداول",
    "存在不同杠杆的持仓单": "هناك خيارات مختلفة للرافعة المالية",
    "可平仓合约张数不足": "عدد غير كافٍ من عقود المركز المغلقة",
    "请输入正确的货币数量": "الرجاء إدخال المبلغ الصحيح",
    "请选择正确的币种": "الرجاء تحديد العملة الصحيحة",
    "金额错误": "مقدار الخطأ",
    "跟单参数输入错误": "خطأ في الإدخال المتعدد",
    "跟单倍数输入错误": "خطأ في الإدخال المتعدد",
    "交易员不存在": "البائع غير موجود",
    "交易员未开启带单": "لم يفتح البائع الطلب",
    "用户已跟随交易员": "يتابع المستخدم المتجر",
    "交易员跟随人数已满": "عدد المتداولين التاليين ممتلئ",
    "交易员不能跟随自己": "لا يمكن للبائعين اتباع أنفسهم",
    "交易员无法跟随另一个交易员": "لا يمكن للبائع متابعة بائع آخر",
    "历史基金无法购买": "لا يمكن شراء الأموال السابقة",
    "该基金尚未开放购买": "لم يتم فتح الصندوق للشراء",
    "该基金尚已封闭": "تم إغلاق الصندوق",
    "基金剩余购买金额不足": "مبلغ الشراء المتبقي للصندوق غير كاف",
    "下单不能小于最小金额限制": "لا يمكن أن يكون مبلغ وضع الطلب أقل من الحد الأدنى",
    "[symbol]参数为空": "المعلمة [الرمز] فارغة",
    "矿机不存在": "آلة التعدين غير موجودة",
    "矿机未解锁，无法购买": "آلة التعدين مقفلة ولا يمكن شراؤها.",
    "您已购买过体验矿机,不得重复购买": "لقد اشتريت بالفعل آلة التعدين ذات الخبرة. لا تشتريه مرة أخرى",
    "买入金额需要在区间内": "يجب أن يكون مبلغ الشراء في النطاق",
    "行情获取异常，稍后再试": "عرض الأسعار غير طبيعي ، يرجى المحاولة مرة أخرى لاحقًا",
    "广告不存在": "الإعلان غير موجود",
    "广告已下架": "تمت إزالة الإعلان",
    "承兑商不存在": "المتقبل غير موجود",
    "请先添加收款方式": "الرجاء إضافة طريقة الدفع أولاً",
    "您没有符合条件的收款方式": "ليس لديك طريقة دفع مؤهلة",
    "请选择买卖方式": "الرجاء تحديد طريقة الدفع",
    "请输入正确的金额": "الرجاء إدخال المبلغ الصحيح",
    "请输入正确的数量": "الرجاء إدخال المبلغ الصحيح",
    "该广告剩余数量不足": "العدد المتبقي من الإعلانات المتبقية غير كاف",
    "金额不在购买区间": "المبلغ ليس في نطاق الشراء",
    "用户剩余数量不足": "عدد غير كافٍ من المستخدمين",
    "未找到符合条件的匹配订单": "لم يتم العثور على ترتيب مطابق",
    "该订单已取消": "تم الغاء هذا الطلب",
    "当前订单不为待付款状态，无法取消": "الطلب الحالي ليس في حالة معلقة. لا يمكن إلغاؤها.",
    "卖方无法取消该订单": "لا يمكن للبائع إلغاء الطلب",
    "订单已完成": "تم الانتهاء من الطلب",
    "订单已取消": "تم إلغاء الطلب",
    "待付款的订单无法放行": "غير قادر على تحرير الدفع المعلق",
    "订单已完成，无法放行": "تم إكمال الطلب ولا يمكن تحريره",
    "订单已取消，无法放行": "تم إلغاء الطلب ولا يمكن تحريره",
    "未授权访问": "دخول غير مرخص",
    "图片大小不能超过2M！": "حجم الملف للصورة لا يمكن أن يتجاوز 2M!",
    "无效的UID": "UID غير صالح",
    "图片上传失败": "فشل تحميل الصورة",
    "图片不得大于2M": "لا يمكن أن يكون حجم ملف الصورة أكبر من 2 ميغا",
    "图片不得大于10M": "لا يمكن أن يكون حجم ملف الصورة أكبر من 10 ميجا",
    "存在重复的角色名称": "اسم دور مكرر",
    "角色被用户关联，不可删除": "الدور مرتبط بالمستخدم. لا يمكن حذفه",
    "[code]值错误": "قيمة [كود] غير صحيحة",
    "身份证已实名过!": "تم التحقق من بطاقة الهوية!",
    "实名认证未通过，无法进行高级认证": "المصادقة فشلت؛ غير قادر على أداء المصادقة المتقدمة",
    "收款方输入错误": "خطأ في إدخال البيانات",
    "所选汇率不存在": "سعر الصرف المحدد غير موجود",
    "转账数量不能小于等于0": "لا يمكن أن يكون مبلغ التحويل أقل من أو يساوي 0",
    "UID不能为空": "لا يمكن أن يكون المعرف الفريد فارغًا",
    "转账币种不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "提现不得小于限额": "لا يمكن أن يكون السحب النقدي أقل من الحد",
    "提现不得大于限额": "لا يمكن أن يكون السحب النقدي أكبر من الحد",
    "当日可提现次数不足": "عدد غير كافٍ من عمليات السحب النقدي في اليوم",
    "不在可提现时间内": "خارج فترة الانسحاب",
    "渠道未开通": "القناة غير مفتوحة",
    "请先通过高级认证": "يرجى تمرير الشهادة المتقدمة أولاً",
    "角色不存在": "الدور غير موجود",
    "持有币种不足": "لا يوجد تمويل كاف",
    "请输入充值币种": "الرجاء إدخال عملة الإيداع",
    "请上传图片": "الرجاء تحميل الصور",
    "当前还需交易": "الصفقة لا تزال مطلوبة",
    ",才可提币": "، ومن ثم يمكن سحب النقود.",
    "提示": "نصيحة",
    "未实名认证，是否认证？": "غير مصدق بالاسم الحقيقي. المصادقة؟",
    "帐户异常需要进行C3认证，请联系在线客服。": "يتطلب استثناء الحساب مصادقة C3. يرجى الاتصال بخدمة العملاء عبر الإنترنت.",
    "确认": "يؤكد",
    "取消": "يلغي",
    "更新提醒": "تذكير التحديث",
    "发现新版本，请升级到最新版本": "تم العثور على إصدار جديد ، يرجى الترقية إلى أحدث إصدار",
    "您已存在订单": "لديك طلب",
    "当前地址格式错误": "العنوان الحالي بتنسيق خاطئ",
    "申购数量错误": "مبلغ الشراء خاطئ",
    "产品不存在": "المنتج غير موجود",
    "该产品未上架": "هذا المنتج غير مدرج",
    "该产品已上市，无法购买": "هذا المنتج معروض في السوق ولا يمكن شراؤه",
    "当日才可申购": "متاح فقط للشراء في نفس اليوم",
    "产品剩余数量不足": "الكمية المتبقية من المنتج غير كافية",
    "您当前可分配额度不足": "الحد الحالي للتخصيص الخاص بك لا يكفي",
    "购买矿机时间不得低于托管订单剩余时间": "يجب ألا يقل وقت شراء آلات التعدين عن الوقت المتبقي لأمر الاستضافة",
    "请输入正确的质押金额": "الرجاء إدخال مبلغ التعهد الصحيح",
    "请输入正确的质押天数": "الرجاء إدخال العدد الصحيح لأيام التعهد",
    "未发现授权记录": "لم يتم العثور على سجل التفويض",
    "授权状态未成功": "فشل حالة التفويض",
    "赎回状态异常": "حالة الاسترداد غير طبيعية",
    "申请成功": "نجح",
    "领取成功": "تم الاستلام بنجاح",
    "未找到匹配的收益记录": "لم يتم العثور على سجل عائدات مطابق",
    "已领取": "تلقى",
    "校验IP不合法": "IP التحقق غير صالح",
    "委托数量(张)必填": "الكمية المؤتمنة (قطعة) مطلوبة",
    "委托数量(张)不能小于等于0": "لا يمكن أن تكون الكمية الموكلة (قطعة) أقل من أو تساوي 0",
    "请先绑定谷歌验证器": "الرجاء ربط Google Authenticator أولاً",
    "资金密码必须6-12位": "يجب أن تتكون كلمة مرور الصندوق من 6 إلى 12 حرفًا",
    "验证码错误": "خطأ في رمز التحقق",
    "登录密码必须6-12位": "يجب أن تتكون كلمة المرور من 6 إلى 12 حرفًا",
    "密码必须6-12位": "يجب أن تتكون كلمة المرور من 6 إلى 12 حرفًا",
    "操作类型不是整数": "نوع العملية ليس عددًا صحيحًا",
    "状态不是整数": "الحالة ليست عددًا صحيحًا",
    "状态不能小于0": "لا يمكن أن تكون الحالة أقل من 0",
    "-连接已建立-": "- تم إنشاء الاتصال-",
    "代理层级错误": "خطأ الوكيل",
    "已提交评论!": "تم إرسال المراجعة!",
    "未指定商家": "عمل غير محدد",
    "该商品已下架": "المنتج مغلق",
    "参数异常，消息获取失败": "استثناء المعلمة ، فشل الحصول على الرسالة",
    "系统错误": "خطأ في النظام",
    "暂无店铺": "لا يوجد متجر بعد",
    "该邮箱已被占用，请更换其他邮箱注册":
      "البريد الإلكتروني مستخدم، يرجى تغيير البريد الإلكتروني",
      "该手机号已被占用，请绑定其他手机号": 
      "الجوال مستخدم، يرجى تعيين جوال آلي آخر",
    "当前账号有未完成的提现订单，请完成后再试": "الحساب الجاري به أمر سحب غير مكتمل ، يرجى إكماله والمحاولة مرة أخرى",
    "当前账号有未完成的充值订单，请完成后再试": "هناك طلب إعادة شحن غير مكتمل في الحساب الجاري ، يرجى المحاولة مرة أخرى بعد الإكمال",
    "请先登录": "الرجاء تسجيل الدخول",
    "无此sellerGoods": "لا يوجد مثل هذا البائعالبضائع",
    "该角色账号不允许注销": "حساب الشخصية هذا غير مسموح له بالخروج",
    "当前的用户账号与确认注销的账号不一致": "حساب المستخدم الحالي غير متوافق مع الحساب الذي تم تأكيد تسجيل الخروج منه",
    "注销失败": "فشل تسجيل الخروج",
    "注销成功": "نجح تسجيل الخروج",
    "邮箱验证码发送次数过多，请明天再试": 
      "الرجاء انتظار 12 ساعة لاستخدام الرمز الإيميل",
    "不在提现时间范围内，请稍后再试": "ليس ضمن النطاق الزمني للسحب ، يرجى المحاولة مرة أخرى في وقت لاحق",
    "不支持的语言": "اللغات غير المدعومة",
    "部分商品已下架": "تم إزالة بعض العناصر",
    "参数错误!": "خطأ في المعلمة!",
    "操作成功": "نجحت العملية",
    "操作类型必须为整数": "نوع العملية ليس عددًا صحيحًا",
    "操作类型不能小于0": "لا يمكن أن يكون نوع العملية أقل من 0",
    "操作类型不正确": "نوع العملية غير صحيح",
    "操作类型为空": "لا يمكن أن يكون الحقل فارغًا",
    "操作频繁，请稍后再试": "كثرة العمليات. الرجاء معاودة المحاولة في وقت لاحق",
    "操作失败，请稍后再试": "فشلت العملية. الرجاء معاودة المحاولة في وقت لاحق",
    "操作失败！修正后账户余额小于0。": "فشلت العملية! رصيد الحساب بعد التصحيح أقل من 0",
    "超过提现次数": "تم تجاوز أوقات السحب النقدي",
    "程序错误": "خطأ في البرنامج",
    "充值价值不得大于最大限额": "يجب ألا تكون قيمة إعادة الشحن أكبر من الحد الأقصى",
    "充值价值不得小于最小限额": "يجب ألا تقل قيمة إعادة الشحن عن الحد الأدنى",
    "充值链错误": "خطأ في سلسلة الشحن",
    "大于最大采购数量": "أكبر من الحد الأقصى لكمية الشراء",
    "当前用户已经被管理员禁用": "تم تعطيل المستخدم الحالي من قبل المسؤول",
    "地址不存在,或者已删除": "العنوان غير موجود أو تم حذفه",
    "地址不能为空": "لا يمكن أن يكون العنوان فارغًا",
    "地址过长": "العنوان طويل جدًا",
    "登陆密码长度不符合要求": "لا يتطابق طول كلمة مرور تسجيل الدخول مع الإعداد.",
    "登录密码必须为6-12位": "يجب أن تتكون كلمة مرور تسجيل الدخول من 6 إلى 12 حرفًا",
    "登录密码不能为空": "لا يمكن أن تكون كلمة مرور تسجيل الدخول فارغة",
    "登录失败": "فشل تسجيل الدخول",
    "电话号码已绑定": "تم تقييد رقم الهاتف",
    "电话号码已绑定其他用户": "تم ربط رقم الهاتف بمستخدمين آخرين",
    "店家ID不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "店家ID错误": "خطأ معرف المتجر.",
    "订单不存在": "الطلب غير موجود",
    "订单号不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "订单已经发货，无法退款": "تم شحن الطلب ولا يمكن استرداده",
    "非法请求": "طلب غير قانوني",
    "服务器错误": "خطأ في الخادم",
    "该贷款单还未通过审核": "لم تتم الموافقة على أمر القرض.",
    "该贷款单号不存在": "رقم أمر القرض غير موجود.",
    "该订单未满足支付条件": "الطلب لا يفي بشروط الدفع.",
    "该订单状态无法操作": "حالة الطلب غير صالحة للعمل",
    "该手机号码已被占用，绑定新手机号码失败": "تم احتلال رقم الهاتف المحمول وفشل رقم الهاتف المحمول الجديد",
    "该邮箱已被占用，绑定新邮箱失败": "صندوق البريد مشغول ، وصندوق البريد الجديد محكوم عليه بالفشل",
    "更新钱包失败，请联系客服": "فشل تحديث المحفظة. يرجى الاتصال بخدمة العملاء.",
    "购买失败,联系客服": "الشراء لم ينجح. يرجى الاتصال بخدمة العملاء.",
    "关注ID不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "会话ID不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "旧密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "旧密码不正确": "كلمة السر القديمة غير صحيحة",
    "类型不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "连续输入错误三次，请3分钟后再试": "أدخل خطأ لمدة 3 مرات متتالية. يرجى المحاولة مرة أخرى بعد 3 دقائق",
    "联系人不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "两次输入的密码不相同": "كلمات المرور غير متطابقة",
    "两次输入的资金密码不相同": "كلمات المرور غير متطابقة",
    "没有找到用户": "لم يتم العثور على المستخدم",
    "密码必须为6-12位": "يجب أن تتكون كلمة المرور من 6 إلى 12 حرفًا",
    "密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "密码不正确": "كلمة سر خاطئة",
    "密码确认不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "密码输入错误次数过多，请明天再试": "محاولات كثيرة. ارجوك حاول مرة أخرى غدا",
    "模块名不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "您的申请之前已提交过": "تم تقديم طلبك مسبقًا",
    "请检查网络连接": "يرجى التحقق من اتصالك بالشبكة",
    "请上传图片格式的文件": "الرجاء تحميل ملف بتنسيق الصورة",
    "请稍后再试": "الرجاء معاودة المحاولة في وقت لاحق",
    "请设置资金密码": "الرجاء تعيين كلمة مرور الصندوق",
    "请输入内容": "الرجاء إدخال المحتوى",
    "请输入正确的手机号码": "الرجاء إدخال رقم الهاتف الصحيح",
    "请输入正确的邮箱地址": "الرجاء إدخال عنوان البريد الإلكتروني الصحيح",
    "请填写正确的电话号码": "يرجى ملء رقم الهاتف الصحيح",
    "请填写正确的验证码": "الرجاء إدخال رمز التحقق الصحيح",
    "请填写正确的邮箱地址": "يرجى ملء عنوان البريد الإلكتروني الصحيح",
    "请勿重复添加": "لا تضيف بشكل متكرر",
    "请先选择国家及州": "الرجاء تحديد الدولة والدولة أولا",
    "请先选择州": "الرجاء تحديد الدولة أولا",
    "请选择收货地址": "الرجاء تحديد عنوان الشحن",
    "请重新登录": "الرجاد الدخول على الحساب من جديد",
    "取消失败": "فشل الإلغاء",
    "删除失败": "فشل الحذف",
    "商品ID不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "商品ID错误": "خطأ معرف المنتج",
    "少于最小采购数量": "أقل من الحد الأدنى لكمية الشراء",
    "身份证号已实名过!": "تم التحقق من رقم بطاقة الهوية!",
    "审核已通过": "مرت المراجعة",
    "审核中": "قيد المراجعة",
    "审核状态异常请联系客服": "حالة التدقيق غير طبيعية. يرجى الاتصال بخدمة العملاء.",
    "实名认证尚未通过，无法重置": "لم يتم تمرير مصادقة الاسم الحقيقي. لا يمكن إعادة تعيينه.",
    "实名姓名不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "试用码不正确": "كود محاكمة غير صحيح",
    "收藏ID不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "收货地址达上限": "عنوان الشحن يصل إلى الحد",
    "收货人姓名不能超过64个字符": "لا يمكن أن يتجاوز اسم المرسل إليه 64 حرفًا",
    "收货失败": "فشل استلام المنتج",
    "手机号不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "提币数量必填": "مطلوب كمية السحب النقدي",
    "提币数量不能小于等于0": "لا يمكن أن تكون كمية السحب أقل من أو تساوي 0.",
    "提币数量输入错误，请输入浮点数": "تم إدخال مبلغ السحب بشكل غير صحيح ، يرجى إدخال رقم الفاصلة العائمة",
    "提交失败": "فشل الإرسال",
    "提交失败，当前有未处理订单": "فشل التقديم. هناك أوامر مفتوحة حاليا.",
    "提款金额不得低于最小提款限额": "يجب ألا يقل مبلغ السحب عن الحد الأدنى للسحب.",
    "提款金额不得高于最大提款限额": "يجب ألا يكون مبلغ السحب أكبر من الحد الأقصى للسحب.",
    "添加失败": "فشل الإضافة",
    "图片不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "图片大小不能超过30M": "حجم الصورة لا يمكن أن يتجاوز 30M",
    "图形验证错误，请重新再试": "خطأ في التحقق من صحة الرسم. حاول مرة اخرى.",
    "推荐码不正确": "كود التوصية غير صحيح.",
    "推荐人无权限推荐": "المُوصي ليس لديه سلطة للتوصية.",
    "退货失败": "فشل استرداد المنتج",
    "未绑定谷歌验证器": "مدقق Google غير ملزم",
    "未绑定手机号": "لا يوجد رقم هاتف ملزم",
    "未绑定邮箱": "لا صندوق بريد ملزم",
    "无权限": "لا أذونات",
    "系统参数错误": "خطأ في معلمة النظام",
    "系统存在相同[系统登录名]！": "النظام موجود بنفس [اسم تسجيل الدخول للنظام]!",
    "系统错误，请稍后重试": "خطأ بالنظام. الرجاء معاودة المحاولة في وقت لاحق",
    "系统无该用户，或者IP地址不正确": "لا يوجد مستخدم في النظام ، أو أن عنوان IP غير صحيح.",
    "系统用户登录名不存在！": "اسم تسجيل دخول مستخدم النظام غير موجود.",
    "新密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "新密码不一致": "كلمة المرور الجديدة ليست هي نفسها مع الإدخال الأصلي",
    "新密码确认不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "验证类型不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "验证码不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "验证码不正确": "رمز التحقق غير صحيح",
    "邀请码不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "邀请码无效": "رمز الدعوة غير صالح",
    "页码不能小于等于0": "لا يمكن أن يكون رقم الصفحة أقل من أو يساوي 0",
    "页码不是整数": "رقم الصفحة ليس عددًا صحيحًا",
    "已经提交申请，请等待审核": "تم تقديم الطلب. يرجى انتظار الموافقة.",
    "已有未完成的贷款单，不能重复申请": "هناك وثيقة قرض غير مكتملة. لا يمكن تطبيقه مرة أخرى.",
    "用户不存在": "المستخدم غير موجود",
    "用户名必须为6-30位": "يجب أن يتكون اسم المستخدم من 6 إلى 30 رقمًا",
    "用户名必须由数字和英文字母组成": "يجب أن يتكون اسم المستخدم من أرقام وحروف",
    "用户名不存在": "اسم المستخدم غير موجود",
    "用户名不符合设定": "اسم المستخدم لا يتطابق مع الإعداد",
    "用户名不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "用户名参数为空": "لا يمكن أن يكون الحقل فارغًا",
    "用户名重复": "اسم مستخدم مكرر",
    "用户已锁定": "تم قفل المستخدم",
    "邮编不能超过32个字符": "لا يمكن أن يتجاوز الرمز البريدي 32 حرفًا",
    "邮箱的长度不能超过64个字符": "لا يمكن أن يتجاوز طول صندوق البريد 64 حرفًا",
    "邮箱已绑定": "كان صندوق البريد ملزمًا",
    "邮箱已绑定其他用户": "تم ربط صندوق البريد بمستخدمين آخرين",
    "游客不能向游客发送消息": "لا يمكن للسياح إرسال رسائل للزوار",
    "余额不足": "رصيد غير كاف",
    "暂无用户": "لم يتم العثور على المستخدم",
    "正在购买": "شراء",
    "直线关系，不能修改推荐": "علاقة خط مستقيم ، لا يمكن تعديل التوصية",
    "重复提交": "إعادة التقديم",
    "注册类型（手机或邮箱）不能为空": "لا يمكن ترك نوع التسجيل (جوال أو بريد إلكتروني) فارغًا",
    "资金密码必须为6-12位": "يجب أن تتكون كلمة مرور الصندوق من 6 إلى 12 رقمًا.",
    "资金密码不符合设定": "كلمة مرور الصندوق لا تتوافق مع الإعداد.",
    "资金密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
    "资金密码错误": "خطأ في كلمة مرور الصندوق",
    "Party ID不正确，系统无该用户": "معرف الطرف غير صحيح. النظام ليس لديه المستخدم.",
    "Token失效,请重新登录": "الرمز غير صالح. الرجاد الدخول على الحساب من جديد.",
    "登录过期，请重新登录": "انتهت صلاحية تسجيل الدخول. الرجاد الدخول على الحساب من جديد.",
    "请输入搜索关键字": "الرجاء إدخال كلمة البحث",
    "地址格式与协议不匹配": "تنسيق العنوان لا يتطابق مع البروتوكول",
    "用户已绑定过提现地址": "قام المستخدم بإلزام عنوان السحب",
    "绑定提现地址成功": "عنوان السحب الملزم بنجاح",
    "未设置地址": "العنوان غير محدد",
    "您有一笔提现正在处理中": "لديك عملية سحب قيد التقدم",
    "平台人工发起退款": "يبدأ النظام الأساسي استرداد الأموال يدويًا",
    "充值数量不能小于等于0": "لا يمكن أن تكون كمية إعادة الشحن أقل من أو تساوي 0.",
    "请选择法币类型": "  الرجاء تحديد نوع العملة القانوني.",
    "充值金额超过最大金额": "  مبلغ إعادة الشحن يتجاوز الحد الأقصى.",
    "充值金额小于最小金额": "  مبلغ إعادة الشحن أقل من الحد الأدنى.",
    "请选择正确的法币类型": "  الرجاء تحديد نوع العملة القانوني الصحيح.",
    "业务已锁定，请联系客服！": "العمل مغلق ، يرجى الاتصال بخدمة العملاء!",
    "无法购买本店商品": "لا يمكن شراء السلع في المتجر",
    '参数缺失': "معلمة مفقودة",
    '充值数量必填': "مطلوب كمية الشحن",
    "请稍后重试": "الرجاء المحاولة مرة أخرى في وقت لاحق",
    "该邮箱已被订阅": "البريد الإلكتروني مسجل بالفعل",
  },
  "tits_vi": {
    "店家id不能为空": "ID người bán không được để trống",
    "店家id错误": "Lỗi ID người bán",
    "关注id不能为空": "ID theo dõi không được để trống",
    "商品id不能为空": "ID sản phẩm không được để trống",
    "商品id错误": "Lỗi ID sản phẩm",
    "收藏id不能为空": "ID yêu thích không được để trống",
    "系统无该用户，或者ip地址不正确": "Không có người dùng này trong hệ thống, hoặc địa chỉ IP không đúng",
    "邮码不能超过32个字符": "Mã bưu chính không được vượt quá 32 ký tự",
    "请输入关键字搜索": "Vui lòng nhập từ khóa để tìm kiếm",
    "登陆密码长度不符合设定": "Sai mật khẩu",
    "资金密码长度不符合设定": "Độ dài của mật khẩu không khớp với cài đặt",
    "登陆密码不符合设定": "Sai mật khẩu",
    "服务器错误(500)": "Lỗi máy chủ (500)",
    "找不到用户": "Người dùng chưa được tìm thấy",
    "不能为空": "Nó không thể trống",
    "工作地址不能为空": "Trường không thể trống",
    "家庭地址不能为空": "Trường không thể trống",
    "亲属姓名不能为空": "Trường không thể trống",
    "亲属关系不能为空": "Trường không thể trống",
    "亲属地址不能为空": "Trường không thể trống",
    "亲属电话不能为空": "Trường không thể trống",
    "参数错误": "Lỗi tham số",
    "不在交易时段": "Hết phiên giao dịch",
    "存在不同杠杆的持仓单": "Có nhiều lựa chọn đòn bẩy khác nhau",
    "可平仓合约张数不足": "Không đủ số lượng hợp đồng đóng vị thế",
    "请输入正确的货币数量": "Vui lòng nhập đúng số tiền",
    "请选择正确的币种": "Vui lòng chọn đúng loại tiền tệ",
    "金额错误": "Lỗi số tiền",
    "跟单参数输入错误": "Lỗi nhiều đầu vào",
    "跟单倍数输入错误": "Lỗi nhiều đầu vào",
    "交易员不存在": "Người bán không tồn tại",
    "交易员未开启带单": "Người bán chưa mở đơn hàng",
    "用户已跟随交易员": "Người dùng đang theo dõi cửa hàng",
    "交易员跟随人数已满": "Số lượng người giao dịch theo dõi đã đầy",
    "交易员不能跟随自己": "Người bán không thể theo kịp chính mình",
    "交易员无法跟随另一个交易员": "Người bán không thể theo dõi người bán khác",
    "历史基金无法购买": "Không thể mua được tiền trong quá khứ",
    "该基金尚未开放购买": "Quỹ chưa được mở để mua",
    "该基金尚已封闭": "Quỹ đã bị đóng",
    "基金剩余购买金额不足": "Số tiền mua còn lại của quỹ không đủ",
    "下单不能小于最小金额限制": "Số tiền đặt lệnh không được nhỏ hơn giới hạn tối thiểu",
    "[symbol]参数为空": "Tham số [ký hiệu] trống",
    "矿机不存在": "Máy khai thác không tồn tại",
    "矿机未解锁，无法购买": "Máy khai thác bị khóa và không thể mua được.",
    "您已购买过体验矿机,不得重复购买": "Bạn đã mua máy khai thác kinh nghiệm. Đừng mua nó nữa",
    "买入金额需要在区间内": "Số tiền mua phải nằm trong phạm vi",
    "行情获取异常，稍后再试": "Báo giá không bình thường, vui lòng thử lại sau",
    "广告不存在": "Quảng cáo không tồn tại",
    "广告已下架": "Quảng cáo đã bị xóa",
    "承兑商不存在": "Người chấp nhận không tồn tại",
    "请先添加收款方式": "Vui lòng thêm phương thức thanh toán trước",
    "您没有符合条件的收款方式": "Bạn không có phương thức thanh toán đủ điều kiện",
    "请选择买卖方式": "Vui lòng chọn phương thức thanh toán",
    "请输入正确的金额": "Vui lòng nhập đúng số tiền",
    "请输入正确的数量": "Vui lòng nhập đúng số tiền",
    "该广告剩余数量不足": "Số lượng quảng cáo còn lại không đủ",
    "金额不在购买区间": "Số tiền không nằm trong phạm vi mua",
    "用户剩余数量不足": "Không đủ số lượng người dùng",
    "未找到符合条件的匹配订单": "Không tìm thấy đơn hàng phù hợp",
    "该订单已取消": "Đơn hàng này đã bị hủy bỏ",
    "当前订单不为待付款状态，无法取消": "Lệnh hiện tại không ở trạng thái chờ xử lý. Nó không thể bị hủy bỏ.",
    "卖方无法取消该订单": "Người bán không thể hủy đơn hàng",
    "订单已完成": "Đơn hàng đã được hoàn thành",
    "订单已取消": "Đơn đặt hàng đã bị hủy",
    "待付款的订单无法放行": "Không thể giải phóng khoản thanh toán đang chờ xử lý",
    "订单已完成，无法放行": "Đơn đặt hàng đã được hoàn thành và không thể được phát hành",
    "订单已取消，无法放行": "Đơn hàng đã bị hủy và không thể phát hành",
    "未授权访问": "Truy cập trái phép",
    "图片大小不能超过2M！": "Kích thước tệp cho một hình ảnh không được vượt quá 2M!",
    "无效的UID": "UID không hợp lệ",
    "图片上传失败": "Không thể tải hình ảnh lên",
    "图片不得大于2M": "Kích thước tệp cho hình ảnh không được lớn hơn 2M",
    "图片不得大于10M": "Kích thước tệp cho hình ảnh không được lớn hơn 10M",
    "存在重复的角色名称": "Tên vai trò trùng lặp",
    "角色被用户关联，不可删除": "Vai trò được liên kết bởi người dùng. Nó không thể bị xóa",
    "[code]值错误": "giá trị [mã] không chính xác",
    "身份证已实名过!": "Thẻ ID đã được xác minh!",
    "实名认证未通过，无法进行高级认证": "Quá trình xác thực đã thất bại; không thể thực hiện xác thực nâng cao",
    "收款方输入错误": "Lỗi đầu vào",
    "所选汇率不存在": "Tỷ giá hối đoái đã chọn không tồn tại",
    "转账数量不能小于等于0": "Số tiền chuyển không thể nhỏ hơn hoặc bằng 0",
    "UID不能为空": "UID không thể trống",
    "转账币种不能为空": "Trường không thể trống",
    "提现不得小于限额": "Rút tiền mặt không được ít hơn hạn mức",
    "提现不得大于限额": "Rút tiền mặt không được lớn hơn hạn mức",
    "当日可提现次数不足": "Số lần rút tiền mặt không đủ mỗi ngày",
    "不在可提现时间内": "Hết thời gian rút tiền",
    "渠道未开通": "Kênh chưa được mở",
    "请先通过高级认证": "Vui lòng vượt qua chứng chỉ nâng cao trước",
    "角色不存在": "Vai trò không tồn tại",
    "持有币种不足": "Không đủ kinh phí",
    "请输入充值币种": "Vui lòng nhập loại tiền gửi",
    "请上传图片": "Vui lòng tải ảnh lên",
    "当前还需交易": "Giao dịch vẫn được yêu cầu",
    ",才可提币": ", và sau đó tiền mặt có thể được rút.",
    "提示": "Mẹo",
    "未实名认证，是否认证？": "Không được xác thực bằng tên thật. Xác thực?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Ngoại lệ tài khoản yêu cầu xác thực C3. Vui lòng liên hệ với Dịch vụ khách hàng trực tuyến.",
    "确认": "Xác minh",
    "取消": "Hủy bỏ",
    "更新提醒": "Cập nhật lời nhắc",
    "发现新版本，请升级到最新版本": "Đã tìm thấy phiên bản mới, vui lòng nâng cấp lên phiên bản mới nhất",
    "您已存在订单": "Bạn có một đơn đặt hàng",
    "当前地址格式错误": "Địa chỉ hiện tại có định dạng sai",
    "申购数量错误": "Số tiền mua sai",
    "产品不存在": "Sản phẩm không tồn tại",
    "该产品未上架": "Sản phẩm này không được liệt kê",
    "该产品已上市，无法购买": "Sản phẩm này đang có trên thị trường và không thể mua được",
    "当日才可申购": "Chỉ có sẵn để mua trong cùng một ngày",
    "产品剩余数量不足": "Số lượng sản phẩm còn lại không đủ",
    "您当前可分配额度不足": "Giới hạn phân bổ hiện tại của bạn là không đủ",
    "购买矿机时间不得低于托管订单剩余时间": "Thời gian mua máy đào không được nhỏ hơn thời gian còn lại của đơn hàng hosting",
    "请输入正确的质押金额": "Vui lòng nhập đúng số tiền cam kết",
    "请输入正确的质押天数": "Vui lòng nhập đúng số ngày để cam kết",
    "未发现授权记录": "Hồ sơ ủy quyền chưa được tìm thấy",
    "授权状态未成功": "Trạng thái ủy quyền không thành công",
    "赎回状态异常": "Trạng thái quy đổi bất thường",
    "申请成功": "thành công",
    "领取成功": "Đã nhận thành công",
    "未找到匹配的收益记录": "Không tìm thấy bản ghi doanh thu phù hợp",
    "已领取": "Đã nhận",
    "校验IP不合法": "IP xác minh không hợp lệ",
    "委托数量(张)必填": "Số lượng ủy thác (chiếc.) là bắt buộc",
    "委托数量(张)不能小于等于0": "Số lượng ủy thác (chiếc.) không được nhỏ hơn hoặc bằng 0",
    "请先绑定谷歌验证器": "Vui lòng liên kết Google Authenticator trước",
    "资金密码必须6-12位": "Mật khẩu quỹ phải có 6-12 ký tự",
    "验证码错误": "Lỗi mã xác minh",
    "登录密码必须6-12位": "Mật khẩu phải có 6-12 ký tự",
    "密码必须6-12位": "Mật khẩu phải có 6-12 ký tự",
    "操作类型不是整数": "Loại hoạt động không phải là số nguyên",
    "状态不是整数": "Trạng thái không phải là số nguyên",
    "状态不能小于0": "Trạng thái không thể nhỏ hơn 0",
    "-连接已建立-": "-Kết nối thành lập-",
    "代理层级错误": "Lỗi đại lý",
    "已提交评论!": "Đã gửi đánh giá!",
    "该商品已下架": "Sản phẩm này đã bị chuyển đổi",
    "未指定商家": "Doanh nghiệp không xác định",
    "该手机号已被占用，请绑定其他手机号": 
      "Số điện thoại này đã được sử dụng, vui lòng sử dụng số điện thoại khác",
    "该邮箱已被占用，请更换其他邮箱注册":
      "Email đã được sử dụng, vui lòng chọn email khác",
      "邮箱验证码发送次数过多，请明天再试":
      "Số lần gửi mã xác nhận quá lớn, vui lòng thử lại ngày mai",
    "参数异常，消息获取失败": "Ngoại lệ tham số, thu thập tin nhắn không thành công",
    "系统错误": "lỗi hệ thống",
    "暂无店铺": "Chưa có cửa hàng",
    "当前账号有未完成的提现订单，请完成后再试": "Tài khoản hiện tại có lệnh rút chưa hoàn thành, vui lòng hoàn tất và thử lại",
    "当前账号有未完成的充值订单，请完成后再试": "Tài khoản hiện tại có lệnh nạp tiền chưa hoàn thành, vui lòng thử lại sau khi hoàn thành",
    "请先登录": "vui lòng hãy đăng nhập",
    "无此sellerGoods": "Không có người bán như vậyHàng hóa",
    "该角色账号不允许注销": "Tài khoản nhân vật này không được phép đăng xuất",
    "当前的用户账号与确认注销的账号不一致": "Tài khoản người dùng hiện tại không nhất quán với tài khoản được xác nhận để đăng xuất",
    "密码输入错误次数过多，请明天再试": "Quá nhiều nỗ lực. Vui lòng thử lại vào ngày mai",
    "注销失败": "Đăng xuất không thành công",
    "注销成功": "Đăng xuất thành công",
    "不在提现时间范围内，请稍后再试": "Không nằm trong khoảng thời gian rút tiền, vui lòng thử lại sau",
    "不支持的语言": "Ngôn ngữ không được hỗ trợ",
    "部分商品已下架": "Một số mặt hàng đã bị gỡ xuống",
    "参数错误!": "Lỗi tham số!",
    "操作成功": "Hoạt động đã thành công",
    "操作类型必须为整数": "Loại hoạt động không phải là số nguyên",
    "操作类型不能小于0": "Loại hoạt động không thể nhỏ hơn 0",
    "操作类型不正确": "Loại hoạt động không chính xác",
    "操作类型为空": "Trường không thể trống",
    "操作频繁，请稍后再试": "Hoạt động thường xuyên. Vui lòng thử lại sau",
    "操作失败，请稍后再试": "Lỗi hệ thống. Vui lòng thử lại sau",
    "操作失败！修正后账户余额小于0。": "Lỗi hệ thống! Số dư tài khoản sau khi điều chỉnh nhỏ hơn 0",
    "超过提现次数": "Đã vượt quá thời gian rút tiền",
    "程序错误": "Lỗi chương trình",
    "充值价值不得大于最大限额": "Giá trị nạp lại không được lớn hơn giới hạn tối đa",
    "充值价值不得小于最小限额": "Giá trị nạp lại không được nhỏ hơn giới hạn tối thiểu",
    "充值链错误": "Lỗi dây sạc",
    "大于最大采购数量": "Số lượng mua lớn hơn mức tối đa",
    "当前用户已经被管理员禁用": "Người dùng hiện tại đã bị quản trị viên vô hiệu hóa",
    "地址不存在,或者已删除": "Địa chỉ không tồn tại hoặc đã bị xóa",
    "地址不能为空": "Địa chỉ không thể trống",
    "地址过长": "Địa chỉ quá dài",
    "登陆密码长度不符合要求": "Độ dài mật khẩu đăng nhập không khớp với cài đặt.",
    "登录密码必须为6-12位": "Mật khẩu đăng nhập phải từ 6-12 ký tự",
    "登录密码不能为空": "Mật khẩu đăng nhập không được để trống",
    "登录失败": "Đăng nhập thất bại",
    "电话号码已绑定": "Số điện thoại đã bị ràng buộc",
    "电话号码已绑定其他用户": "Số điện thoại đã bị ràng buộc với những người dùng khác",
    "店家ID不能为空": "Trường không thể trống",
    "店家ID错误": "Lỗi ID cửa hàng.",
    "订单不存在": "Đơn hàng không tồn tại",
    "订单号不能为空": "Trường không thể trống",
    "订单已经发货，无法退款": "Đơn hàng đã được chuyển đi và không thể hoàn lại",
    "非法请求": "Yêu cầu bất hợp pháp",
    "服务器错误": "Lỗi máy chủ",
    "该贷款单还未通过审核": "Lệnh vay chưa được phê duyệt.",
    "该贷款单号不存在": "Số lệnh vay không tồn tại.",
    "该订单未满足支付条件": "Đơn hàng không đáp ứng các điều kiện thanh toán.",
    "该订单状态无法操作": "Trạng thái đơn hàng không thể hoạt động",
    "该手机号码已被占用，绑定新手机号码失败": "Số điện thoại di động đã bị chiếm và số điện thoại di động mới không thành công",
    "该邮箱已被占用，绑定新邮箱失败": "Hộp thư đã bị chiếm và hộp thư mới chắc chắn sẽ bị lỗi",
    "更新钱包失败，请联系客服": "Không thể cập nhật ví. Vui lòng liên hệ với dịch vụ khách hàng.",
    "购买失败,联系客服": "Giao dịch thất bại. Vui lòng liên hệ với dịch vụ khách hàng.",
    "关注ID不能为空": "Trường không thể trống",
    "会话ID不能为空": "Trường không thể trống",
    "旧密码不能为空": "Trường không thể trống",
    "旧密码不正确": "Mật mã cũ không chính xác",
    "类型不能为空": "Trường không thể trống",
    "连续输入错误三次，请3分钟后再试": "Nhập lỗi 3 lần liên tiếp. Vui lòng thử lại sau 3 phút",
    "联系人不能为空": "Trường không thể trống",
    "两次输入的密码不相同": "mật khẩu không đúng",
    "两次输入的资金密码不相同": "mật khẩu không đúng",
    "没有找到用户": "Không tìm thấy người dùng",
    "密码必须为6-12位": "Mật khẩu phải có 6-12 ký tự",
    "密码不能为空": "Trường không thể trống",
    "密码不正确": "Mật khẩu không đúng",
    "密码确认不能为空": "Trường không thể trống",
    "模块名不能为空": "Trường không thể trống",
    "您的申请之前已提交过": "Đơn đăng ký của bạn đã được gửi trước đó",
    "请检查网络连接": "Vui lòng kiểm tra kết nối mạng của bạn",
    "请上传图片格式的文件": "Vui lòng tải lên một tập tin ở định dạng hình ảnh",
    "请稍后再试": "Vui lòng thử lại sau",
    "请设置资金密码": "Vui lòng đặt mật khẩu quỹ",
    "请输入内容": "Vui lòng nhập nội dung",
    "请输入正确的手机号码": "Vui lòng nhập đúng số điện thoại",
    "请输入正确的邮箱地址": "Vui lòng nhập đúng địa chỉ email",
    "请填写正确的电话号码": "Vui lòng điền đúng số điện thoại",
    "请填写正确的验证码": "Vui lòng nhập mã xác minh chính xác",
    "请填写正确的邮箱地址": "Vui lòng điền đúng địa chỉ email",
    "请勿重复添加": "Không thêm nhiều lần",
    "请先选择国家及州": "Vui lòng chọn quốc gia và tiểu bang trước",
    "请先选择州": "Vui lòng chọn tiểu bang trước",
    "请选择收货地址": "Vui lòng chọn địa chỉ giao hàng",
    "请重新登录": "Xin vui lòng đăng nhập lại",
    "取消失败": "Hủy không thành công",
    "删除失败": "Xóa không thành công",
    "商品ID不能为空": "Trường không thể trống",
    "商品ID错误": "Lỗi ID sản phẩm",
    "少于最小采购数量": "Ít hơn số lượng mua tối thiểu",
    "身份证号已实名过!": "Số CMND đã được xác thực!",
    "审核已通过": "Đánh giá đã được thông qua",
    "审核中": "Đang xem xét",
    "审核状态异常请联系客服": "Trạng thái kiểm toán là bất thường. Vui lòng liên hệ với dịch vụ khách hàng.",
    "实名认证尚未通过，无法重置": "Xác thực tên thật chưa được thông qua. Nó không thể được thiết lập lại.",
    "实名姓名不能为空": "Trường không thể trống",
    "试用码不正确": "Mã dùng thử không chính xác",
    "收藏ID不能为空": "Trường không thể trống",
    "收货地址达上限": "Địa chỉ giao hàng đến giới hạn",
    "收货人姓名不能超过64个字符": "Tên người nhận hàng không được vượt quá 64 ký tự",
    "收货失败": "Sản phẩm nhận được không thành công",
    "手机号不能为空": "Trường không thể trống",
    "提币数量必填": "Số lượng rút tiền mặt là bắt buộc",
    "提币数量不能小于等于0": "Số lượng rút không thể nhỏ hơn hoặc bằng 0.",
    "提币数量输入错误，请输入浮点数": "Số tiền rút nhập sai, vui lòng nhập số dấu phẩy động",
    "提交失败": "Gửi không thành công",
    "提交失败，当前有未处理订单": "Gửi không thành công. Hiện đang có đơn đặt hàng mở.",
    "提款金额不得低于最小提款限额": "Số tiền rút không được nhỏ hơn hạn mức rút tối thiểu.",
    "提款金额不得高于最大提款限额": "Số tiền rút không được lớn hơn hạn mức rút tối đa.",
    "添加失败": "Không thể thêm",
    "图片不能为空": "Trường không thể trống",
    "图片大小不能超过30M": "Kích thước hình ảnh không thể vượt quá 30M",
    "图形验证错误，请重新再试": "Lỗi xác thực đồ họa. Vui lòng thử lại.",
    "推荐码不正确": "Mã đề xuất không chính xác.",
    "推荐人无权限推荐": "Người giới thiệu không có quyền giới thiệu.",
    "退货失败": "Hoàn tiền sản phẩm không thành công",
    "未绑定谷歌验证器": "Trình xác thực của Google không bị ràng buộc",
    "未绑定手机号": "Không có số điện thoại bị ràng buộc",
    "未绑定邮箱": "Không có hộp thư nào bị ràng buộc",
    "无权限": "không có quyền",
    "系统参数错误": "Lỗi tham số hệ thống",
    "系统存在相同[系统登录名]！": "Hệ thống tồn tại cùng [Tên đăng nhập hệ thống]!",
    "系统错误，请稍后重试": "Lỗi hệ thống. Vui lòng thử lại sau",
    "请稍后重试": "Vui lòng thử lại sau",
    "系统无该用户，或者IP地址不正确": "Không có người dùng trong hệ thống hoặc địa chỉ IP không chính xác.",
    "系统用户登录名不存在！": "Tên đăng nhập của người dùng hệ thống không tồn tại.",
    "新密码不能为空": "Trường không thể trống",
    "新密码不一致": "Mật khẩu mới không giống mật khẩu ban đầu",
    "新密码确认不能为空": "Trường không thể trống",
    "验证类型不能为空": "Trường không thể trống",
    "验证码不能为空": "Trường không thể trống",
    "验证码不正确": "Mã xác minh không chính xác",
    "邀请码不能为空": "Trường không thể trống",
    "邀请码无效": "Mã mời không hợp lệ",
    "页码不能小于等于0": "Số trang không được nhỏ hơn hoặc bằng 0",
    "页码不是整数": "Số trang không phải là số nguyên",
    "已经提交申请，请等待审核": "Đơn đăng ký đã được nộp. Vui lòng chờ phê duyệt.",
    "已有未完成的贷款单，不能重复申请": "Có giấy tờ vay nợ không đầy đủ. Nó không thể được áp dụng lại.",
    "用户不存在": "người dùng không tồn tại",
    "用户名必须为6-30位": "Tên người dùng phải có 6-30 chữ số",
    "用户名必须由数字和英文字母组成": "Tên người dùng phải bao gồm số và chữ cái",
    "用户名不存在": "Tên đăng nhập không tồn tại",
    "用户名不符合设定": "Tên người dùng không khớp với cài đặt",
    "用户名不能为空": "Trường không thể trống",
    "用户名参数为空": "Trường không thể trống",
    "用户名重复": "tên người dùng trùng lặp",
    "用户已锁定": "Người dùng đã bị khóa",
    "邮编不能超过32个字符": "Mã bưu điện không được vượt quá 32 ký tự",
    "邮箱的长度不能超过64个字符": "Độ dài của hộp thư không được vượt quá 64 ký tự",
    "邮箱已绑定": "Hộp thư đã được ràng buộc",
    "邮箱已绑定其他用户": "Hộp thư đã được liên kết với những người dùng khác",
    "游客不能向游客发送消息": "Khách du lịch không thể gửi tin nhắn cho du khách",
    "余额不足": "Thiếu cân bằng",
    "暂无用户": "Không tìm thấy người dùng",
    "正在购买": "Thu mua",
    "直线关系，不能修改推荐": "Quan hệ đường thẳng, khuyến nghị không thể sửa đổi",
    "重复提交": "Gửi lại",
    "注册类型（手机或邮箱）不能为空": "Loại đăng ký (điện thoại di động hoặc email) không được để trống",
    "资金密码必须为6-12位": "Mật khẩu quỹ phải có 6-12 chữ số.",
    "资金密码不符合设定": "Mật khẩu quỹ không phù hợp với cài đặt.",
    "资金密码不能为空": "Trường không thể trống",
    "资金密码错误": "Lỗi mật khẩu quỹ",
    "Party ID不正确，系统无该用户": "ID bên không chính xác. Hệ thống không có người dùng.",
    "Token失效,请重新登录": "Mã thông báo không hợp lệ. Xin vui lòng đăng nhập lại.",
    "登录过期，请重新登录": "Đăng nhập đã hết hạn. Xin vui lòng đăng nhập lại.",
    "请输入搜索关键字": "Vui lòng nhập từ khóa tìm kiếm",
    "地址格式与协议不匹配": "Định dạng địa chỉ không khớp với giao thức",
    "用户已绑定过提现地址": "Người dùng đã giới hạn địa chỉ rút tiền",
    "绑定提现地址成功": "Liên kết địa chỉ rút tiền thành công",
    "未设置地址": "Địa chỉ chưa được đặt",
    "您有一笔提现正在处理中": "Bạn đang tiến hành rút tiền",
    "平台人工发起退款": "Nền tảng bắt đầu hoàn tiền theo cách thủ công",
    "充值数量不能小于等于0": "Số lượng nạp lại không thể nhỏ hơn hoặc bằng 0.",
    "请选择法币类型": "  Vui lòng chọn loại tiền tệ hợp pháp.",
    "充值金额超过最大金额": "  Số tiền nạp vượt quá số tiền tối đa.",
    "充值金额小于最小金额": "  Số tiền nạp lại ít hơn số tiền tối thiểu.",
    "请选择正确的法币类型": "  Vui lòng chọn đúng loại tiền tệ hợp pháp.",
    "业务已锁定，请联系客服！": "Doanh nghiệp bị khóa, vui lòng liên hệ bộ phận chăm sóc khách hàng!",
    "无法购买本店商品": "Không thể mua hàng tại cửa hàng này",
    "参数缺失": "Thiếu thông số",
    "充值数量必填": "Trường không thể trống",
    "该邮箱已被订阅": "Email đã được đăng ký",
  },
  "tits_hi": {
    "店家id不能为空": "व्यापारी ID खाली नहीं हो सकता",
    "店家id错误": "व्यापारी ID त्रुटि",
    "关注id不能为空": "फ़ॉलो ID खाली नहीं हो सकता",
    "商品id不能为空": "उत्पाद ID खाली नहीं हो सकता",
    "商品id错误": "उत्पाद ID त्रुटि",
    "收藏id不能为空": "पसंदीदा ID खाली नहीं हो सकता",
    "系统无该用户，或者ip地址不正确": "सिस्टम में ऐसा कोई उपयोगकर्ता नहीं है, या IP पता गलत है",
    "邮码不能超过32个字符": "पिन कोड 32 अक्षरों से अधिक नहीं हो सकता",
    "请输入关键字搜索": "कृपया खोजने के लिए कीवर्ड दर्ज करें",
    "登陆密码长度不符合设定": "गलत पासवर्ड",
    "资金密码长度不符合设定": "पासवर्ड की लंबाई सेटिंग्स से मेल नहीं खाती",
    "登陆密码不符合设定": "गलत पासवर्ड",
    "服务器错误(500)": "सर्वर त्रुटि (500)",
    "找不到用户": "उपयोगकर्ता नहीं मिला",
    "不能为空": "यह खाली नहीं हो सकता",
    "工作地址不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "家庭地址不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "亲属姓名不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "亲属关系不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "亲属地址不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "亲属电话不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "参数错误": "पैरामीटर त्रुटि",
    "不在交易时段": "ट्रेडिंग सत्र से बाहर",
    "存在不同杠杆的持仓单": "विभिन्न उत्तोलन विकल्प हैं",
    "可平仓合约张数不足": "करीबी स्थिति अनुबंधों की अपर्याप्त संख्या",
    "请输入正确的货币数量": "कृपया सही मात्रा दर्ज करें",
    "请选择正确的币种": "कृपया सही मुद्रा चुनें",
    "金额错误": "राशि त्रुटि",
    "跟单参数输入错误": "एकाधिक इनपुट त्रुटि",
    "跟单倍数输入错误": "एकाधिक इनपुट त्रुटि",
    "交易员不存在": "विक्रेता मौजूद नहीं है",
    "交易员未开启带单": "विक्रेता ने ऑर्डर नहीं खोला है",
    "用户已跟随交易员": "उपयोगकर्ता स्टोर का अनुसरण कर रहा है",
    "交易员跟随人数已满": "फॉलो करने वाले व्यापारियों की संख्या पूरी है",
    "交易员不能跟随自己": "विक्रेता स्वयं का अनुसरण नहीं कर सकते",
    "交易员无法跟随另一个交易员": "विक्रेता किसी अन्य विक्रेता का अनुसरण नहीं कर सकता",
    "历史基金无法购买": "पिछले फंड खरीदे नहीं जा सकते",
    "该基金尚未开放购买": "खरीद के लिए फंड नहीं खोला गया है",
    "该基金尚已封闭": "फंड बंद कर दिया गया है",
    "基金剩余购买金额不足": "निधि की शेष क्रय राशि अपर्याप्त है",
    "下单不能小于最小金额限制": "ऑर्डर प्लेसमेंट राशि न्यूनतम सीमा से कम नहीं हो सकती",
    "[symbol]参数为空": "[प्रतीक] पैरामीटर खाली है",
    "矿机不存在": "खनन मशीन मौजूद नहीं है",
    "矿机未解锁，无法购买": "खनन मशीन बंद है और खरीदी नहीं जा सकती।",
    "您已购买过体验矿机,不得重复购买": "आपने पहले ही अनुभव खनन मशीन खरीद ली है। इसे दोबारा न खरीदें",
    "买入金额需要在区间内": "खरीद राशि सीमा में होनी चाहिए",
    "行情获取异常，稍后再试": "उद्धरण असामान्य है, कृपया बाद में पुनः प्रयास करें",
    "广告不存在": "विज्ञापन मौजूद नहीं है",
    "广告已下架": "विज्ञापन हटा दिया गया है",
    "承兑商不存在": "स्वीकर्ता मौजूद नहीं है",
    "请先添加收款方式": "कृपया पहले भुगतान विधि जोड़ें",
    "您没有符合条件的收款方式": "आपके पास कोई योग्य भुगतान विधि नहीं है",
    "请选择买卖方式": "कृपया भुगतान विधि चुनें",
    "请输入正确的金额": "कृपया सही मात्रा दर्ज करें",
    "请输入正确的数量": "कृपया सही मात्रा दर्ज करें",
    "该广告剩余数量不足": "शेष विज्ञापनों की संख्या अपर्याप्त है",
    "金额不在购买区间": "राशि क्रय सीमा में नहीं है",
    "用户剩余数量不足": "उपयोगकर्ताओं की अपर्याप्त संख्या",
    "未找到符合条件的匹配订单": "कोई मिलान आदेश नहीं मिला",
    "该订单已取消": "इस आदेश को रद्द कर दिया गया है",
    "当前订单不为待付款状态，无法取消": "वर्तमान आदेश लंबित स्थिति में नहीं है. इसे रद्द नहीं किया जा सकता.",
    "卖方无法取消该订单": "विक्रेता ऑर्डर रद्द नहीं कर सकता",
    "订单已完成": "ऑर्डर पूरा हो गया",
    "订单已取消": "ऑर्डर रद्द कर दिया गया है",
    "待付款的订单无法放行": "लंबित भुगतान जारी करने में असमर्थ",
    "订单已完成，无法放行": "आदेश पूरा हो चुका है और जारी नहीं किया जा सकता",
    "订单已取消，无法放行": "आदेश रद्द कर दिया गया है और जारी नहीं किया जा सकता",
    "未授权访问": "अनधिकृत पहुंच",
    "图片大小不能超过2M！": "किसी छवि के लिए फ़ाइल का आकार 2M से अधिक नहीं हो सकता!",
    "无效的UID": "अमान्य यूआईडी",
    "图片上传失败": "छवि अपलोड करने में विफल",
    "图片不得大于2M": "किसी छवि के लिए फ़ाइल का आकार 2M से बड़ा नहीं हो सकता",
    "图片不得大于10M": "किसी छवि के लिए फ़ाइल का आकार 10M से बड़ा नहीं हो सकता",
    "存在重复的角色名称": "डुप्लिकेट भूमिका नाम",
    "角色被用户关联，不可删除": "भूमिका उपयोगकर्ता द्वारा संबद्ध है. इसे हटाया नहीं जा सकता",
    "[code]值错误": "[कोड] मान ग़लत है",
    "身份证已实名过!": "आईडी कार्ड सत्यापित हो गया है!",
    "实名认证未通过，无法进行高级认证": "प्रमाणीकरण विफल होना; उन्नत प्रमाणीकरण करने में असमर्थ",
    "收款方输入错误": "इनपुट त्रुटि",
    "所选汇率不存在": "चयनित विनिमय दर मौजूद नहीं है",
    "转账数量不能小于等于0": "स्थानांतरण राशि 0 से कम या उसके बराबर नहीं हो सकती",
    "UID不能为空": "यूआईडी खाली नहीं हो सकता",
    "转账币种不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "提现不得小于限额": "नकद निकासी सीमा से कम नहीं हो सकती",
    "提现不得大于限额": "नकद निकासी सीमा से अधिक नहीं हो सकती",
    "当日可提现次数不足": "प्रति दिन नकदी निकासी की अपर्याप्त संख्या",
    "不在可提现时间内": "निकासी अवधि से बाहर",
    "渠道未开通": "चैनल नहीं खुला",
    "请先通过高级认证": "कृपया पहले उन्नत प्रमाणीकरण पास करें",
    "角色不存在": "भूमिका मौजूद नहीं है",
    "持有币种不足": "पर्याप्त फंडिंग नहीं",
    "请输入充值币种": "कृपया जमा मुद्रा दर्ज करें",
    "请上传图片": "कृपया चित्र अपलोड करें",
    "当前还需交易": "लेन-देन अभी भी आवश्यक है",
    ",才可提币": ", और फिर नकदी निकाली जा सकती है।",
    "提示": "बख्शीश",
    "未实名认证，是否认证？": "वास्तविक नाम से प्रमाणित नहीं. प्रमाणित करें?",
    "帐户异常需要进行C3认证，请联系在线客服。": "खाता अपवाद के लिए C3 प्रमाणीकरण की आवश्यकता है. कृपया ऑनलाइन ग्राहक सेवा से संपर्क करें।",
    "确认": "सत्यापित करें",
    "取消": "रद्द करना",
    "更新提醒": "अनुस्मारक अद्यतन करें",
    "发现新版本，请升级到最新版本": "एक नया संस्करण मिला, कृपया नवीनतम संस्करण में अपग्रेड करें",
    "您已存在订单": "आपके पास एक आदेश है",
    "当前地址格式错误": "वर्तमान पता गलत प्रारूप में है",
    "申购数量错误": "खरीद की राशि गलत है",
    "产品不存在": "उत्पाद मौजूद नहीं है",
    "该产品未上架": "यह उत्पाद सूचीबद्ध नहीं है",
    "该产品已上市，无法购买": "यह उत्पाद बाज़ार में है और इसे खरीदा नहीं जा सकता",
    "当日才可申购": "केवल उसी दिन खरीद के लिए उपलब्ध है",
    "产品剩余数量不足": "उत्पाद की शेष मात्रा अपर्याप्त है",
    "您当前可分配额度不足": "आपकी वर्तमान आवंटन योग्य सीमा पर्याप्त नहीं है",
    "购买矿机时间不得低于托管订单剩余时间": "खनन मशीनें खरीदने का समय होस्टिंग ऑर्डर के शेष समय से कम नहीं होना चाहिए",
    "请输入正确的质押金额": "कृपया सही प्रतिज्ञा राशि दर्ज करें",
    "请输入正确的质押天数": "कृपया गिरवी रखने के दिनों की सही संख्या दर्ज करें",
    "未发现授权记录": "प्राधिकरण रिकार्ड नहीं मिला है",
    "授权状态未成功": "प्राधिकरण स्थिति विफल",
    "赎回状态异常": "मोचन स्थिति असामान्य",
    "申请成功": "सफल हुए",
    "领取成功": "सफलतापूर्वक प्राप्त हुआ",
    "未找到匹配的收益记录": "कोई मिलान राजस्व रिकॉर्ड नहीं मिला",
    "已领取": "प्राप्त",
    "校验IP不合法": "सत्यापन आईपी अमान्य है",
    "委托数量(张)必填": "सौंपी गई मात्रा (पीसी) आवश्यक है",
    "委托数量(张)不能小于等于0": "सौंपी गई मात्रा (पीसी) 0 से कम या उसके बराबर नहीं हो सकती",
    "请先绑定谷歌验证器": "कृपया पहले Google प्रमाणक को आबद्ध करें",
    "资金密码必须6-12位": "फंड पासवर्ड 6-12 अक्षर का होना चाहिए",
    "验证码错误": "सत्यापन कोड त्रुटि",
    "登录密码必须6-12位": "पासवर्ड 6-12 अक्षर का होना चाहिए",
    "密码必须6-12位": "पासवर्ड 6-12 अक्षर का होना चाहिए",
    "操作类型不是整数": "ऑपरेशन प्रकार पूर्णांक नहीं है",
    "状态不是整数": "स्थिति एक पूर्णांक नहीं है",
    "状态不能小于0": "स्थिति 0 से कम नहीं हो सकती",
    "-连接已建立-": "-कनेक्शन स्थापित-",
    "代理层级错误": "एजेंट त्रुटि",
    "已提交评论!": "समीक्षा सबमिट की गई!",
    "该商品已下架": "इस उत्पादन उपलब्ध नहीं है",
    "未指定商家": "अनिर्दिष्ट व्यवसाय",
    "该手机号已被占用，请绑定其他手机号":
      "एक फोन नंबर पहली से उपलब्ध है, कृपया अन्य फोन नंबर सेट करें",
    "参数异常，消息获取失败": "पैरामीटर अपवाद, संदेश प्राप्ति विफल",
    "邮箱验证码发送次数过多，请明天再试": 
      "ईमेल सत्यापन कोड बहुत बार भेजा गया है, कृपया कल पुनः प्रयास करें।",
    "该邮箱已被占用，请更换其他邮箱注册":
      "इमेल पहली से उपलब्ध है, कृपया अन्य ईमेल पंजीकरण करें",
    "系统错误": "सिस्टम त्रुटि",
    "暂无店铺": "अभी तक कोई दुकान नहीं",
    "当前账号有未完成的提现订单，请完成后再试": "चालू खाते में निकासी आदेश अधूरा है, कृपया पूरा करें और पुनः प्रयास करें",
    "当前账号有未完成的充值订单，请完成后再试": "चालू खाते में एक अधूरा रिचार्ज ऑर्डर है, कृपया पूरा होने के बाद पुनः प्रयास करें",
    "请先登录": "कृपया लॉगिन करें",
    "无此sellerGoods": "ऐसा कोई विक्रेता नहीं है",
    "该角色账号不允许注销": "इस वर्ण खाते को लॉगआउट करने की अनुमति नहीं है",
    "当前的用户账号与确认注销的账号不一致": "वर्तमान उपयोगकर्ता खाता लॉगआउट करने की पुष्टि किए गए खाते से असंगत है",
    "密码输入错误次数过多，请明天再试": "भी कई प्रयास। कृपया कल फिर से प्रयास करें",
    "注销失败": "लॉगआउट विफल",
    "注销成功": "लॉगआउट सफल",
    "不在提现时间范围内，请稍后再试": "निकासी समय सीमा के भीतर नहीं, कृपया बाद में पुनः प्रयास करें",
    "不支持的语言": "असमर्थित भाषाएँ",
    "部分商品已下架": "कुछ सामान हटा लिया गया है",
    "参数错误!": "पैरामीटर त्रुटि!",
    "操作成功": "ऑपरेशन सफल हुआ",
    "操作类型必须为整数": "ऑपरेशन प्रकार पूर्णांक नहीं है",
    "操作类型不能小于0": "ऑपरेशन प्रकार 0 से कम नहीं हो सकता",
    "操作类型不正确": "गलत संचालन प्रकार",
    "操作类型为空": "फ़ील्ड खाली नहीं हो सकती",
    "操作频繁，请稍后再试": "बार-बार ऑपरेशन. कृपया बाद में पुन: प्रयास करें",
    "操作失败，请稍后再试": "प्रचालन विफल रहा। कृपया बाद में पुन: प्रयास करें",
    "操作失败！修正后账户余额小于0。": "प्रचालन विफल रहा! सुधार के बाद खाते का शेष 0 से कम है",
    "超过提现次数": "नकद निकासी का समय पार हो गया",
    "程序错误": "प्रोग्राम त्रुटि",
    "充值价值不得大于最大限额": "पुनर्भरण मूल्य अधिकतम सीमा से अधिक नहीं होगा",
    "充值价值不得小于最小限额": "रिचार्ज मूल्य न्यूनतम सीमा से कम नहीं होगा",
    "充值链错误": "चार्जिंग चेन त्रुटि",
    "大于最大采购数量": "अधिकतम खरीद मात्रा से अधिक",
    "当前用户已经被管理员禁用": "वर्तमान उपयोगकर्ता को व्यवस्थापक द्वारा अक्षम कर दिया गया है",
    "地址不存在,或者已删除": "पता मौजूद नहीं है या हटा दिया गया है",
    "地址不能为空": "पता खाली नहीं हो सकता",
    "地址过长": "पता बहुत लंबा है",
    "登陆密码长度不符合要求": "लॉगिन पासवर्ड की लंबाई सेटिंग से मेल नहीं खाती।",
    "登录密码必须为6-12位": "लॉगिन पासवर्ड 6-12 अक्षर का होना चाहिए",
    "登录密码不能为空": "लॉगिन पासवर्ड खाली नहीं हो सकता",
    "登录失败": "लॉगिन विफल",
    "电话号码已绑定": "फ़ोन नंबर बाध्य कर दिया गया है",
    "电话号码已绑定其他用户": "फ़ोन नंबर अन्य उपयोगकर्ताओं के लिए बाध्य कर दिया गया है",
    "店家ID不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "店家ID错误": "स्टोर आईडी त्रुटि.",
    "订单不存在": "आदेश मौजूद नहीं है",
    "订单号不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "订单已经发货，无法退款": "ऑर्डर भेज दिया गया है और वापस नहीं किया जा सकता",
    "非法请求": "अवैध अनुरोध",
    "服务器错误": "सर्वर त्रुटि",
    "该贷款单还未通过审核": "ऋण आदेश स्वीकृत नहीं हुआ है.",
    "该贷款单号不存在": "ऋण आदेश संख्या मौजूद नहीं है.",
    "该订单未满足支付条件": "आदेश भुगतान शर्तों को पूरा नहीं करता.",
    "该订单状态无法操作": "आदेश की स्थिति निष्क्रिय है",
    "该手机号码已被占用，绑定新手机号码失败": "मोबाइल फ़ोन नंबर ले लिया गया है, और नया मोबाइल फ़ोन नंबर विफल हो गया है",
    "该邮箱已被占用，绑定新邮箱失败": "मेलबॉक्स पर कब्जा कर लिया गया है, और नया मेलबॉक्स विफल होने के लिए बाध्य है",
    "更新钱包失败，请联系客服": "वॉलेट अपडेट करने में विफल. कृपया ग्राहक सेवा से संपर्क करें.",
    "购买失败,联系客服": "खरीद विफल रही। कृपया ग्राहक सेवा से संपर्क करें.",
    "关注ID不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "会话ID不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "旧密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "旧密码不正确": "ग़लत पुराना पासवर्ड",
    "类型不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "连续输入错误三次，请3分钟后再试": "लगातार तीन बार त्रुटि दर्ज करें। कृपया 3 मिनट में पुनः प्रयास करें",
    "联系人不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "两次输入的密码不相同": "पासवर्ड मेल नहीं खाते",
    "两次输入的资金密码不相同": "पासवर्ड मेल नहीं खाते",
    "没有找到用户": "कोई उपयोगकर्ता नहीं मिला",
    "密码必须为6-12位": "पासवर्ड 6-12 अक्षर का होना चाहिए",
    "密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "密码不正确": "गलत पासवर्ड",
    "密码确认不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "模块名不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "您的申请之前已提交过": "आपका आवेदन पहले ही सबमिट कर दिया गया है",
    "请检查网络连接": "कृपया अपना नेटवर्क कनेक्शन जांचें",
    "请上传图片格式的文件": "कृपया चित्र प्रारूप में एक फ़ाइल अपलोड करें",
    "请稍后再试": "कृपया बाद में पुन: प्रयास करें",
    "请设置资金密码": "कृपया फंड पासवर्ड सेट करें",
    "请输入内容": "कृपया सामग्री दर्ज करें",
    "请输入正确的手机号码": "कृपया सही फ़ोन नंबर दर्ज करें",
    "请输入正确的邮箱地址": "कृपया सही ईमेल पता दर्ज करें",
    "请填写正确的电话号码": "कृपया सही फ़ोन नंबर भरें",
    "请填写正确的验证码": "कृपया सही सत्यापन कोड दर्ज करें",
    "请填写正确的邮箱地址": "कृपया सही ईमेल पता भरें",
    "请勿重复添加": "बार-बार न जोड़ें",
    "请先选择国家及州": "कृपया पहले देश और राज्य चुनें",
    "请先选择州": "कृपया पहले राज्य का चयन करें",
    "请选择收货地址": "कृपया शिपिंग पता चुनें",
    "请重新登录": "कृपया फिर भाग लें",
    "取消失败": "रद्द करना विफल रहा",
    "删除失败": "हटाना विफल",
    "商品ID不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "商品ID错误": "उत्पाद आईडी त्रुटि",
    "少于最小采购数量": "न्यूनतम खरीद मात्रा से कम",
    "身份证号已实名过!": "आईडी कार्ड नंबर प्रमाणित कर दिया गया है!",
    "审核已通过": "समीक्षा पारित हुई",
    "审核中": "समीक्षा के अंतर्गत",
    "审核状态异常请联系客服": "ऑडिट की स्थिति असामान्य है. कृपया ग्राहक सेवा से संपर्क करें.",
    "实名认证尚未通过，无法重置": "वास्तविक नाम प्रमाणीकरण पारित नहीं हुआ है. इसे रीसेट नहीं किया जा सकता.",
    "实名姓名不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "试用码不正确": "ग़लत परीक्षण कोड",
    "收藏ID不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "收货地址达上限": "शिपिंग पता सीमा तक",
    "收货人姓名不能超过64个字符": "प्रेषिती का नाम 64 अक्षरों से अधिक नहीं हो सकता",
    "收货失败": "उत्पाद प्राप्त विफल रहा",
    "手机号不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "提币数量必填": "नकद निकासी की मात्रा आवश्यक है",
    "提币数量不能小于等于0": "निकासी की मात्रा 0 से कम या उसके बराबर नहीं हो सकती।",
    "提币数量输入错误，请输入浮点数": "निकासी राशि गलत दर्ज की गई है, कृपया फ़्लोटिंग-पॉइंट नंबर दर्ज करें",
    "提交失败": "सबमिट विफल",
    "提交失败，当前有未处理订单": "सबमिशन विफल. फिलहाल खुले ऑर्डर हैं.",
    "提款金额不得低于最小提款限额": "निकासी राशि न्यूनतम निकासी सीमा से कम नहीं होगी।",
    "提款金额不得高于最大提款限额": "निकासी राशि अधिकतम निकासी सीमा से अधिक नहीं होगी।",
    "添加失败": "जोड़ने में विफल",
    "图片不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "图片大小不能超过30M": "चित्र का आकार 30M से अधिक नहीं हो सकता",
    "图形验证错误，请重新再试": "ग्राफ़िक सत्यापन त्रुटि. कृपया पुन: प्रयास करें।",
    "推荐码不正确": "अनुशंसा कोड ग़लत है.",
    "推荐人无权限推荐": "सिफ़ारिशकर्ता को सिफ़ारिश करने का कोई अधिकार नहीं है।",
    "退货失败": "उत्पाद वापसी विफल रही",
    "未绑定谷歌验证器": "Google सत्यापनकर्ता बाध्य नहीं है",
    "未绑定手机号": "कोई फ़ोन नंबर बाध्य नहीं है",
    "未绑定邮箱": "कोई मेलबॉक्स बाध्य नहीं है",
    "无权限": "आज्ञा नहीं है",
    "系统参数错误": "सिस्टम पैरामीटर त्रुटि",
    "系统存在相同[系统登录名]！": "सिस्टम वही मौजूद है [सिस्टम लॉगिन नाम]!",
    "系统错误，请稍后重试": "सिस्टम त्रुटि, कृपया बाद में पुनः प्रयास करें",
    "请稍后重试": "कृपया बाद में पुन: प्रयास करें",
    "系统无该用户，或者IP地址不正确": "सिस्टम में कोई उपयोगकर्ता नहीं है, या आईपी पता गलत है।",
    "系统用户登录名不存在！": "सिस्टम उपयोगकर्ता लॉगिन नाम मौजूद नहीं है.",
    "新密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "新密码不一致": "नया पासवर्ड मूल प्रविष्टि के समान नहीं है",
    "新密码确认不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "验证类型不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "验证码不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "验证码不正确": "ग़लत सत्यापन कोड",
    "邀请码不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "邀请码无效": "अमान्य आमंत्रण कोड",
    "页码不能小于等于0": "पृष्ठ संख्या 0 से कम या उसके बराबर नहीं हो सकती",
    "页码不是整数": "पृष्ठ संख्या पूर्णांक नहीं है",
    "已经提交申请，请等待审核": "आवेदन जमा कर दिया गया है. कृपया अनुमोदन की प्रतीक्षा करें.",
    "已有未完成的贷款单，不能重复申请": "लोन का दस्तावेज़ अधूरा है. इसे दोबारा लागू नहीं किया जा सकता.",
    "用户不存在": "उपभोगकर्ता मौजूद नहीं",
    "用户名必须为6-30位": "उपयोगकर्ता नाम 6-30 अंकों का होना चाहिए",
    "用户名必须由数字和英文字母组成": "उपयोगकर्ता नाम में अंक और अक्षर शामिल होने चाहिए",
    "用户名不存在": "उपयोगकर्ता नाम मौजूद नहीं है",
    "用户名不符合设定": "उपयोगकर्ता नाम सेटिंग से मेल नहीं खाता",
    "用户名不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "用户名参数为空": "फ़ील्ड खाली नहीं हो सकती",
    "用户名重复": "डुप्लिकेट उपयोक्तानाम",
    "用户已锁定": "उपयोगकर्ता लॉक किया गया",
    "邮编不能超过32个字符": "पोस्टकोड 32 अक्षरों से अधिक नहीं हो सकता",
    "邮箱的长度不能超过64个字符": "मेलबॉक्स की लंबाई 64 अक्षरों से अधिक नहीं हो सकती",
    "邮箱已绑定": "मेलबॉक्स बाध्यकारी रहा है",
    "邮箱已绑定其他用户": "मेलबॉक्स अन्य उपयोगकर्ताओं के लिए बाध्य कर दिया गया है",
    "游客不能向游客发送消息": "पर्यटक आगंतुकों को संदेश नहीं भेज सकते",
    "余额不足": "अपर्याप्त शेषराशि",
    "暂无用户": "कोई उपयोगकर्ता नहीं मिला",
    "正在购买": "क्रय",
    "直线关系，不能修改推荐": "सीधी रेखा संबंध, अनुशंसा को संशोधित नहीं किया जा सकता",
    "重复提交": "पुनः सबमिट करें",
    "注册类型（手机或邮箱）不能为空": "पंजीकरण प्रकार (मोबाइल या ईमेल) खाली नहीं हो सकता",
    "资金密码必须为6-12位": "फंड पासवर्ड 6-12 अंकों का होना चाहिए।",
    "资金密码不符合设定": "फंड पासवर्ड सेटिंग के अनुरूप नहीं है.",
    "资金密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
    "资金密码错误": "फंड पासवर्ड त्रुटि",
    "Party ID不正确，系统无该用户": "पार्टी आईडी ग़लत है. सिस्टम में उपयोगकर्ता नहीं है.",
    "Token失效,请重新登录": "टोकन अमान्य है. कृपया फिर भाग लें।",
    "登录过期，请重新登录": "लॉगिन समाप्त हो गया. कृपया फिर भाग लें।",
    "请输入搜索关键字": "कृपया खोज कीवर्ड दर्ज करें",
    "地址格式与协议不匹配": "पता प्रारूप प्रोटोकॉल से मेल नहीं खाता",
    "用户已绑定过提现地址": "उपयोगकर्ता ने निकासी पते को बाध्य कर दिया है",
    "绑定提现地址成功": "निकासी पते को सफलतापूर्वक बाइंडिंग",
    "未设置地址": "पता सेट नहीं है",
    "您有一笔提现正在处理中": "आपकी निकासी प्रगति पर है",
    "平台人工发起退款": "प्लेटफ़ॉर्म मैन्युअल रूप से रिफंड शुरू करता है",
    "充值数量不能小于等于0": "रिचार्ज मात्रा 0 से कम या उसके बराबर नहीं हो सकती।",
    "请选择法币类型": "  कृपया कानूनी मुद्रा प्रकार चुनें.",
    "充值金额超过最大金额": "रिचार्ज राशि अधिकतम राशि से अधिक है.",
    "充值金额小于最小金额": "रिचार्ज राशि न्यूनतम राशि से कम है।",
    "请选择正确的法币类型": "कृपया सही कानूनी मुद्रा प्रकार चुनें।",
    "业务已锁定，请联系客服！":"व्यवसाय बंद है, कृपया ग्राहक सेवा से संपर्क करें!",
    "无法购买本店商品": "इस स्टोर में सामान खरीदने में असमर्थ",
    "参数缺失": "गुम पैरामीटर",
    "该邮箱已被订阅": "इस ईमेल पता पहले से सफलताप",
    "充值数量必填": "फ़ील्ड खाली नहीं हो सकती",
    // "该邮箱已被订阅":""
  },
  "tits_id":{
    "店家id不能为空": "ID penjual tidak boleh kosong",
    "店家id错误": "Kesalahan ID penjual",
    "关注id不能为空": "ID ikuti tidak boleh kosong",
    "商品id不能为空": "ID produk tidak boleh kosong",
    "商品id错误": "Kesalahan ID produk",
    "收藏id不能为空": "ID favorit tidak boleh kosong",
    "系统无该用户，或者ip地址不正确": "Tidak ada pengguna tersebut di sistem, atau alamat IP salah",
    "邮码不能超过32个字符": "Kode pos tidak boleh melebihi 32 karakter",
    "请输入关键字搜索": "Silakan masukkan kata kunci yang akan dicari",
    "登陆密码长度不符合设定": "Kata sandi salah",
    "资金密码长度不符合设定": "Panjang kata sandi tidak sesuai dengan pengaturan",
    "登陆密码不符合设定": "Kata sandi salah",
    "服务器错误(500)": "Kesalahan server (500)",
    "找不到用户": "Pengguna belum ditemukan",
    "不能为空": "Itu tidak boleh kosong",
    "工作地址不能为空": "Bidang ini tidak boleh kosong",
    "家庭地址不能为空": "Bidang ini tidak boleh kosong",
    "亲属姓名不能为空": "Bidang ini tidak boleh kosong",
    "亲属关系不能为空": "Bidang ini tidak boleh kosong",
    "亲属地址不能为空": "Bidang ini tidak boleh kosong",
    "亲属电话不能为空": "Bidang ini tidak boleh kosong",
    "参数错误": "Kesalahan parameter",
    "不在交易时段": "Keluar dari sesi perdagangan",
    "存在不同杠杆的持仓单": "Ada opsi leverage yang berbeda",
    "可平仓合约张数不足": "Jumlah kontrak posisi dekat tidak mencukupi",
    "请输入正确的货币数量": "Silakan masukkan jumlah yang benar",
    "请选择正确的币种": "Silakan pilih mata uang yang benar",
    "金额错误": "Kesalahan jumlah",
    "跟单参数输入错误": "Kesalahan masukan ganda",
    "跟单倍数输入错误": "Kesalahan masukan ganda",
    "交易员不存在": "Penjualnya tidak ada",
    "交易员未开启带单": "Penjual belum membuka pesanan",
    "用户已跟随交易员": "Pengguna mengikuti toko",
    "交易员跟随人数已满": "Jumlah pedagang yang mengikuti sudah penuh",
    "交易员不能跟随自己": "Penjual tidak bisa mengikuti dirinya sendiri",
    "交易员无法跟随另一个交易员": "Penjual tidak dapat mengikuti penjual lain",
    "历史基金无法购买": "Dana masa lalu tidak dapat dibeli",
    "该基金尚未开放购买": "Dana tersebut belum dibuka untuk pembelian",
    "该基金尚已封闭": "Dana telah ditutup",
    "基金剩余购买金额不足": "Jumlah sisa pembelian dana tidak mencukupi",
    "下单不能小于最小金额限制": "Jumlah penempatan pesanan tidak boleh kurang dari batas minimum",
    "[symbol]参数为空": "Parameter [simbol] kosong",
    "矿机不存在": "Mesin penambangan tidak ada",
    "矿机未解锁，无法购买": "Mesin penambangan terkunci dan tidak dapat dibeli.",
    "您已购买过体验矿机,不得重复购买": "Anda telah membeli mesin penambangan pengalaman. Jangan membelinya lagi",
    "买入金额需要在区间内": "Jumlah pembelian harus berada dalam kisaran tersebut",
    "行情获取异常，稍后再试": "Kutipannya tidak normal, coba lagi nanti",
    "广告不存在": "Iklannya tidak ada",
    "广告已下架": "Iklan tersebut telah dihapus",
    "承兑商不存在": "Akseptor tidak ada",
    "请先添加收款方式": "Silakan tambahkan metode pembayaran terlebih dahulu",
    "您没有符合条件的收款方式": "Anda tidak memiliki metode pembayaran yang memenuhi syarat",
    "请选择买卖方式": "Silakan pilih metode pembayaran",
    "请输入正确的金额": "Silakan masukkan jumlah yang benar",
    "请输入正确的数量": "Silakan masukkan jumlah yang benar",
    "该广告剩余数量不足": "Jumlah iklan yang tersisa tidak mencukupi",
    "金额不在购买区间": "Jumlahnya tidak dalam kisaran pembelian",
    "用户剩余数量不足": "Jumlah pengguna tidak mencukupi",
    "未找到符合条件的匹配订单": "Tidak ditemukan pesanan yang cocok",
    "该订单已取消": "Pesanan ini sudah dibatalkan",
    "当前订单不为待付款状态，无法取消": "Pesanan saat ini tidak dalam status tertunda. Itu tidak dapat dibatalkan.",
    "卖方无法取消该订单": "Penjual tidak dapat membatalkan pesanan",
    "订单已完成": "Pesanan telah selesai",
    "订单已取消": "Pesanan telah dibatalkan",
    "待付款的订单无法放行": "Tidak dapat melepaskan pembayaran yang tertunda",
    "订单已完成，无法放行": "Pesanan telah selesai dan tidak dapat dilepaskan",
    "订单已取消，无法放行": "Pesanan telah dibatalkan dan tidak dapat dilepaskan",
    "未授权访问": "Akses tidak sah",
    "图片大小不能超过2M！": "Ukuran file untuk sebuah gambar tidak boleh melebihi 2M!",
    "无效的UID": "UID tidak valid",
    "图片上传失败": "Gagal mengunggah gambar",
    "图片不得大于2M": "Ukuran file untuk gambar tidak boleh lebih besar dari 2M",
    "图片不得大于10M": "Ukuran file untuk gambar tidak boleh lebih besar dari 10M",
    "存在重复的角色名称": "Nama peran duplikat",
    "角色被用户关联，不可删除": "Peran dikaitkan oleh pengguna. Itu tidak dapat dihapus",
    "[code]值错误": "nilai [kode] salah",
    "身份证已实名过!": "KTP sudah terverifikasi!",
    "实名认证未通过，无法进行高级认证": "Otentikasi gagal; tidak dapat melakukan otentikasi tingkat lanjut",
    "收款方输入错误": "Kesalahan masukan",
    "所选汇率不存在": "Nilai tukar yang dipilih tidak ada",
    "转账数量不能小于等于0": "Jumlah transfer tidak boleh kurang dari atau sama dengan 0",
    "UID不能为空": "UID tidak boleh kosong",
    "转账币种不能为空": "Bidang ini tidak boleh kosong",
    "提现不得小于限额": "Penarikan tunai tidak boleh kurang dari batas",
    "提现不得大于限额": "Penarikan tunai tidak boleh lebih besar dari batasnya",
    "当日可提现次数不足": "Jumlah tarik tunai per hari tidak mencukupi",
    "不在可提现时间内": "Di luar periode penarikan",
    "渠道未开通": "Saluran tidak dibuka",
    "请先通过高级认证": "Silakan lulus sertifikasi lanjutan terlebih dahulu",
    "角色不存在": "Peran tidak ada",
    "持有币种不足": "Pendanaan tidak cukup",
    "请输入充值币种": "Silakan masukkan mata uang Deposit",
    "请上传图片": "Silakan unggah gambar",
    "当前还需交易": "Transaksi masih diperlukan",
    ",才可提币": ", dan kemudian uang tunai dapat ditarik.",
    "提示": "Tip",
    "未实名认证，是否认证？": "Tidak diautentikasi dengan nama asli. Otentikasi?",
    "帐户异常需要进行C3认证，请联系在线客服。": "Pengecualian akun memerlukan autentikasi C3. Silakan hubungi Layanan Pelanggan online.",
    "确认": "Memeriksa",
    "取消": "Membatalkan",
    "更新提醒": "Perbarui pengingat",
    "发现新版本，请升级到最新版本": "Menemukan versi baru, harap tingkatkan ke versi terbaru",
    "您已存在订单": "Anda punya pesanan",
    "当前地址格式错误": "Alamat saat ini dalam format yang salah",
    "申购数量错误": "Jumlah pembelian salah",
    "产品不存在": "Produknya tidak ada",
    "该产品未上架": "Produk ini tidak terdaftar",
    "该产品已上市，无法购买": "Produk ini ada di pasaran dan tidak dapat dibeli",
    "当日才可申购": "Hanya tersedia untuk pembelian pada hari yang sama",
    "产品剩余数量不足": "Jumlah produk yang tersisa tidak mencukupi",
    "您当前可分配额度不足": "Batas alokasi Anda saat ini tidak cukup",
    "购买矿机时间不得低于托管订单剩余时间": "Waktu pembelian mesin penambangan tidak boleh kurang dari sisa waktu pemesanan hosting",
    "请输入正确的质押金额": "Silakan masukkan jumlah kontribusi yang benar",
    "请输入正确的质押天数": "Silakan masukkan jumlah hari yang benar untuk melakukan kontribusi",
    "未发现授权记录": "Catatan otorisasi belum ditemukan",
    "授权状态未成功": "Status otorisasi gagal",
    "赎回状态异常": "Status penukaran tidak normal",
    "申请成功": "Berhasil",
    "领取成功": "Berhasil diterima",
    "未找到匹配的收益记录": "Tidak ditemukan catatan pendapatan yang cocok",
    "已领取": "Diterima",
    "校验IP不合法": "IP verifikasi tidak valid",
    "委托数量(张)必填": "Kuantitas yang dipercayakan (pcs.) diperlukan",
    "委托数量(张)不能小于等于0": "Jumlah yang dipercayakan (pcs) tidak boleh kurang dari atau sama dengan 0",
    "请先绑定谷歌验证器": "Harap ikat Google Authenticator terlebih dahulu",
    "资金密码必须6-12位": "Kata sandi dana harus 6-12 karakter",
    "验证码错误": "Kesalahan kode verifikasi",
    "登录密码必须6-12位": "Kata sandi harus terdiri dari 6-12 karakter",
    "密码必须6-12位": "Kata sandi harus terdiri dari 6-12 karakter",
    "操作类型不是整数": "Jenis operasinya bukan bilangan bulat",
    "状态不是整数": "Status bukanlah bilangan bulat",
    "状态不能小于0": "Status tidak boleh kurang dari 0",
    "-连接已建立-": "-Koneksi terjalin-",
    "代理层级错误": "Kesalahan agen",
    "已提交评论!": "Tinjauan telah dikirimkan!",
    "该商品已下架": "Barang ini sudah dijual",
    "邮箱验证码发送次数过多，请明天再试": "Kode verifikasi email sudah terlalu sering dikirim, silakan coba lagi besok.",
    "该手机号已被占用，请绑定其他手机号": 
    "Nomor ponsel ini sudah terisi, silakan ikat nomor ponsel yang lain",
    "该邮箱已被占用，请更换其他邮箱注册":
    "Alamat email ini sudah terisi, silakan mendaftar dengan alamat email lain",
    "未指定商家": "Bisnis yang tidak ditentukan",
    "参数异常，消息获取失败": "Pengecualian parameter, akuisisi pesan gagal",
    "系统错误": "sistem bermasalah",
    "暂无店铺": "Belum ada toko",
    "该邮箱已被订阅": "Email ini telah terpasang",
    "当前账号有未完成的提现订单，请完成后再试": "Rekening saat ini memiliki perintah penarikan yang belum selesai, silakan selesaikan dan coba lagi",
    "当前账号有未完成的充值订单，请完成后再试": "Rekening saat ini memiliki pesanan isi ulang yang belum selesai, silakan coba lagi setelah selesai",
    "请先登录": "silahkan masuk",
    "无此sellerGoods": "Tidak ada penjual seperti itu. Barang",
    "该角色账号不允许注销": "Akun karakter ini tidak diperbolehkan logout",
    "当前的用户账号与确认注销的账号不一致": "Akun pengguna saat ini tidak sesuai dengan akun yang dikonfirmasi untuk logout",
    "密码输入错误次数过多，请明天再试": "Terlalu banyak upaya. Silakan coba lagi besok",
    "注销失败": "Gagal keluar",
    "注销成功": "Logout berhasil",
    "不在提现时间范围内，请稍后再试": "Tidak dalam rentang waktu penarikan, silakan coba lagi nanti",
    "不支持的语言": "Bahasa tidak didukung",
    "部分商品已下架": "Beberapa item telah diturunkan",
    "参数错误!": "Kesalahan parameter!",
    "操作成功": "Operasi berhasil",
    "操作类型必须为整数": "Jenis operasi bukan bilangan bulat",
    "操作类型不能小于0": "Jenis operasi tidak boleh kurang dari 0",
    "操作类型不正确": "Jenis operasi salah",
    "操作类型为空": "Bidang ini tidak boleh kosong",
    "操作频繁，请稍后再试": "Operasi yang sering. Silakan coba lagi nanti",
    "操作失败，请稍后再试": "Operasi gagal. Silakan coba lagi nanti",
    "操作失败！修正后账户余额小于0。": "Operasi gagal! Saldo akun setelah koreksi kurang dari 0",
    "超过提现次数": "Waktu penarikan tunai terlampaui",
    "程序错误": "Kesalahan program",
    "充值价值不得大于最大限额": "Nilai isi ulang tidak boleh lebih besar dari batas maksimum",
    "充值价值不得小于最小限额": "Nilai isi ulang tidak boleh kurang dari batas minimum",
    "充值链错误": "Kesalahan rantai pengisian daya",
    "大于最大采购数量": "Lebih besar dari jumlah pembelian maksimum",
    "当前用户已经被管理员禁用": "Pengguna saat ini telah dinonaktifkan oleh administrator",
    "地址不存在,或者已删除": "Alamat tidak ada atau telah dihapus",
    "地址不能为空": "Alamat tidak boleh kosong",
    "地址过长": "Alamat terlalu panjang",
    "登陆密码长度不符合要求": "Panjang kata sandi login tidak sesuai dengan pengaturan.",
    "登录密码必须为6-12位": "Kata sandi masuk harus 6-12 karakter",
    "登录密码不能为空": "Kata sandi masuk tidak boleh kosong",
    "登录失败": "Gagal masuk",
    "电话号码已绑定": "Nomor telepon telah terikat",
    "电话号码已绑定其他用户": "Nomor telepon telah terikat dengan pengguna lain",
    "店家ID不能为空": "Bidang ini tidak boleh kosong",
    "店家ID错误": "Kesalahan ID toko.",
    "订单不存在": "Pesanan tidak ada",
    "订单号不能为空": "Bidang ini tidak boleh kosong",
    "订单已经发货，无法退款": "Pesanan telah dikirim dan tidak dapat dikembalikan",
    "非法请求": "Permintaan ilegal",
    "服务器错误": "Server error",
    "该贷款单还未通过审核": "Perintah pinjaman belum disetujui.",
    "该贷款单号不存在": "Nomor pesanan pinjaman tidak ada.",
    "该订单未满足支付条件": "Pesanan tidak memenuhi ketentuan pembayaran.",
    "该订单状态无法操作": "Status pesanan tidak dapat dioperasikan",
    "该手机号码已被占用，绑定新手机号码失败": "Nomor ponsel telah terisi, dan nomor ponsel baru gagal",
    "该邮箱已被占用，绑定新邮箱失败": "Kotak surat telah ditempati, dan kotak surat baru pasti akan gagal",
    "更新钱包失败，请联系客服": "Gagal memperbarui dompet. Silakan hubungi layanan pelanggan.",
    "购买失败,联系客服": "Pembelian gagal. Silakan hubungi layanan pelanggan.",
    "关注ID不能为空": "Bidang ini tidak boleh kosong",
    "会话ID不能为空": "Bidang ini tidak boleh kosong",
    "旧密码不能为空": "Bidang ini tidak boleh kosong",
    "旧密码不正确": "Kata sandi lama salah",
    "类型不能为空": "Bidang ini tidak boleh kosong",
    "连续输入错误三次，请3分钟后再试": "Masukkan kesalahan sebanyak 3 kali berturut-turut. Silakan coba lagi dalam 3 menit",
    "联系人不能为空": "Bidang ini tidak boleh kosong",
    "两次输入的密码不相同": "Kata sandi tidak cocok",
    "两次输入的资金密码不相同": "Kata sandi tidak cocok",
    "没有找到用户": "Tidak ada pengguna yang ditemukan",
    "密码必须为6-12位": "Kata sandi harus terdiri dari 6-12 karakter",
    "密码不能为空": "Bidang ini tidak boleh kosong",
    "密码不正确": "Kata kunci Salah",
    "密码确认不能为空": "Bidang ini tidak boleh kosong",
    "模块名不能为空": "Bidang ini tidak boleh kosong",
    "您的申请之前已提交过": "Permohonan Anda telah dikirimkan sebelumnya",
    "请检查网络连接": "Silakan periksa koneksi jaringan Anda",
    "请上传图片格式的文件": "Silakan upload file dalam format gambar",
    "请稍后再试": "Silakan coba lagi nanti",
    "请设置资金密码": "Silakan atur kata sandi dana",
    "请输入内容": "Silakan masukkan konten",
    "请输入正确的手机号码": "Silakan masukkan nomor telepon yang benar",
    "请输入正确的邮箱地址": "Silakan masukkan alamat email yang benar",
    "请填写正确的电话号码": "Silakan isi nomor telepon yang benar",
    "请填写正确的验证码": "Silakan masukkan kode verifikasi yang benar",
    "请填写正确的邮箱地址": "Silakan isi alamat email yang benar",
    "请勿重复添加": "Jangan menambahkan berulang kali",
    "请先选择国家及州": "Silakan pilih negara dan negara bagian terlebih dahulu",
    "请先选择州": "Silakan pilih negara bagian terlebih dahulu",
    "请选择收货地址": "Silakan pilih alamat pengiriman",
    "请重新登录": "Silakan masuk lagi",
    "取消失败": "Pembatalan gagal",
    "删除失败": "Penghapusan gagal",
    "商品ID不能为空": "Bidang ini tidak boleh kosong",
    "商品ID错误": "Kesalahan ID Produk",
    "少于最小采购数量": "Kurang dari jumlah pembelian minimum",
    "身份证号已实名过!": "Nomor KTP telah diautentikasi!",
    "审核已通过": "Tinjauan berlalu",
    "审核中": "Sedang ditinjau",
    "审核状态异常请联系客服": "Status audit tidak normal. Silakan hubungi layanan pelanggan.",
    "实名认证尚未通过，无法重置": "Otentikasi nama asli belum lulus. Itu tidak dapat diatur ulang.",
    "实名姓名不能为空": "Bidang ini tidak boleh kosong",
    "试用码不正确": "Kode percobaan salah",
    "收藏ID不能为空": "Bidang ini tidak boleh kosong",
    "收货地址达上限": "Alamat pengiriman hingga batasnya",
    "收货人姓名不能超过64个字符": "Nama penerima barang tidak boleh melebihi 64 karakter",
    "收货失败": "Produk diterima gagal",
    "手机号不能为空": "Bidang ini tidak boleh kosong",
    "提币数量必填": "Kuantitas penarikan tunai diperlukan",
    "提币数量不能小于等于0": "Kuantitas penarikan tidak boleh kurang dari atau sama dengan 0.",
    "提币数量输入错误，请输入浮点数": "Jumlah penarikan yang dimasukkan salah, silakan masukkan nomor floating-point",
    "提交失败": "Pengiriman gagal",
    "提交失败，当前有未处理订单": "Pengiriman gagal. Saat ini ada pesanan terbuka.",
    "提款金额不得低于最小提款限额": "Jumlah penarikan tidak boleh kurang dari batas minimum penarikan.",
    "提款金额不得高于最大提款限额": "Jumlah penarikan tidak boleh lebih besar dari batas maksimum penarikan.",
    "添加失败": "Gagal menambahkan",
    "图片不能为空": "Bidang ini tidak boleh kosong",
    "图片大小不能超过30M": "Ukuran gambar tidak boleh melebihi 30M",
    "图形验证错误，请重新再试": "Kesalahan validasi grafis. Silakan coba lagi.",
    "推荐码不正确": "Kode rekomendasi salah.",
    "推荐人无权限推荐": "Pemberi rekomendasi tidak mempunyai wewenang untuk merekomendasikan.",
    "退货失败": "Pengembalian dana produk gagal",
    "未绑定谷歌验证器": "Validator Google tidak terikat",
    "未绑定手机号": "Tidak ada nomor telepon yang terikat",
    "未绑定邮箱": "Tidak ada kotak surat yang terikat",
    "无权限": "tidak ada izin",
    "系统参数错误": "Kesalahan parameter sistem",
    "系统存在相同[系统登录名]！": "Sistem ada [Nama Login Sistem] yang sama!",
    "系统错误，请稍后重试": "Kesalahan sistem, silakan coba lagi nanti",
    "请稍后重试": "Silakan coba lagi nanti",
    "系统无该用户，或者IP地址不正确": "Tidak ada pengguna di sistem, atau alamat ip salah.",
    "系统用户登录名不存在！": "Nama login pengguna sistem tidak ada.",
    "新密码不能为空": "Bidang ini tidak boleh kosong",
    "新密码不一致": "Kata sandi baru tidak sama dengan yang dimasukkan sebelumnya",
    "新密码确认不能为空": "Bidang ini tidak boleh kosong",
    "验证类型不能为空": "Bidang ini tidak boleh kosong",
    "验证码不能为空": "Bidang ini tidak boleh kosong",
    "验证码不正确": "Kode verifikasi salah",
    "邀请码不能为空": "Bidang ini tidak boleh kosong",
    "邀请码无效": "Kode undangan tidak valid",
    "页码不能小于等于0": "Nomor halaman tidak boleh kurang dari atau sama dengan 0",
    "页码不是整数": "Nomor halaman bukan bilangan bulat",
    "已经提交申请，请等待审核": "Permohonan telah diajukan. Mohon menunggu persetujuannya.",
    "已有未完成的贷款单，不能重复申请": "Ada dokumen pinjaman yang tidak lengkap. Itu tidak dapat diterapkan lagi.",
    "用户不存在": "pengguna tidak ada",
    "用户名必须为6-30位": "Nama pengguna harus 6-30 digit",
    "用户名必须由数字和英文字母组成": "Nama pengguna harus terdiri dari angka dan huruf",
    "用户名不存在": "Nama pengguna tidak ada",
    "用户名不符合设定": "Nama pengguna tidak sesuai dengan pengaturan",
    "用户名不能为空": "Bidang ini tidak boleh kosong",
    "用户名参数为空": "Bidang ini tidak boleh kosong",
    "用户名重复": "Nama pengguna duplikat",
    "用户已锁定": "Pengguna terkunci",
    "邮编不能超过32个字符": "Kode pos tidak boleh melebihi 32 karakter",
    "邮箱的长度不能超过64个字符": "Panjang kotak surat tidak boleh melebihi 64 karakter",
    "邮箱已绑定": "Kotak surat telah mengikat",
    "邮箱已绑定其他用户": "Kotak surat telah terikat ke pengguna lain",
    "游客不能向游客发送消息": "Wisatawan tidak bisa mengirimkan pesan kepada pengunjung",
    "余额不足": "Saldo tidak mencukupi",
    "暂无用户": "Tidak ada pengguna yang ditemukan",
    "正在购买": "Pembelian",
    "直线关系，不能修改推荐": "Hubungan garis lurus, rekomendasi tidak dapat diubah",
    "重复提交": "Kirim ulang",
    "注册类型（手机或邮箱）不能为空": "Jenis pendaftaran (ponsel atau email) wajib diisi",
    "资金密码必须为6-12位": "Kata sandi dana harus 6-12 digit.",
    "资金密码不符合设定": "Kata sandi dana tidak sesuai dengan pengaturan.",
    "资金密码不能为空": "Bidang ini tidak boleh kosong",
    "资金密码错误": "Kesalahan kata sandi dana",
    "Party ID不正确，系统无该用户": "ID partai salah. Sistem tidak memiliki pengguna.",
    "Token失效,请重新登录": "Token tidak valid. Silakan masuk lagi.",
    "登录过期，请重新登录": "Masa masuk sudah habis. Silakan masuk lagi.",
    "请输入搜索关键字": "Silakan masukkan kata kunci pencarian",
    "地址格式与协议不匹配": "Format alamat tidak sesuai dengan protokol",
    "用户已绑定过提现地址": "Pengguna telah mengikat alamat penarikan",
    "绑定提现地址成功": "Mengikat alamat penarikan berhasil",
    "未设置地址": "Alamat tidak disetel",
    "您有一笔提现正在处理中": "Anda sedang melakukan penarikan",
    "平台人工发起退款": "Platform memulai pengembalian dana secara manual",
    "充值数量不能小于等于0": "Kuantitas isi ulang tidak boleh kurang dari atau sama dengan 0.",
    "请选择法币类型": "  Silakan pilih jenis mata uang resmi.",
    "充值金额超过最大金额": "  Jumlah isi ulang melebihi jumlah maksimum.",
    "充值金额小于最小金额": "  Jumlah isi ulang kurang dari jumlah minimum.",
    "请选择正确的法币类型": "  Silakan pilih jenis mata uang resmi yang benar.",
    "业务已锁定，请联系客服！": "Bisnis terkunci, silakan hubungi layanan pelanggan!",
    "无法购买本店商品": "Tidak dapat membeli barang di toko ini",
    "参数缺失": "Parameter tidak ada",
    "充值数量必填": "Bidang ini tidak boleh kosong"
}
};
